import * as React from "react"

const SvgComponent = (props) => (
    <svg
        width={1310}
        height={1060}
        fill="none"
        viewBox="0 0 1310 1060"
        xmlns="http://www.w3.org/2000/svg"

    >
        <path
            d="M1136.3.002 0 656.032l169.5 293.58 1136.3-656.03L1136.3.002z"
            fill="url(#a)"
        />
        <path
            d="M1221.6 150 88 810.59l88.164 151.3 1133.6-660.59-88.16-151.3z"
            fill="#191822"
        />
        <path d="m890.14 344.42-500 290.55z" fill="#35404D" />
        <path d="m890.14 344.42-500 290.55" stroke="#DEDDE2" />
        <path
            d="M393.64 637.02a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM886.64 350.02a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
            fill="#F72585"
        />
        <path
            d="m640.08 489.26-.028 303.93c-.003 7.76-5.451 17.2-12.169 21.084l-124.58 72.037"
            stroke="#DEDDE2"
        />
        <path
            d="M699.11 907.06c-.689.689-1.544 1.33-2.541 1.905l-124.65 71.88c-3.101 1.789-7.246 2.773-11.671 2.773s-8.57-.984-11.671-2.773l-124.65-71.88c-2.631-1.517-4.229-3.48-4.499-5.525-.222-1.685.455-3.37 1.958-4.873.689-.689 1.544-1.33 2.541-1.905l124.65-71.88c3.101-1.789 7.246-2.774 11.671-2.774s8.57.985 11.671 2.774l124.65 71.88c2.632 1.517 4.23 3.479 4.499 5.525.223 1.685-.454 3.37-1.958 4.873z"
            fill="#282739"
        />
        <path
            d="M422.09 899.28c-.889.889-1.902 2.311-1.674 4.035.228 1.73 1.651 3.431 4.007 4.79l124.65 71.88c2.952 1.702 6.92 2.639 11.172 2.64 4.252-.001 8.219-.938 11.171-2.64l124.65-71.88c.922-.531 1.707-1.119 2.334-1.746.889-.889 1.901-2.311 1.674-4.035-.229-1.73-1.652-3.432-4.008-4.79l-124.65-71.88c-2.952-1.702-6.919-2.64-11.171-2.64s-8.22.938-11.172 2.64l-124.65 71.88c-.921.531-1.706 1.119-2.333 1.746zm-1.414-1.415c.738-.738 1.654-1.433 2.748-2.064l124.65-71.88c6.722-3.876 17.62-3.876 24.341 0l124.65 71.88c6.722 3.876 6.722 10.16 0 14.036l-124.65 71.881c-6.721 3.875-17.619 3.875-24.341-.001l-124.65-71.88c-5.627-3.244-6.543-8.177-2.748-11.972z"
            fill="#DEDDE2"
        />
        <path
            d="M699.11 907.06c-.689.689-1.544 1.329-2.541 1.905l-124.65 71.88c-3.101 1.788-7.246 2.773-11.671 2.773s-8.569-.985-11.671-2.773l-181.37-104.9c-2.633-1.518-4.231-3.481-4.501-5.526-.222-1.685.455-3.37 1.958-4.873.689-.689 1.544-1.33 2.542-1.905l124.65-71.88c3.102-1.789 7.247-2.774 11.671-2.774 4.425 0 8.57.985 11.671 2.774l181.38 104.9c2.633 1.518 4.231 3.481 4.5 5.526.223 1.685-.454 3.37-1.958 4.874z"
            fill="#282739"
        />
        <path
            d="M365.37 866.26c-.889.889-1.901 2.311-1.674 4.035.229 1.73 1.652 3.431 4.01 4.791l181.37 104.9c2.951 1.702 6.919 2.64 11.171 2.64s8.219-.938 11.171-2.64l124.65-71.88c.922-.531 1.707-1.119 2.334-1.746.889-.889 1.901-2.311 1.674-4.035-.228-1.73-1.652-3.431-4.01-4.791l-181.37-104.9c-2.952-1.702-6.92-2.64-11.172-2.64s-8.219.938-11.171 2.64l-124.65 71.88c-.922.531-1.707 1.119-2.334 1.746zm-1.414-1.415c.738-.738 1.654-1.433 2.749-2.064l124.65-71.88c6.721-3.876 17.619-3.876 24.341 0l181.38 104.9c6.722 3.876 6.722 10.16 0 14.036l-124.65 71.88c-6.721 3.876-17.619 3.876-24.341 0l-181.38-104.9c-5.627-3.244-6.544-8.177-2.749-11.972z"
            fill="#DEDDE2"
        />
        <path
            d="M477.92 852.94c-4.774.592-3.109 1.158-3.109 2.243 0 1.532-2.481 2.217-5.494 2.217-5.375 0-7.985-2.291-7.985-4.259s3.318-3.926 8.7-3.926c5.665 0 9.222.653 10.115 1.949.651.961-1.324 1.664-2.227 1.776z"
            fill="#231F20"
            opacity={0.29}
            style={{
                mixBlendMode: "multiply",
            }}
        />
        <path
            d="M422.23 872.68a2.994 2.994 0 0 1-3.131.028l-3.106-1.941c-.56-.443-.6-1.065.168-1.573l39.424-22.306c2.108-1.2 3.526-1.952 5.2-1.02l2.749 1.77c.884.54.738 1.179-.048 1.67L422.23 872.68z"
            fill="#231F20"
            opacity={0.21}
            style={{
                mixBlendMode: "multiply",
            }}
        />
        <path
            d="M551.84 927.92a.818.818 0 0 1 .406 1.24.818.818 0 0 1-.396.299l-12.737 7.4a2.917 2.917 0 0 1-2.654 0l-12.986-7.5a.805.805 0 0 1-.555-.764.801.801 0 0 1 .15-.473.806.806 0 0 1 .397-.298l12.734-7.4a2.936 2.936 0 0 1 2.656 0l12.985 7.496zM518.41 911.53a.807.807 0 0 1 .556.765.816.816 0 0 1-.546.774l-12.737 7.4a2.93 2.93 0 0 1-2.656 0l-12.984-7.5a.814.814 0 0 1-.008-1.538l12.736-7.4a2.917 2.917 0 0 1 2.654 0l12.985 7.499zM499.4 890.12a.82.82 0 0 1 .556.766.804.804 0 0 1-.15.474.806.806 0 0 1-.397.298l-12.736 7.4a2.929 2.929 0 0 1-2.654 0l-12.985-7.5a.805.805 0 0 1-.554-.765.816.816 0 0 1 .545-.772l12.736-7.4a2.929 2.929 0 0 1 2.654 0l12.985 7.499z"
            fill="#000"
            opacity={0.22}
        />
        <path
            d="m424.79 869.13-.005.954a1.79 1.79 0 0 1-1.044 1.459 5.587 5.587 0 0 1-5.082 0 1.797 1.797 0 0 1-1.06-1.482v-.953a1.783 1.783 0 0 0 1.062 1.481 5.589 5.589 0 0 0 5.079 0 1.783 1.783 0 0 0 1.045-1.459h.005z"
            fill="#2D3E50"
        />
        <path
            d="M423.73 867.65c1.41.814 1.414 2.13.015 2.942a5.605 5.605 0 0 1-5.079 0c-1.407-.812-1.417-2.128-.017-2.942a5.594 5.594 0 0 1 5.081 0z"
            fill="#23303E"
        />
        <path
            d="m458.43 849.12-.007.954a1.784 1.784 0 0 1-1.042 1.462 5.606 5.606 0 0 1-5.081 0 1.8 1.8 0 0 1-1.061-1.48v-.957a1.802 1.802 0 0 0 1.063 1.483 5.617 5.617 0 0 0 5.079 0 1.797 1.797 0 0 0 1.045-1.462h.004z"
            fill="#2D3E50"
        />
        <path
            d="M457.37 847.64c1.406.812 1.414 2.128.016 2.943a5.605 5.605 0 0 1-5.079 0c-1.409-.815-1.418-2.131-.019-2.943a5.583 5.583 0 0 1 5.082 0z"
            fill="#23303E"
        />
        <path
            d="m422.52 833.66-.034 35.025a.639.639 0 0 1-.383.536 2.035 2.035 0 0 1-1.856 0 .673.673 0 0 1-.269-.218.675.675 0 0 1-.122-.324l.035-35.028a.659.659 0 0 0 .388.543 2.062 2.062 0 0 0 1.86 0 .65.65 0 0 0 .381-.534z"
            fill="#2D3E50"
        />
        <path
            d="M422.14 844.11a.576.576 0 0 1 .384.54.573.573 0 0 1-.384.541 2.087 2.087 0 0 1-1.86 0 .577.577 0 0 1-.391-.538.567.567 0 0 1 .383-.543 2.06 2.06 0 0 1 1.868 0z"
            fill="#273545"
        />
        <path
            d="m456.14 813.78-.035 35.026a.644.644 0 0 1-.382.534 2.04 2.04 0 0 1-1.859 0 .644.644 0 0 1-.267-.218.65.65 0 0 1-.121-.323l.033-35.025a.647.647 0 0 0 .387.541 2.059 2.059 0 0 0 1.861 0 .647.647 0 0 0 .383-.535z"
            fill="#2D3E50"
        />
        <path
            d="M455.76 824.22a.572.572 0 0 1 0 1.08 2.058 2.058 0 0 1-1.861 0 .567.567 0 0 1-.385-.54.573.573 0 0 1 .385-.54 2.062 2.062 0 0 1 1.861 0z"
            fill="#273545"
        />
        <path
            d="m458.41 823.34-1.158-.673a.5.5 0 0 1 .512-.048l1.158.671a.507.507 0 0 0-.512.05z"
            fill="#2D3E50"
        />
        <path
            d="m418.54 846.36-1.154-.669 39.87-23.022 1.158.673-39.874 23.018z"
            fill="#273545"
        />
        <path
            d="m418.03 848.07-1.155-.669a.513.513 0 0 1-.209-.465 1.575 1.575 0 0 1 .718-1.242l1.153.669a1.6 1.6 0 0 0-.714 1.244.504.504 0 0 0 .207.463z"
            fill="#2D3E50"
        />
        <path
            d="M458.41 823.34c.4-.23.719-.045.721.41a1.585 1.585 0 0 1-.715 1.244l-39.873 23.02c-.4.231-.72.047-.722-.413a1.6 1.6 0 0 1 .715-1.244l39.874-23.017z"
            fill="#23303E"
        />
        <path
            d="m443.2 821.19-.578-.336a.84.84 0 0 0 .855-.085 2.665 2.665 0 0 0 1.206-2.085 1.28 1.28 0 0 0-.051-.364l.579.337c.033.119.05.241.051.365a2.662 2.662 0 0 1-1.206 2.083.843.843 0 0 1-.856.085z"
            fill="#F3D541"
        />
        <path
            d="m444.13 820.67-.579-.338.04.017.577.335-.038-.014z"
            fill="#993228"
        />
        <path
            d="m444.1 820.72-.58-.336.029-.054.579.338-.028.052z"
            fill="#A9372C"
        />
        <path
            d="m444.16 820.68-.577-.335.927-1.709.58.335-.93 1.709z"
            fill="#A9382D"
        />
        <path
            d="m445.05 818.96-.577-.336.04.017.58.335-.043-.016z"
            fill="#993228"
        />
        <path
            d="m445.05 818.96-.577-.336.161-.3.579.337-.163.299z"
            fill="#A9372C"
        />
        <path d="m444.1 820.72-.234-.159.263.108-.029.051z" fill="#B33B2F" />
        <path d="m444.1 820.72-.58-.336-.234-.159.58.336.234.159z" fill="#74261F" />
        <path
            d="m443.86 820.56-.58-.336.264.106.579.337-.263-.107z"
            fill="#993228"
        />
        <path
            d="m451.81 806.59-.579-.336a2.64 2.64 0 0 0 .849-.897 2.64 2.64 0 0 0 .351-1.183.852.852 0 0 0-.352-.778l.577.336a.837.837 0 0 1 .352.776 2.647 2.647 0 0 1-1.2 2.082h.002z"
            fill="#F3D541"
        />
        <path
            d="m451.72 806.63-.579-.335.088-.047.579.336a.566.566 0 0 1-.088.046z"
            fill="#F3D541"
        />
        <path
            d="m445.21 818.66-.579-.337 6.512-12.024.578.335-6.511 12.026z"
            fill="#B19B2F"
        />
        <path
            d="m451.73 806.64-.578-.335.643-1.187.58.336-.645 1.186z"
            fill="#A9372D"
        />
        <path
            d="m451.81 806.59-.579-.336a2.64 2.64 0 0 0 .849-.897 2.64 2.64 0 0 0 .351-1.183.852.852 0 0 0-.352-.778l.577.336a.837.837 0 0 1 .352.776 2.647 2.647 0 0 1-1.2 2.082h.002z"
            fill="#F3D541"
        />
        <path
            d="m444 818.54-.578-.335 1.053.416.577.336-1.052-.417z"
            fill="#993228"
        />
        <path d="m444 818.54-.578-.334.139-.254.577.333-.138.255z" fill="#A9372D" />
        <path
            d="m443.2 821.19-.578-.336a.841.841 0 0 1-.352-.777 1.551 1.551 0 0 1 .016-.245l.577.336a1.864 1.864 0 0 0-.017.247.856.856 0 0 0 .354.775z"
            fill="#E84C3D"
        />
        <path
            d="M445.22 818.66c.033.118.05.241.051.365a2.656 2.656 0 0 1-1.206 2.083c-.664.384-1.208.079-1.21-.69 0-.083.006-.165.017-.247l1 .391.235.16.028-.052.038.013.93-1.708-.043-.016.16-.299z"
            fill="#E24139"
        />
        <path
            d="m442.87 820.17-.572-.336.994.392.58.336-1.002-.392zM443.84 818.48l-.578-.337.161.064.578.334-.161-.061z"
            fill="#993228"
        />
        <path
            d="m444.14 818.29-.138.255-.161-.062c.069-.052.14-.1.214-.145.028-.017.056-.03.085-.048z"
            fill="#E24139"
        />
        <path
            d="m443.84 818.48-.578-.337c.067-.052.138-.099.211-.142.031-.017.059-.033.089-.047l.577.333c-.029.018-.057.031-.085.048a2.592 2.592 0 0 0-.214.145z"
            fill="#E84C3D"
        />
        <path
            d="m444.14 818.29-.577-.333 6.512-12.024.577.335-6.512 12.022z"
            fill="#A9372D"
        />
        <path
            d="m452.37 805.45-.58-.336-.932-.636.577.336.935.636z"
            fill="#74261F"
        />
        <path
            d="m451.44 804.81.935.637-.645 1.185-6.511 12.026-.163.301-1.052-.417.138-.255 6.512-12.022.786-1.455z"
            fill="#E24139"
        />
        <path
            d="m450.65 806.27-.577-.335.786-1.453.577.336-.786 1.452z"
            fill="#A9372D"
        />
        <path
            d="m451.81 803.82-.578-.336a.859.859 0 0 1 .856-.084l.577.336a.852.852 0 0 0-.855.084z"
            fill="#E84C3D"
        />
        <path
            d="M451.81 803.82c.664-.384 1.205-.075 1.207.692a2.649 2.649 0 0 1-1.2 2.082.82.82 0 0 1-.088.046l.644-1.186-.934-.636-.787 1.453a1.268 1.268 0 0 1-.048-.367 2.654 2.654 0 0 1 1.206-2.084z"
            fill="#E24139"
        />
        <path
            d="m450.65 806.27-.577-.335a1.236 1.236 0 0 1-.05-.367 2.646 2.646 0 0 1 1.206-2.085l.578.336a2.641 2.641 0 0 0-1.205 2.083c-.002.124.014.248.048.368z"
            fill="#E84C3D"
        />
        <path
            d="m431.21 832.05-.58-.334a.848.848 0 0 0 .86-.083 2.64 2.64 0 0 0 1.2-2.085 1.205 1.205 0 0 0-.045-.358l.578.335c.034.117.05.238.049.359a2.649 2.649 0 0 1-.351 1.186 2.638 2.638 0 0 1-.849.899.845.845 0 0 1-.857.081h-.005z"
            fill="#F3D541"
        />
        <path
            d="m432.06 831.75-.576-.335.928-1.705.575.335-.927 1.705z"
            fill="#A9372D"
        />
        <path
            d="m431.98 831.8-.579-.335-.934-.632.577.335.936.632zM432.02 831.72l-.58-.338-.932-.632.575.336.937.634z"
            fill="#74261F"
        />
        <path
            d="m431.04 831.17-.577-.335.045-.078.575.336-.043.077z"
            fill="#AA382D"
        />
        <path d="m431.09 831.09-.575-.336-.2-.14.578.339.197.137z" fill="#74261F" />
        <path
            d="m431.21 832.05-.58-.334a.85.85 0 0 1-.35-.774 1.66 1.66 0 0 1 .03-.33l.578.339a1.612 1.612 0 0 0-.03.325.854.854 0 0 0 .352.774z"
            fill="#E84C3D"
        />
        <path
            d="M433.22 829.53c.034.116.051.237.049.359a2.664 2.664 0 0 1-1.2 2.085c-.665.382-1.207.074-1.209-.693 0-.109.01-.218.03-.325l.2.137-.043.077.936.632.043-.075.04.026.926-1.705-.037-.025.265-.493z"
            fill="#E24139"
        />
        <path
            d="m432.06 831.75-.576-.335-.043-.029.58.338.039.026z"
            fill="#74261F"
        />
        <path d="m431.98 831.8.043-.075-.58-.336-.02.035.557.376z" fill="#AA382D" />
        <path
            d="m432.99 830.04-.575-.335-.038-.026.576.337.037.024z"
            fill="#74261F"
        />
        <path
            d="m432.95 830.02-.576-.337.267-.491.578.335-.269.493z"
            fill="#AA382D"
        />
        <path
            d="m439.4 818.81-.579-.337 3.468 1.367.577.336-3.466-1.366z"
            fill="#A08C2B"
        />
        <path
            d="m440.27 817.08-.577-.336 3.563 1.405.578.337-3.564-1.406z"
            fill="#993228"
        />
        <path
            d="m440.28 817.08-.577-.336v-.106a.84.84 0 0 0-.352-.772l.579.336a.84.84 0 0 1 .279.34.84.84 0 0 1 .072.434v.1l-.001.004zM438.9 819.14l-.58-.336c.06-.023.118-.051.173-.083.12-.07.232-.153.333-.247l.579.337a2.11 2.11 0 0 1-.333.244 1.309 1.309 0 0 1-.172.085z"
            fill="#F3D541"
        />
        <path
            d="m433.22 829.53-.578-.335 5.68-10.394.58.336-5.682 10.393z"
            fill="#B29C30"
        />
        <path
            d="m439.14 818.71-.576-.335.265.1.579.337-.268-.102z"
            fill="#993228"
        />
        <path
            d="m438.9 819.14.238-.434.267.105a2.11 2.11 0 0 1-.333.244 1.309 1.309 0 0 1-.172.085z"
            fill="#E24139"
        />
        <path
            d="m438.9 819.14-.58-.336.241-.433.576.335-.237.434z"
            fill="#AA382D"
        />
        <path
            d="m439.14 818.71-.576-.335.8-1.47.579.339-.803 1.466z"
            fill="#AA382D"
        />
        <path
            d="m440.28 817.08-.577-.336v-.106a.84.84 0 0 0-.352-.772l.579.336a.84.84 0 0 1 .279.34.84.84 0 0 1 .072.434v.1l-.001.004z"
            fill="#F3D541"
        />
        <path
            d="m431.04 831.17.043-.077.936.634-.043.075-.936-.632z"
            fill="#E24139"
        />
        <path
            d="m432.95 830.02-.576-.337-.936-.634.579.336.933.635z"
            fill="#74261F"
        />
        <path
            d="m432.02 829.39-.579-.336.131-.238.577.339-.129.235z"
            fill="#AA382D"
        />
        <path
            d="m431.9 829.31-.579-.34c.054-.037.11-.073.163-.106l.09-.048.577.339a.737.737 0 0 0-.087.048.871.871 0 0 0-.164.107z"
            fill="#E84C3D"
        />
        <path
            d="m432.15 829.15-.128.236-.123-.081a.983.983 0 0 1 .164-.107.917.917 0 0 1 .087-.048z"
            fill="#E24139"
        />
        <path
            d="m432.02 829.39-.579-.336-.122-.085.579.34.122.081z"
            fill="#74261F"
        />
        <path
            d="m432.15 829.15-.577-.339 5.745-10.505.577.335-5.745 10.509z"
            fill="#AA382D"
        />
        <path
            d="m439.94 817.23-.579-.339-.923-.622.579.338.923.623z"
            fill="#74261F"
        />
        <path
            d="m439.03 816.59 1.242.488 3.564 1.406.161.062 1.052.417.043.016-.93 1.709-.12.216-.181-.337-1-.392-3.461-1.366-.268-.1.8-1.466-.923-.623.021-.03z"
            fill="#E24139"
        />
        <path
            d="m439.03 816.59-.576-.338 1.241.49.577.336-1.242-.488z"
            fill="#993228"
        />
        <path
            d="m437.9 818.64-.577-.335 1.116-2.042.576.337-1.115 2.04z"
            fill="#AA382D"
        />
        <path
            d="m439.01 816.6.937.635-.8 1.466-.237.434-5.682 10.393-.269.493-.933-.635.129-.235 5.744-10.51 1.111-2.041z"
            fill="#E24139"
        />
        <path
            d="m439.02 816.61-.579-.338-.011-.011.576.337.014.012z"
            fill="#74261F"
        />
        <path
            d="m439.06 816.28-.579-.339a.86.86 0 0 1 .862-.083l.579.336a.852.852 0 0 0-.862.086z"
            fill="#E84C3D"
        />
        <path
            d="M439.06 816.28c.667-.387 1.211-.081 1.213.688v.1l-1.242-.488-.012.025-.014-.011-1.115 2.04a1.386 1.386 0 0 1-.029-.28c.023-.416.143-.821.351-1.181.209-.36.499-.666.848-.893z"
            fill="#E24139"
        />
        <path
            d="m437.9 818.64-.578-.335a1.375 1.375 0 0 1-.028-.279 2.649 2.649 0 0 1 1.2-2.083l.579.339a2.635 2.635 0 0 0-1.2 2.078c0 .094.01.188.029.28h-.002z"
            fill="#E84C3D"
        />
        <path
            d="m431.89 829.31-.579-.34-1.766-1.2.578.334 1.767 1.206z"
            fill="#7A6B21"
        />
        <path
            d="m430.89 830.95-.578-.339-1.812-1.228.576.334 1.814 1.233z"
            fill="#74261F"
        />
        <path
            d="m430.13 828.1-.578-.334c.027-.132.041-.266.042-.4a.844.844 0 0 0-.352-.776l.576.335a.852.852 0 0 1 .355.775 2.095 2.095 0 0 1-.043.395v.005z"
            fill="#F3D541"
        />
        <path
            d="m428.91 829.61-.578-.336.717-1.193.576.336-.715 1.193z"
            fill="#AE392E"
        />
        <path
            d="m429.07 829.72-.576-.334-.16-.108.578.336.158.106z"
            fill="#74261F"
        />
        <path
            d="m428.75 829.89-.578-.335c.074-.031.147-.066.217-.106a.746.746 0 0 0 .1-.064l.576.334a1.688 1.688 0 0 1-.1.065c-.071.04-.144.075-.219.106h.004z"
            fill="#F3D541"
        />
        <path
            d="m428.75 829.89-.578-.335.162-.278.578.336-.162.277z"
            fill="#AE392E"
        />
        <path
            d="m421.6 840.72-.578-.336a.841.841 0 0 0 .86-.082 2.65 2.65 0 0 0 1.2-2.079.802.802 0 0 0-.01-.147l.58.335c0 .046.006.1.006.146a2.64 2.64 0 0 1-1.2 2.079.847.847 0 0 1-.861.084h.003z"
            fill="#F3D541"
        />
        <path
            d="m421.6 840.72-.578-.336a.841.841 0 0 0 .86-.082 2.65 2.65 0 0 0 1.2-2.079.802.802 0 0 0-.01-.147l.58.335c0 .046.006.1.006.146a2.64 2.64 0 0 1-1.2 2.079.847.847 0 0 1-.861.084h.003z"
            fill="#F3D541"
        />
        <path
            d="m423.66 838.41-.58-.335 5.094-8.516.578.335-5.092 8.516z"
            fill="#B69F31"
        />
        <path
            d="m422.8 839.84-.58-.336.859-1.436.58.335-.859 1.437z"
            fill="#AE392E"
        />
        <path
            d="m430.13 828.1-.578-.334c.027-.132.041-.266.042-.4a.844.844 0 0 0-.352-.776l.576.335a.852.852 0 0 1 .355.775 2.095 2.095 0 0 1-.043.395v.005zM421.6 840.72l-.578-.336a.841.841 0 0 0 .86-.082 2.65 2.65 0 0 0 1.2-2.079.802.802 0 0 0-.01-.147l.58.335c0 .046.006.1.006.146a2.64 2.64 0 0 1-1.2 2.079.847.847 0 0 1-.861.084h.003z"
            fill="#F3D541"
        />
        <path
            d="m428.89 828.07-.576-.334.742.35.576.336-.742-.352z"
            fill="#953127"
        />
        <path
            d="m430.13 828.1-.578-.334-.922-.626.579.338.921.622z"
            fill="#74261F"
        />
        <path
            d="m429.21 827.48.921.622 1.767 1.2.122.081.933.635.037.024-.927 1.705-.039-.026-.936-.634-.2-.137-1.814-1.232-.158-.107.715-1.193-.742-.352.321-.586z"
            fill="#E24139"
        />
        <path
            d="m428.89 828.07-.576-.334.32-.595.579.338-.323.591z"
            fill="#A9382D"
        />
        <path
            d="m428.61 827.94-.581-.334.282.133.576.334-.277-.133z"
            fill="#953127"
        />
        <path
            d="m427.78 829.32-.578-.337.827-1.384.581.334-.83 1.387zM422.75 837.74l-.581-.335 5.03-8.414.578.337-5.027 8.412z"
            fill="#AE392E"
        />
        <path
            d="m428.96 827.02-.576-.333a.843.843 0 0 1 .858-.086l.576.335a.858.858 0 0 0-.858.084z"
            fill="#E84C3D"
        />
        <path
            d="m421.78 839.36-.578-.333 1.02.48.58.336-1.022-.483z"
            fill="#953127"
        />
        <path
            d="m421.78 839.36-.578-.333.97-1.627.581.335-.973 1.625z"
            fill="#AE392E"
        />
        <path
            d="m422.46 837.86-.575-.339c.092-.051.189-.092.289-.124l.581.335a1.38 1.38 0 0 0-.295.128z"
            fill="#E84C3D"
        />
        <path
            d="M428.96 827.02c.668-.382 1.208-.076 1.213.691a2.095 2.095 0 0 1-.043.395l-.921-.623-.323.591-.278-.133-.83 1.387a1.512 1.512 0 0 1-.017-.223 2.642 2.642 0 0 1 1.199-2.085z"
            fill="#E24139"
        />
        <path
            d="m427.78 829.32-.578-.337a1.38 1.38 0 0 1-.015-.222 2.62 2.62 0 0 1 1.2-2.082l.576.333a2.65 2.65 0 0 0-1.2 2.085c0 .074.006.149.017.223zM421.6 840.72l-.578-.336a.845.845 0 0 1-.351-.771 2.656 2.656 0 0 1 1.2-2.085l.575.339c-.35.228-.641.536-.85.897a2.66 2.66 0 0 0-.35 1.185.84.84 0 0 0 .351.771h.003z"
            fill="#E84C3D"
        />
        <path
            d="M422.46 837.86a1.38 1.38 0 0 1 .295-.128l-.973 1.625 1.022.484.859-1.437c0 .046.006.1.006.146a2.64 2.64 0 0 1-1.2 2.079c-.666.387-1.21.08-1.212-.687a2.653 2.653 0 0 1 1.203-2.082z"
            fill="#E24139"
        />
        <path
            d="m418.46 817.85 38.468-22.207.077 27.816-38.466 22.208-.079-27.817z"
            fill="#DEDDE2"
        />
        <path
            d="m418.54 845.67-.577-.335-.079-27.818.577.336.079 27.817z"
            fill="#ADABB9"
        />
        <path
            d="m418.47 817.85-.577-.336 38.465-22.207.58.337-38.468 22.206z"
            fill="#D1B738"
        />
        <path
            d="m457.82 795.28-1.155-.674a.5.5 0 0 1 .51-.047l1.157.672a.503.503 0 0 0-.512.049z"
            fill="#2D3E50"
        />
        <path
            d="m417.95 818.29-1.158-.672 39.873-23.021 1.155.675-39.87 23.018z"
            fill="#273545"
        />
        <path
            d="m417.44 820-1.157-.673a.504.504 0 0 1-.209-.46 1.586 1.586 0 0 1 .717-1.244l1.158.672a1.573 1.573 0 0 0-.719 1.245.501.501 0 0 0 .041.259.5.5 0 0 0 .169.201z"
            fill="#2D3E50"
        />
        <path
            d="M457.82 795.28c.4-.231.721-.046.721.412a1.586 1.586 0 0 1-.715 1.242l-39.872 23.022c-.4.229-.722.043-.723-.412a1.565 1.565 0 0 1 .719-1.245l39.87-23.019z"
            fill="#23303E"
        />
        <path
            d="M531.6 931.35a1.944 1.944 0 0 0-.885 1.535c0 .563.4.789.889.507a1.957 1.957 0 0 0 .886-1.536c0-.564-.4-.79-.89-.506zm0 1.636c-.3.174-.539.035-.539-.3a1.19 1.19 0 0 1 .535-.929c.3-.171.537-.035.538.308a1.17 1.17 0 0 1-.528.921h-.006z"
            fill="#3B3B3B"
        />
        <path
            d="M531.6 931.75c.3-.171.537-.035.538.308a1.178 1.178 0 0 1-.534.924c-.3.174-.539.035-.539-.3a1.18 1.18 0 0 1 .535-.932z"
            fill="#747474"
        />
        <path
            d="M531.48 930.86a.622.622 0 0 0-.63.061 1.954 1.954 0 0 0-.885 1.53.63.63 0 0 0 .259.574l.741.429a.622.622 0 0 1-.258-.568 1.94 1.94 0 0 1 .885-1.535.622.622 0 0 1 .631-.061l-.743-.43z"
            fill="#4C4C4C"
        />
        <path
            d="M544.56 923.86a1.942 1.942 0 0 0-.885 1.534c0 .564.4.788.89.506a1.954 1.954 0 0 0 .885-1.531c-.002-.565-.402-.791-.89-.509zm0 1.637c-.3.17-.537.034-.537-.3a1.167 1.167 0 0 1 .535-.93c.3-.169.538-.034.538.309a1.183 1.183 0 0 1-.534.921h-.002z"
            fill="#3B3B3B"
        />
        <path
            d="M544.56 924.26c.3-.169.538-.034.538.309a1.175 1.175 0 0 1-.536.925c-.3.17-.537.034-.537-.3a1.175 1.175 0 0 1 .535-.934z"
            fill="#747474"
        />
        <path
            d="M544.45 923.37a.618.618 0 0 0-.633.063 1.914 1.914 0 0 0-.627.66 1.918 1.918 0 0 0-.255.874.623.623 0 0 0 .256.567l.74.429a.622.622 0 0 1-.258-.568 1.95 1.95 0 0 1 .885-1.534.602.602 0 0 1 .629-.06l-.737-.431z"
            fill="#4C4C4C"
        />
        <path
            d="M544 931.16a.62.62 0 0 0-.634-.06c-.059.036-.123.072-.185.107-.086.052-.171.1-.257.15l-.295.174a.615.615 0 0 1 .631.061c.109.064.21.141.3.231l-.3.174a1.17 1.17 0 0 1 .534.926.375.375 0 0 1-.157.344l.5-.29c.007.049.011.099.011.149a.625.625 0 0 1-.257.57l.74-.43a.63.63 0 0 0 .259-.57 1.976 1.976 0 0 0-.89-1.536z"
            fill="#3B3B3B"
        />
        <path
            d="m542.88 931.96.742-.431a.374.374 0 0 0-.158.344 1.183 1.183 0 0 0 .537.928l-.742.429a1.177 1.177 0 0 1-.534-.926.375.375 0 0 1 .155-.344z"
            fill="#4C4C4C"
        />
        <path
            d="M543.26 931.59c-.492-.283-.889-.055-.893.508a1.963 1.963 0 0 0 .886 1.534c.491.283.89.057.892-.508a1.95 1.95 0 0 0-.885-1.534zm0 1.638a1.174 1.174 0 0 1-.534-.926c0-.34.243-.48.537-.307a1.174 1.174 0 0 1 .534.926c-.005.34-.246.483-.542.307h.005z"
            fill="#4C4C4C"
        />
        <path
            d="M543.26 932c-.294-.173-.537-.033-.537.307a1.18 1.18 0 0 0 .534.926c.3.171.537.033.537-.307a1.182 1.182 0 0 0-.534-.926z"
            fill="#7B7B7B"
        />
        <path
            d="M531.04 923.68a.637.637 0 0 0-.632-.064c-.062.037-.123.075-.184.109-.087.049-.175.1-.26.15l-.3.174a.62.62 0 0 1 .634.062c.11.063.211.142.3.233l-.3.171a1.17 1.17 0 0 1 .532.925.36.36 0 0 1-.031.194.363.363 0 0 1-.126.151l.5-.286c.008.048.012.097.014.146a.626.626 0 0 1-.26.568l.74-.428a.629.629 0 0 0 .259-.571 1.951 1.951 0 0 0-.886-1.534z"
            fill="#3B3B3B"
        />
        <path
            d="M530.3 924.11c-.491-.285-.893-.056-.894.507a1.965 1.965 0 0 0 .886 1.534c.492.285.892.056.9-.507a1.944 1.944 0 0 0-.892-1.534zm0 1.638a1.186 1.186 0 0 1-.535-.929c0-.341.242-.476.539-.3.156.101.285.238.377.399.093.16.146.341.155.526-.005.336-.246.477-.541.306l.005-.002z"
            fill="#4C4C4C"
        />
        <path
            d="M530.3 924.51c-.3-.171-.537-.036-.539.3a1.182 1.182 0 0 0 .535.929c.294.171.535.03.536-.309a1.178 1.178 0 0 0-.532-.92z"
            fill="#7B7B7B"
        />
        <path
            d="m544.54 922.65-6.076 3.53v1.174l6.075-3.529a.44.44 0 0 0 .257-.361v-1.172a.436.436 0 0 1-.256.358z"
            fill="#303030"
        />
        <path
            d="M529.85 922.65a.45.45 0 0 1-.18-.146.448.448 0 0 1-.08-.217v1.171a.449.449 0 0 0 .261.367l6.116 3.531v-1.176l-6.117-3.53z"
            fill="#3E3E3E"
        />
        <path
            d="M544.54 921.93a1.356 1.356 0 0 0-1.249 0l-6.076 3.53.005.246 6.519-3.789a.4.4 0 0 1 .36 0c.021.008.04.022.053.04a.112.112 0 0 1 0 .127.117.117 0 0 1-.053.04l-6.52 3.791.888.267 6.076-3.53a.383.383 0 0 0 .258-.363.382.382 0 0 0-.261-.359z"
            fill="#414141"
        />
        <path
            d="M530.3 921.92a.401.401 0 0 1 .359 0l6.561 3.786-.005-.246-6.116-3.531a1.375 1.375 0 0 0-1.251 0 .382.382 0 0 0-.188.583.389.389 0 0 0 .188.139l6.117 3.53.893-.267-6.558-3.788c-.1-.057-.1-.148 0-.206z"
            fill="#494949"
        />
        <path
            d="M544.1 921.92c.021.007.04.021.053.039a.112.112 0 0 1 0 .127.117.117 0 0 1-.053.04l-6.52 3.791 6.562 3.789c.021.007.04.021.053.039a.112.112 0 0 1 0 .127.117.117 0 0 1-.053.04.4.4 0 0 1-.358 0l-6.562-3.79-6.521 3.79a.405.405 0 0 1-.361 0c-.1-.057-.1-.149 0-.206l6.521-3.791-6.561-3.789c-.1-.057-.1-.148 0-.206a.397.397 0 0 1 .359 0l6.561 3.786 6.519-3.788a.404.404 0 0 1 .18-.043.407.407 0 0 1 .181.045z"
            fill="#303030"
        />
        <path
            d="M544.58 930.44a1.356 1.356 0 0 1-1.247 0l-6.119-3.53v1.173l6.118 3.535a1.405 1.405 0 0 0 1.248 0 .453.453 0 0 0 .256-.361l.005-1.174a.448.448 0 0 1-.261.357z"
            fill="#3E3E3E"
        />
        <path
            d="m544.58 929.72-6.119-3.533-.888-.267 6.563 3.789c.021.007.04.021.053.039a.112.112 0 0 1 0 .127.109.109 0 0 1-.053.039.388.388 0 0 1-.358 0l-6.562-3.79v.785l6.119 3.53a1.338 1.338 0 0 0 1.247 0 .38.38 0 0 0-.002-.719z"
            fill="#4C4C4C"
        />
        <path
            d="m537.22 926.12-6.521 3.79a.405.405 0 0 1-.361 0c-.1-.057-.1-.149 0-.206l6.521-3.791-.893.267-6.077 3.533a.38.38 0 0 0-.188.583.38.38 0 0 0 .188.139 1.356 1.356 0 0 0 1.249 0l6.077-3.53.005-.785z"
            fill="#4C4C4C"
        />
        <path
            d="M531.14 930.44a1.357 1.357 0 0 1-1.249 0 .432.432 0 0 1-.26-.359v1.173a.437.437 0 0 0 .258.364 1.39 1.39 0 0 0 1.248 0l6.079-3.533v-1.173l-6.076 3.528zM538.31 923.02a.543.543 0 0 0-.311-.444 1.697 1.697 0 0 0-1.553-.013.539.539 0 0 0-.331.453l-.013 3.062a.369.369 0 0 0 .014.066.9.9 0 0 0 .008.051c.009.025.02.049.033.072.01.015.014.03.024.044a.827.827 0 0 0 .095.113c.043.038.09.071.139.1a1.714 1.714 0 0 0 1.551.015.661.661 0 0 0 .144-.1.514.514 0 0 0 .106-.109.269.269 0 0 1 .028-.046c.009-.023.025-.048.032-.071a.262.262 0 0 0 .012-.054.416.416 0 0 0 .012-.069c.005-.926.005-2.149.01-3.07z"
            fill="#303030"
        />
        <path
            d="M537.61 920.32a.867.867 0 0 0-.789-.007.284.284 0 0 0-.167.23l-.008 2.291a.18.18 0 0 0 .006.032v.028c0 .012.012.02.018.034l.006.017a.36.36 0 0 0 .037.041c.004.009.01.017.017.023a.517.517 0 0 0 .071.052.858.858 0 0 0 .862-.047l.009-.013a.457.457 0 0 0 .044-.044.048.048 0 0 0 .008-.018.232.232 0 0 0 .022-.041.15.15 0 0 0 .006-.029c0-.011.006-.023.006-.033V920.547a.273.273 0 0 0-.148-.227z"
            fill="#969696"
        />
        <path
            d="M551.44 925.81c.291.388.721.65 1.2.731.524.109 2.258.324 2.258.324.86.108 1.9.381 2.066 1.225.03.186.039.375.029.564-.108.47-.566.656-1.124.856-.616.215-1.245.388-1.884.519-.842.182-1.71.2-2.558.054a13.372 13.372 0 0 0-1.436-.177c-.456 0-.38.332-.432.761l-1.455.38a2.23 2.23 0 0 1-2.379-1.454l.393-3.2 5.322-.583z"
            fill="#545454"
        />
        <path
            d="M550.5 929.84c.886.145 1.787.183 2.682.113a16.682 16.682 0 0 0 2.854-.768c.493-.175.916-.48.951-.761a1.07 1.07 0 0 1 0 .277c-.1.473-.564.66-1.122.858-.616.217-1.246.392-1.885.524a6.794 6.794 0 0 1-2.558.049s-1.173-.167-1.218-.172c-.269-.043-.537.03-.542.079.005-.021.114-.271.838-.199zM548.18 930.48l1.44-.375c-.013.143-.05.474-.065.614l-1.455.379a2.231 2.231 0 0 1-2.38-1.456l.079-.614a2.225 2.225 0 0 0 2.381 1.452z"
            fill="#383736"
        />
        <path
            d="M546.82 922.63a1.075 1.075 0 0 0 .936.916c.505.044 1.236.064 1.236.064.864-.159 1.944-.146 2.145.5.046.124.072.254.075.386-.043.477.125.079-.524.656a15.2 15.2 0 0 1-1.992 1.285 3.196 3.196 0 0 1-1.756.436 4.14 4.14 0 0 0-1-.076c-.431.053-.321.594-.321 1.018l-1.318.546a2.084 2.084 0 0 1-2.4-1.134v-3.392l4.919-1.205z"
            fill="#545454"
        />
        <path
            d="M546.4 926.67a7.532 7.532 0 0 0 1.909-.377 9.989 9.989 0 0 0 2.285-1.2 1.199 1.199 0 0 0 .586-.815c.015.09.024.18.028.271.032.431-.345.669-.658.889a8.17 8.17 0 0 1-1.858 1.052 4.306 4.306 0 0 1-1.647.324s-.589.025-.979.044c-.173.008-.416.112-.416.158.01-.029.063-.33.75-.346zM544.3 927.98l1.306-.54c0 .141.012.287.012.422l-1.318.544a2.09 2.09 0 0 1-2.4-1.132v-.427a2.083 2.083 0 0 0 2.4 1.133z"
            fill="#383736"
        />
        <path
            d="m550.18 908.84 2.99 3.184s-.855 14.363-.965 14.654c-.144.384-.771 1.347-2.989 1.736-1.1.189-3.378-.836-3.423-1.207l.341-10.845 4.046-7.522z"
            fill="#383736"
        />
        <path
            d="m545.8 911.69 2.942 1.593s-.615 11.57-.723 11.857c-.145.385-1.145 1.916-3.9 1.207-1.685-.433-2.557-1.173-2.6-1.542l.387-11.009 3.894-2.106zM531.82 909.52l3.328-1.543 7.037-2.844c1.764-.835 5.591-.963 5.495 2.7l.051 1.3-6.748 3.565s-5.254 2.29-7.522 2.076c-4.052-.385-1.641-5.254-1.641-5.254z"
            fill="#282827"
        />
        <path
            d="m529.9 915.34 7.163-4.12a.675.675 0 0 1 .679-.072l8.066 4.65a.69.69 0 0 0-.35-.06.685.685 0 0 0-.332.126l-7.157 4.123a2.104 2.104 0 0 0-.957 1.653.662.662 0 0 0 .279.61c-1.988-1.153-6.076-3.488-8.064-4.643a.67.67 0 0 1-.28-.614 2.094 2.094 0 0 1 .953-1.653z"
            fill="silver"
        />
        <path
            d="M537.97 919.99a2.104 2.104 0 0 0-.957 1.654c0 .606.432.853.959.546l7.161-4.126a2.091 2.091 0 0 0 .954-1.648c0-.61-.43-.854-.96-.548l-7.157 4.122z"
            fill="#ADADAD"
        />
        <path
            d="M478.77 895.38a1.932 1.932 0 0 0-.884 1.534c0 .563.4.787.889.506a1.942 1.942 0 0 0 .886-1.531c-.001-.567-.399-.792-.891-.509zm0 1.64c-.294.167-.538.031-.538-.309a1.193 1.193 0 0 1 .534-.928c.3-.171.539-.035.539.309a1.193 1.193 0 0 1-.531.928h-.004z"
            fill="#3B3B3B"
        />
        <path
            d="M478.77 895.78c.3-.171.539-.035.539.309a1.186 1.186 0 0 1-.535.928c-.294.167-.538.031-.538-.309a1.212 1.212 0 0 1 .534-.928z"
            fill="#747474"
        />
        <path
            d="M478.66 894.88a.635.635 0 0 0-.632.064 1.945 1.945 0 0 0-.882 1.531.626.626 0 0 0 .255.571l.741.43a.608.608 0 0 1-.206-.249.606.606 0 0 1-.052-.32 1.936 1.936 0 0 1 .884-1.534.632.632 0 0 1 .631-.064l-.739-.429z"
            fill="#4C4C4C"
        />
        <path
            d="M491.73 887.89a1.948 1.948 0 0 0-.882 1.535c0 .563.4.789.888.505a1.948 1.948 0 0 0 .886-1.531c-.001-.564-.4-.791-.892-.509zm.006 1.637c-.3.172-.539.035-.539-.306a1.182 1.182 0 0 1 .534-.927c.3-.169.539-.033.542.306a1.183 1.183 0 0 1-.537.927z"
            fill="#3B3B3B"
        />
        <path
            d="M491.73 888.3c.3-.169.539-.033.542.306a1.17 1.17 0 0 1-.537.927c-.3.172-.539.035-.539-.306a1.183 1.183 0 0 1 .534-.927z"
            fill="#747474"
        />
        <path
            d="M491.62 887.41a.64.64 0 0 0-.634.063 1.939 1.939 0 0 0-.625.661 1.943 1.943 0 0 0-.259.872.619.619 0 0 0 .26.57l.738.431a.618.618 0 0 1-.257-.569 1.948 1.948 0 0 1 .882-1.535.619.619 0 0 1 .633-.061l-.738-.432z"
            fill="#4C4C4C"
        />
        <path
            d="M491.18 895.19a.638.638 0 0 0-.633-.061c-.063.035-.123.074-.185.106-.086.051-.173.1-.258.151s-.2.116-.3.173a.626.626 0 0 1 .634.063c.108.063.207.141.294.231l-.3.172a1.174 1.174 0 0 1 .535.927.382.382 0 0 1-.158.346l.5-.29c0 .048.01.1.01.147a.618.618 0 0 1-.258.57l.74-.429a.625.625 0 0 0 .26-.571 1.962 1.962 0 0 0-.881-1.535z"
            fill="#3B3B3B"
        />
        <path
            d="m490.05 895.99.742-.43a.369.369 0 0 0-.156.344c.01.185.063.366.155.528.093.161.222.298.377.401l-.739.429a1.177 1.177 0 0 1-.535-.925.394.394 0 0 1 .032-.195.39.39 0 0 1 .124-.152z"
            fill="#4C4C4C"
        />
        <path
            d="M490.44 895.62c-.492-.284-.89-.055-.892.507a1.951 1.951 0 0 0 .885 1.536c.491.28.888.053.891-.51a1.942 1.942 0 0 0-.884-1.533zm-.005 1.637a1.165 1.165 0 0 1-.535-.925c0-.343.241-.479.538-.309a1.186 1.186 0 0 1 .535.927c-.002.34-.241.479-.538.307z"
            fill="#4C4C4C"
        />
        <path
            d="M490.43 896.03c-.3-.17-.538-.034-.538.309a1.169 1.169 0 0 0 .535.925c.3.172.536.033.538-.307a1.183 1.183 0 0 0-.535-.927z"
            fill="#7B7B7B"
        />
        <path
            d="M478.21 887.71a.638.638 0 0 0-.633-.061c-.058.035-.119.072-.183.107l-.26.152c-.087.052-.2.114-.295.171a.613.613 0 0 1 .631.062c.11.063.211.142.3.234l-.3.172a1.165 1.165 0 0 1 .534.925.371.371 0 0 1-.158.345l.5-.289c0 .05.011.1.011.148a.618.618 0 0 1-.259.569l.74-.43a.617.617 0 0 0 .259-.571 1.951 1.951 0 0 0-.887-1.534z"
            fill="#3B3B3B"
        />
        <path
            d="M477.47 888.14c-.489-.287-.889-.057-.891.506a1.969 1.969 0 0 0 .887 1.537c.49.281.892.054.892-.508a1.955 1.955 0 0 0-.888-1.535zm0 1.637a1.177 1.177 0 0 1-.531-.926c0-.34.24-.477.535-.3a1.168 1.168 0 0 1 .534.925c-.004.335-.244.474-.542.301h.004z"
            fill="#4C4C4C"
        />
        <path
            d="M477.47 888.55c-.295-.172-.534-.035-.535.3a1.18 1.18 0 0 0 .531.926c.3.173.538.034.538-.306a1.17 1.17 0 0 0-.534-.92z"
            fill="#7B7B7B"
        />
        <path
            d="m491.71 886.68-6.076 3.533v1.173l6.073-3.531a.439.439 0 0 0 .257-.359v-1.173a.439.439 0 0 1-.254.357z"
            fill="#303030"
        />
        <path
            d="M477.02 886.68a.445.445 0 0 1-.262-.363v1.175a.438.438 0 0 0 .26.363l6.117 3.531v-1.173l-6.115-3.533z"
            fill="#3E3E3E"
        />
        <path
            d="M491.71 885.96a1.368 1.368 0 0 0-1.247 0l-6.076 3.53v.248l6.519-3.788a.385.385 0 0 1 .358 0c.021.007.04.021.053.039a.112.112 0 0 1 0 .127.117.117 0 0 1-.053.04l-6.523 3.79.893.268 6.076-3.533a.385.385 0 0 0 .258-.361.374.374 0 0 0-.072-.221.373.373 0 0 0-.186-.139z"
            fill="#414141"
        />
        <path
            d="M477.46 885.95a.4.4 0 0 1 .357 0l6.567 3.79v-.248l-6.118-3.531a1.368 1.368 0 0 0-1.249 0 .379.379 0 0 0-.257.36.383.383 0 0 0 .257.361l6.117 3.533.891-.268-6.563-3.79c-.101-.055-.102-.155-.002-.207z"
            fill="#494949"
        />
        <path
            d="M491.26 885.95c.021.007.04.021.053.04.013.018.02.04.02.063s-.007.045-.02.063a.105.105 0 0 1-.053.04l-6.523 3.79 6.567 3.789a.113.113 0 0 1 .073.104.11.11 0 0 1-.073.105.388.388 0 0 1-.359 0l-6.561-3.793-6.524 3.791a.39.39 0 0 1-.359 0c-.1-.058-.1-.15 0-.209l6.518-3.789-6.563-3.79c-.1-.057-.1-.151 0-.206a.393.393 0 0 1 .357 0l6.567 3.79 6.519-3.788a.386.386 0 0 1 .361 0z"
            fill="#303030"
        />
        <path
            d="M491.75 894.48a1.382 1.382 0 0 1-1.248 0l-6.117-3.536v1.176l6.117 3.531a1.379 1.379 0 0 0 1.248 0 .443.443 0 0 0 .176-.145.445.445 0 0 0 .078-.214l.006-1.178a.453.453 0 0 1-.26.366z"
            fill="#3E3E3E"
        />
        <path
            d="m491.75 893.75-6.117-3.532-.893-.268 6.567 3.789a.11.11 0 0 1 .073.104.113.113 0 0 1-.073.105.401.401 0 0 1-.359 0l-6.561-3.793v.785l6.117 3.536a1.379 1.379 0 0 0 1.248 0 .378.378 0 0 0 .257-.364.38.38 0 0 0-.259-.362z"
            fill="#4C4C4C"
        />
        <path
            d="m484.39 890.16-6.524 3.791a.382.382 0 0 1-.359 0c-.1-.058-.1-.15 0-.209l6.518-3.789-.891.268-6.076 3.532a.383.383 0 0 0 0 .726 1.386 1.386 0 0 0 1.25 0l6.076-3.536.006-.783z"
            fill="#4C4C4C"
        />
        <path
            d="M478.31 894.48a1.386 1.386 0 0 1-1.25 0 .45.45 0 0 1-.262-.368v1.174a.43.43 0 0 0 .081.218.433.433 0 0 0 .181.147 1.38 1.38 0 0 0 1.248 0l6.078-3.531v-1.176l-6.076 3.536zM485.49 887.06a.543.543 0 0 0-.313-.445 1.714 1.714 0 0 0-1.554-.018.56.56 0 0 0-.331.455l-.009 3.062a.55.55 0 0 0 .011.069.42.42 0 0 0 .009.049.399.399 0 0 0 .035.072l.023.045a.421.421 0 0 0 .066.074c.009.014.02.027.032.039a.881.881 0 0 0 .136.1 1.729 1.729 0 0 0 1.553.015.781.781 0 0 0 .141-.1.205.205 0 0 0 .035-.037.44.44 0 0 0 .071-.072.323.323 0 0 0 .025-.049l.037-.071c.011-.023.005-.035.01-.055a.285.285 0 0 0 .011-.065l.012-3.068z"
            fill="#303030"
        />
        <path
            d="M484.78 884.35a.859.859 0 0 0-.787-.005.28.28 0 0 0-.169.229l-.006 2.291a.193.193 0 0 0 0 .034v.018a.4.4 0 0 0 .02.042c.005.008.005.017.011.024l.029.035a.18.18 0 0 0 .02.019c.022.018.046.035.07.053a.874.874 0 0 0 .791.008.873.873 0 0 0 .071-.051l.018-.02a.39.39 0 0 0 .036-.034.15.15 0 0 0 .012-.026.14.14 0 0 0 .018-.037.054.054 0 0 0 0-.018.22.22 0 0 0 .005-.044c0-.344.005-.746.005-1.145v-1.145a.274.274 0 0 0-.144-.228z"
            fill="#969696"
        />
        <path d="M494.83 888.61c.063-.033.121.034 0 0z" fill="#E8C5AC" />
        <path
            d="M490.51 875.21c-.011-1.044-7.33-2.261-7.157-3.02 0 0 8.43-2.632 10.026-2.588 3.718.1 2.781 3.205 2.781 3.205l-4.465 12.495-.028.043a2.245 2.245 0 0 0 1.185 1.986c.29.2 1.932 1.263 1.958 1.27a.052.052 0 0 0 .023.007c-.035.021-.07.071-.07.2 0 .424-4.329.046-4.329.046a2.899 2.899 0 0 1-1.564-.3c-.428-.321-.6-1.775-.6-2.17.106-9.174 2.24-11.174 2.24-11.174z"
            fill="#E8C5AC"
        />
        <path
            d="m489.77 888.92-.108 1.008a.927.927 0 0 1-.607.139.952.952 0 0 1-.586-.281l-.328-1.581a1.728 1.728 0 0 0 1.187.689c.145.031.294.039.442.026z"
            fill="#7C7676"
        />
        <path
            d="M490.64 887.58c1.652 1.053 2.684.482 2.832.4.6-.322.35-.7.023-.928-.1-.064-.211-.11-.327-.136a5.009 5.009 0 0 1 2.033.178c.152.1.29.244.3.358a.607.607 0 0 1-.16.419s-.951.385-1.611.72c-1.122.577-3.846.228-4.865.271-.348.014-.827-.522-.855-1.19-.054-.45.039-.906.266-1.3.433.006.85.164 1.178.446.182.131.841.545 1.186.762z"
            fill="#B21B0B"
        />
        <path
            d="M488.97 888.71c.15.032.7.061 1.543.142a5.706 5.706 0 0 0 3.17-.324 9.96 9.96 0 0 0 1.349-.629c.164-.1.505-.293.467-.438a.488.488 0 0 1-.069.415c-.644.396-1.323.733-2.028 1.008a13.121 13.121 0 0 1-3.217.093 14.365 14.365 0 0 1-1.565-.093c-.341-.066-.4-.481-.423-.537.235.165.496.288.773.363z"
            fill="#7C7676"
        />
        <path
            d="M487.16 880.07s-3.027-4.1-1.031-5.8c0 0 6.207-1.944 7.146-2.312 6.053-2.375 5.482 3.321 5.482 3.321l-4.194 12.041s-.026.548-.006.73c.043.444.534.634 1.755 1 .368.111 1.258.416 1.278.42.24.081.781.406.156.516-.418.071-4.192 1.166-4.192 1.166s-1.481-.323-1.9-.358c-.536-.039-.589-.478-.589-.875l.156-.651c-.149-8.921 1.853-10.2 1.781-10.818l-5.842 1.62z"
            fill="#FFE1CC"
        />
        <path
            d="m492.4 891.08-.223.988a.97.97 0 0 1-.641.065 1.008 1.008 0 0 1-.575-.35l-.157-1.613a1.843 1.843 0 0 0 1.3.886c.296.009.296.024.296.024z"
            fill="#7C7676"
        />
        <path
            d="M493.55 889.73a3.353 3.353 0 0 0 2.783.338c.649-.243.705-.579.4-.844a1.256 1.256 0 0 0-.421-.174c.797.12 1.571.361 2.295.713a.575.575 0 0 1 .15.39.572.572 0 0 1-.21.4s-1.025.269-1.742.521c-1.217.437-4.272-.074-5.325-.157-.36-.028-.794-.619-.744-1.289a2.033 2.033 0 0 1 .421-1.252c.442.059.851.265 1.16.586.393.284.805.541 1.233.768z"
            fill="#D32A1E"
        />
        <path
            d="M491.43 890.63c.53.163 1.07.289 1.618.376a7.886 7.886 0 0 0 3.716-.012c.498-.117.986-.271 1.462-.46.176-.076.526-.292.525-.381.01.322-.114.408-.114.408-.718.295-1.453.545-2.2.751a9.147 9.147 0 0 1-3.878-.186c-.644-.074-.9.027-1.191-.139a1.15 1.15 0 0 1-.523-.676c.171.146.37.254.585.319z"
            fill="#7C7676"
        />
        <path
            d="m477.07 879.37 7.163-4.121a.68.68 0 0 1 .681-.067l8.065 4.647a.667.667 0 0 0-.349-.059.668.668 0 0 0-.332.125l-7.16 4.124a2.103 2.103 0 0 0-.954 1.654.665.665 0 0 0 .278.611c-1.988-1.155-6.076-3.49-8.065-4.644a.677.677 0 0 1-.278-.616 2.107 2.107 0 0 1 .951-1.654z"
            fill="silver"
        />
        <path
            d="M485.14 884.02a2.106 2.106 0 0 0-.955 1.654c0 .605.431.85.96.547l7.16-4.123a2.104 2.104 0 0 0 .953-1.651c0-.61-.43-.856-.958-.551l-7.16 4.124z"
            fill="#ADADAD"
        />
        <path
            d="M488.53 870.38c1.08 0 5.171 2.888 5.171 2.888a3.118 3.118 0 0 1 1.454 3.352 3.12 3.12 0 0 1-.531 1.178s-4.4 1.633-5.423 2.047c-1.6.652-5.274 1.081-7.245.331a10.243 10.243 0 0 1-3.236-1.485 3.776 3.776 0 0 1-1.154-3.423c.1-.874.259-1.74.474-2.592 0 0 10.309-2.296 10.49-2.296z"
            fill="#3A3535"
        />
        <path
            d="m462.2 849.83.014 2.549a2.73 2.73 0 0 0 .71 2.09 2.71 2.71 0 0 0 2.028.872h.934s1.556-.17 1.18-2.363c-.131-.76-.592-3.361-.592-3.361l-4.274.213z"
            fill="#383736"
        />
        <path
            d="M462.2 849.28c-.057.911-.052 1.826.014 2.737a2.48 2.48 0 0 0 1.657 2.486c.338.118.697.163 1.053.13.9 0 1.133.019 1.157.019.655-.019 1.137-.69.942-2.091-.086-.607-.68-3.273-.722-3.273l-4.101-.008z"
            fill="#545454"
        />
        <path
            d="M472.68 828.83c.135.517.924.677 1.4.556.16-.042.512.9.848 1.2a.446.446 0 0 0 .722-.143 17.53 17.53 0 0 0-.963-1.746c-.63-1.122-1.126-1.039-1.6-.922s-.539.531-.407 1.055z"
            fill="#FFE8D9"
        />
        <path
            d="M472.7 828.42c-.535.116-1.785-.7-1.785-.7l-.137-.352c-.488-1.262-2.255-5.579-2.645-7.213-.43-1.8-.979-5.065-.979-5.065s-.9-3.788.934-4.663c1.048-.5 2.976.227 3.28 3.244.118 1.161.646 6.028.646 6.028l1.833 7.039s-.104 1.454-1.147 1.682z"
            fill="#6EDBCE"
        />
        <path
            d="m471.86 828.11 1.36-.367.931 1.481.067.262.338 2.164a1.083 1.083 0 0 1-.144.835 1.097 1.097 0 0 1-.695.485c-.706.19-.076.019-.076.019a1.133 1.133 0 0 1-1.327-.758l-.954-2.658c-.167-.569-.121-1.295.5-1.463z"
            fill="#FFE8D9"
        />
        <path
            d="M474.29 827.58c.054.24-.377.826-1.064 1.042a3.241 3.241 0 0 1-1.366.2c-.455-.052-.721-.171-.819-.462 0 0-.369-1.074-.468-1.419-.065-.22.044-.246.044-.246a.944.944 0 0 0 .107.23 1.66 1.66 0 0 0 1.552.272c1.423-.259 1.409-1.13 1.409-1.13.207-.043.293.033.334.274l.271 1.239z"
            fill="#B8FFF5"
        />
        <path
            d="m475.44 847.12.864.619s3.472 1.223 3.71 1.314c.271.1.866.27.845.757a.57.57 0 0 1-.055.293 1.969 1.969 0 0 1-1.221.732 15.44 15.44 0 0 1-3.327.171 7.887 7.887 0 0 1-1.911-.321s-.581-.11-.661.094c.003.154.028.307.074.454l-1.452-.429a3.69 3.69 0 0 1-.333-.979l-.162-1.961 3.629-.744z"
            fill="#545454"
        />
        <path
            d="M480.15 850.44a3.548 3.548 0 0 1-1.038.342c-1.31.178-2.637.183-3.948.015-.238-.031-1.143-.162-1.143-.162s-.361.062-.341.145c0-.044.006-.008-.014 0 .012.154.041.306.088.453l.351-.271s1.1.137 1.3.176c1.284.157 2.583.151 3.866-.018a2.51 2.51 0 0 0 1.554-.939.515.515 0 0 0 .014-.416 2.487 2.487 0 0 1-.689.675z"
            fill="#282827"
        />
        <path
            d="m473.68 850.78-1.6-.532c.057.19.123.376.2.559l1.453.43c-.005-.045-.037-.336-.053-.457z"
            fill="#282827"
        />
        <path
            d="M471.48 828.1s2.834 8.366 3.662 11.169a72.203 72.203 0 0 1 1.12 7.73c.182.824.314.981.1 1.283-.818 1.133-3.71 2.953-4.424 1.238a72.07 72.07 0 0 0-1.865-8.154c-1.188-2.971-5.226-11.2-5.226-11.2l6.633-2.066z"
            fill="#282827"
        />
        <path
            d="M469.88 810.7c1 1.708 1.522 3.144 1.658 6.638l.143 9.734c.019.47.117 1.033-.274 1.311 0 0-3.515 3.053-5.359 2.908a18.243 18.243 0 0 1-3.676-1.132c-.874-.379-.9-.9-.933-1.136l-1.273-14.081c-.087-1.089 3.775-3.563 4.42-3.978l2.644-.92s1.972-.504 2.65.656z"
            fill="#81F2E7"
        />
        <path
            d="M468.15 812.04c-1.441 1.435-2.285-.052-3.225-1.158l-.177-3.992 3.3.948.102 4.202z"
            fill="#E8C5AC"
        />
        <path
            d="M464.86 809.53c-.003.212.005.424.024.636.369 1.615 2.371 2.208 2.371 2.208.254.121.249.419.226.807l-.1 1.152c-.027.373-.22.344-.374.193 0 0-1.547-1.245-1.984-1.668-1.027-.992-.947-1.227-.613-2.532.202-.787.45-.796.45-.796zM467.73 812.31a.339.339 0 0 0-.008.494l.613.825c.318.359.345.055.34-.247l-.006-2.188c-.179-1.373-.546-1.425-.546-1.425-.005.2.003.401.026.6a2.87 2.87 0 0 1-.419 1.941z"
            fill="#B8FFF5"
        />
        <path
            d="M465.76 804.61a.888.888 0 0 1 .932.744l.064 1.632a.488.488 0 0 1-.33.432c-.456.113-.673-.284-.9-.719-.014-.027-.3-.673-.321-.712-.247-.546-.212-1.348.555-1.377z"
            fill="#FFE8D9"
        />
        <path
            d="m467.39 802.18-3.141.136.173 5.67c.058.39.053.74.131 1.066a1.609 1.609 0 0 0 .716 1.006 7.284 7.284 0 0 0 1.572.863c.339.144.71.196 1.076.153.327-.122.639-.281.93-.473a1.822 1.822 0 0 0 .989-1.121c.161-.513.283-1.037.367-1.567l.31-3.38.09-3.036-3.213.683z"
            fill="#FFE1CC"
        />
        <path
            d="M469.94 800.89a1.826 1.826 0 0 1 .96 2.492c-.309 1.121-.428 1.34-.411 1.355s.009-.748.011-1.2c0-.667-.673-.421-.941-.191-.4.334-1.334.966-1.361.982-.353.222-.43.069-.468-.191-.006-.059-.021-.4-.021-.4-.047.036-.865.459-1.085.6a1.427 1.427 0 0 0-.665 1.454l.018.492c.01.259.066.55-.188.532-.271-.019-.251-.121-.338-.395 0 0-.07-1.279-1.1-.743-.545.282-.1 1.505-.058 1.575l.269 1.853c-.227.08-.758-.286-1.079-.918-.59-1.162-.965-2-1.13-2.353a4.286 4.286 0 0 1 5.176-6.053c.831.305 1.638.676 2.411 1.109z"
            fill="#D1D3D3"
        />
        <path d="m463.79 805.31.21-.1-.482.229-.211.1.483-.229z" fill="#232323" />
        <path d="m466.42 807.17.213-.1.023-.286-.214.1-.022.286z" fill="#222" />
        <path
            d="M464 805.21a.491.491 0 0 1 .263-.022.49.49 0 0 1 .237.114l2.16 1.484-.214.1-2.157-1.489a.503.503 0 0 0-.5-.088l.211-.099z"
            fill="#1F1F1F"
        />
        <path
            d="M464.28 805.4a.505.505 0 0 0-.5-.088l-.483.227c-.056.025-.063.118-.019.207a.266.266 0 0 0 .084.107.105.105 0 0 0 .043.019.13.13 0 0 0 .048-.003l.524-.248a.252.252 0 0 1 .246.048l2.188 1.5.022-.283-2.153-1.486z"
            fill="#3A3A3A"
        />
        <path
            d="M466.57 807.08v.067l.004.013.009.011a.104.104 0 0 0 .039.012.086.086 0 0 0 .039-.006l.005-.066a.088.088 0 0 1-.04.004.089.089 0 0 1-.038-.012c-.004-.002-.008-.006-.01-.01s-.004-.009-.004-.013h-.004z"
            fill="#6B6B6B"
        />
        <path
            d="M466.59 807.06c-.022.012-.023.031-.005.044a.072.072 0 0 0 .038.013.08.08 0 0 0 .04-.005l.059-.029a.021.021 0 0 0 .011-.008c.002-.004.004-.008.004-.013s-.002-.009-.004-.013a.031.031 0 0 0-.011-.009.098.098 0 0 0-.037-.014.086.086 0 0 0-.039.006l-.056.028z"
            fill="#6B6B6B"
        />
        <path
            d="M466.72 807.08c.005-.002.009-.005.012-.009s.005-.009.006-.013l-.007.067c0 .011-.006.016-.018.022l-.057.028.005-.066.059-.029z"
            fill="#4F4F4F"
        />
        <path
            d="m466.52 806.98.053.035-.005.071-.052-.04a.02.02 0 0 1-.01-.01.022.022 0 0 1-.004-.013v-.068c.001.006.003.011.006.015s.007.007.012.01z"
            fill="#4B4B4B"
        />
        <path
            d="m466.58 807.02-.005.07a.098.098 0 0 0 .081 0c.004 0 .008-.002.011-.004s.006-.005.007-.009l.008-.075c0 .009-.009.015-.02.022a.085.085 0 0 1-.082-.007v.003z"
            fill="#959595"
        />
        <path
            d="M466.52 806.93c-.022.014-.025.034 0 .049l.053.036a.1.1 0 0 0 .041.014.083.083 0 0 0 .041-.007c.024-.012.026-.032 0-.046l-.052-.04a.108.108 0 0 0-.083-.006z"
            fill="#6B6B6B"
        />
        <path
            d="m466.58 806.92-.005.069c0 .01 0 .016.015.025.012.006.025.01.038.01s.027-.004.038-.01l.005-.064a.089.089 0 0 1-.04.006.13.13 0 0 1-.038-.012.03.03 0 0 1-.01-.012.032.032 0 0 1-.003-.014v.002z"
            fill="#8D8D8D"
        />
        <path
            d="M466.6 806.91c-.024.011-.026.03-.006.045a.094.094 0 0 0 .038.012.093.093 0 0 0 .04-.006l.057-.03c.022-.01.025-.027 0-.041a.075.075 0 0 0-.037-.013.073.073 0 0 0-.039.005l-.053.028z"
            fill="#959595"
        />
        <path
            d="M466.73 806.92a.035.035 0 0 0 .017-.012v.06l-.007.012a.083.083 0 0 1-.012.008l-.058.026.005-.064.055-.03z"
            fill="#4F4F4F"
        />
        <path d="m471.33 805.18.213-.1.025-.286-.213.1-.025.286z" fill="#222" />
        <path
            d="m471.48 805.09-.006.067a.036.036 0 0 0 .013.021.073.073 0 0 0 .038.014.071.071 0 0 0 .04-.007v-.067c-.012.005-.025.006-.038.005s-.025-.004-.036-.011a.047.047 0 0 1-.014-.014l.003-.008z"
            fill="#6B6B6B"
        />
        <path
            d="M471.5 805.07a.016.016 0 0 0-.01.008c-.003.004-.005.008-.005.013s.002.009.005.013a.022.022 0 0 0 .01.009c.011.006.024.01.037.011a.095.095 0 0 0 .037-.005l.062-.028c.023-.009.024-.029 0-.043a.08.08 0 0 0-.037-.012.078.078 0 0 0-.04.005l-.059.029z"
            fill="#6B6B6B"
        />
        <path
            d="M471.63 805.09a.037.037 0 0 0 .017-.013v.059c0 .009-.006.016-.019.021l-.058.028v-.067l.06-.028z"
            fill="#4F4F4F"
        />
        <path
            d="m471.43 804.99.054.038v.066l-.054-.036c-.011-.007-.016-.014-.015-.024l.006-.067c0 .004 0 .008.002.012a.026.026 0 0 0 .007.011z"
            fill="#4B4B4B"
        />
        <path
            d="M471.49 805.03v.066a.094.094 0 0 0 .04.013.082.082 0 0 0 .041-.006c.005-.002.009-.005.012-.009s.005-.009.005-.013l.005-.066c0 .008-.007.015-.019.021s-.026.008-.04.007-.027-.006-.039-.013h-.005z"
            fill="#959595"
        />
        <path
            d="M471.44 804.95c-.025.012-.026.032-.005.047l.054.038a.076.076 0 0 0 .039.013.081.081 0 0 0 .04-.007c.025-.01.026-.032 0-.047l-.049-.038a.109.109 0 0 0-.039-.011.09.09 0 0 0-.04.005z"
            fill="#6B6B6B"
        />
        <path
            d="m471.5 804.93-.006.066c0 .005.001.009.004.014.002.004.006.007.01.01.011.006.024.01.037.011a.08.08 0 0 0 .037-.005l.006-.068c-.012.005-.025.007-.038.005a.082.082 0 0 1-.037-.013.024.024 0 0 1-.009-.008.02.02 0 0 1-.004-.012z"
            fill="#8D8D8D"
        />
        <path
            d="M471.51 804.91c-.023.01-.024.031 0 .041a.07.07 0 0 0 .036.014c.013.002.027 0 .039-.006l.061-.028c.02-.009.02-.029 0-.043-.012-.007-.025-.011-.039-.012s-.028.001-.04.006l-.057.028z"
            fill="#959595"
        />
        <path
            d="M471.64 804.93c.004-.002.008-.004.011-.008.003-.003.004-.008.004-.012v.065c0 .008-.007.015-.015.023l-.063.028.006-.068.057-.028z"
            fill="#4F4F4F"
        />
        <path
            d="m471.13 805.46.053-.706a.14.14 0 0 0-.048-.129l.193.136a.142.142 0 0 1 .042.058.14.14 0 0 1 .007.07l-.055.707a.413.413 0 0 1-.072.185.408.408 0 0 1-.148.132l-.193-.132a.435.435 0 0 0 .221-.321z"
            fill="#2F2F2F"
        />
        <path
            d="m471.53 804.48-.2-.133a.308.308 0 0 0-.312 0l.194.133a.313.313 0 0 1 .313 0h.005z"
            fill="#3A3A3A"
        />
        <path
            d="m469.75 806.34 1.163-.553.193.132-1.162.558c-.021.011-.045.018-.069.018s-.048-.007-.069-.018l-.193-.135a.129.129 0 0 0 .069.017.134.134 0 0 0 .068-.019z"
            fill="#1F1F1F"
        />
        <path
            d="M469.95 805.25a.432.432 0 0 0-.219.322l-.054.7c-.01.122.075.18.185.127l1.162-.55a.433.433 0 0 0 .22-.322l.055-.706c.007-.123-.075-.179-.187-.126l-1.162.555z"
            fill="#B2D3D3"
            opacity={0.67}
            style={{
                mixBlendMode: "screen",
            }}
        />
        <path
            d="m471.21 804.48-.194-.133-1.159.554.193.136 1.16-.557z"
            fill="#282828"
        />
        <path
            d="M469.37 805.94c.006.005.01.012.012.02a.053.053 0 0 1 .002.025v.071a.138.138 0 0 0 .04.126l.036.022c.018.012.034.029.044.049s.014.042.013.065l-.011.145a.307.307 0 0 0 .106.29l-.194-.133a.307.307 0 0 1-.1-.293l.011-.142a.12.12 0 0 0-.008-.056.119.119 0 0 0-.033-.044l-.045-.031a.137.137 0 0 1-.048-.131v-.072a.045.045 0 0 0-.012-.044l.187.133z"
            fill="#2F2F2F"
        />
        <path
            d="m470.05 805.04-.194-.136a.971.971 0 0 0-.495.72l.194.132a.956.956 0 0 1 .495-.716z"
            fill="#3A3A3A"
        />
        <path
            d="m469.56 805.73-.191-.133-.009.071.193.137.007-.075z"
            fill="#1D1D1D"
        />
        <path
            d="m469.51 805.74-.2-.134c-.045-.03-.118-.031-.231.022a.583.583 0 0 0-.291.288l.194.133a.573.573 0 0 1 .291-.285c.114-.053.187-.053.232-.024h.005z"
            fill="#3A3A3A"
        />
        <path
            d="m468.49 806.72.053-.707a.142.142 0 0 0-.006-.071.143.143 0 0 0-.041-.058l.195.133a.136.136 0 0 1 .039.058.133.133 0 0 1 .007.071l-.054.706a.423.423 0 0 1-.22.32l-.193-.132a.452.452 0 0 0 .148-.134.452.452 0 0 0 .072-.186z"
            fill="#2F2F2F"
        />
        <path
            d="m468.88 805.74-.193-.135a.312.312 0 0 0-.314.006l.193.132a.31.31 0 0 1 .314 0v-.003z"
            fill="#3A3A3A"
        />
        <path
            d="m467.1 807.6 1.162-.553.193.132-1.159.554a.132.132 0 0 1-.14 0l-.2-.133c.022.013.047.02.072.02s.05-.007.072-.02z"
            fill="#1F1F1F"
        />
        <path
            d="M467.31 806.5a.435.435 0 0 0-.22.321l-.054.705c-.008.125.076.18.186.127l1.16-.552a.44.44 0 0 0 .223-.322l.052-.7c.011-.125-.072-.182-.184-.128l-1.163.549z"
            fill="#B2D3D3"
            opacity={0.67}
            style={{
                mixBlendMode: "screen",
            }}
        />
        <path
            d="m466.91 807.02-.053.708a.314.314 0 0 0 .014.158.32.32 0 0 0 .092.131l-.193-.133a.303.303 0 0 1-.1-.29l.053-.7.187.126z"
            fill="#2F2F2F"
        />
        <path
            d="m468.57 805.74-.193-.132-1.161.553.193.135 1.161-.556z"
            fill="#282828"
        />
        <path
            d="M468.57 805.74c.252-.118.439.009.42.285v.023a.573.573 0 0 1 .291-.285c.167-.081.25-.039.275.042l.006-.052a.951.951 0 0 1 .495-.716l1.16-.557c.252-.117.44.009.42.285l-.056.707a.965.965 0 0 1-.495.72l-1.16.553c-.253.119-.442-.009-.419-.284l.011-.145a.125.125 0 0 0-.019-.076.125.125 0 0 0-.06-.051.132.132 0 0 1-.047-.06.129.129 0 0 1-.007-.075v-.071c.006-.058-.036-.068-.124-.024-.131.06-.135.122-.138.15l-.006.071a.394.394 0 0 1-.069.186.543.543 0 0 0-.105.219l-.01.145a.965.965 0 0 1-.494.72l-1.163.556c-.251.118-.439-.009-.418-.286l.053-.708a.956.956 0 0 1 .5-.716l1.159-.556zm1.19.6c-.012.121.074.177.184.128l1.162-.558a.427.427 0 0 0 .22-.317l.055-.707c.011-.122-.073-.18-.189-.124l-1.16.55a.435.435 0 0 0-.22.321l-.052.707zm-2.648 1.257c-.008.125.075.18.19.128l1.159-.554a.422.422 0 0 0 .22-.32l.054-.706c.01-.121-.074-.178-.185-.127l-1.162.554a.432.432 0 0 0-.149.133.436.436 0 0 0-.071.187l-.056.7v.005z"
            fill="#1F1F1F"
        />
        <path
            d="m467.41 806.3-.193-.135a.954.954 0 0 0-.5.721l.192.13a.956.956 0 0 1 .5-.716h.001z"
            fill="#3A3A3A"
        />
        <path
            d="M464.3 805.44a.898.898 0 0 1 .936.748l.063 1.63s-.025.36-.328.433c-.459.114-.677-.284-.9-.721-.013-.026-.3-.671-.321-.71-.25-.546-.217-1.349.55-1.38z"
            fill="#FFE8D9"
        />
        <path
            d="m467.73 813.17.759.9-.253 1.236-.7-.676.194-1.46z"
            fill="#305670"
        />
        <path
            d="m468.04 813.88 1.834 7.905-.673 3-1.126-2.343-.035-8.562z"
            fill="#305670"
        />
        <path
            d="M468.72 828.58a7.088 7.088 0 0 0 2.977-1.032l.012.759.187 1.162-2.21 1.049-.966-1.938z"
            fill="#282827"
        />
        <path
            d="m468.91 829.43-1.978 19.339-.061 1.778c-.006.6-.8 1.251-1.8 1.427a3.409 3.409 0 0 1-1.921-.117 1.913 1.913 0 0 1-1.209-1.341l-.219-9.085-.172-11.58 7.36-.421z"
            fill="#383736"
        />
        <path
            d="M463.25 828.31c-.466.7-1.851.4-1.851.4s-2.152-1.406-4.015-2.825-1.992-2.519-1.044-4.317l2.939-5.365s.941-2.378 2.415-2.3c1.692.085 2.634 2.433 1.789 3.988-.465.856-2.468 3.429-3.4 4.611-.313.393-.263.726-.059.873l3.206 2.973a1.664 1.664 0 0 1 .02 1.962z"
            fill="#A4FFF4"
        />
        <path
            d="m461.59 831.53-.3-2.808c2.628.08 5.258.009 7.878-.215.269-.053.855 2.386.141 3.436a8.242 8.242 0 0 0-.974 2.922l-6.745-3.335z"
            fill="#383736"
        />
        <path
            d="m462.33 829.07-.043-.548 1.267-1.682 1.835.409s1.695.356 2.008 1.4c.573 1.9-.874 1.864-.874 1.864a6.124 6.124 0 0 0-1.253-.437c-.154 0-1.484-.144-1.484-.144-.816-.092-1.261-.248-1.456-.862z"
            fill="#FFE8D9"
        />
        <path
            d="M464.21 826.86a1.854 1.854 0 0 1-.395 1.9c-.566.689-.882.7-.882.7-.392.173-.665.21-.882.019 0 0-.8-.593-1.044-.826-.156-.151-.064-.244-.064-.244.08.07.182.11.288.112.485-.028.94-.243 1.27-.6.961-.981.6-1.733.6-1.733.143-.139.306-.119.454.058l.655.614z"
            fill="#DCFFF9"
        />
        <path
            d="m578.12 855.92-.8-.465v.562a.9.9 0 0 1-.4.7l-.487.277.8.467.49-.283a.884.884 0 0 0 .4-.691l-.003-.567z"
            fill="#323232"
        />
        <path
            d="M578.74 855.56v.812a1.773 1.773 0 0 1-.8 1.389l-.7.4v-.71l.49-.283a.868.868 0 0 0 .4-.691v-.563l.61-.354z"
            fill="#232323"
        />
        <path
            d="M569.61 875.09a1.95 1.95 0 0 0-.877 1.524c0 .559.4.784.884.5a1.942 1.942 0 0 0 .88-1.523c-.002-.559-.402-.785-.887-.501zm0 1.63c-.292.169-.531.034-.531-.31a1.166 1.166 0 0 1 .529-.919c.293-.17.536-.034.538.3a1.184 1.184 0 0 1-.532.929h-.004z"
            fill="#3B3B3B"
        />
        <path
            d="M569.61 875.49c.293-.17.536-.034.538.3a1.193 1.193 0 0 1-.536.925c-.292.169-.531.034-.531-.31a1.155 1.155 0 0 1 .529-.915z"
            fill="#747474"
        />
        <path
            d="M569.5 874.6a.619.619 0 0 0-.628.063 1.936 1.936 0 0 0-.881 1.522.63.63 0 0 0 .257.569l.734.424a.621.621 0 0 1-.254-.564 1.937 1.937 0 0 1 .877-1.524.619.619 0 0 1 .629-.064l-.734-.426z"
            fill="#4C4C4C"
        />
        <path
            d="M582.49 867.65a1.942 1.942 0 0 0-.88 1.528c0 .557.4.784.885.5a1.942 1.942 0 0 0 .883-1.525c.001-.559-.396-.784-.888-.503zm.005 1.627c-.294.17-.532.035-.536-.3a1.193 1.193 0 0 1 .531-.923c.3-.17.537-.033.538.306a1.155 1.155 0 0 1-.529.917h-.004z"
            fill="#3B3B3B"
        />
        <path
            d="M582.49 868.05c.3-.17.537-.033.538.306a1.166 1.166 0 0 1-.533.919c-.294.17-.532.035-.536-.3a1.182 1.182 0 0 1 .531-.925z"
            fill="#747474"
        />
        <path
            d="M582.39 867.16a.623.623 0 0 0-.626.064 1.93 1.93 0 0 0-.881 1.524.617.617 0 0 0 .257.565l.735.428a.623.623 0 0 1-.258-.564 1.949 1.949 0 0 1 .88-1.528.627.627 0 0 1 .631-.06l-.738-.429z"
            fill="#4C4C4C"
        />
        <path
            d="M581.94 874.91a.62.62 0 0 0-.63-.059c-.061.033-.122.07-.181.107-.086.047-.172.1-.258.15s-.2.114-.3.168a.63.63 0 0 1 .63.062c.107.065.205.143.292.232l-.294.17a1.168 1.168 0 0 1 .53.92.375.375 0 0 1-.154.345l.494-.287c.008.049.012.098.014.148a.617.617 0 0 1-.26.565l.736-.43a.617.617 0 0 0 .258-.564 1.94 1.94 0 0 0-.877-1.527z"
            fill="#3B3B3B"
        />
        <path
            d="m580.83 875.7.734-.428a.376.376 0 0 0-.154.342 1.154 1.154 0 0 0 .529.922l-.734.428a1.147 1.147 0 0 1-.377-.397 1.142 1.142 0 0 1-.153-.525.372.372 0 0 1 .155-.342z"
            fill="#4C4C4C"
        />
        <path
            d="M581.21 875.33c-.489-.28-.886-.053-.886.505a1.934 1.934 0 0 0 .879 1.527c.487.282.887.055.889-.5a1.95 1.95 0 0 0-.882-1.532zm-.005 1.63a1.156 1.156 0 0 1-.53-.922c0-.337.239-.476.533-.306a1.168 1.168 0 0 1 .53.92c0 .339-.24.48-.533.308z"
            fill="#4C4C4C"
        />
        <path
            d="M581.21 875.73c-.294-.17-.533-.031-.533.306.008.185.06.365.153.525.092.161.221.297.377.397.293.172.533.031.533-.308a1.177 1.177 0 0 0-.53-.92z"
            fill="#7B7B7B"
        />
        <path
            d="M569.06 867.46a.627.627 0 0 0-.629-.062c-.061.037-.12.073-.184.109-.086.048-.17.1-.256.151s-.2.11-.294.169a.623.623 0 0 1 .627.06c.107.066.206.144.295.233l-.295.171a1.159 1.159 0 0 1 .531.92.375.375 0 0 1-.156.345l.494-.288a.89.89 0 0 1 .013.146.61.61 0 0 1-.26.566l.739-.428a.617.617 0 0 0 .256-.566 1.927 1.927 0 0 0-.881-1.526z"
            fill="#3B3B3B"
        />
        <path
            d="M568.32 867.89c-.487-.283-.882-.054-.882.506a1.948 1.948 0 0 0 .877 1.525c.488.283.885.055.887-.5a1.95 1.95 0 0 0-.882-1.531zm0 1.631a1.178 1.178 0 0 1-.531-.922c0-.339.238-.475.534-.3a1.167 1.167 0 0 1 .531.92c-.003.333-.244.471-.537.302h.003z"
            fill="#4C4C4C"
        />
        <path
            d="M568.32 868.29c-.3-.17-.534-.034-.534.3a1.17 1.17 0 0 0 .531.922c.293.169.534.031.534-.307a1.166 1.166 0 0 0-.531-.915z"
            fill="#7B7B7B"
        />
        <path
            d="m582.48 866.45-6.044 3.512v1.166l6.041-3.513a.436.436 0 0 0 .255-.354v-1.165a.437.437 0 0 1-.252.354z"
            fill="#303030"
        />
        <path
            d="M567.88 866.45a.44.44 0 0 1-.262-.361v1.167a.429.429 0 0 0 .26.359l6.084 3.513v-1.165l-6.082-3.513z"
            fill="#3E3E3E"
        />
        <path
            d="M582.48 865.73a1.366 1.366 0 0 0-1.243 0l-6.043 3.51.006.244 6.482-3.767a.399.399 0 0 1 .357 0c.1.057.1.152 0 .206l-6.482 3.766.881.27 6.044-3.512c.345-.197.34-.518-.002-.717z"
            fill="#414141"
        />
        <path
            d="M568.31 865.72a.403.403 0 0 1 .36 0l6.524 3.767-.006-.244-6.08-3.512a1.366 1.366 0 0 0-1.242 0c-.344.2-.34.52.006.717l6.08 3.513.888-.269-6.527-3.768a.107.107 0 0 1-.072-.101.108.108 0 0 1 .069-.103z"
            fill="#494949"
        />
        <path
            d="M582.04 865.72c.1.057.1.152 0 .206l-6.482 3.766 6.525 3.77c.021.007.04.021.054.039a.113.113 0 0 1 0 .128.112.112 0 0 1-.054.04.407.407 0 0 1-.355 0l-6.528-3.768-6.483 3.768a.405.405 0 0 1-.356 0c-.1-.055-.1-.146 0-.207l6.485-3.768-6.527-3.768a.12.12 0 0 1-.054-.04.11.11 0 0 1 0-.126.107.107 0 0 1 .054-.04.4.4 0 0 1 .36 0l6.524 3.767 6.482-3.767a.388.388 0 0 1 .355 0z"
            fill="#303030"
        />
        <path
            d="M582.52 874.19a1.362 1.362 0 0 1-1.24 0l-6.082-3.51v1.167l6.082 3.513a1.376 1.376 0 0 0 1.24 0 .448.448 0 0 0 .255-.361l.007-1.165a.448.448 0 0 1-.262.356z"
            fill="#3E3E3E"
        />
        <path
            d="m582.52 873.47-6.086-3.512-.881-.27 6.525 3.77a.103.103 0 0 1 .054.04.104.104 0 0 1 .021.063.105.105 0 0 1-.021.064.103.103 0 0 1-.054.04.404.404 0 0 1-.355 0l-6.528-3.768v.781l6.082 3.51a1.365 1.365 0 0 0 1.24 0 .378.378 0 0 0 .189-.579.379.379 0 0 0-.186-.139z"
            fill="#4C4C4C"
        />
        <path
            d="m575.2 869.9-6.483 3.768a.405.405 0 0 1-.356 0c-.1-.055-.1-.146 0-.207l6.485-3.768-.888.269-6.041 3.511a.38.38 0 0 0 0 .718 1.356 1.356 0 0 0 1.243 0l6.043-3.51-.003-.781z"
            fill="#4C4C4C"
        />
        <path
            d="M569.16 874.19a1.356 1.356 0 0 1-1.243 0 .429.429 0 0 1-.256-.359l-.005 1.166a.44.44 0 0 0 .26.363 1.365 1.365 0 0 0 1.24 0l6.043-3.51v-1.167l-6.039 3.507zM576.29 866.82a.534.534 0 0 0-.309-.439 1.692 1.692 0 0 0-1.542-.017.552.552 0 0 0-.331.451l-.009 3.046a.284.284 0 0 0 .01.065.308.308 0 0 0 .008.053c.009.024.02.047.034.068a.43.43 0 0 1 .022.049c.02.026.042.05.066.072a.373.373 0 0 1 .032.036.721.721 0 0 0 .139.1c.237.124.501.189.769.191.267.003.532-.058.772-.178a.993.993 0 0 0 .143-.1c.012-.013.021-.024.034-.036a.994.994 0 0 0 .068-.076c.01-.015.02-.03.028-.047.012-.023.024-.046.034-.071a.218.218 0 0 0 .011-.052.742.742 0 0 0 .012-.068c.003-.912.005-2.132.009-3.047z"
            fill="#303030"
        />
        <path
            d="M575.59 864.12a.861.861 0 0 0-.785-.008.303.303 0 0 0-.114.093.296.296 0 0 0-.053.137l-.005 2.277v.033a.065.065 0 0 1 .005.027l.016.034c0 .007 0 .017.014.025a.35.35 0 0 0 .029.036c.007.005.011.012.018.018.021.02.045.038.07.052.12.064.254.097.39.098.136.002.27-.03.391-.091a.469.469 0 0 0 .076-.049.086.086 0 0 1 .013-.014c.015-.018.028-.029.039-.042a.084.084 0 0 0 .013-.027.09.09 0 0 0 .017-.034c0-.008 0-.017.006-.026a.186.186 0 0 0 .006-.034v-1.141l.005-1.139a.272.272 0 0 0-.151-.225z"
            fill="#969696"
        />
        <path
            d="M581.12 845.62a2.274 2.274 0 0 1 1.054 2.15l-.217.931c-.1.448-.159 3.535-.161 4.058l-.015 4.872c0 .361-.258.51-.575.324l-6.746-3.893a1.257 1.257 0 0 1-.571-.989l.014-4.868c0-.524-.05-3.671-.151-4.242l-.217-1.179c-.154-.881.364-1.333 1.068-.929l6.517 3.765z"
            fill="#ADADAD"
        />
        <path
            d="m582.83 844.62-6.519-3.761a.767.767 0 0 0-.774-.078l-1.714 1a.78.78 0 0 1 .775.076l6.517 3.765a2.267 2.267 0 0 1 1.054 2.15l-.217.931c-.1.448-.159 3.535-.161 4.058l-.015 4.872a.396.396 0 0 1-.167.367l1.716-1a.397.397 0 0 0 .165-.366l.011-4.869c.006-.523.058-3.61.163-4.058l.22-.933a2.285 2.285 0 0 0-1.054-2.154z"
            fill="#969696"
        />
        <path
            d="m581.06 859.63-7.761-4.479a.635.635 0 0 0-.652-.064l-7.719 4.448a.642.642 0 0 1 .652.065l7.758 4.479a2.005 2.005 0 0 1 .914 1.58.651.651 0 0 1-.268.591c1.9-1.107 5.816-3.343 7.717-4.452a.624.624 0 0 0 .268-.584 2.006 2.006 0 0 0-.909-1.584z"
            fill="silver"
        />
        <path
            d="M573.34 864.08a2.014 2.014 0 0 1 .914 1.58c0 .584-.414.819-.922.525l-7.758-4.475a2.017 2.017 0 0 1-.912-1.584c0-.581.411-.815.92-.522l7.758 4.476z"
            fill="#ADADAD"
        />
        <path d="m573.51 843.03.649-.433v16.846l-.649.79V843.03z" fill="#894E0E" />
        <path
            d="m572.57 842.51.658-.435.929.518-.649.433-.938-.516z"
            fill="#995710"
        />
        <path d="M573.51 843.03v15.41l-.937-.68v-15.25l.937.52z" fill="#5F360A" />
        <path
            d="m564.53 861.59.688-.363v13.215l-.684.417-.004-13.269z"
            fill="#894E0E"
        />
        <path
            d="M564.3 865.6s1.956 2.3 2.482 2.73c.93.458 1.925.77 2.95.926.543.1 1.07.309 1.371-.364.409-.909-1.938-6.732-1.938-6.732l-4.865.292v3.148z"
            fill="#352F2F"
        />
        <path
            d="M562.02 877.69c.019-.015 1.367-1.739 1.638-2.108a2.773 2.773 0 0 0 .43-2.279l-1.792-7.719a2.985 2.985 0 0 1 .1-1.8c.084-.193.198-.37.338-.527l7.743-5.636 1.3.557c1.485 1.733.744 2.531.744 3.592 0 .056-4.179 3.025-5.2 3.777-.211.203-.361.46-.434.744.123.954.344 6.17.51 8l.06.842a1.625 1.625 0 0 1-.353 1 19.256 19.256 0 0 1-2.322 2.137 2.805 2.805 0 0 1-2.553.63.656.656 0 0 1-.5-.484.653.653 0 0 1 .222-.658l.069-.068z"
            fill="#E8C5AC"
        />
        <path
            d="m566.62 878.2-1.034-.452.712-.823h.577l-.255 1.275z"
            fill="#5B5454"
        />
        <path
            d="m567.52 876.78-.211 1.02s-.027.187-.44.328c-.1.034-.254.065-.254.065l-.095-1.158 1-.255z"
            fill="#7C7676"
        />
        <path
            d="M561.31 879.82a.779.779 0 0 1-.251-.953.71.71 0 0 1 .727-.472c-.247.324 2.215.889 1.184.691-.638-.122 1.325-.434 2.067-.852a7.79 7.79 0 0 0 1.393-1.285 3.207 3.207 0 0 0 1.074-1.863c.063.281.092.568.087.857 0 .779-.327.913-.327.913s-.041.273-.743.582c-.789.349-1.329 1.73-2.362 2.245a3.357 3.357 0 0 1-2.849.137z"
            fill="#7C7676"
        />
        <path
            d="M561.34 879.57c-.531-.326-.445-.77.4-1.619.035-.037.228-.215.228-.215-.247.323-.183.811.669.95a2.735 2.735 0 0 0 2.183-.649 9.294 9.294 0 0 0 1.859-1.626 3.085 3.085 0 0 0 .711-2.114 1.367 1.367 0 0 1 .473 1.37 3.518 3.518 0 0 1-.406 1.251l-1.15.537c-.766.364-.918 1.381-2.159 1.957a3.121 3.121 0 0 1-2.808.158z"
            fill="#B21B0B"
        />
        <path
            d="M565.22 879.47a220.63 220.63 0 0 0 1.7-2.3 3.204 3.204 0 0 0 .376-2.607l-1.8-7.2a2.812 2.812 0 0 1 .454-2.79l6.243-6.287s2.574-1.2 3.942.563c1.4 1.8 1.465 2.879.436 4.291-.032.044-5.174 3.4-6.266 4.044-.373.223-.254.733-.217.883.607 2.657.408 5.613.495 7.807l.01.13.065.913c-.004.36-.129.709-.353.991a18.99 18.99 0 0 1-2.325 2.139 2.79 2.79 0 0 1-2.549.632.65.65 0 0 1-.486-.844.652.652 0 0 1 .205-.298c.026-.026.045-.049.07-.067z"
            fill="#FFE1CC"
        />
        <path
            d="m569.82 879.98-1.036-.456.712-.82h.58l-.256 1.276z"
            fill="#5B5454"
        />
        <path
            d="m570.72 878.56-.211 1.024s-.027.184-.439.324c-.107.035-.256.069-.256.069l-.093-1.161.999-.256z"
            fill="#7C7676"
        />
        <path
            d="M564.51 881.59a.783.783 0 0 1-.252-.956.708.708 0 0 1 .727-.471c-.247.326 2.215.892 1.183.691-.639-.125 1.324-.432 2.068-.852a7.651 7.651 0 0 0 1.393-1.285 3.193 3.193 0 0 0 1.076-1.861c.062.281.091.568.086.856 0 .777-.327.913-.327.913s-.041.272-.743.582c-.789.348-1.328 1.728-2.362 2.245a3.362 3.362 0 0 1-2.849.138z"
            fill="#7C7676"
        />
        <path
            d="M564.55 881.35c-.535-.325-.448-.773.4-1.62.036-.035.231-.213.231-.213-.249.322-.187.81.667.952a2.762 2.762 0 0 0 2.183-.65 8.367 8.367 0 0 0 1.86-1.626 2.924 2.924 0 0 0 .706-2.185 1.542 1.542 0 0 1 .478 1.442 3.58 3.58 0 0 1-.409 1.249l-1.147.537c-.766.365-.918 1.378-2.16 1.958a3.109 3.109 0 0 1-2.809.156z"
            fill="#B21B0B"
        />
        <path
            d="M568.07 858.32c-.721.607-5.1 4.121-5.172 4.179-.952.786-.5 1.286-.5 1.286 0-.037.364-.767 1-.694 1.557.276 3.061.791 4.46 1.528 2.48 1.178 3.236 4.269 3.236 4.269.41-.396.784-.829 1.115-1.293.495-.618 5.936-2.175 6.271-5.836a18.608 18.608 0 0 0-.341-4.272s-1.693 2.409-5.753 1.472c-3.064-.7-3.2-2.072-3.2-2.072a3.058 3.058 0 0 1-1.116 1.433z"
            fill="#5B5353"
        />
        <path
            d="m564.63 852.63 6.345-7.221c.811-1.246 1.329-4.229-.265-4.2-1.035.018-3.106 2.589-4.284 3.919a74.414 74.414 0 0 0-4.769 6.026c-.882 1.4.863 1.922.727 2.008a1.82 1.82 0 0 0 2.246-.532z"
            fill="#911309"
        />
        <path
            d="m569.5 841.19-1.367 5.87a5.968 5.968 0 0 0-.186 1.82c.146.649.451 1.253.887 1.757a4.011 4.011 0 0 1 .629 3.007l-.3 3.525s-.19.954 2.344 1.908c5.581 2.108 6.85-.114 6.85-.114.09-.247.114-.512.071-.77-.163-.788-.3-1.309-.465-1.9l-.666-3a4.906 4.906 0 0 1-.209-1.334l.792-3.859s1.1-2.668.166-3.83a18.373 18.373 0 0 0-4.094-3.295 5.231 5.231 0 0 0-1.275-.387 5.142 5.142 0 0 0-3.177.602z"
            fill="#B21B0B"
        />
        <path
            d="M570.79 842.96c1.6 1.242 2.246-.329 3.039-1.538l-.288-4.218-3.324.655.573 5.101z"
            fill="#E8C5AC"
        />
        <path
            d="M573.72 840.09s.066.531.056.63c-.17 1.639-2.072 2.469-2.072 2.469-.234.151-.2.445-.123.828l.243 1.12c.07.366.26.313.39.145 0 0 1.376-1.419 1.755-1.887.889-1.1.786-1.329.293-2.573-.295-.753-.542-.732-.542-.732z"
            fill="#EDEDED"
        />
        <path
            d="M571.39 842.97c.177.191.253.344.156.507l-.732 1.074c-.311.417-.411.126-.442-.175l-.2-2.183c.008-1.376.365-1.472.365-1.472s.007.1.038.387c.077.689.361 1.338.815 1.862z"
            fill="#EDEDED"
        />
        <path
            d="M572.56 858.04s-.538.261-.428.523c.322.499.731.936 1.208 1.29a.52.52 0 0 0 .639.128c.183-.147.662-1.163.165-1.611s-1.411-.533-1.584-.33z"
            fill="#911309"
        />
        <path
            d="M567 842.07s1.147-.435.837-2.2a7.687 7.687 0 0 0-.466-1.67c-1.32-3.741.447-5.686 2.2-6.688a5.636 5.636 0 0 1 4.637.007c.984.584.085 1.577-.807 3.177a10.176 10.176 0 0 0-1.191 5.021c.476 2.37-4.101 3.345-5.21 2.353z"
            fill="#562D07"
        />
        <path
            d="M569.55 834.36c-2.173.538-1.769 2.357-1.528 3.572.169.851.666 2.4.666 2.4.591 1.508 1.341 2.287 2.232 2.368 1.114.1 2.356-.925 3.216-2.574.47-.744.713-1.608.7-2.488l-.352-4.858s-3.78 1.297-4.934 1.58z"
            fill="#FFE1CC"
        />
        <path
            d="M567.16 834.33c.293-1.382 2.953-3.472 5.277-3.316a4.92 4.92 0 0 1 1.965.617c1.913 1.088 2.336 3.133 2.028 5.547-.216 1.7.342 2.228 1.04 2.709a6.847 6.847 0 0 1-1.565 2.058 8.292 8.292 0 0 1-3.282 1.8 6.9 6.9 0 0 0 .372-3.653c-.25-1.8-.528-2.478-.713-2.51s-.558 0-1.114-.061a2.738 2.738 0 0 1-.343-.866c-.182-.735-.2-.814-.2-.822-.078.32-.088.653-.029.978.013.259.05.517.109.771a4.981 4.981 0 0 1-1.678-.183 3.574 3.574 0 0 1-.212-.806 2.746 2.746 0 0 1-.016-.462c-.07.214-.111.437-.123.662-.011.221-.014.436-.016.568a2.56 2.56 0 0 1-1.424-.55c-.294-.302-.374-1.088-.076-2.481z"
            fill="#562D07"
        />
        <path
            d="m489.52 827.97.817-.472v.572a.907.907 0 0 0 .407.709l.5.287-.815.475-.5-.291a.901.901 0 0 1-.407-.706l-.002-.574z"
            fill="#323232"
        />
        <path
            d="M488.9 827.61v.827a1.802 1.802 0 0 0 .818 1.417l.716.413v-.724l-.5-.291a.895.895 0 0 1-.407-.706v-.574l-.627-.362z"
            fill="#232323"
        />
        <path
            d="M497.3 848.04a1.97 1.97 0 0 0 .9 1.553c.5.287.9.055.9-.516a1.973 1.973 0 0 0-.9-1.554c-.494-.289-.9-.057-.9.517zm.355.2c0-.346.245-.487.547-.311a1.197 1.197 0 0 1 .542.939c0 .346-.247.483-.545.311a1.193 1.193 0 0 1-.544-.935v-.004z"
            fill="#3B3B3B"
        />
        <path
            d="M498.2 847.93c-.3-.176-.547-.035-.547.311a1.189 1.189 0 0 0 .544.939c.3.172.545.035.545-.311a1.187 1.187 0 0 0-.542-.939z"
            fill="#747474"
        />
        <path
            d="M498.31 847.02a.622.622 0 0 1 .639.064 1.96 1.96 0 0 1 .9 1.553.643.643 0 0 1-.262.581l-.748.435a.64.64 0 0 0 .261-.58 1.971 1.971 0 0 0-.9-1.554.645.645 0 0 0-.639-.065l.749-.434z"
            fill="#4C4C4C"
        />
        <path
            d="M484.16 840.44a1.984 1.984 0 0 0 .9 1.555c.5.287.9.056.9-.514a1.974 1.974 0 0 0-.9-1.554c-.494-.289-.9-.061-.9.513zm.354.206c0-.346.249-.486.548-.313a1.191 1.191 0 0 1 .541.941c0 .346-.244.487-.544.311a1.21 1.21 0 0 1-.385-.404 1.22 1.22 0 0 1-.16-.535z"
            fill="#3B3B3B"
        />
        <path
            d="M485.06 840.34c-.3-.173-.547-.033-.548.313a1.194 1.194 0 0 0 .545.939c.3.176.544.035.544-.311a1.196 1.196 0 0 0-.541-.941z"
            fill="#747474"
        />
        <path
            d="M485.17 839.43a.632.632 0 0 1 .641.058 1.982 1.982 0 0 1 .9 1.557.645.645 0 0 1-.262.578l-.75.434a.624.624 0 0 0 .261-.575 1.97 1.97 0 0 0-.9-1.554.621.621 0 0 0-.64-.066l.75-.432z"
            fill="#4C4C4C"
        />
        <path
            d="M485.62 847.33a.621.621 0 0 1 .641-.062c.063.035.126.072.189.109l.26.15c.1.061.2.119.3.176a.635.635 0 0 0-.643.063c-.109.066-.21.146-.3.237l.3.174a1.185 1.185 0 0 0-.543.937.384.384 0 0 0 .16.353l-.5-.295c-.008.049-.013.1-.014.15a.62.62 0 0 0 .263.577l-.749-.432a.635.635 0 0 1-.263-.581 1.985 1.985 0 0 1 .899-1.556z"
            fill="#3B3B3B"
        />
        <path
            d="m486.76 848.14-.749-.435a.383.383 0 0 1 .159.348c-.01.189-.064.372-.159.535a1.191 1.191 0 0 1-.383.406l.748.437a1.2 1.2 0 0 0 .545-.943.385.385 0 0 0-.161-.348z"
            fill="#4C4C4C"
        />
        <path
            d="M485.48 849.32c0 .571.408.8.9.514a1.967 1.967 0 0 0 .9-1.554c0-.572-.408-.8-.9-.516a1.98 1.98 0 0 0-.9 1.556zm.358-.208a1.183 1.183 0 0 1 .543-.937c.3-.174.546-.034.547.309a1.198 1.198 0 0 1-.545.943c-.3.171-.545.034-.545-.315z"
            fill="#4C4C4C"
        />
        <path
            d="M486.38 848.18c.3-.174.546-.034.547.309a1.2 1.2 0 0 1-.545.943c-.3.171-.545.034-.545-.315a1.185 1.185 0 0 1 .543-.937z"
            fill="#7B7B7B"
        />
        <path
            d="M498.77 839.74a.64.64 0 0 1 .64-.062l.188.109c.087.05.177.1.263.152s.2.117.3.174a.64.64 0 0 0-.64.065 1.347 1.347 0 0 0-.3.236l.3.173a1.194 1.194 0 0 0-.545.939.388.388 0 0 0 .158.351l-.5-.293c-.007.05-.012.1-.014.15a.63.63 0 0 0 .263.576l-.749-.435a.643.643 0 0 1-.263-.578 1.988 1.988 0 0 1 .899-1.557z"
            fill="#3B3B3B"
        />
        <path
            d="M498.62 841.74c0 .569.407.8.907.514.262-.17.48-.4.637-.67.156-.271.246-.575.263-.887 0-.57-.406-.8-.9-.513a1.982 1.982 0 0 0-.642.668 1.986 1.986 0 0 0-.265.888zm.359-.208a1.19 1.19 0 0 1 .545-.939c.3-.172.541-.034.541.31a1.191 1.191 0 0 1-.54.941c-.3.174-.543.033-.546-.312z"
            fill="#4C4C4C"
        />
        <path
            d="M499.52 840.59c.3-.172.541-.034.541.31a1.2 1.2 0 0 1-.54.941c-.3.174-.543.033-.546-.312a1.189 1.189 0 0 1 .545-.939z"
            fill="#7B7B7B"
        />
        <path
            d="m485.08 838.71 6.165 3.581v1.191l-6.159-3.582a.432.432 0 0 1-.261-.362v-1.191a.447.447 0 0 0 .255.363z"
            fill="#303030"
        />
        <path
            d="M499.97 838.71a.45.45 0 0 0 .264-.369l.005 1.189a.442.442 0 0 1-.265.37l-6.207 3.582v-1.19l6.203-3.582z"
            fill="#3E3E3E"
        />
        <path
            d="M485.08 837.97a1.374 1.374 0 0 1 1.264 0l6.163 3.579-.006.252-6.61-3.844c-.056-.029-.118-.043-.181-.043s-.125.014-.181.043c-.1.059-.1.153 0 .211l6.613 3.842-.9.272-6.169-3.579a.387.387 0 0 1-.186-.595.39.39 0 0 1 .193-.138z"
            fill="#414141"
        />
        <path
            d="M499.52 837.96a.41.41 0 0 0-.363 0l-6.657 3.844.006-.252 6.2-3.581a1.382 1.382 0 0 1 1.268 0 .386.386 0 0 1-.005.731l-6.2 3.582-.9-.273 6.656-3.842a.113.113 0 0 0 .048-.169.105.105 0 0 0-.053-.04z"
            fill="#494949"
        />
        <path
            d="M485.53 837.96c-.1.059-.1.153 0 .211l6.613 3.842-6.656 3.844a.11.11 0 0 0-.054.041.11.11 0 0 0 .054.169.383.383 0 0 0 .363 0l6.652-3.844 6.612 3.843a.394.394 0 0 0 .367 0 .113.113 0 0 0 .073-.105.113.113 0 0 0-.073-.105l-6.612-3.844 6.656-3.842a.11.11 0 0 0 .074-.105.11.11 0 0 0-.074-.106.405.405 0 0 0-.363 0l-6.657 3.844-6.61-3.844a.397.397 0 0 0-.365.001z"
            fill="#303030"
        />
        <path
            d="M485.03 846.6a1.412 1.412 0 0 0 1.268 0l6.2-3.58v1.185l-6.2 3.587a1.405 1.405 0 0 1-1.268 0 .461.461 0 0 1-.259-.368v-1.189a.456.456 0 0 0 .259.365z"
            fill="#3E3E3E"
        />
        <path
            d="m485.04 845.87 6.205-3.583.9-.272-6.656 3.844c-.022.007-.041.021-.054.04s-.021.042-.021.065a.114.114 0 0 0 .075.105.394.394 0 0 0 .363 0l6.652-3.844v.8l-6.2 3.58a1.406 1.406 0 0 1-1.268 0 .387.387 0 0 1 .004-.735z"
            fill="#4C4C4C"
        />
        <path
            d="m492.5 842.22 6.612 3.843a.406.406 0 0 0 .367 0 .113.113 0 0 0 .053-.169.113.113 0 0 0-.053-.041l-6.612-3.844.9.273 6.162 3.582a.385.385 0 0 1 0 .733 1.405 1.405 0 0 1-1.266 0l-6.163-3.58v-.797z"
            fill="#4C4C4C"
        />
        <path
            d="M498.66 846.6a1.405 1.405 0 0 0 1.266 0 .448.448 0 0 0 .261-.368l.006 1.188a.449.449 0 0 1-.264.372 1.411 1.411 0 0 1-1.267 0l-6.163-3.587v-1.185l6.161 3.58zM491.4 839.08a.546.546 0 0 1 .313-.45 1.73 1.73 0 0 1 1.574-.018.565.565 0 0 1 .339.462l.006 3.108c-.001.022-.004.044-.007.066l-.01.051a.399.399 0 0 1-.035.072.956.956 0 0 1-.023.045.821.821 0 0 1-.067.077 1.288 1.288 0 0 1-.033.038 1.21 1.21 0 0 1-.138.1 1.74 1.74 0 0 1-1.576.016 1.13 1.13 0 0 1-.145-.1c-.014-.012-.02-.026-.032-.037a.641.641 0 0 1-.071-.077.231.231 0 0 1-.028-.048c-.012-.024-.027-.047-.039-.073a.347.347 0 0 1-.008-.055.276.276 0 0 1-.011-.069c-.009-.932-.009-2.174-.009-3.108z"
            fill="#303030"
        />
        <path
            d="M492.09 836.33a.883.883 0 0 1 .8-.008.285.285 0 0 1 .174.234l.007 2.322a.097.097 0 0 1-.006.034v.027a.111.111 0 0 1-.018.034l-.011.026a.156.156 0 0 1-.033.035l-.011.015a.493.493 0 0 1-.078.058.879.879 0 0 1-.8.008.9.9 0 0 1-.074-.052.077.077 0 0 0-.018-.018.247.247 0 0 1-.035-.037.16.16 0 0 1-.015-.029l-.017-.032c0-.008 0-.017-.007-.028s0-.025-.005-.035c0-.347 0-.755-.006-1.161v-1.163a.284.284 0 0 1 .153-.23z"
            fill="#969696"
        />
        <path
            d="m495.21 824.28-.581-.339-2.745 1.6.581.336 2.745-1.597z"
            fill="#313131"
        />
        <path
            d="m494.43 824.82 1.2-5.388.581.34 2.55 1.473v.673l-2.682-1.546-1.07 4.788-.579-.34z"
            fill="#313131"
        />
        <path
            d="m491.88 826.31.581.34v-.775l-.581-.338v.773zM499.47 820.84v.674l-.7.4v-.673l.7-.401z"
            fill="#464646"
        />
        <path
            d="m499.47 820.84-.7.405-3.131-1.812.7-.405 3.131 1.812z"
            fill="#363636"
        />
        <path
            d="m495.21 824.27.873-3.9.516.3-.918 4.1-3.216 1.86v-.767l2.745-1.593z"
            fill="#464646"
        />
        <path
            d="M486.84 828.68a.2.2 0 0 1 .071.079.2.2 0 0 1 .018.105v1.376l-1.746-1.015-.006-1.374a.207.207 0 0 0-.016-.104.206.206 0 0 0-.067-.082l1.746 1.015z"
            fill="#818182"
        />
        <path
            d="M486.47 816.26a2.32 2.32 0 0 0-1.074 2.193l.221.949c.107.459.162 3.607.164 4.141l.014 4.968c0 .371.265.519.588.331l.251-.145c.161-.094.295-.018.295.165v1.376l5.646-3.259a.286.286 0 0 0 .145-.248l-.005-1.211a.652.652 0 0 1 .292-.5l.254-.147a1.283 1.283 0 0 0 .584-1.009l-.016-4.965c0-.534.05-3.743.154-4.325l.218-1.2c.161-.893-.368-1.355-1.089-.943l-6.642 3.829z"
            fill="#ADADAD"
        />
        <path
            d="m484.72 815.24 6.647-3.838a.784.784 0 0 1 .788-.077l1.749 1.016a.796.796 0 0 0-.408-.07.795.795 0 0 0-.386.147l-6.644 3.838a2.321 2.321 0 0 0-1.074 2.193l.221.949c.107.459.162 3.607.164 4.141l.014 4.968a.406.406 0 0 0 .17.372l-1.746-1.017a.394.394 0 0 1-.171-.373l-.015-4.966c0-.534-.056-3.681-.163-4.138l-.223-.953a2.316 2.316 0 0 1 1.077-2.192z"
            fill="#969696"
        />
        <path
            d="m488.8 811.55-.484-.281v2.769l.485.28-.001-2.768z"
            fill="#3B3B3B"
        />
        <path d="M488.8 811.55v2.768l.727-.419v-2.769l-.727.42z" fill="#292929" />
        <path
            d="m486.53 831.75 7.911-4.567a.655.655 0 0 1 .664-.066l7.873 4.536a.656.656 0 0 0-.665.066l-7.913 4.568a2.048 2.048 0 0 0-.929 1.615.652.652 0 0 0 .271.6c-1.94-1.128-5.931-3.406-7.871-4.537a.648.648 0 0 1-.273-.6 2.05 2.05 0 0 1 .932-1.615z"
            fill="silver"
        />
        <path
            d="M494.4 836.29a2.051 2.051 0 0 0-.929 1.615c0 .591.42.83.934.533l7.915-4.569a2.042 2.042 0 0 0 .931-1.614c0-.593-.421-.831-.938-.533l-7.913 4.568z"
            fill="#ADADAD"
        />
        <path
            d="m485.94 809.25 4.468-2.579a.41.41 0 0 1 .417-.042l1.163.679a.417.417 0 0 0-.415.039l-4.466 2.581a1.287 1.287 0 0 0-.582 1.008l.006 1.946a.42.42 0 0 0 .167.375l-1.163-.678a.418.418 0 0 1-.17-.375l-.006-1.945a1.296 1.296 0 0 1 .581-1.009z"
            fill="#969696"
        />
        <path
            d="M487.1 809.93a1.289 1.289 0 0 0-.582 1.008l.006 1.946c0 .369.262.522.586.333l4.465-2.58a1.27 1.27 0 0 0 .582-1.009v-1.944c0-.371-.263-.523-.587-.335l-4.47 2.581z"
            fill="#ADADAD"
        />
        <path
            d="m486.4 829.16-.583-.342-3 1.732.582.338 3.001-1.728z"
            fill="#313131"
        />
        <path
            d="m482.66 827.58.989 3.173 2.753-1.587v.763l-3.22 1.857-1.2-3.82.678-.386z"
            fill="#3B3B3B"
        />
        <path d="M485.24 829.03v.674l-.7.4v-.672l.7-.402z" fill="#3B3B3B" />
        <path
            d="m482 827.96 2.551 1.473v.672l-2.289-1.321.936 3-.582-.336-1.2-3.824.584.336z"
            fill="#2C2C2C"
        />
        <path
            d="m485.24 829.03-.7.406-3.133-1.812.7-.406 3.133 1.812z"
            fill="#363636"
        />
        <path
            d="m481.9 826.75 1.107-.642a.47.47 0 0 1 .229-.085.475.475 0 0 1 .241.037l5.823 3.388a.468.468 0 0 0-.465.046l-1.11.641a1.435 1.435 0 0 0-.655 1.133.456.456 0 0 0 .193.421l-5.826-3.384a.459.459 0 0 1-.191-.422 1.439 1.439 0 0 1 .654-1.133z"
            fill="#C6C6C6"
        />
        <path
            d="M487.72 830.13a1.432 1.432 0 0 0-.655 1.133c0 .416.3.585.66.377l1.11-.642a1.438 1.438 0 0 0 .652-1.136c0-.415-.3-.584-.657-.373l-1.11.641z"
            fill="#ADADAD"
        />
        <path
            d="m495.42 818.16 1.112-.644a.466.466 0 0 1 .466-.045l5.825 3.385a.461.461 0 0 0-.467.047l-1.109.641a1.439 1.439 0 0 0-.656 1.131.454.454 0 0 0 .193.423l-5.826-3.387a.464.464 0 0 1-.153-.184.467.467 0 0 1-.038-.236 1.448 1.448 0 0 1 .653-1.131z"
            fill="#C6C6C6"
        />
        <path
            d="M501.25 821.54a1.432 1.432 0 0 0-.656 1.131c0 .419.3.588.658.379l1.111-.644a1.444 1.444 0 0 0 .654-1.133c0-.416-.3-.583-.658-.374l-1.109.641z"
            fill="#ADADAD"
        />
        <path
            d="m603.7 874.59-.8-.468v.563a.893.893 0 0 1-.4.694l-.489.283.8.465.488-.282a.892.892 0 0 0 .4-.7l.001-.555z"
            fill="#323232"
        />
        <path
            d="M604.31 874.23v.81a1.767 1.767 0 0 1-.799 1.391l-.701.406v-.711l.489-.282a.89.89 0 0 0 .4-.7v-.56l.611-.354z"
            fill="#232323"
        />
        <path
            d="M595.18 893.76a1.927 1.927 0 0 0-.881 1.523c0 .563.4.787.886.506a1.946 1.946 0 0 0 .879-1.524c0-.562-.397-.788-.884-.505zm.005 1.626c-.3.17-.536.035-.536-.3a1.162 1.162 0 0 1 .533-.923c.291-.168.534-.034.534.306a1.187 1.187 0 0 1-.156.522 1.19 1.19 0 0 1-.375.395z"
            fill="#3B3B3B"
        />
        <path
            d="M595.18 894.16c.291-.168.534-.034.534.306a1.177 1.177 0 0 1-.531.92c-.3.17-.536.035-.536-.3a1.165 1.165 0 0 1 .533-.926z"
            fill="#747474"
        />
        <path
            d="M595.07 893.27a.628.628 0 0 0-.629.062 1.945 1.945 0 0 0-.878 1.526.62.62 0 0 0 .052.318.62.62 0 0 0 .207.247l.735.427a.615.615 0 0 1-.258-.567 1.937 1.937 0 0 1 .881-1.523.613.613 0 0 1 .627-.063l-.737-.427z"
            fill="#4C4C4C"
        />
        <path
            d="M608.07 886.31a1.949 1.949 0 0 0-.88 1.527c0 .56.4.785.887.5a1.936 1.936 0 0 0 .88-1.522c-.004-.56-.401-.785-.887-.505zm.005 1.629c-.3.168-.533.033-.535-.3a1.172 1.172 0 0 1 .53-.921c.3-.17.534-.037.538.3a1.183 1.183 0 0 1-.533.921z"
            fill="#3B3B3B"
        />
        <path
            d="M608.07 886.72c.3-.17.534-.037.538.3a1.193 1.193 0 0 1-.533.921c-.3.168-.533.033-.535-.3a1.167 1.167 0 0 1 .53-.921z"
            fill="#747474"
        />
        <path
            d="M607.96 885.82a.617.617 0 0 0-.628.062 1.941 1.941 0 0 0-.881 1.526.628.628 0 0 0 .258.566l.735.427a.618.618 0 0 1-.257-.565 1.941 1.941 0 0 1 .88-1.527.608.608 0 0 1 .306-.116.606.606 0 0 1 .322.056l-.735-.429z"
            fill="#4C4C4C"
        />
        <path
            d="M607.51 893.57a.623.623 0 0 0-.627-.062l-.184.108-.257.15-.294.169a.63.63 0 0 1 .629.061c.107.066.205.144.293.232l-.3.172a1.174 1.174 0 0 1 .534.92.372.372 0 0 1-.157.342l.494-.286c.006.049.009.097.009.146a.614.614 0 0 1-.255.568l.735-.43a.602.602 0 0 0 .256-.564 1.931 1.931 0 0 0-.876-1.526z"
            fill="#3B3B3B"
        />
        <path
            d="m606.4 894.37.733-.428a.38.38 0 0 0-.153.341 1.182 1.182 0 0 0 .53.924l-.735.427a1.172 1.172 0 0 1-.529-.922.375.375 0 0 1 .154-.342z"
            fill="#4C4C4C"
        />
        <path
            d="M606.78 894c-.488-.282-.885-.053-.886.507a1.946 1.946 0 0 0 .878 1.524c.492.283.886.058.886-.505a1.926 1.926 0 0 0-.878-1.526zm-.006 1.631a1.178 1.178 0 0 1-.529-.921c0-.34.239-.476.533-.306a1.174 1.174 0 0 1 .534.92c0 .337-.242.475-.538.307z"
            fill="#4C4C4C"
        />
        <path
            d="M606.78 894.4c-.294-.17-.533-.034-.533.306a1.163 1.163 0 0 0 .529.921c.3.168.538.03.538-.307a1.17 1.17 0 0 0-.534-.92z"
            fill="#7B7B7B"
        />
        <path
            d="M594.63 886.13a.612.612 0 0 0-.626-.06c-.062.037-.125.071-.185.106l-.258.148-.293.174a.626.626 0 0 1 .629.059c.107.064.205.142.293.231l-.3.173a1.19 1.19 0 0 1 .533.92.374.374 0 0 1-.156.342l.492-.286c.008.049.012.097.014.146a.636.636 0 0 1-.053.319.628.628 0 0 1-.206.248l.735-.429a.62.62 0 0 0 .259-.565 1.952 1.952 0 0 0-.878-1.526z"
            fill="#3B3B3B"
        />
        <path
            d="M593.9 886.56c-.49-.283-.887-.054-.889.5a1.955 1.955 0 0 0 .881 1.527c.489.28.885.056.889-.505a1.952 1.952 0 0 0-.881-1.522zm-.006 1.629a1.183 1.183 0 0 1-.534-.92c0-.34.242-.475.538-.3a1.18 1.18 0 0 1 .533.92c-.001.334-.245.471-.538.3h.001z"
            fill="#4C4C4C"
        />
        <path
            d="M593.9 886.96c-.3-.17-.534-.035-.538.3a1.18 1.18 0 0 0 .534.92c.293.171.537.034.537-.3a1.174 1.174 0 0 0-.533-.92z"
            fill="#7B7B7B"
        />
        <path
            d="m608.05 885.11-6.039 3.511v1.165l6.04-3.511a.43.43 0 0 0 .256-.356v-1.166a.428.428 0 0 1-.257.357z"
            fill="#303030"
        />
        <path
            d="M593.44 885.11a.44.44 0 0 1-.26-.362v1.164a.432.432 0 0 0 .258.363l6.083 3.512v-1.166l-6.081-3.511z"
            fill="#3E3E3E"
        />
        <path
            d="M608.04 884.4a1.365 1.365 0 0 0-1.24 0l-6.043 3.51.005.244 6.484-3.766a.375.375 0 0 1 .352 0c.1.058.1.152 0 .206l-6.48 3.768.885.268 6.039-3.511a.381.381 0 0 0 .186-.582.379.379 0 0 0-.188-.137z"
            fill="#414141"
        />
        <path
            d="M593.88 884.38a.392.392 0 0 1 .356 0l6.527 3.766-.005-.243-6.082-3.512a1.385 1.385 0 0 0-1.242 0 .38.38 0 0 0 0 .719l6.083 3.511.886-.268-6.526-3.768c-.096-.053-.096-.147.003-.205z"
            fill="#494949"
        />
        <path
            d="M607.6 884.38c.1.058.1.152 0 .206l-6.48 3.768 6.527 3.768c.021.007.04.021.054.039a.113.113 0 0 1 0 .128.126.126 0 0 1-.054.04.399.399 0 0 1-.357 0l-6.524-3.769-6.484 3.769a.399.399 0 0 1-.357 0 .123.123 0 0 1-.055-.04.113.113 0 0 1 0-.128.114.114 0 0 1 .055-.039l6.482-3.768-6.526-3.768c-.1-.054-.1-.148 0-.206a.386.386 0 0 1 .356 0l6.527 3.766 6.484-3.766a.381.381 0 0 1 .352 0z"
            fill="#303030"
        />
        <path
            d="M608.1 892.86a1.386 1.386 0 0 1-1.243 0l-6.082-3.511v1.167l6.08 3.509a1.377 1.377 0 0 0 1.243 0 .437.437 0 0 0 .256-.36v-1.163a.45.45 0 0 1-.254.358z"
            fill="#3E3E3E"
        />
        <path
            d="m608.09 892.14-6.082-3.513-.885-.268 6.527 3.768a.116.116 0 0 1 .055.04.113.113 0 0 1 0 .128.114.114 0 0 1-.055.039.387.387 0 0 1-.357 0l-6.524-3.769v.783l6.082 3.511a1.374 1.374 0 0 0 1.243 0 .371.371 0 0 0 .184-.14.377.377 0 0 0-.002-.44.379.379 0 0 0-.186-.139z"
            fill="#4C4C4C"
        />
        <path
            d="m600.77 888.56-6.484 3.769a.387.387 0 0 1-.357 0 .116.116 0 0 1-.054-.039.113.113 0 0 1 0-.128.118.118 0 0 1 .054-.04l6.482-3.768-.886.268-6.042 3.513a.382.382 0 0 0 0 .719 1.373 1.373 0 0 0 1.242 0l6.041-3.511.004-.783z"
            fill="#4C4C4C"
        />
        <path
            d="M594.73 892.86a1.378 1.378 0 0 1-1.242 0 .444.444 0 0 1-.258-.36v1.163a.433.433 0 0 0 .258.362 1.378 1.378 0 0 0 1.242 0l6.043-3.508v-1.167l-6.043 3.51zM601.86 885.48a.53.53 0 0 0-.308-.441 1.71 1.71 0 0 0-1.545-.019.555.555 0 0 0-.33.452l-.01 3.048c0 .021.01.042.011.064s0 .033.01.053a.365.365 0 0 0 .035.068.267.267 0 0 0 .02.046c.021.026.044.05.067.074.01.013.02.025.032.036a.678.678 0 0 0 .137.1c.238.123.501.189.769.192.268.002.533-.059.773-.178a.95.95 0 0 0 .144-.1.38.38 0 0 0 .033-.037.687.687 0 0 0 .069-.074.33.33 0 0 0 .026-.049.773.773 0 0 0 .037-.069.208.208 0 0 0 .011-.054.295.295 0 0 0 .011-.065v-.006c.002-.91.007-2.128.008-3.041z"
            fill="#303030"
        />
        <path
            d="M601.16 882.79a.842.842 0 0 0-.39-.099.874.874 0 0 0-.393.09.29.29 0 0 0-.172.228l-.005 2.279.005.032a.103.103 0 0 1 .005.024c0 .014.011.025.016.036s.008.015.014.024a.09.09 0 0 0 .03.034.223.223 0 0 0 .019.024.463.463 0 0 0 .068.048.863.863 0 0 0 .785.01.53.53 0 0 0 .073-.051l.017-.02a.182.182 0 0 0 .034-.034.285.285 0 0 1 .016-.03l.021-.031a.113.113 0 0 1 0-.026.193.193 0 0 0 0-.034c0-.339.005-.737.007-1.138v-1.137a.27.27 0 0 0-.15-.229z"
            fill="#969696"
        />
        <path
            d="M606.69 864.28a2.297 2.297 0 0 1 1.058 2.152l-.223.932c-.106.447-.161 3.535-.161 4.059l-.011 4.869c0 .363-.26.509-.577.327l-6.746-3.9a1.236 1.236 0 0 1-.57-.988l.014-4.867c0-.525-.051-3.673-.156-4.243l-.211-1.182c-.158-.878.364-1.33 1.064-.926l6.519 3.767z"
            fill="#ADADAD"
        />
        <path
            d="m608.4 863.29-6.519-3.762a.774.774 0 0 0-.775-.078l-1.71 1a.76.76 0 0 1 .773.074l6.519 3.762a2.302 2.302 0 0 1 1.058 2.152l-.223.932c-.106.447-.161 3.535-.161 4.059l-.011 4.869a.397.397 0 0 1-.17.365l1.715-.994a.4.4 0 0 0 .166-.367l.013-4.867c0-.525.058-3.612.164-4.061l.217-.932a2.281 2.281 0 0 0-1.056-2.152z"
            fill="#969696"
        />
        <path
            d="m606.63 878.3-7.759-4.481a.643.643 0 0 0-.652-.062l-7.722 4.445a.64.64 0 0 1 .655.067l7.756 4.48a1.993 1.993 0 0 1 .911 1.58.637.637 0 0 1-.263.586c1.9-1.1 5.815-3.339 7.719-4.446a.643.643 0 0 0 .268-.588 2.008 2.008 0 0 0-.913-1.581z"
            fill="silver"
        />
        <path
            d="M598.9 882.74a2.002 2.002 0 0 1 .911 1.58c0 .583-.412.817-.917.525l-7.756-4.48a2.01 2.01 0 0 1-.914-1.582c0-.583.413-.816.92-.523l7.756 4.48z"
            fill="#ADADAD"
        />
        <path
            d="M590.92 867.73c.911-1.012 3.493-3.987 3.493-3.987s2.616-4.648 1.3-5.328c-1.3-.672-2.107-.4-3.72 2.105-.377.589-3.762 4.97-4.21 5.463a3.829 3.829 0 0 0-.716 2.642s.989 2.284 3.853-.895z"
            fill="#3A566D"
        />
        <path
            d="m600.1 860.2 1.19-.692-.04 16.241-1.191.694.041-16.243z"
            fill="#894E0E"
        />
        <path
            d="m598.68 859.38 1.193-.691 1.42.821-1.192.692-1.421-.822z"
            fill="#995710"
        />
        <path
            d="m600.1 860.2-.038 16.243-1.421-.823.038-16.242 1.421.822z"
            fill="#5F360A"
        />
        <path
            d="m596.8 874.56 1.586-.924 1.423.82-1.585.924-1.424-.82z"
            fill="#995710"
        />
        <path
            d="m590.62 879.8 1.591-.922-.042 13.99-1.588.923.039-13.991z"
            fill="#894E0E"
        />
        <path
            d="m589.19 878.98 1.588-.924 1.424.821-1.591.922-1.421-.819z"
            fill="#995710"
        />
        <path
            d="m590.62 879.8-.039 13.991-1.421-.822.039-13.988 1.421.819z"
            fill="#5F360A"
        />
        <path
            d="m589.15 890.61-.828.706s-3.8 1.845-4.053 1.937a.63.63 0 0 0-.425.56.457.457 0 0 0 .083.3 2.01 2.01 0 0 0 1.3.639 13.845 13.845 0 0 0 3.495-.247c.262-.124 1.822-.392 1.947-.489 0 0 .482-.016.581.185.01.157-.002.315-.037.469l1.448-.559c.133-.329.22-.676.258-1.029l.256-2.031-4.025-.441z"
            fill="#545454"
        />
        <path
            d="M583.92 893.94c.354.389.837.638 1.36.7a8.733 8.733 0 0 0 3.941-.568 5.206 5.206 0 0 1 1.567-.3s.495.05.477.426c0 .075.031.02.018.107a.213.213 0 0 0-.012-.1c-.1-.2-.5.079-.5.079-.164-.181-.044-.376-1.21-.02a10.719 10.719 0 0 1-3.987.76 2.56 2.56 0 0 1-1.663-.828.506.506 0 0 1-.051-.424c.017.057.037.113.06.168z"
            fill="#282827"
        />
        <path
            d="m591.27 894.11 1.569-.6a5.445 5.445 0 0 1-.159.589l-1.451.559c.008-.038.035-.417.041-.548zM602.3 871.14l-5.656 1.648-7.935 5.549s-1.653.857-1.374 3.824c.242 2.544.45 9.336.45 9.336.007.619.281.816.78 1.083 3.07 1.622 4.64.339 4.64.339.245-.141.224-.307.245-.52l-.157-10.128 5.855-3.215s2.812-1.268 2.989-3.411c.075-.882.163-4.505.163-4.505z"
            fill="#282827"
        />
        <path
            d="m591.82 893.27-2.516 2.112s-1.272 1.021-1.739 1.292a.85.85 0 0 0-.373.66.6.6 0 0 0 .149.459c.401.34.884.572 1.4.671a4.559 4.559 0 0 0 2.978-.581c.245-.158 1.915-1.233 2.039-1.334.347-.277.664-.387.784-.2 0 0-.013.456-.013.524l1.4-.963c.048-.274.078-.551.09-.829v-2.042l-4.199.231z"
            fill="#282827"
        />
        <path
            d="m591.82 892.97-2.516 2.114s-1.272 1.02-1.739 1.292a.845.845 0 0 0-.373.66.622.622 0 0 0 .149.461c.401.34.884.57 1.4.669a4.565 4.565 0 0 0 2.978-.582c.245-.154 1.915-1.232 2.039-1.332.347-.279.664-.386.784-.2 0 0-.013.459-.013.527l1.4-.964a6.36 6.36 0 0 0 .09-.826v-2.049l-4.199.23z"
            fill="#545454"
        />
        <path
            d="m604.53 873.26-5.224 1.607-7.641 5.436s-1.673.659-1.524 3.645c.092 1.853.227 1.964.476 9.644.008.617.425.929.927 1.2 3.066 1.618 4.322.21 4.322.21.248-.138.226-.3.248-.522l-.152-9.3c-.007-.622.05-.866.6-1.164l5.251-2.873s2.81-1.266 2.988-3.412c.074-.888-.271-4.471-.271-4.471z"
            fill="#383736"
        />
        <path
            d="M594.34 858.41c-.844 1.846-1.228 3.366-1.008 6.942l.964 12.366a1.68 1.68 0 0 0 .647 1.42s3.655 1.553 5.531 1.293a9.504 9.504 0 0 0 3.672-1.523 2.71 2.71 0 0 0 .836-2.477s.491-10.752.064-13.941a2.865 2.865 0 0 0-1.187-1.7c-.583-.447-4.093-2.656-4.093-2.656l-2.793-.668s-2.061-.312-2.633.944z"
            fill="#4D6B89"
        />
        <path
            d="M595.8 862.17c-.577-.73-.617-3.635.522-4.743.218-.006.436.005.653.031l2.793.668s.657.388 1.458.925c-.38.032-1.223 1.2-2.424 2.5-1.12 1.198-2.202 1.631-3.002.619z"
            fill="#BDCCD1"
        />
        <path
            d="M596.24 859.58c1.615 1.316 2.325-.286 3.168-1.515l-.232-4.089-3.268 1.309.332 4.295z"
            fill="#E8C5AC"
        />
        <path
            d="M599.33 856.69s.059.551.047.651c-.216 1.687-2.193 2.5-2.193 2.5-.248.152-.212.455-.147.851l.223 1.163c.064.378.259.325.4.158 0 0 1.447-1.432 1.852-1.906.944-1.119.839-1.348.365-2.646-.285-.788-.547-.771-.547-.771zM596.7 859.81a.34.34 0 0 1 .134.237.343.343 0 0 1-.075.263l-.539.9c-.288.406-.349.093-.374-.215l-.22-2.232c.04-1.413.411-1.506.411-1.506.024.203.035.408.034.613-.026.7.197 1.387.629 1.94z"
            fill="#EDEDED"
        />
        <path
            d="M597.91 851.76a.906.906 0 0 0-.877.855l.1 1.673s.063.361.381.407c.478.067.659-.359.845-.83l.252-.757c.197-.582.082-1.397-.701-1.348z"
            fill="#FFE8D9"
        />
        <path
            d="m595.01 850.23 3.2-.348.7 5.775c0 .4.058.755.032 1.1a1.647 1.647 0 0 1-.572 1.13 7.364 7.364 0 0 1-1.458 1.118 2.194 2.194 0 0 1-1.064.324 4.585 4.585 0 0 1-1.015-.338 1.861 1.861 0 0 1-1.178-.979 11.274 11.274 0 0 1-.615-1.533l-.836-3.378-.564-3.064 3.37.193z"
            fill="#FFE1CC"
        />
        <path
            d="M592.22 849.32c-.844.606-1.192 1.328-.59 2.671.488 1.089.642 1.3.629 1.314s-.124-.757-.2-1.212c-.107-.674.616-.53.922-.341.453.279 1.5.773 1.535.787.387.168.444 0 .44-.268 0-.061-.041-.41-.041-.41.054.027.949.328 1.2.438.27.111.501.301.662.545.16.244.243.532.238.824l.046.569c.029.264.034.552.3.538.121-.005.3-.014.407-.5 0 0 .34-.989.863-.972.627.016.328 1.507.3 1.584l.017 1.921c.242.045.723-.408.95-1.094.421-1.273.669-2.177.782-2.562a4.396 4.396 0 0 0-6.184-5.332c-.799.437-1.56.939-2.276 1.5z"
            fill="#633A11"
        />
        <path
            d="M598.52 853.3c-.784-.125-.763 1.129-.763 1.129l.1 1.4s.1.509.417.506c.373-.005.607-.3.767-.773.01-.028.252-.7.261-.746a1.104 1.104 0 0 0-.036-.941 1.11 1.11 0 0 0-.746-.575z"
            fill="#FFE8D9"
        />
        <path
            d="m543.47 839.93-.8-.466v.56a.873.873 0 0 1-.4.7l-.49.281.8.466.489-.282a.871.871 0 0 0 .283-.299c.07-.12.11-.256.117-.395l.001-.565z"
            fill="#323232"
        />
        <path
            d="M544.08 839.57v.809a1.773 1.773 0 0 1-.8 1.391l-.7.4v-.709l.489-.282a.871.871 0 0 0 .283-.299c.07-.12.11-.256.117-.395v-.56l.611-.355z"
            fill="#232323"
        />
        <path
            d="M534.96 859.09c-.256.166-.47.391-.623.655-.152.265-.24.562-.256.868 0 .561.4.784.886.5a1.94 1.94 0 0 0 .88-1.519c-.002-.562-.401-.792-.887-.504zm.005 1.628c-.295.168-.534.034-.534-.309a1.166 1.166 0 0 1 .531-.92c.293-.17.536-.035.536.307a1.182 1.182 0 0 1-.533.922z"
            fill="#3B3B3B"
        />
        <path
            d="M534.96 859.49c.293-.17.536-.035.536.307a1.17 1.17 0 0 1-.533.922c-.295.168-.534.034-.534-.309a1.177 1.177 0 0 1 .531-.92z"
            fill="#747474"
        />
        <path
            d="M534.85 858.6a.63.63 0 0 0-.63.064 1.927 1.927 0 0 0-.879 1.524.61.61 0 0 0 .258.566l.733.427a.611.611 0 0 1-.257-.566 1.937 1.937 0 0 1 .879-1.523.619.619 0 0 1 .629-.062l-.733-.43z"
            fill="#4C4C4C"
        />
        <path
            d="M547.84 851.65a1.948 1.948 0 0 0-.878 1.525c0 .56.395.788.885.5a1.933 1.933 0 0 0 .883-1.521c-.004-.561-.401-.785-.89-.504zm0 1.627c-.291.17-.53.034-.534-.3a1.178 1.178 0 0 1 .531-.921c.3-.171.537-.035.539.3a1.184 1.184 0 0 1-.533.921h-.003z"
            fill="#3B3B3B"
        />
        <path
            d="M547.84 852.05c.3-.171.537-.035.539.3a1.173 1.173 0 0 1-.537.921c-.291.17-.529.034-.534-.3a1.18 1.18 0 0 1 .532-.921z"
            fill="#747474"
        />
        <path
            d="M547.74 851.16a.632.632 0 0 0-.631.063 1.94 1.94 0 0 0-.879 1.525.6.6 0 0 0 .052.318c.045.1.116.185.206.247l.735.429a.612.612 0 0 1-.204-.249.61.61 0 0 1-.053-.318 1.948 1.948 0 0 1 .878-1.525.62.62 0 0 1 .307-.115.619.619 0 0 1 .323.055l-.734-.43z"
            fill="#4C4C4C"
        />
        <path
            d="M547.3 858.91a.616.616 0 0 0-.627-.06c-.064.034-.122.069-.186.105-.086.051-.174.1-.259.15s-.194.115-.295.172a.636.636 0 0 1 .634.06c.105.065.203.143.29.232l-.293.173a1.163 1.163 0 0 1 .53.919.38.38 0 0 1-.154.342l.493-.285c.007.048.011.097.012.146a.611.611 0 0 1-.258.565l.736-.426a.618.618 0 0 0 .204-.249.618.618 0 0 0 .054-.317 1.942 1.942 0 0 0-.881-1.527z"
            fill="#3B3B3B"
        />
        <path
            d="m546.18 859.71.735-.429a.374.374 0 0 0-.156.34 1.165 1.165 0 0 0 .533.92l-.734.431a1.161 1.161 0 0 1-.533-.924.36.36 0 0 1 .155-.338z"
            fill="#4C4C4C"
        />
        <path
            d="M546.56 859.34c-.492-.28-.888-.054-.888.5a1.939 1.939 0 0 0 .881 1.529c.487.28.883.054.885-.506a1.96 1.96 0 0 0-.878-1.523zm-.005 1.631a1.161 1.161 0 0 1-.533-.924c0-.338.238-.475.535-.3a1.156 1.156 0 0 1 .53.919c0 .336-.241.474-.532.305z"
            fill="#4C4C4C"
        />
        <path
            d="M546.56 859.74c-.3-.173-.535-.036-.535.3a1.174 1.174 0 0 0 .533.924c.291.169.532.031.532-.307a1.168 1.168 0 0 0-.53-.917z"
            fill="#7B7B7B"
        />
        <path
            d="M534.4 851.47a.619.619 0 0 0-.629-.063c-.061.036-.125.073-.183.109a8.586 8.586 0 0 0-.258.15c-.1.055-.195.113-.295.171a.628.628 0 0 1 .322-.056c.11.011.215.051.305.116.11.065.211.143.3.234l-.3.17a1.168 1.168 0 0 1 .532.919.363.363 0 0 1-.156.342l.494-.287c.008.049.012.099.013.149a.602.602 0 0 1-.26.564l.738-.427a.618.618 0 0 0 .256-.566 1.927 1.927 0 0 0-.879-1.525z"
            fill="#3B3B3B"
        />
        <path
            d="M533.66 851.89c-.486-.282-.883-.053-.885.506a1.942 1.942 0 0 0 .881 1.526c.488.281.887.055.887-.5a1.954 1.954 0 0 0-.883-1.532zm0 1.631a1.184 1.184 0 0 1-.53-.924c0-.337.241-.472.534-.299a1.159 1.159 0 0 1 .532.919c-.006.336-.245.475-.54.304h.004z"
            fill="#4C4C4C"
        />
        <path
            d="M533.66 852.3c-.293-.17-.534-.034-.534.3a1.171 1.171 0 0 0 .53.923c.295.171.536.032.536-.307a1.17 1.17 0 0 0-.532-.916z"
            fill="#7B7B7B"
        />
        <path
            d="m547.82 850.45-6.041 3.512v1.163l6.043-3.508a.43.43 0 0 0 .255-.355v-1.169a.437.437 0 0 1-.257.357z"
            fill="#303030"
        />
        <path
            d="M533.22 850.45a.427.427 0 0 1-.258-.362v1.168a.44.44 0 0 0 .259.361l6.076 3.509v-1.162l-6.077-3.514z"
            fill="#3E3E3E"
        />
        <path
            d="M547.82 849.73a1.365 1.365 0 0 0-1.241 0l-6.041 3.511.005.245 6.481-3.766a.393.393 0 0 1 .355 0 .11.11 0 0 1 .069.1c0 .022-.007.043-.019.061s-.03.032-.05.039l-6.485 3.77.887.267 6.041-3.512a.375.375 0 0 0 .25-.358.379.379 0 0 0-.252-.357z"
            fill="#414141"
        />
        <path
            d="M533.66 849.72a.404.404 0 0 1 .36 0l6.527 3.766-.005-.245-6.084-3.511a1.362 1.362 0 0 0-1.241 0c-.344.2-.342.518 0 .719l6.082 3.514.885-.269-6.526-3.77a.102.102 0 0 1-.052-.04.106.106 0 0 1-.019-.062c0-.023.007-.045.02-.063a.12.12 0 0 1 .053-.039z"
            fill="#494949"
        />
        <path
            d="M547.38 849.72a.11.11 0 0 1 .069.1c0 .022-.007.043-.019.061s-.03.032-.05.039l-6.485 3.77 6.529 3.765c.022.008.04.022.053.041a.107.107 0 0 1 0 .128.106.106 0 0 1-.053.04.393.393 0 0 1-.356 0l-6.525-3.767-6.484 3.767a.392.392 0 0 1-.356 0 .113.113 0 0 1-.073-.105.113.113 0 0 1 .073-.105l6.481-3.765-6.526-3.77a.111.111 0 0 1-.049-.039.109.109 0 0 1 0-.121.107.107 0 0 1 .049-.04.401.401 0 0 1 .36 0l6.527 3.766 6.481-3.766a.389.389 0 0 1 .354.001z"
            fill="#303030"
        />
        <path
            d="M547.87 858.19a1.365 1.365 0 0 1-1.24 0l-6.082-3.509v1.166l6.08 3.509a1.35 1.35 0 0 0 1.24 0 .432.432 0 0 0 .256-.357v-1.166a.444.444 0 0 1-.254.357z"
            fill="#3E3E3E"
        />
        <path
            d="m547.87 857.47-6.083-3.51-.887-.267 6.529 3.765a.114.114 0 0 1 .074.105.11.11 0 0 1-.074.104.393.393 0 0 1-.356 0l-6.525-3.767v.781l6.082 3.509a1.363 1.363 0 0 0 1.24 0 .379.379 0 0 0 .186-.581.385.385 0 0 0-.186-.139zM540.54 853.9l-6.484 3.767a.392.392 0 0 1-.356 0 .113.113 0 0 1-.073-.105.113.113 0 0 1 .073-.105l6.481-3.765-.885.269-6.043 3.508a.378.378 0 0 0-.256.36.38.38 0 0 0 .256.36 1.355 1.355 0 0 0 1.242 0l6.043-3.509.002-.78z"
            fill="#4C4C4C"
        />
        <path
            d="M534.5 858.19a1.355 1.355 0 0 1-1.242 0 .443.443 0 0 1-.258-.361v1.166a.444.444 0 0 0 .258.361 1.359 1.359 0 0 0 1.244 0l6.043-3.509v-1.166l-6.045 3.509zM541.63 850.82a.54.54 0 0 0-.306-.441 1.69 1.69 0 0 0-1.544-.018.56.56 0 0 0-.333.453l-.008 3.046c0 .022.008.043.01.067a.195.195 0 0 0 .067.164.78.78 0 0 0 .232.21 1.7 1.7 0 0 0 1.543.015.705.705 0 0 0 .141-.1c.015-.011.024-.025.037-.034.025-.026.05-.05.07-.074a.255.255 0 0 0 .024-.05.324.324 0 0 0 .036-.069.213.213 0 0 0 .01-.055.227.227 0 0 0 .013-.067l.008-3.047z"
            fill="#303030"
        />
        <path
            d="M540.94 848.12a.86.86 0 0 0-.785-.005.289.289 0 0 0-.17.226v2.311a.077.077 0 0 1 .007.027c0 .009.011.021.015.035l.015.024a.122.122 0 0 0 .03.034l.016.02a.624.624 0 0 0 .071.053.869.869 0 0 0 .781.009.393.393 0 0 0 .128-.108l.015-.026a.117.117 0 0 0 .016-.034.07.07 0 0 0 .005-.028.198.198 0 0 0 .006-.032v-2.28a.261.261 0 0 0-.045-.133.262.262 0 0 0-.105-.093z"
            fill="#969696"
        />
        <path
            d="M546.46 829.62a2.274 2.274 0 0 1 1.055 2.15l-.22.936c-.105.448-.157 3.534-.157 4.057l-.016 4.87c0 .365-.261.51-.575.328l-6.748-3.9a1.26 1.26 0 0 1-.57-.986l.015-4.869c0-.526-.053-3.671-.154-4.241l-.212-1.18c-.157-.881.361-1.33 1.063-.927l6.519 3.762z"
            fill="#ADADAD"
        />
        <path
            d="m548.17 828.62-6.52-3.762a.748.748 0 0 0-.773-.076l-1.713.994a.766.766 0 0 1 .774.077l6.519 3.763a2.281 2.281 0 0 1 1.055 2.15l-.22.936c-.105.448-.157 3.534-.157 4.057l-.016 4.87a.395.395 0 0 1-.17.367l1.716-.994a.402.402 0 0 0 .133-.164.398.398 0 0 0 .034-.207l.014-4.866c0-.527.053-3.612.164-4.061l.216-.932a2.276 2.276 0 0 0-1.056-2.152z"
            fill="#969696"
        />
        <path
            d="m546.4 843.63-7.757-4.479a.665.665 0 0 0-.317-.12.659.659 0 0 0-.334.056l-7.72 4.447a.652.652 0 0 1 .652.066l7.757 4.48a2.001 2.001 0 0 1 .913 1.58.631.631 0 0 1-.268.589c1.9-1.107 5.819-3.341 7.722-4.448a.655.655 0 0 0 .211-.258.655.655 0 0 0 .054-.33 2.002 2.002 0 0 0-.913-1.583z"
            fill="silver"
        />
        <path
            d="M538.68 848.08a1.996 1.996 0 0 1 .913 1.58c0 .583-.412.817-.92.524l-7.758-4.478a2.005 2.005 0 0 1-.911-1.583c0-.581.411-.813.919-.523l7.757 4.48z"
            fill="#ADADAD"
        />
        <path
            d="M530.7 833.06c.911-1.014 3.493-3.986 3.493-3.986s2.616-4.647 1.3-5.329c-1.3-.674-2.1-.4-3.717 2.105-.379.591-3.762 4.969-4.209 5.463a3.818 3.818 0 0 0-.716 2.642s.983 2.284 3.849-.895z"
            fill="#3A566D"
        />
        <path
            d="m539.88 825.53 1.189-.691-.037 16.241-1.193.692.041-16.242z"
            fill="#894E0E"
        />
        <path
            d="m538.46 824.71 1.191-.689 1.421.82-1.189.691-1.423-.822z"
            fill="#995710"
        />
        <path
            d="m539.88 825.53-.041 16.242-1.422-.82.04-16.245 1.423.823z"
            fill="#5F360A"
        />
        <path
            d="m536.58 839.9 1.588-.925 1.423.822-1.59.923-1.421-.82z"
            fill="#995710"
        />
        <path
            d="m530.4 845.13 1.586-.924-.039 13.99-1.588.924.041-13.99z"
            fill="#894E0E"
        />
        <path
            d="m528.97 844.31 1.587-.924 1.421.82-1.586.924-1.422-.82z"
            fill="#995710"
        />
        <path
            d="m530.4 845.13-.041 13.99-1.422-.82.041-13.99 1.422.82z"
            fill="#5F360A"
        />
        <path
            d="m528.93 855.94-.828.707s-3.809 1.845-4.055 1.937a.628.628 0 0 0-.425.556.472.472 0 0 0 .083.3c.34.37.806.599 1.307.642 1.17.063 2.343-.021 3.492-.248.264-.123 1.822-.394 1.948-.494 0 0 .482-.012.581.187.01.157-.003.315-.037.469l1.447-.558c.135-.329.222-.675.258-1.027l.258-2.031-4.029-.44z"
            fill="#545454"
        />
        <path
            d="M523.7 859.28c.356.386.838.632 1.358.693a8.72 8.72 0 0 0 3.942-.565 5.318 5.318 0 0 1 1.567-.309s.5.052.477.426c0 .079.032.023.017.11a.24.24 0 0 0-.009-.1c-.1-.2-.507.08-.507.08-.164-.18-.045-.377-1.21-.02a10.6 10.6 0 0 1-3.985.759 2.566 2.566 0 0 1-1.664-.827.519.519 0 0 1-.05-.426c.017.061.039.121.064.179z"
            fill="#282827"
        />
        <path
            d="m531.05 859.45 1.568-.6a5.428 5.428 0 0 1-.159.588l-1.448.561c.008-.044.035-.422.039-.549zM542.08 836.48l-5.658 1.648-7.933 5.551s-1.656.856-1.375 3.821c.241 2.546.451 9.337.451 9.337.008.62.281.816.783 1.083 3.066 1.62 4.636.34 4.636.34.245-.14.226-.306.245-.521l-.157-10.13 5.855-3.215s2.809-1.264 2.989-3.411c.072-.881.164-4.503.164-4.503z"
            fill="#282827"
        />
        <path
            d="m531.6 858.61-2.515 2.114s-1.27 1.019-1.741 1.289a.85.85 0 0 0-.372.662.597.597 0 0 0 .148.459c.401.34.883.572 1.4.672a4.548 4.548 0 0 0 2.976-.583c.25-.159 1.916-1.232 2.04-1.333.351-.278.664-.388.789-.2 0 0-.016.459-.016.527l1.4-.963c.047-.274.077-.551.089-.829v-2.045l-4.198.23z"
            fill="#282827"
        />
        <path
            d="m531.6 858.31-2.515 2.112s-1.27 1.02-1.741 1.293a.831.831 0 0 0-.372.66.595.595 0 0 0 .148.458c.4.341.883.572 1.4.671a4.548 4.548 0 0 0 2.976-.583c.25-.154 1.916-1.232 2.04-1.332.351-.28.664-.388.789-.2 0 0-.016.459-.016.524l1.4-.961c.047-.275.077-.553.089-.831v-2.045l-4.198.234z"
            fill="#545454"
        />
        <path
            d="m544.31 838.6-5.225 1.608-7.645 5.437s-1.669.66-1.522 3.646c.1 1.852.228 1.963.478 9.645.007.617.423.927.927 1.191 3.069 1.624 4.324.215 4.324.215.248-.141.223-.3.248-.522l-.155-9.307c-.01-.623.051-.866.6-1.166l5.254-2.869s2.809-1.27 2.987-3.412c.071-.883-.271-4.466-.271-4.466z"
            fill="#383736"
        />
        <path
            d="M534.11 823.74c-.845 1.844-1.229 3.366-1.009 6.941l.967 12.371a1.675 1.675 0 0 0 .648 1.418s3.653 1.553 5.529 1.293a9.543 9.543 0 0 0 3.674-1.523 2.704 2.704 0 0 0 .837-2.474s.488-10.755.062-13.944a2.85 2.85 0 0 0-1.183-1.7c-.586-.449-4.1-2.66-4.1-2.66l-2.794-.663s-2.059-.314-2.631.941z"
            fill="#4D6B89"
        />
        <path
            d="M535.57 827.51c-.577-.728-.617-3.637.52-4.743.218-.005.436.006.652.034l2.794.663s.659.388 1.461.926c-.378.033-1.222 1.2-2.424 2.495-1.126 1.206-2.207 1.638-3.003.625z"
            fill="#BDCCD1"
        />
        <path
            d="M536.02 824.92c1.611 1.317 2.322-.287 3.166-1.515l-.231-4.092-3.273 1.31.338 4.297z"
            fill="#E8C5AC"
        />
        <path
            d="M539.11 822.02s.057.549.045.647c-.214 1.69-2.191 2.5-2.191 2.5-.248.152-.212.454-.148.849l.224 1.162c.061.379.257.328.4.161 0 0 1.449-1.433 1.852-1.906.944-1.118.843-1.349.363-2.646-.289-.783-.545-.767-.545-.767zM536.47 825.15a.363.363 0 0 1 .137.24.367.367 0 0 1-.076.266l-.543.9c-.287.4-.344.092-.373-.215l-.22-2.233c.041-1.42.411-1.51.411-1.51.026.204.037.41.033.616-.024.699.2 1.385.631 1.936z"
            fill="#EDEDED"
        />
        <path
            d="M537.68 817.09a.915.915 0 0 0-.876.854l.1 1.672s.063.359.379.406c.481.068.661-.358.845-.828.01-.026.237-.716.254-.757.2-.583.091-1.399-.702-1.347z"
            fill="#FFE8D9"
        />
        <path
            d="m534.78 815.56 3.2-.348.706 5.773c0 .4.058.757.032 1.1a1.66 1.66 0 0 1-.57 1.127 7.456 7.456 0 0 1-1.459 1.12c-.321.2-.689.311-1.066.322a4.78 4.78 0 0 1-1.016-.334 1.872 1.872 0 0 1-1.173-.984 10.556 10.556 0 0 1-.619-1.534l-.839-3.376-.56-3.063 3.364.197z"
            fill="#FFE1CC"
        />
        <path
            d="M531.99 814.65c-.843.605-1.191 1.328-.587 2.671.487 1.09.641 1.3.628 1.314s-.127-.758-.2-1.21c-.106-.677.613-.533.922-.341.455.277 1.5.772 1.534.784.388.169.444 0 .442-.266 0-.062-.039-.411-.039-.411.051.028.947.328 1.192.439a1.452 1.452 0 0 1 .9 1.368l.045.57c.031.264.035.552.3.539.122-.005.3-.015.41-.5 0 0 .335-.988.862-.972.625.018.329 1.511.3 1.589l.016 1.917c.242.044.721-.407.949-1.1.419-1.271.669-2.177.782-2.562a4.388 4.388 0 0 0-1.283-4.763 4.396 4.396 0 0 0-4.901-.567c-.796.438-1.556.94-2.272 1.501z"
            fill="#633A11"
        />
        <path
            d="M538.3 818.63c-.785-.122-.764 1.129-.764 1.129l.1 1.4s.1.508.418.506c.372-.005.606-.3.767-.773.009-.029.249-.7.26-.745a1.098 1.098 0 0 0-.036-.941 1.114 1.114 0 0 0-.745-.576z"
            fill="#FFE8D9"
        />
        <path
            d="M529.32 838.05c-.341-.19-.348-.506-.019-.7l1.49-.914a1.344 1.344 0 0 1 1.214-.031l2.408 1.317a.375.375 0 0 1 .263.345.375.375 0 0 1-.241.36l-1.49.912a1.343 1.343 0 0 1-1.216.027l-2.409-1.316z"
            fill="#9E9D9D"
        />
        <path
            d="M533.04 844.77v.242l-.563.326v-.242l.563-.326zM533.89 844.29v.243l-.561.324v-.243l.561-.324z"
            fill="#393939"
        />
        <path
            d="m532.53 845.23.513-.3v-.17l-.513.293v.177zM533.38 844.76l.508-.3v-.17l-.511.293.003.177z"
            fill="#1C1C1C"
        />
        <path
            d="M473.66 850.34c0 .988.003 1.975.008 2.961.015 5.015 3.308 10.025 9.9 13.853l-.009-2.962c-6.588-3.825-9.885-8.834-9.899-13.852z"
            fill="#9B7049"
        />
        <path
            d="m473.66 850.34.008 2.961c.015 5.015 3.308 10.025 9.9 13.853l-.009-2.962c-6.586-3.825-9.883-8.834-9.9-13.852h.001z"
            fill="#916627"
        />
        <path
            d="m483.56 864.19.01 2.962 68.1 39.8-.007-2.962-68.103-39.8z"
            fill="#9B7049"
        />
        <path
            d="m551.66 903.99.007 2.962c13.257 7.7 34.816 7.7 48.159 0 6.714-3.875 10.07-8.964 10.056-14.046l-.01-2.961c.016 5.082-3.34 10.168-10.056 14.048-13.34 7.7-34.9 7.7-48.156 0v-.003z"
            fill="#9B7049"
        />
        <path
            d="M483.72 836.29c-13.343 7.7-13.409 20.2-.155 27.9l68.1 39.8c13.255 7.7 34.816 7.7 48.156 0s13.417-20.193.161-27.9l-68.1-39.8c-13.256-7.703-34.819-7.705-48.162 0z"
            fill="#CCA475"
        />
        <path
            d="m530.74 845.79-12.854-7.4v.37a.727.727 0 0 0 .363.63l12.124 6.981a.729.729 0 0 0 .725 0l8.871-5.235a.551.551 0 0 0 .272-.474v-.235l-9.501 5.363z"
            fill="#848484"
        />
        <path
            d="M540.03 840.12a.38.38 0 0 1 .212.338.38.38 0 0 1-.202.344l-9.3 4.983-12.854-7.4 9.275-4.187a1.544 1.544 0 0 1 1.326.031l11.543 5.891z"
            fill="#D3D3D3"
        />
        <path
            d="M535.76 842.09c.116.067.237.346-.219.54l-4.122 2.247c-.339.212-.629.023-.945-.157l-10.859-6.258a.244.244 0 0 1-.113-.366.244.244 0 0 1 .113-.09l3.97-2.506a.7.7 0 0 1 .636-.088l11.539 6.678z"
            fill="#898686"
        />
        <path
            d="M526.6 836.87c.055.031.055.08 0 .109l-.545.319a.215.215 0 0 1-.193 0l-.551-.319c-.054-.029-.054-.078 0-.111l.549-.316a.197.197 0 0 1 .189 0l.551.318zM523.9 839.75a.067.067 0 0 1 .028.022c.006.01.01.022.01.034a.071.071 0 0 1-.01.035.067.067 0 0 1-.028.022l-.55.318a.215.215 0 0 1-.192 0l-.552-.32c-.054-.03-.054-.079 0-.111l.549-.316a.198.198 0 0 1 .191 0l.554.316zM524.85 840.31c.054.033.054.078 0 .111l-.548.319c-.03.014-.063.022-.096.022s-.065-.008-.095-.022l-.553-.319c-.055-.033-.055-.078 0-.111l.549-.319a.208.208 0 0 1 .191 0l.552.319zM525.81 840.86c.054.029.054.079 0 .112l-.549.316a.197.197 0 0 1-.19 0l-.554-.318c-.011-.004-.021-.012-.028-.022s-.011-.022-.011-.034.004-.024.011-.034.017-.018.028-.022l.549-.319a.229.229 0 0 1 .193 0l.551.321zM524.69 836.93c.054.029.054.077 0 .11l-.548.319a.204.204 0 0 1-.192 0l-1.516-.876c-.012-.004-.023-.011-.03-.021s-.011-.022-.011-.035c0-.012.004-.024.011-.034s.018-.017.03-.021l.548-.319a.208.208 0 0 1 .19 0l1.518.877zM525.61 837.44c.054.034.054.082 0 .114l-.551.319a.208.208 0 0 1-.191 0l-.55-.319c-.055-.032-.055-.08 0-.114l.55-.315a.208.208 0 0 1 .19 0l.552.315zM526.64 838.03a.062.062 0 0 1 .031.021.063.063 0 0 1 0 .071.062.062 0 0 1-.031.021l-.552.321a.193.193 0 0 1-.188 0l-.552-.319a.06.06 0 0 1-.028-.022.053.053 0 0 1-.011-.034c0-.013.003-.025.011-.035a.06.06 0 0 1 .028-.022l.547-.317a.201.201 0 0 1 .191 0l.554.315zM527.6 838.59c.056.032.056.082 0 .11l-.549.319a.199.199 0 0 1-.193 0l-.548-.315c-.052-.028-.052-.079 0-.11l.548-.318a.199.199 0 0 1 .192 0l.55.314zM528.57 839.15c.053.03.053.077 0 .111l-.55.317a.203.203 0 0 1-.094.022.206.206 0 0 1-.094-.022l-.555-.317c-.052-.034-.052-.083 0-.114l.551-.319a.216.216 0 0 1 .189 0l.553.322zM523.76 837.47a.058.058 0 0 1 .039.054.058.058 0 0 1-.039.054l-.547.32a.216.216 0 0 1-.193 0l-1.516-.877a.06.06 0 0 1-.028-.021.058.058 0 0 1 0-.068.056.056 0 0 1 .028-.022l.553-.32a.22.22 0 0 1 .094-.022c.033 0 .065.008.095.022l1.514.88zM524.72 838.03c.052.031.055.079 0 .11l-.55.319a.193.193 0 0 1-.187 0l-.555-.319c-.054-.031-.054-.081 0-.11l.549-.321c.03-.014.063-.022.096-.022s.066.008.096.022l.551.321zM525.72 838.62c.052.032.053.081 0 .111l-.549.32a.224.224 0 0 1-.095.022.225.225 0 0 1-.096-.022l-.553-.32c-.055-.03-.055-.079 0-.111l.551-.317c.03-.014.062-.022.095-.022s.065.008.095.022l.552.317zM526.68 839.17c.052.03.052.078 0 .111l-.547.316a.204.204 0 0 1-.192 0l-.553-.32a.058.058 0 0 1-.028-.021c-.008-.01-.011-.022-.011-.034s.003-.024.011-.034a.058.058 0 0 1 .028-.021l.55-.319a.214.214 0 0 1 .191 0l.551.322zM526.78 841.41c.012.005.021.012.028.022s.01.022.01.034a.062.062 0 0 1-.01.035.062.062 0 0 1-.028.022l-.55.321a.21.21 0 0 1-.192 0l-.553-.321a.063.063 0 0 1-.038-.057.06.06 0 0 1 .011-.034.059.059 0 0 1 .027-.022l.551-.316a.199.199 0 0 1 .192 0l.552.316zM529.54 839.71c.055.031.055.081 0 .11l-.549.32a.229.229 0 0 1-.193 0l-.551-.32c-.012-.004-.022-.011-.029-.021s-.011-.022-.011-.034.004-.024.011-.034.017-.017.029-.021l.55-.318a.208.208 0 0 1 .19 0l.553.318zM527.64 839.73c.055.03.055.08 0 .111l-.549.321a.22.22 0 0 1-.19 0l-.554-.321a.065.065 0 0 1-.028-.021c-.007-.01-.011-.022-.011-.034s.004-.024.011-.034.017-.018.028-.022l.548-.319a.23.23 0 0 1 .192 0l.553.319zM528.61 840.29c.055.031.055.082 0 .109l-.547.32a.215.215 0 0 1-.193 0l-.554-.32c-.053-.027-.053-.078 0-.109l.547-.317c.03-.017.063-.025.097-.025s.067.008.097.025l.553.317zM524.79 839.18c.055.03.055.079 0 .112l-.547.316a.208.208 0 0 1-.191 0l-.555-.316c-.051-.033-.051-.082 0-.112l.551-.321a.208.208 0 0 1 .191 0l.551.321zM525.75 839.74c.055.03.055.08 0 .113l-.55.317a.193.193 0 0 1-.188 0l-.554-.318c-.054-.034-.054-.082 0-.112l.55-.318c.029-.015.062-.024.095-.024s.065.009.094.024l.553.318zM526.72 840.3c.053.032.053.08 0 .111l-.545.318a.215.215 0 0 1-.193 0l-.552-.318c-.053-.031-.055-.079 0-.111l.549-.32a.22.22 0 0 1 .19 0l.551.32zM527.69 840.86c.054.029.054.079 0 .112l-.55.316a.204.204 0 0 1-.191 0l-.553-.318c-.056-.032-.056-.081 0-.11l.547-.321a.225.225 0 0 1 .192 0l.555.321zM527.74 841.97c.053.029.053.077 0 .108l-.549.319a.199.199 0 0 1-.192 0l-.551-.319c-.054-.033-.054-.081 0-.108l.549-.322a.22.22 0 0 1 .191 0l.552.322zM530.64 840.34c.051.034.053.082 0 .111l-.551.321a.211.211 0 0 1-.096.022.21.21 0 0 1-.095-.022l-.55-.321c-.055-.03-.055-.081 0-.111l.549-.318c.03-.014.062-.022.095-.022s.065.008.095.022l.553.318zM529.58 840.84c.054.031.054.08 0 .109l-.551.318a.198.198 0 0 1-.191 0l-.553-.316c-.011-.004-.021-.012-.028-.022s-.011-.021-.011-.034c0-.012.004-.024.011-.033a.06.06 0 0 1 .028-.022l.553-.323a.215.215 0 0 1 .187 0l.555.323zM528.65 841.41a.06.06 0 0 1 .04.057.06.06 0 0 1-.04.056l-.55.321a.208.208 0 0 1-.19 0l-.556-.321c-.011-.004-.02-.012-.027-.022s-.011-.022-.011-.034.004-.024.011-.034.016-.018.027-.023l.551-.316a.204.204 0 0 1 .191 0l.554.316zM521.04 838.07c.012.004.022.011.029.021s.011.022.011.035a.06.06 0 0 1-.04.056l-.551.319c-.029.015-.062.024-.095.024s-.065-.009-.094-.024l-.555-.319a.067.067 0 0 1-.027-.023c-.006-.01-.01-.021-.01-.033s.004-.024.01-.034a.064.064 0 0 1 .027-.022l.551-.319a.197.197 0 0 1 .189 0l.555.319zM521.95 838.6c.054.031.055.081 0 .11l-.548.319a.199.199 0 0 1-.192 0l-.553-.319a.065.065 0 0 1-.028-.021c-.006-.01-.01-.022-.01-.034s.004-.023.01-.033a.067.067 0 0 1 .028-.022l.551-.318a.182.182 0 0 1 .189 0l.553.318zM522.92 839.16a.056.056 0 0 1 .028.022.055.055 0 0 1 .011.033c0 .013-.004.024-.011.034s-.016.018-.028.022l-.55.318a.206.206 0 0 1-.094.022.207.207 0 0 1-.095-.022l-.555-.318a.059.059 0 0 1-.037-.056c0-.011.003-.023.01-.033s.016-.018.027-.022l.551-.32a.208.208 0 0 1 .189 0l.554.32zM531.56 839.79a.066.066 0 0 1 .029.021c.007.01.01.022.01.034s-.003.024-.01.034a.066.066 0 0 1-.029.021l-.549.321a.216.216 0 0 1-.193 0l-4.409-2.546c-.053-.034-.053-.085 0-.114l.549-.316a.197.197 0 0 1 .19 0l4.412 2.545zM532.54 840.36c.056.032.056.081 0 .113l-.548.318a.215.215 0 0 1-.188 0l-.556-.318c-.054-.032-.054-.081 0-.113l.55-.318a.216.216 0 0 1 .188 0l.554.318zM533.52 840.94c.055.032.055.081 0 .11l-.549.32a.208.208 0 0 1-.189 0l-.553-.32c-.054-.029-.054-.078 0-.11l.549-.32c.029-.015.061-.022.094-.022s.065.007.094.022l.554.32zM531.58 840.91c.053.031.053.081 0 .109l-.55.321a.208.208 0 0 1-.191 0l-.555-.321a.06.06 0 0 1-.038-.055.06.06 0 0 1 .011-.033.051.051 0 0 1 .027-.021l.551-.319a.225.225 0 0 1 .192 0l.553.319zM521.92 837.46c.051.031.051.078 0 .108l-.55.321a.21.21 0 0 1-.189 0l-.554-.321c-.054-.03-.054-.077 0-.111l.549-.317c.03-.015.062-.022.095-.022s.066.007.095.022l.554.32zM522.88 838.01c.056.033.056.08 0 .111l-.546.319a.215.215 0 0 1-.192 0l-.554-.319c-.052-.031-.053-.078 0-.111l.549-.318c.029-.015.062-.024.095-.024s.065.009.094.024l.554.318zM523.85 838.57c.011.005.02.013.026.023.007.01.01.021.01.033s-.003.024-.01.034a.056.056 0 0 1-.026.022l-.552.32a.204.204 0 0 1-.189 0l-.551-.32c-.056-.033-.056-.08 0-.112l.551-.317a.204.204 0 0 1 .187 0l.554.317zM530.56 841.47c.053.031.053.078 0 .11l-.55.317a.198.198 0 0 1-.191 0l-.553-.317c-.054-.032-.054-.081 0-.11l.549-.321c.03-.014.063-.022.096-.022s.066.008.096.022l.553.321zM531.64 842.02c.053.031.053.082 0 .111l-.549.318a.208.208 0 0 1-.191 0l-.553-.32a.058.058 0 0 1-.039-.056c0-.012.003-.024.01-.034s.017-.017.029-.021l.551-.32a.219.219 0 0 1 .189 0l.553.322zM533.5 843.12a.06.06 0 0 1 .028.022.055.055 0 0 1 .011.033c0 .013-.004.024-.011.034s-.017.018-.028.022l-.552.319a.2.2 0 0 1-.19 0l-1.516-.875c-.054-.032-.054-.08 0-.113l.549-.316a.191.191 0 0 1 .189 0l1.52.874zM529.62 841.97c.051.029.051.077 0 .108l-.55.319a.194.194 0 0 1-.189 0l-.555-.319c-.053-.033-.053-.081 0-.108l.549-.322c.03-.014.063-.022.096-.022s.066.008.096.022l.553.322zM530.59 842.56a.06.06 0 0 1 .04.057.06.06 0 0 1-.04.056l-.551.317c-.028.017-.061.027-.094.027s-.066-.01-.095-.027l-.553-.317c-.052-.032-.054-.08 0-.113l.549-.316a.204.204 0 0 1 .192 0l.552.316zM532.51 843.64c.054.033.054.08 0 .109l-.547.321c-.03.014-.063.022-.096.022s-.065-.008-.095-.022l-1.519-.878c-.053-.032-.053-.08 0-.109l.55-.318a.204.204 0 0 1 .188 0l1.519.875zM528.7 842.5c.055.032.055.08 0 .111l-.548.318a.206.206 0 0 1-.094.022.207.207 0 0 1-.095-.022l-.555-.32c-.052-.029-.052-.078 0-.109l.549-.321a.215.215 0 0 1 .192 0l.551.321zM531.6 844.17c.056.031.056.081 0 .111l-.549.32a.215.215 0 0 1-.192 0l-1.516-.876c-.055-.032-.055-.082 0-.112l.548-.318a.208.208 0 0 1 .19 0l1.519.875zM534.48 841.5c.054.029.054.079 0 .109l-.549.318a.199.199 0 0 1-.192 0l-.551-.318c-.053-.03-.053-.08 0-.109l.546-.319c.03-.016.063-.025.097-.025s.067.009.097.025l.552.319zM535.46 842.04c.056.028.056.079 0 .109l-.547.32a.214.214 0 0 1-.191 0l-.554-.321c-.053-.029-.055-.08 0-.108l.551-.319a.211.211 0 0 1 .19 0l.551.319z"
            fill="#4A4A4A"
        />
        <path
            d="m533.74 841.92-.551-.318a.06.06 0 0 1-.028-.022.065.065 0 0 1-.014-.033v.111c0 .017.015.037.042.055l.551.32v-.113z"
            fill="#636363"
        />
        <path
            d="M534.52 841.55c-.001.012-.005.023-.012.033s-.017.017-.028.022l-.549.318a.204.204 0 0 1-.192 0v.113a.228.228 0 0 0 .192 0l.548-.32a.067.067 0 0 0 .027-.023.062.062 0 0 0 .014-.032v-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m534.72 842.47-.554-.321a.065.065 0 0 1-.028-.021.076.076 0 0 1-.011-.033v.109a.06.06 0 0 0 .013.034c.007.01.017.018.029.022l.554.319-.003-.109z"
            fill="#636363"
        />
        <path
            d="M535.5 842.1a.053.053 0 0 1-.012.03.055.055 0 0 1-.025.02l-.549.321a.208.208 0 0 1-.191 0v.109a.208.208 0 0 0 .191 0l.549-.319a.064.064 0 0 0 .026-.023.062.062 0 0 0 .011-.033v-.105z"
            fill="#3D3D3D"
        />
        <path
            d="m525.85 837.31-.551-.319c-.012-.004-.021-.012-.028-.022s-.011-.022-.011-.034v.111a.063.063 0 0 0 .039.057l.551.319v-.112z"
            fill="#636363"
        />
        <path
            d="M526.64 836.93a.058.058 0 0 1-.014.033.053.053 0 0 1-.029.02l-.545.319a.216.216 0 0 1-.193 0v.112a.215.215 0 0 0 .193 0l.545-.319a.063.063 0 0 0 .029-.022.064.064 0 0 0 .014-.035v-.108z"
            fill="#3D3D3D"
        />
        <path
            d="m523.15 840.17-.554-.318a.087.087 0 0 1-.027-.023.068.068 0 0 1-.013-.033v.109c0 .021.015.039.04.057l.554.318v-.11z"
            fill="#636363"
        />
        <path
            d="M523.92 839.8a.077.077 0 0 1-.012.033.078.078 0 0 1-.027.024l-.548.317a.204.204 0 0 1-.192 0v.11a.204.204 0 0 0 .192 0l.548-.318c.023-.018.039-.035.039-.057v-.109z"
            fill="#3D3D3D"
        />
        <path
            d="m524.11 840.73-.553-.318c-.029-.015-.042-.035-.04-.056v.111c0 .021.013.04.041.063l.554.321-.002-.121z"
            fill="#636363"
        />
        <path
            d="M524.89 840.35c0 .012-.005.024-.012.034s-.016.017-.028.022l-.548.318a.208.208 0 0 1-.191 0v.11a.208.208 0 0 0 .191 0l.548-.319a.07.07 0 0 0 .028-.023.063.063 0 0 0 .012-.033v-.109z"
            fill="#3D3D3D"
        />
        <path
            d="m525.07 841.28-.554-.318a.066.066 0 0 1-.038-.055v.108a.07.07 0 0 0 .012.034c.006.01.016.019.026.024l.553.318.001-.111z"
            fill="#636363"
        />
        <path
            d="M525.85 840.91c0 .012-.004.024-.011.034s-.017.018-.028.023l-.549.316a.197.197 0 0 1-.19 0v.111a.208.208 0 0 0 .191 0l.549-.318a.067.067 0 0 0 .028-.022.08.08 0 0 0 .011-.034l-.001-.11z"
            fill="#3D3D3D"
        />
        <path
            d="m523.95 837.36-1.516-.876a.067.067 0 0 1-.028-.022.06.06 0 0 1-.013-.032v.109c0 .012.004.023.012.033.007.01.017.017.029.021l1.516.88v-.113z"
            fill="#636363"
        />
        <path
            d="M524.73 836.98a.068.068 0 0 1-.041.055l-.548.319a.21.21 0 0 1-.192 0v.113a.223.223 0 0 0 .189 0l.551-.32c.011-.005.021-.013.028-.023s.012-.021.013-.033v-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m524.86 837.87-.55-.319a.057.057 0 0 1-.028-.023.062.062 0 0 1-.012-.035v.112a.085.085 0 0 0 .014.034.085.085 0 0 0 .028.022l.55.318-.002-.109z"
            fill="#636363"
        />
        <path
            d="M525.64 837.5c-.001.012-.005.023-.012.033s-.017.018-.028.023l-.551.319a.208.208 0 0 1-.191 0v.109a.201.201 0 0 0 .191 0l.551-.318a.067.067 0 0 0 .027-.023.07.07 0 0 0 .013-.032v-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m525.9 838.46-.552-.319a.062.062 0 0 1-.029-.021.06.06 0 0 1-.013-.033v.109c.001.012.005.024.012.034s.017.018.028.023l.553.316.001-.109z"
            fill="#636363"
        />
        <path
            d="M526.68 838.09a.053.053 0 0 1-.01.032.064.064 0 0 1-.027.022l-.552.321a.204.204 0 0 1-.188 0v.109c.029.015.062.024.095.024s.065-.009.094-.024l.552-.316a.072.072 0 0 0 .026-.023.076.076 0 0 0 .011-.032l-.001-.113z"
            fill="#3D3D3D"
        />
        <path
            d="m526.87 839.02-.551-.315a.073.073 0 0 1-.027-.022.079.079 0 0 1-.013-.033v.11a.07.07 0 0 0 .04.054l.551.319v-.113z"
            fill="#636363"
        />
        <path
            d="M527.64 838.65a.068.068 0 0 1-.037.055l-.549.319a.202.202 0 0 1-.193 0v.109a.202.202 0 0 0 .193 0l.549-.317c.023-.016.037-.032.037-.053v-.113z"
            fill="#3D3D3D"
        />
        <path
            d="m527.83 839.58-.555-.317c-.01-.006-.019-.014-.026-.024s-.011-.022-.013-.034v.111a.07.07 0 0 0 .013.032c.007.01.016.018.026.023l.555.32v-.111z"
            fill="#636363"
        />
        <path
            d="M528.61 839.21c0 .021-.013.039-.04.057l-.55.317a.204.204 0 0 1-.188 0v.111a.204.204 0 0 0 .188 0l.55-.32a.066.066 0 0 0 .038-.055l.002-.11z"
            fill="#3D3D3D"
        />
        <path
            d="m523.02 837.9-1.516-.877a.066.066 0 0 1-.039-.055v.111a.06.06 0 0 0 .012.032c.007.01.016.017.027.022l1.516.879v-.112z"
            fill="#636363"
        />
        <path
            d="M523.8 837.52a.062.062 0 0 1-.013.034.06.06 0 0 1-.028.022l-.547.32a.216.216 0 0 1-.193 0v.112a.228.228 0 0 0 .193 0l.547-.319a.074.074 0 0 0 .028-.022.079.079 0 0 0 .013-.033v-.114z"
            fill="#3D3D3D"
        />
        <path
            d="m523.98 838.46-.555-.319a.067.067 0 0 1-.028-.022.065.065 0 0 1-.011-.033v.108c0 .012.004.024.011.033.007.01.016.018.028.022l.552.32.003-.109z"
            fill="#636363"
        />
        <path
            d="M524.76 838.08a.055.055 0 0 1-.011.033.06.06 0 0 1-.028.022l-.55.319a.193.193 0 0 1-.187 0v.109a.2.2 0 0 0 .19 0l.55-.32c.011-.004.021-.011.028-.02s.011-.02.011-.032l-.003-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m524.98 839.05-.553-.32a.07.07 0 0 1-.039-.057v.112c.001.012.005.023.012.033s.016.018.027.023l.552.318.001-.109z"
            fill="#636363"
        />
        <path
            d="M525.76 838.67a.076.076 0 0 1-.011.033.078.078 0 0 1-.026.022l-.549.32a.22.22 0 0 1-.191 0v.109a.208.208 0 0 0 .096.022.214.214 0 0 0 .096-.022l.549-.318a.07.07 0 0 0 .025-.023.066.066 0 0 0 .012-.033l-.001-.11z"
            fill="#3D3D3D"
        />
        <path
            d="m525.94 839.61-.553-.32c-.011-.005-.021-.012-.028-.022s-.011-.021-.011-.033v.109c0 .012.004.024.011.035.006.01.016.018.028.023l.553.318v-.11z"
            fill="#636363"
        />
        <path
            d="M526.72 839.23a.07.07 0 0 1-.039.057l-.547.316a.204.204 0 0 1-.192 0v.11a.197.197 0 0 0 .189 0l.55-.318c.011-.005.02-.013.027-.023s.011-.021.011-.033l.001-.109z"
            fill="#3D3D3D"
        />
        <path
            d="m526.04 841.84-.553-.321a.07.07 0 0 1-.027-.021.066.066 0 0 1-.012-.032v.108a.068.068 0 0 0 .011.033.07.07 0 0 0 .026.022l.555.32v-.109z"
            fill="#636363"
        />
        <path
            d="M526.82 841.47a.068.068 0 0 1-.011.031.062.062 0 0 1-.025.02l-.55.321a.215.215 0 0 1-.192 0v.109a.215.215 0 0 0 .192 0l.55-.32a.066.066 0 0 0 .026-.021.063.063 0 0 0 .01-.032v-.108z"
            fill="#3D3D3D"
        />
        <path
            d="m528.8 840.14-.551-.32a.09.09 0 0 1-.029-.022.071.071 0 0 1-.013-.034v.109a.075.075 0 0 0 .04.059l.553.317v-.109z"
            fill="#636363"
        />
        <path
            d="M529.58 839.76c-.001.012-.005.023-.012.033s-.016.018-.027.023l-.549.32a.229.229 0 0 1-.193 0v.109a.21.21 0 0 0 .095.022.211.211 0 0 0 .096-.022l.551-.317a.072.072 0 0 0 .027-.025.07.07 0 0 0 .012-.034v-.109z"
            fill="#3D3D3D"
        />
        <path
            d="m526.91 840.16-.554-.321c-.011-.005-.02-.012-.027-.022s-.011-.022-.012-.034v.111a.062.062 0 0 0 .039.054l.554.318v-.106z"
            fill="#636363"
        />
        <path
            d="M527.69 839.79a.065.065 0 0 1-.041.054l-.549.321a.22.22 0 0 1-.19 0v.106a.211.211 0 0 0 .19 0l.548-.318a.06.06 0 0 0 .042-.052v-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m527.87 840.72-.554-.32a.066.066 0 0 1-.039-.055v.111c.001.012.005.023.012.033s.016.018.027.023l.554.321v-.113z"
            fill="#636363"
        />
        <path
            d="M528.65 840.34a.068.068 0 0 1-.013.033.073.073 0 0 1-.027.022l-.547.32a.215.215 0 0 1-.193 0v.113c.03.014.063.022.096.022s.065-.008.095-.022l.549-.321c.026-.017.04-.035.04-.056v-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m524.05 839.61-.555-.316a.103.103 0 0 1-.026-.025.085.085 0 0 1-.011-.034v.109a.06.06 0 0 0 .011.034.076.076 0 0 0 .028.022l.555.321-.002-.111z"
            fill="#636363"
        />
        <path
            d="M524.83 839.24a.077.077 0 0 1-.012.035.081.081 0 0 1-.028.024l-.547.316a.208.208 0 0 1-.191 0v.111a.214.214 0 0 0 .191 0l.547-.321a.083.083 0 0 0 .028-.021.066.066 0 0 0 .012-.033v-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m525.02 840.17-.554-.318a.081.081 0 0 1-.042-.057v.108c0 .023.016.041.042.059l.554.318v-.11z"
            fill="#636363"
        />
        <path
            d="M525.8 839.8a.083.083 0 0 1-.013.034.077.077 0 0 1-.028.023l-.55.317a.207.207 0 0 1-.188 0v.11a.204.204 0 0 0 .188 0l.55-.318c.027-.018.041-.035.041-.057v-.109z"
            fill="#3D3D3D"
        />
        <path
            d="m525.98 840.73-.552-.318a.062.062 0 0 1-.028-.022.054.054 0 0 1-.012-.034v.111a.062.062 0 0 0 .013.034.076.076 0 0 0 .028.022l.552.317-.001-.11z"
            fill="#636363"
        />
        <path
            d="M526.76 840.35a.071.071 0 0 1-.013.034.073.073 0 0 1-.03.022l-.545.318a.216.216 0 0 1-.193 0v.11a.205.205 0 0 0 .193 0l.545-.317a.08.08 0 0 0 .029-.023.08.08 0 0 0 .014-.033v-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m526.95 841.28-.553-.318a.056.056 0 0 1-.028-.022.055.055 0 0 1-.012-.033v.108a.067.067 0 0 0 .04.058l.553.318v-.111z"
            fill="#636363"
        />
        <path
            d="M527.73 840.91c-.001.012-.005.024-.012.034s-.017.018-.028.023l-.55.316a.201.201 0 0 1-.191 0v.111a.204.204 0 0 0 .189 0l.55-.318a.063.063 0 0 0 .041-.056l.001-.11z"
            fill="#3D3D3D"
        />
        <path
            d="m527 842.4-.551-.319a.073.073 0 0 1-.027-.022.068.068 0 0 1-.013-.033v.111c.002.011.006.022.013.031s.016.017.027.021l.551.323v-.112z"
            fill="#636363"
        />
        <path
            d="M527.78 842.03a.073.073 0 0 1-.012.032.064.064 0 0 1-.027.022l-.549.319a.204.204 0 0 1-.192 0v.112c.03.015.063.022.096.022s.066-.007.096-.022l.549-.32c.01-.006.019-.013.026-.023s.011-.021.013-.032v-.11z"
            fill="#3D3D3D"
        />
        <path
            d="m529.76 840.69-.555-.32a.066.066 0 0 1-.039-.055v.111a.079.079 0 0 0 .013.033.085.085 0 0 0 .028.022l.555.318-.002-.109z"
            fill="#636363"
        />
        <path
            d="M530.67 840.39a.059.059 0 0 1-.011.032.059.059 0 0 1-.025.022l-.551.321a.208.208 0 0 1-.191 0v.109a.22.22 0 0 0 .191 0l.551-.318a.064.064 0 0 0 .024-.022.078.078 0 0 0 .012-.032v-.112z"
            fill="#3D3D3D"
        />
        <path
            d="m528.83 841.27-.553-.316c-.011-.005-.02-.014-.027-.024s-.011-.022-.012-.034v.111a.066.066 0 0 0 .039.055l.553.322v-.114z"
            fill="#636363"
        />
        <path
            d="M529.62 840.9a.065.065 0 0 1-.038.056l-.551.318a.198.198 0 0 1-.191 0v.114a.242.242 0 0 0 .191 0l.551-.322a.068.068 0 0 0 .038-.053v-.113z"
            fill="#3D3D3D"
        />
        <path
            d="m527.91 841.84-.556-.321a.067.067 0 0 1-.025-.022.071.071 0 0 1-.013-.031v.108a.071.071 0 0 0 .038.055l.554.32.002-.109z"
            fill="#636363"
        />
        <path
            d="M528.7 841.47a.06.06 0 0 1-.013.031.057.057 0 0 1-.026.02l-.55.321a.208.208 0 0 1-.19 0v.109a.215.215 0 0 0 .192 0l.55-.32a.056.056 0 0 0 .027-.021.068.068 0 0 0 .011-.032l-.001-.108z"
            fill="#3D3D3D"
        />
        <path
            d="m520.3 838.5-.555-.319a.058.058 0 0 1-.026-.023.068.068 0 0 1-.013-.033v.11a.066.066 0 0 0 .012.033.07.07 0 0 0 .027.021l.555.318v-.107z"
            fill="#636363"
        />
        <path
            d="M521.07 838.12a.068.068 0 0 1-.011.032.056.056 0 0 1-.027.021l-.55.319a.208.208 0 0 1-.19 0v.111a.207.207 0 0 0 .189 0l.551-.32a.067.067 0 0 0 .025-.022.063.063 0 0 0 .012-.032l.001-.109z"
            fill="#3D3D3D"
        />
        <path
            d="m521.21 839.03-.553-.319a.065.065 0 0 1-.028-.024.08.08 0 0 1-.011-.034v.111a.071.071 0 0 0 .013.034c.006.01.015.018.026.024l.553.317v-.109z"
            fill="#636363"
        />
        <path
            d="M522 838.65c-.001.012-.004.024-.011.034s-.017.017-.028.022l-.548.319a.204.204 0 0 1-.192 0v.109a.189.189 0 0 0 .096.025.191.191 0 0 0 .096-.025l.548-.317c.011-.005.02-.013.027-.023s.011-.021.012-.033v-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m522.18 839.58-.555-.318c-.011-.006-.02-.014-.027-.024s-.011-.021-.012-.033v.11a.066.066 0 0 0 .039.055l.553.321.002-.111z"
            fill="#636363"
        />
        <path
            d="M522.96 839.21a.077.077 0 0 1-.04.057l-.55.318a.204.204 0 0 1-.189 0v.111a.22.22 0 0 0 .191 0l.55-.321a.082.082 0 0 0 .027-.022.079.079 0 0 0 .013-.033l-.002-.11z"
            fill="#3D3D3D"
        />
        <path
            d="m530.82 840.22-4.427-2.57c-.012-.005-.021-.014-.028-.024s-.012-.022-.012-.034v.113c0 .02.012.04.058.077l4.409 2.549v-.111zM531.81 840.79l-.556-.318c-.011-.005-.021-.014-.028-.024s-.012-.022-.013-.034v.112a.067.067 0 0 0 .041.056l.556.318v-.11z"
            fill="#636363"
        />
        <path
            d="M532.59 840.42a.083.083 0 0 1-.013.034.065.065 0 0 1-.028.024l-.548.318a.222.222 0 0 1-.188 0v.11a.204.204 0 0 0 .188 0l.548-.318c.011-.005.021-.012.028-.022s.011-.022.012-.034l.001-.112zM531.6 839.85a.078.078 0 0 1-.012.032.07.07 0 0 1-.027.021l-.549.32a.225.225 0 0 1-.192 0v.11a.229.229 0 0 0 .193 0l.549-.318c.011-.006.02-.014.027-.024s.011-.022.012-.034l-.001-.107z"
            fill="#3D3D3D"
        />
        <path
            d="m532.78 841.37-.553-.32a.06.06 0 0 1-.027-.02.068.068 0 0 1-.013-.033v.109a.068.068 0 0 0 .013.033.06.06 0 0 0 .027.02l.553.322v-.111z"
            fill="#636363"
        />
        <path
            d="M533.56 841a.066.066 0 0 1-.012.033.072.072 0 0 1-.029.02l-.549.32a.204.204 0 0 1-.189 0v.111a.197.197 0 0 0 .189 0l.549-.322a.066.066 0 0 0 .029-.02.066.066 0 0 0 .012-.033V841z"
            fill="#3D3D3D"
        />
        <path
            d="M525.65 836.32c.052.032.052.079 0 .113l-.548.315a.199.199 0 0 1-.192 0l-1.519-.875c-.052-.03-.052-.079 0-.111l.549-.32a.208.208 0 0 1 .191 0l1.519.878z"
            fill="#4A4A4A"
        />
        <path
            d="m524.91 836.75-1.519-.875c-.011-.005-.021-.013-.028-.023s-.011-.021-.011-.033v.111c0 .012.004.023.011.033s.017.017.028.022l1.517.877.002-.112z"
            fill="#636363"
        />
        <path
            d="M525.7 836.37c-.001.012-.005.024-.012.034s-.016.019-.027.024l-.548.315a.199.199 0 0 1-.192 0v.112a.215.215 0 0 0 .192 0l.55-.319a.078.078 0 0 0 .026-.022.08.08 0 0 0 .013-.032l-.002-.112z"
            fill="#3D3D3D"
        />
        <path
            d="m530.84 841.34-.555-.321a.073.073 0 0 1-.027-.022.078.078 0 0 1-.012-.032v.11c0 .02.015.039.039.056l.554.318.001-.109z"
            fill="#636363"
        />
        <path
            d="M531.62 840.97a.075.075 0 0 1-.04.051l-.55.321a.212.212 0 0 1-.191 0v.109a.208.208 0 0 0 .191 0l.551-.32a.061.061 0 0 0 .025-.023.06.06 0 0 0 .012-.032l.002-.106z"
            fill="#3D3D3D"
        />
        <path
            d="m521.18 837.89-.554-.321a.075.075 0 0 1-.029-.021.08.08 0 0 1-.014-.033v.109a.06.06 0 0 0 .014.034c.007.01.017.018.029.022l.554.317v-.107z"
            fill="#636363"
        />
        <path
            d="M521.96 837.51a.07.07 0 0 1-.013.032.067.067 0 0 1-.025.022l-.55.321a.21.21 0 0 1-.189 0v.107a.191.191 0 0 0 .189 0l.55-.317a.061.061 0 0 0 .025-.023.07.07 0 0 0 .013-.032v-.11z"
            fill="#3D3D3D"
        />
        <path
            d="m522.15 838.44-.554-.319a.065.065 0 0 1-.028-.024.06.06 0 0 1-.011-.034v.111c0 .012.004.024.011.034s.017.018.028.023l.554.319v-.11z"
            fill="#636363"
        />
        <path
            d="M522.92 838.07a.055.055 0 0 1-.012.033.063.063 0 0 1-.028.023l-.546.319a.208.208 0 0 1-.096.022.214.214 0 0 1-.096-.022v.11c.03.015.063.022.096.022a.208.208 0 0 0 .096-.022l.546-.319a.067.067 0 0 0 .028-.022.06.06 0 0 0 .012-.032v-.112z"
            fill="#3D3D3D"
        />
        <path
            d="m523.11 839.01-.551-.32a.064.064 0 0 1-.029-.022.062.062 0 0 1-.013-.034v.111a.068.068 0 0 0 .013.033.062.062 0 0 0 .029.021l.551.32v-.109z"
            fill="#636363"
        />
        <path
            d="M523.89 838.63a.066.066 0 0 1-.012.033.076.076 0 0 1-.028.022l-.552.32a.21.21 0 0 1-.189 0v.109a.197.197 0 0 0 .189 0l.552-.319c.01-.005.019-.012.026-.021s.011-.02.013-.031l.001-.113z"
            fill="#3D3D3D"
        />
        <path
            d="m529.8 841.83-.548-.318c-.029-.017-.042-.036-.042-.056v.108c0 .022.013.04.042.057l.548.32v-.111z"
            fill="#636363"
        />
        <path
            d="M530.59 841.53a.066.066 0 0 1-.039.055l-.55.317a.204.204 0 0 1-.191 0v.114a.23.23 0 0 0 .192 0l.548-.32c.011-.005.021-.013.028-.023s.012-.021.013-.033l-.001-.11z"
            fill="#3D3D3D"
        />
        <path
            d="m530.9 842.45-.553-.32a.07.07 0 0 1-.028-.023.071.071 0 0 1-.01-.035v.111c0 .012.004.024.01.034a.07.07 0 0 0 .028.023l.553.318v-.108z"
            fill="#636363"
        />
        <path
            d="M531.68 842.07a.066.066 0 0 1-.011.036.06.06 0 0 1-.03.022l-.549.318c-.029.016-.062.023-.095.023s-.066-.007-.096-.023v.108a.198.198 0 0 0 .191 0l.549-.316a.066.066 0 0 0 .041-.057v-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m532.76 843.55-1.516-.875c-.027-.017-.043-.037-.043-.056v.109a.074.074 0 0 0 .043.056l1.516.877v-.111z"
            fill="#636363"
        />
        <path
            d="M533.54 843.18a.071.071 0 0 1-.039.053l-.552.319c-.029.015-.062.024-.095.024s-.066-.009-.095-.024v.111a.223.223 0 0 0 .19 0l.552-.321a.07.07 0 0 0 .027-.021.066.066 0 0 0 .012-.032v-.109z"
            fill="#3D3D3D"
        />
        <path
            d="m528.88 842.4-.555-.319a.073.073 0 0 1-.041-.055v.111c.002.011.007.022.014.031s.017.016.027.021l.555.323v-.112z"
            fill="#636363"
        />
        <path
            d="M529.65 842.03a.058.058 0 0 1-.01.032.058.058 0 0 1-.027.022l-.55.319a.194.194 0 0 1-.189 0v.112a.206.206 0 0 0 .094.022.207.207 0 0 0 .095-.022l.55-.323a.058.058 0 0 0 .037-.051v-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m529.84 842.96-.553-.317a.075.075 0 0 1-.026-.024.067.067 0 0 1-.01-.034v.111a.076.076 0 0 0 .011.033.078.078 0 0 0 .026.022l.554.32-.002-.111z"
            fill="#636363"
        />
        <path
            d="M530.64 842.62a.07.07 0 0 1-.012.034.076.076 0 0 1-.028.022l-.551.317a.182.182 0 0 1-.189 0v.111a.204.204 0 0 0 .189 0l.551-.319a.07.07 0 0 0 .028-.023.063.063 0 0 0 .012-.033v-.109z"
            fill="#3D3D3D"
        />
        <path
            d="m531.77 844.07-1.519-.878a.064.064 0 0 1-.027-.022.06.06 0 0 1-.013-.032v.109c0 .023.014.039.04.058l1.519.877v-.112z"
            fill="#636363"
        />
        <path
            d="M532.55 843.7a.07.07 0 0 1-.013.032.06.06 0 0 1-.027.021l-.547.321a.214.214 0 0 1-.191 0v.112a.208.208 0 0 0 .191 0l.547-.322a.058.058 0 0 0 .027-.022.064.064 0 0 0 .013-.033v-.109z"
            fill="#3D3D3D"
        />
        <path
            d="m527.97 842.93-.555-.32a.064.064 0 0 1-.027-.022.06.06 0 0 1-.012-.032v.108a.078.078 0 0 0 .04.057l.555.319-.001-.11z"
            fill="#636363"
        />
        <path
            d="M528.74 842.56c-.001.012-.006.023-.013.033s-.017.017-.028.021l-.548.318a.204.204 0 0 1-.189 0v.11a.197.197 0 0 0 .189 0l.548-.319a.066.066 0 0 0 .029-.021.07.07 0 0 0 .012-.034v-.108z"
            fill="#3D3D3D"
        />
        <path
            d="m528.93 843.48-.552-.318a.066.066 0 0 1-.029-.023.063.063 0 0 1-.013-.035v.114c0 .019.014.038.042.054l.552.317v-.109z"
            fill="#636363"
        />
        <path
            d="M529.71 843.11a.083.083 0 0 1-.013.034.075.075 0 0 1-.026.024l-.551.318a.2.2 0 0 1-.19 0v.109a.2.2 0 0 0 .19 0l.549-.317c.025-.016.041-.035.041-.054v-.114z"
            fill="#3D3D3D"
        />
        <path
            d="M529.67 843.06a.066.066 0 0 1 .029.021c.007.01.011.022.011.034s-.004.024-.011.034a.066.066 0 0 1-.029.021l-.551.318a.197.197 0 0 1-.19 0l-.552-.318c-.056-.031-.056-.082 0-.111l.548-.319a.198.198 0 0 1 .191 0l.554.32z"
            fill="#4A4A4A"
        />
        <path
            d="m530.86 844.6-1.516-.876a.073.073 0 0 1-.029-.023.07.07 0 0 1-.012-.034v.112a.06.06 0 0 0 .012.032c.007.01.017.017.028.021l1.517.876v-.108z"
            fill="#636363"
        />
        <path
            d="M531.64 844.23c-.001.012-.005.023-.012.032s-.016.017-.027.022l-.549.32a.21.21 0 0 1-.192 0v.106a.199.199 0 0 0 .192 0l.549-.318c.011-.005.02-.013.027-.022s.011-.02.012-.032v-.108z"
            fill="#3D3D3D"
        />
        <path
            d="M534.47 842.58a.058.058 0 0 1 .028.021c.007.009.01.021.01.033a.056.056 0 0 1-.038.054l-.55.322a.214.214 0 0 1-.191 0l-2.436-1.413c-.054-.03-.054-.078 0-.11l.55-.319a.205.205 0 0 1 .19 0l2.437 1.412z"
            fill="#4A4A4A"
        />
        <path
            d="m533.73 843.01-2.436-1.413a.074.074 0 0 1-.028-.022.066.066 0 0 1-.012-.033v.11a.077.077 0 0 0 .012.033c.007.01.016.018.027.023l2.437 1.41v-.108z"
            fill="#636363"
        />
        <path
            d="M534.5 842.63a.071.071 0 0 1-.013.031.067.067 0 0 1-.025.022l-.55.32a.208.208 0 0 1-.191 0v.11a.208.208 0 0 0 .191 0l.55-.319a.06.06 0 0 0 .036-.054l.002-.11z"
            fill="#3D3D3D"
        />
        <path
            d="M536.18 842.4c-.519.174-1.1-.413-1.256-.886-.056-.165-1.064.063-1.508-.057a.456.456 0 0 1-.28-.7 17.807 17.807 0 0 1 2.037-.15c1.316-.084 1.526.39 1.682.862s-.154.756-.675.931z"
            fill="#FFE8D9"
        />
        <path
            d="M536.34 841.87c.28.487.394.234.394.234.635.422 1.316.77 2.031 1.038a22.534 22.534 0 0 0 5.8-3.3 4.252 4.252 0 0 0 1.25-4.014s-.552-6.331-.932-7.766c-.64-2.4-3.467-1.332-3.68 1.281.108 2.323.382 4.636.819 6.92a1.585 1.585 0 0 1-.744 1.679l-3.787 2.111s-1.7.866-1.151 1.817z"
            fill="#688CAA"
        />
        <path
            d="m537.25 842.7-.443-1.37-1.79.026-.266.09-2.049.918a1.13 1.13 0 0 0-.378.23 1.126 1.126 0 0 0-.282 1.228c.226.714.02.078.02.078a1.165 1.165 0 0 0 1.4.714l2.816-.664c.582-.177 1.176-.621.972-1.25z"
            fill="#FFE8D9"
        />
        <path
            d="M536.03 840.32c-.244.1-.486.852-.241 1.605.132.493.366.953.688 1.35.335.371.6.536.922.441 0 0 1.176-.347 1.538-.472.234-.083.184-.2.184-.2a.98.98 0 0 1-.267.047c-.3-.036-.79-.3-1.216-1.216-.672-1.436.1-1.97.1-1.97-.092-.21-.215-.24-.453-.125l-1.255.54z"
            fill="#E4EFF4"
        />
        <path
            d="M531.32 834.63a9.091 9.091 0 0 0-.85-2.774c-.62-.736-1.066-1.356-2.33-.852-1.342.538-1.458 2.888-1.237 3.471.21.544 1.371 1.411 1.371 1.411l3.046-1.256z"
            fill="#3A566D"
        />
        <path
            d="M530.2 836.63c.213.5 1.036.547 1.5.351.159-.068.658.84 1.042 1.1a.458.458 0 0 0 .711-.256 17.442 17.442 0 0 0-1.239-1.624c-.807-1.045-1.3-.884-1.76-.691s-.461.614-.254 1.12z"
            fill="#FFE8D9"
        />
        <path
            d="m529.27 836.02 1.32-.576 1.167 1.359.11.257.663 2.143s.192.693-.893 1.069a1.536 1.536 0 0 1-1.792-.716l-.864-1.978c-.256-.557-.318-1.295.289-1.558z"
            fill="#FFE8D9"
        />
        <path
            d="M531.4 834.14c-.111-.232-.848-.435-1.576-.166a3.534 3.534 0 0 0-1.286.721c-.35.343-.5.61-.4.917 0 0 .381 1.124.519 1.474.09.222.2.17.2.17a.99.99 0 0 1-.055-.258c.025-.292.266-.779 1.141-1.233 1.375-.711 1.921.016 1.921.016.205-.1.227-.218.109-.441l-.573-1.2z"
            fill="#E4EFF4"
        />
        <path
            d="M518.8 829.37a.537.537 0 0 0-.547 0l-.142.086 12.37 7.284.255 9.044.3-.172v-8.587a1.104 1.104 0 0 0-.546-.945l-11.69-6.71z"
            fill="#8E8D8D"
        />
        <path
            d="M530.2 836.26a1.096 1.096 0 0 1 .548.948v8.586l-12.854-7.4v-8.584a.369.369 0 0 1 .182-.316.362.362 0 0 1 .365 0l11.759 6.766z"
            fill="#C1BFBD"
        />
        <path
            d="M591.21 869.69a9.12 9.12 0 0 0-.852-2.775c-.621-.734-1.066-1.356-2.329-.852-1.341.538-1.459 2.889-1.236 3.469.209.547 1.371 1.416 1.371 1.416l3.046-1.258z"
            fill="#3A566D"
        />
        <path
            d="M597.45 877.32c-.094.016-8.771-5.31-8.771-5.31l-6 3.616.734.449 5.281-3.147 7.96 5.063.796-.671z"
            fill="#7C7C7C"
        />
        <path
            d="M585.22 873.77a.229.229 0 0 0 .227.233.233.233 0 0 0 .231-.233.23.23 0 0 0-.392-.161.231.231 0 0 0-.066.161z"
            fill="#686868"
        />
        <path
            d="M585.28 873.78c-.082.048-.082.119 0 .167a.312.312 0 0 0 .289 0c.079-.048.079-.119 0-.167a.331.331 0 0 0-.289 0z"
            fill="#7C7C7C"
        />
        <path
            d="m583.04 875.86 8.533 4.958 5.654-3.268-8.53-4.956-5.657 3.266z"
            fill="#14AAB2"
        />
        <path
            d="M588.21 871.69a.97.97 0 0 1 .884 0l9.368 5.446c.243.14.241.369 0 .512l-6.48 3.739a.968.968 0 0 1-.883 0l-9.369-5.445a.27.27 0 0 1-.181-.255.269.269 0 0 1 .181-.255l6.48-3.742zm3.367 8.985 5.654-3.263-8.53-4.96-5.657 3.27 8.533 4.953zm3.51-1.236a.177.177 0 0 0 .117-.164.171.171 0 0 0-.033-.1.171.171 0 0 0-.084-.063.646.646 0 0 0-.566 0c-.034.012-.063.034-.084.063s-.032.064-.032.1.011.071.032.101c.021.029.05.051.084.063a.615.615 0 0 0 .564 0h.002zm-9.8-5.716c-.077.047-.081.121 0 .167a.302.302 0 0 0 .288 0c.081-.046.081-.12 0-.167a.32.32 0 0 0-.286 0h-.002z"
            fill="#BFC1C1"
        />
        <path
            d="m581.73 875.94 9.369 5.445a.966.966 0 0 0 .883 0l6.48-3.739a.316.316 0 0 0 .185-.256v.808a.316.316 0 0 1-.187.26l-6.478 3.74a.981.981 0 0 1-.883 0l-9.37-5.441a.32.32 0 0 1-.179-.255v-.815a.314.314 0 0 0 .055.151.31.31 0 0 0 .125.102z"
            fill="#A7A9AA"
        />
        <path
            d="M594.33 879.27v.049c.004.04.018.079.041.112s.054.06.091.077a.737.737 0 0 0 .653 0 .224.224 0 0 0 .092-.078.229.229 0 0 0 .042-.113v-.051a.225.225 0 0 1-.042.112.222.222 0 0 1-.092.077.714.714 0 0 1-.653 0 .234.234 0 0 1-.132-.185z"
            fill="#616464"
        />
        <path
            d="M594.47 879.08c-.18.107-.182.273 0 .377a.713.713 0 0 0 .653 0 .199.199 0 0 0 .133-.188.2.2 0 0 0-.133-.189.728.728 0 0 0-.653 0z"
            fill="#CCCECE"
        />
        <path
            d="m596.07 879.63-.017-.295-1.365.788.011.3 1.371-.793z"
            fill="#4F4F4F"
        />
        <path
            d="m596.07 879.63-.239-.172-1.143.665.011.3 1.371-.793z"
            fill="#838484"
        />
        <path
            d="M582.84 876.82a.077.077 0 0 1 .045-.008c.015.001.03.007.042.017l1.554.894c.015.008.029.02.039.035a.278.278 0 0 1 .087.187.084.084 0 0 1-.008.044.087.087 0 0 1-.028.035l-.176.1c.012-.01.022-.022.028-.036s.009-.03.008-.045a.304.304 0 0 0-.079-.183c-.014-.014-.03-.025-.044-.037l-1.555-.9a.087.087 0 0 0-.044-.016.08.08 0 0 0-.045.01l.176-.097z"
            fill="#BFC1C1"
        />
        <path
            d="M582.76 876.92c-.07-.035-.127-.006-.127.073a.273.273 0 0 0 .127.216l1.552.9c.071.038.126.008.126-.071a.278.278 0 0 0-.123-.22l-1.555-.898z"
            fill="#838484"
        />
        <path
            d="M590.1 871.68c.214.5 1.035.548 1.5.352.158-.067.656.841 1.044 1.1a.458.458 0 0 0 .605-.062.468.468 0 0 0 .103-.194 17.53 17.53 0 0 0-1.236-1.623c-.811-1.047-1.3-.886-1.764-.692s-.47.614-.252 1.119z"
            fill="#FFE8D9"
        />
        <path
            d="m589.15 871.08 1.324-.575 1.165 1.359.109.258.668 2.142s.188.694-.9 1.07a1.527 1.527 0 0 1-1.79-.718l-.865-1.976c-.253-.559-.314-1.295.289-1.56z"
            fill="#FFE8D9"
        />
        <path
            d="M591.28 869.21c-.109-.232-.85-.435-1.575-.168a3.6 3.6 0 0 0-1.286.72c-.351.343-.5.612-.4.919 0 0 .381 1.123.519 1.471.086.227.2.171.2.171a.954.954 0 0 1-.057-.258c.028-.289.269-.777 1.142-1.23 1.372-.711 1.92.015 1.92.015.206-.1.227-.219.11-.446l-.573-1.194z"
            fill="#E4EFF4"
        />
        <path
            d="M596.41 877.06c-.521.177-1.1-.412-1.256-.887-.058-.162-1.067.065-1.51-.051a.454.454 0 0 1-.353-.493.454.454 0 0 1 .074-.207 17.984 17.984 0 0 1 2.035-.149c1.32-.086 1.528.386 1.686.861s-.158.755-.676.926z"
            fill="#FFE8D9"
        />
        <path
            d="M596.57 876.53c.279.49.4.234.4.234.634.422 1.314.771 2.026 1.041a22.576 22.576 0 0 0 5.8-3.3 4.253 4.253 0 0 0 1.249-4.012s-.554-6.332-.936-7.764c-.639-2.4-3.464-1.336-3.678 1.279.11 2.323.384 4.636.82 6.922a1.582 1.582 0 0 1-.745 1.677l-3.785 2.111s-1.697.86-1.151 1.812z"
            fill="#688CAA"
        />
        <path
            d="m597.48 877.36-.444-1.372-1.792.025-.266.09-2.047.919a1.12 1.12 0 0 0-.662 1.457c.228.714.024.077.024.077a1.155 1.155 0 0 0 1.391.716l2.819-.667c.585-.174 1.18-.618.977-1.245z"
            fill="#FFE8D9"
        />
        <path
            d="M596.26 874.98c-.242.107-.485.854-.241 1.611.134.491.368.95.688 1.346.338.372.605.536.923.442 0 0 1.174-.346 1.539-.473.233-.082.186-.2.186-.2a.952.952 0 0 1-.27.048c-.3-.039-.79-.3-1.218-1.217-.672-1.436.1-1.967.1-1.967-.09-.215-.212-.242-.451-.127l-1.256.537z"
            fill="#E4EFF4"
        />
        <path
            d="M583.47 885.73c0 .4-.528.73-1.179.73s-1.182-.329-1.182-.73.531-.736 1.182-.736 1.179.328 1.179.736z"
            fill="#B9DBD8"
        />
        <path
            d="M583.26 884.77a2.096 2.096 0 0 0-1.9-.022.686.686 0 0 0-.407.559.156.156 0 0 1 .112.034.155.155 0 0 1 .055.103v.28a.611.611 0 0 1 .36-.494 1.833 1.833 0 0 1 1.666.022.58.58 0 0 1 .335.476v-.279a.153.153 0 0 1 .168-.135.66.66 0 0 0-.389-.544z"
            fill="#CAEDEB"
        />
        <path
            d="M582.86 884.88c-.01.04-.122.051-.248.015s-.22-.093-.211-.136.125-.049.25-.017.22.094.209.138z"
            fill="#DCF9F7"
        />
        <path
            d="M583.66 881.12a3.034 3.034 0 0 1-2.757-.027c-.751-.449-.734-1.164.039-1.6a3.026 3.026 0 0 1 2.757.029c.751.449.734 1.164-.039 1.598z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M583.7 879.91c.242.126.429.338.525.594a.874.874 0 0 0-.525-.982 3.026 3.026 0 0 0-2.757-.029c-.481.27-.667.648-.562 1 .101-.27.302-.491.562-.617a3.035 3.035 0 0 1 2.757.034z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M584.46 880.52a.763.763 0 0 0-.03-.285 1.192 1.192 0 0 0-.052-.141l-.024-.046a.056.056 0 0 0-.009-.017l-.006-.013c0-.008-.01-.013-.013-.02s-.016-.027-.024-.037a1.096 1.096 0 0 0-.225-.258 1.51 1.51 0 0 0-.27-.2 2.52 2.52 0 0 0-.245-.131h-.016c-.126-.056-.237-.088-.284-.105s-.152-.044-.3-.073-.245-.039-.313-.047a3.693 3.693 0 0 0-.631 0h-.01a3.513 3.513 0 0 0-.609.106h-.012c-.014.002-.028.006-.042.01a.118.118 0 0 1-.027.006.165.165 0 0 1-.044.016.17.17 0 0 1-.038.013.102.102 0 0 0-.022.009c-.035.012-.071.022-.1.037a2.78 2.78 0 0 0-.27.129 1.201 1.201 0 0 0-.113.072.147.147 0 0 1-.022.01h-.005a1.553 1.553 0 0 0-.216.172 2.006 2.006 0 0 0-.168.198.711.711 0 0 0-.047.074l-.005.011a1.09 1.09 0 0 0-.061.129v.016a1.38 1.38 0 0 0-.042.156c-.006.041-.009.1-.012.14v.069a1.1 1.1 0 0 0 .61.822 3.367 3.367 0 0 0 3.052.03 1.094 1.094 0 0 0 .651-.838v-.023l-.006.009zm-.8.593a3.038 3.038 0 0 1-2.757-.027c-.751-.449-.734-1.164.039-1.6a3.026 3.026 0 0 1 2.757.029c.753.449.736 1.164-.037 1.598h-.002z"
            fill="#B9DBD8"
        />
        <path
            d="M584.46 880.55a1.115 1.115 0 0 1-.651.84 3.37 3.37 0 0 1-3.052-.03 1.09 1.09 0 0 1-.611-.822l.325 4.545v.006-.006c.001.018.004.037.007.056l.01.064a.873.873 0 0 0 .028.1c0 .009.009.023.014.037v.017a1.062 1.062 0 0 0 .266.372 1.557 1.557 0 0 0 .425.281l.045.021c.068.028.146.057.233.086h.009c.034.011.077.022.112.03h.013c.04.009.1.023.181.037h.009c.026 0 .054.008.086.015a.15.15 0 0 1 .03 0c.02 0 .044.006.073.007h.03a.846.846 0 0 0 .087.005h.01c.044 0 .081 0 .121.005s.068 0 .101 0a.469.469 0 0 0 .053 0h.026c.076-.003.152-.009.227-.019l.067-.013.039-.007.039-.005.075-.016h.009a.913.913 0 0 0 .164-.04.547.547 0 0 0 .1-.039.86.86 0 0 0 .09-.029c.038-.016.087-.037.125-.055s.07-.035.1-.054c.047-.026.092-.054.134-.085a1.248 1.248 0 0 0 .314-.299.907.907 0 0 0 .11-.2c.016-.04.032-.092.044-.131a.412.412 0 0 0 .015-.084.16.16 0 0 1 .006-.049c.126-1.514.246-3.027.362-4.541z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M570.88 904.6c0 .4-.527.736-1.181.736s-1.177-.331-1.177-.736.527-.73 1.177-.73 1.181.33 1.181.73z"
            fill="#B9DBD8"
        />
        <path
            d="M570.67 903.65a2.109 2.109 0 0 0-1.9-.02.677.677 0 0 0-.407.558.155.155 0 0 1 .168.137v.279a.6.6 0 0 1 .357-.49c.26-.129.546-.194.836-.19.29.003.575.074.831.209a.581.581 0 0 1 .333.477v-.277a.16.16 0 0 1 .056-.104.15.15 0 0 1 .113-.033.66.66 0 0 0-.387-.546z"
            fill="#CAEDEB"
        />
        <path
            d="M570.27 903.77c-.012.042-.124.049-.25.013s-.218-.093-.209-.137.123-.048.248-.014.222.095.211.138z"
            fill="#DCF9F7"
        />
        <path
            d="M571.08 900.01a3.05 3.05 0 0 1-2.758-.027c-.752-.45-.734-1.164.037-1.6a3.043 3.043 0 0 1 2.758.024c.75.449.735 1.165-.037 1.603z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M571.11 898.79c.241.125.427.335.524.59.1-.342-.07-.709-.524-.982a3.043 3.043 0 0 0-2.758-.024c-.478.268-.667.646-.56 1 .101-.269.301-.489.56-.614a3.026 3.026 0 0 1 2.758.03z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M571.87 899.41a.79.79 0 0 0-.033-.29.848.848 0 0 0-.052-.141l-.024-.046v-.008l-.011-.019-.012-.019a1.075 1.075 0 0 0-.111-.159 1.771 1.771 0 0 0-.407-.339l-.031-.017a1.468 1.468 0 0 0-.217-.109l-.01-.007a2.113 2.113 0 0 0-.29-.1 2.744 2.744 0 0 0-.612-.12 3.286 3.286 0 0 0-.635-.007h-.008a3.006 3.006 0 0 0-.608.108h-.011a.235.235 0 0 0-.043.013.084.084 0 0 1-.024.006c-.018.007-.031.01-.046.017a.182.182 0 0 0-.038.011l-.023.009a2.587 2.587 0 0 0-.51.25c-.076.05-.148.108-.214.172-.021.022-.05.051-.069.074a.819.819 0 0 0-.145.2l-.006.009a.95.95 0 0 0-.063.128v.016a1.368 1.368 0 0 0-.039.156c-.007.041-.01.1-.014.141v.072a1.105 1.105 0 0 0 .608.818 3.368 3.368 0 0 0 3.054.033 1.118 1.118 0 0 0 .652-.837v-.02l-.008.005zm-.8.59a3.05 3.05 0 0 1-2.758-.027c-.752-.45-.734-1.164.037-1.6a3.04 3.04 0 0 1 2.758.024c.752.459.737 1.175-.035 1.613l-.002-.01z"
            fill="#B9DBD8"
        />
        <path
            d="M571.87 899.43a1.117 1.117 0 0 1-.652.837 3.362 3.362 0 0 1-3.054-.033 1.086 1.086 0 0 1-.608-.818 1829.021 1829.021 0 0 0 .329 4.597l.011.065a.675.675 0 0 0 .029.1l.013.035v.014l.012.032a1.041 1.041 0 0 0 .235.329l.018.013a1.4 1.4 0 0 0 .255.193c.039.023.1.056.172.091l.045.018c.075.033.151.062.23.086h.006a.762.762 0 0 0 .116.031l.019.007c.035.008.1.023.177.038h.008c.029 0 .056.009.086.011h.029l.071.011a.893.893 0 0 1 .121.007h.229a.468.468 0 0 1 .053 0h.018a4.009 4.009 0 0 0 .341-.037l.037-.008a.352.352 0 0 0 .077-.016h.007c.041-.01.094-.021.131-.033a.89.89 0 0 0 .134-.045l.089-.033c.041-.015.089-.037.126-.055s.069-.037.1-.051.1-.057.139-.087.105-.082.149-.121c.059-.053.112-.112.16-.177a1.056 1.056 0 0 0 .157-.334.608.608 0 0 0 .015-.087l.005-.049c.124-1.506.246-3.016.365-4.531z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M564.14 872.68c0 .406-.529.733-1.18.733s-1.179-.327-1.179-.733.529-.731 1.179-.731 1.18.328 1.18.731z"
            fill="#B9DBD8"
        />
        <path
            d="M563.92 871.73a2.101 2.101 0 0 0-1.906-.017.67.67 0 0 0-.4.557.152.152 0 0 1 .164.136v.277a.6.6 0 0 1 .357-.488 1.836 1.836 0 0 1 1.667.019.585.585 0 0 1 .335.475v-.284a.156.156 0 0 1 .167-.136.668.668 0 0 0-.119-.321.669.669 0 0 0-.265-.218z"
            fill="#CAEDEB"
        />
        <path
            d="M563.52 871.84c-.01.04-.122.047-.248.013s-.219-.1-.209-.137.124-.049.251-.015.217.1.206.139z"
            fill="#DCF9F7"
        />
        <path
            d="M564.33 868.08a3.04 3.04 0 0 1-2.759-.027c-.748-.45-.731-1.164.042-1.6a3.036 3.036 0 0 1 2.757.025c.752.456.733 1.17-.04 1.602z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M564.37 866.87c.241.125.428.336.523.591.1-.344-.071-.708-.523-.982a3.04 3.04 0 0 0-2.757-.025c-.48.27-.67.648-.562 1 .1-.271.301-.491.562-.614a3.025 3.025 0 0 1 2.757.03z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M565.13 867.49a.938.938 0 0 0-.085-.429c-.01-.014-.016-.031-.026-.046l-.006-.015-.007-.01c-.006-.011-.012-.015-.013-.023l-.026-.043a1.196 1.196 0 0 0-.084-.114c-.04-.045-.1-.1-.136-.14a1.783 1.783 0 0 0-.271-.194l-.033-.019a1.462 1.462 0 0 0-.217-.108l-.009-.007c-.133-.056-.243-.088-.289-.105s-.155-.046-.3-.077-.247-.036-.313-.043a3.522 3.522 0 0 0-.633 0h-.008a3.104 3.104 0 0 0-.611.107h-.006l-.045.01-.026.009c-.014.007-.03.009-.045.017s-.025.01-.037.01l-.023.008a2.746 2.746 0 0 0-.499.247l-.01.006a1.605 1.605 0 0 0-.215.172c-.02.024-.049.049-.069.073s-.071.085-.1.127a.613.613 0 0 0-.046.074l-.005.01a.766.766 0 0 0-.06.13l-.007.014a.79.79 0 0 0-.039.154 1.133 1.133 0 0 0-.012.143v.07a1.105 1.105 0 0 0 .611.82 3.37 3.37 0 0 0 3.053.031 1.136 1.136 0 0 0 .653-.838v-.014l-.006-.007zm-.8.59a3.038 3.038 0 0 1-2.759-.027c-.748-.45-.731-1.164.042-1.6a3.036 3.036 0 0 1 2.757.025c.75.456.731 1.17-.042 1.602h.002z"
            fill="#B9DBD8"
        />
        <path
            d="M565.13 867.51a1.122 1.122 0 0 1-.653.839 3.37 3.37 0 0 1-3.053-.031 1.1 1.1 0 0 1-.611-.82l.326 4.543c0 .015 0 .032.005.05s.007.05.012.067l.025.1c.007.01.008.023.016.035v.017c0 .011.008.02.011.03.053.112.126.213.214.3l.022.024.017.013.019.021c.075.064.154.122.237.174.041.023.1.054.173.091l.043.019c.077.033.155.061.234.086h.006c.032.01.077.021.113.03l.019.005c.059.015.119.027.179.035.03.008.059.012.089.014.01.001.019.003.028.007a.61.61 0 0 0 .073.005l.033.006.085.005h.314c.078-.003.154-.011.23-.023a1.194 1.194 0 0 0 .106-.015l.036-.005c.027-.006.051-.011.078-.019.045-.009.1-.02.134-.031.011 0 .022-.011.033-.013a.836.836 0 0 0 .1-.033c.032-.01.061-.023.09-.032s.087-.037.123-.057.072-.037.1-.051.1-.056.135-.083.109-.084.151-.123a1.015 1.015 0 0 0 .317-.514.603.603 0 0 0 .02-.133c.13-1.505.254-3.016.371-4.533z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M496.15 854.41c0 .4-.525.731-1.177.731s-1.18-.327-1.18-.731.529-.733 1.18-.733 1.177.333 1.177.733z"
            fill="#B9DBD8"
        />
        <path
            d="M495.93 853.45a2.101 2.101 0 0 0-1.9-.017.672.672 0 0 0-.409.557.154.154 0 0 1 .167.135v.28a.6.6 0 0 1 .357-.488 1.837 1.837 0 0 1 1.667.017.577.577 0 0 1 .333.477v-.277c.004-.04.024-.077.055-.103s.071-.038.111-.034a.666.666 0 0 0-.381-.547z"
            fill="#CAEDEB"
        />
        <path
            d="M495.54 853.56c-.014.042-.124.049-.251.015s-.219-.094-.206-.136.122-.049.247-.016.219.095.21.137z"
            fill="#DCF9F7"
        />
        <path
            d="M496.34 849.81a3.044 3.044 0 0 1-2.758-.03c-.751-.447-.734-1.165.038-1.6a3.023 3.023 0 0 1 2.758.028c.751.449.734 1.162-.038 1.602z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M496.38 848.59c.244.126.431.341.522.6a.876.876 0 0 0-.083-.586.876.876 0 0 0-.439-.397 3.04 3.04 0 0 0-2.758-.028c-.478.27-.668.647-.559 1.005.099-.271.299-.494.559-.62a3.066 3.066 0 0 1 2.758.026z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M497.14 849.21a.78.78 0 0 0-.033-.288.864.864 0 0 0-.05-.14c-.009-.014-.015-.03-.025-.048v-.009l-.012-.02-.011-.019-.025-.041a.8.8 0 0 0-.086-.115 1.813 1.813 0 0 0-.406-.337l-.03-.018a3.39 3.39 0 0 0-.218-.111l-.016-.006a2.061 2.061 0 0 0-.286-.1 2.575 2.575 0 0 0-.3-.074c-.139-.028-.248-.038-.313-.047a3.96 3.96 0 0 0-.635 0h-.007a3.062 3.062 0 0 0-.608.107h-.008a.32.32 0 0 0-.066.022.29.29 0 0 0-.048.014.09.09 0 0 0-.036.012 1.947 1.947 0 0 0-.393.174c-.035.019-.076.047-.115.071a.107.107 0 0 0-.022.015h-.005c-.078.048-.15.106-.214.172-.019.021-.051.047-.069.071-.035.04-.069.082-.1.126a.312.312 0 0 0-.047.076h-.006c-.023.048-.045.092-.061.132l-.005.015a.637.637 0 0 0-.037.155.937.937 0 0 0-.017.141v.074a1.107 1.107 0 0 0 .608.82 3.371 3.371 0 0 0 3.055.028 1.117 1.117 0 0 0 .653-.839v-.02l-.006.007zm-.8.593a3.038 3.038 0 0 1-2.758-.03c-.751-.447-.734-1.165.038-1.6a3.026 3.026 0 0 1 2.758.028c.753.456.736 1.169-.036 1.609l-.002-.007z"
            fill="#B9DBD8"
        />
        <path
            d="M497.14 849.23a1.113 1.113 0 0 1-.653.839 3.372 3.372 0 0 1-3.055-.028 1.108 1.108 0 0 1-.608-.822c.11 1.514.218 3.028.324 4.544a.785.785 0 0 0 .019.118c.006.032.017.069.025.1a.239.239 0 0 1 .015.037v.01l.005.011a1.057 1.057 0 0 0 .239.339l.017.017a.081.081 0 0 1 .018.019c.077.066.159.126.244.181.038.021.1.055.172.089.017.006.031.014.045.02.065.027.145.059.232.087h.009l.111.029a3.364 3.364 0 0 0 .195.04h.01c.028.005.057.009.085.012l.029.006c.024 0 .048.002.072.006h.031a.44.44 0 0 1 .088.006h.014a.79.79 0 0 0 .119.006h.1a.523.523 0 0 0 .056 0h.025c.079 0 .156-.011.228-.019a.507.507 0 0 0 .068-.011.51.51 0 0 0 .077-.012.642.642 0 0 1 .075-.01h.007a.99.99 0 0 0 .165-.046c.037-.011.071-.023.1-.035s.065-.022.089-.032a1.37 1.37 0 0 0 .226-.108 1.674 1.674 0 0 0 .285-.203 1.064 1.064 0 0 0 .274-.381.963.963 0 0 0 .057-.215c0-.015.006-.032.009-.05l.357-4.544z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M517.38 848.71c0 .4-.527.732-1.179.732s-1.178-.328-1.178-.732.527-.73 1.178-.73 1.179.33 1.179.73z"
            fill="#B9DBD8"
        />
        <path
            d="M517.17 847.75a2.083 2.083 0 0 0-1.9-.018.67.67 0 0 0-.408.555.155.155 0 0 1 .167.138v.278a.593.593 0 0 1 .358-.488c.26-.129.546-.195.836-.191.29.003.575.074.831.209a.574.574 0 0 1 .332.476v-.276a.16.16 0 0 1 .056-.103.153.153 0 0 1 .112-.034.656.656 0 0 0-.384-.546z"
            fill="#CAEDEB"
        />
        <path
            d="M516.77 847.86c-.009.041-.122.05-.249.017s-.219-.1-.208-.139.122-.051.249-.016.219.095.208.138z"
            fill="#DCF9F7"
        />
        <path
            d="M517.57 844.1a3.037 3.037 0 0 1-2.757-.028c-.751-.449-.732-1.165.039-1.6a3.038 3.038 0 0 1 2.758.027c.748.452.732 1.167-.04 1.601z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M517.61 842.89c.241.127.427.338.523.593.1-.343-.071-.71-.523-.981a3.042 3.042 0 0 0-2.758-.027c-.479.269-.668.649-.561 1 .099-.27.301-.491.561-.614a3.038 3.038 0 0 1 2.758.029z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M518.37 843.51a.848.848 0 0 0-.085-.428l-.023-.048-.008-.013-.008-.014c-.002-.007-.006-.014-.01-.021a.88.88 0 0 0-.113-.156 3.494 3.494 0 0 0-.134-.142 2.064 2.064 0 0 0-.269-.194l-.033-.018a1.927 1.927 0 0 0-.218-.109l-.014-.01a2.828 2.828 0 0 0-.285-.1 2.74 2.74 0 0 0-.3-.075 3.616 3.616 0 0 0-.943-.052h-.009a3.475 3.475 0 0 0-.607.106h-.009a.166.166 0 0 0-.042.012.096.096 0 0 0-.028.007c-.014.005-.031.009-.046.016l-.035.01a.085.085 0 0 1-.024.008l-.1.038a2.813 2.813 0 0 0-.271.131 1.312 1.312 0 0 0-.136.085 1.183 1.183 0 0 0-.213.174l-.071.071a1.322 1.322 0 0 0-.15.201v.012a.741.741 0 0 0-.063.126v.014a1.066 1.066 0 0 0-.037.158c-.009.04-.011.1-.016.137a.58.58 0 0 0 .005.072 1.105 1.105 0 0 0 .606.822 3.372 3.372 0 0 0 3.056.031 1.133 1.133 0 0 0 .653-.84v-.015l-.02.004zm-.8.59a3.037 3.037 0 0 1-2.757-.028c-.751-.449-.732-1.165.039-1.6a3.04 3.04 0 0 1 2.758.027c.748.457.732 1.172-.04 1.606v-.005z"
            fill="#B9DBD8"
        />
        <path
            d="M518.37 843.53a1.151 1.151 0 0 1-.653.841 3.371 3.371 0 0 1-3.056-.031 1.108 1.108 0 0 1-.405-.336 1.11 1.11 0 0 1-.201-.486c.106 1.515.213 3.03.323 4.543v.005-.005a.284.284 0 0 0 .01.057l.008.064a.592.592 0 0 0 .04.135v.02l.013.025c.051.114.122.218.211.306l.023.021.008.011a1.563 1.563 0 0 0 .438.287.278.278 0 0 0 .042.022c.065.028.144.056.232.084h.012l.112.032h.016c.058.017.117.03.177.04l.09.013a.14.14 0 0 0 .029 0 .582.582 0 0 0 .103.008c.028 0 .059.006.089.008h.284a.113.113 0 0 0 .026 0c.08 0 .156-.011.225-.02.025 0 .047-.006.067-.01s.029 0 .043-.006l.035-.007a.466.466 0 0 1 .076-.016h.009c.039-.012.092-.022.131-.035l.033-.008a.932.932 0 0 0 .1-.038c.033-.01.063-.018.091-.029s.088-.039.126-.058l.1-.051c.046-.026.092-.054.136-.084.045-.032.106-.082.15-.121a1.089 1.089 0 0 0 .276-.378c.012-.038.032-.089.04-.129a.358.358 0 0 0 .013-.086.217.217 0 0 0 .008-.051c.128-1.508.251-3.02.37-4.537z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M531.99 877.71c0 .4-.529.731-1.179.731s-1.178-.33-1.178-.731.526-.733 1.178-.733 1.179.333 1.179.733z"
            fill="#B9DBD8"
        />
        <path
            d="M531.78 876.75a2.103 2.103 0 0 0-1.9-.021.679.679 0 0 0-.408.557.156.156 0 0 1 .167.137v.279a.592.592 0 0 1 .357-.489 1.847 1.847 0 0 1 1.667.019.574.574 0 0 1 .333.476v-.277a.15.15 0 0 1 .166-.137.663.663 0 0 0-.382-.544z"
            fill="#CAEDEB"
        />
        <path
            d="M531.38 876.86c-.011.042-.124.048-.249.015s-.22-.1-.208-.135.123-.055.25-.018.222.095.207.138z"
            fill="#DCF9F7"
        />
        <path
            d="M532.19 873.1a3.05 3.05 0 0 1-2.762-.028c-.749-.449-.733-1.166.041-1.6a3.025 3.025 0 0 1 2.758.029c.749.451.732 1.165-.037 1.599z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M532.22 871.89c.242.125.427.337.519.593.108-.345-.068-.711-.519-.98a3.026 3.026 0 0 0-2.758-.029c-.481.269-.67.648-.563 1.005.102-.271.303-.491.563-.617a3.038 3.038 0 0 1 2.758.028z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M532.98 872.51a.854.854 0 0 0-.11-.476l-.005-.009-.008-.017c0-.008-.008-.014-.011-.022a.817.817 0 0 0-.112-.154 1.656 1.656 0 0 0-.408-.34l-.029-.019a1.78 1.78 0 0 0-.218-.11h-.009a2.531 2.531 0 0 0-.291-.106 2.636 2.636 0 0 0-.3-.076c-.139-.026-.248-.036-.311-.043a3.64 3.64 0 0 0-.635-.008h-.008c-.206.017-.41.052-.609.107h-.012a.156.156 0 0 1-.041.015.117.117 0 0 0-.026.01l-.048.01a.189.189 0 0 1-.033.013l-.024.011a.962.962 0 0 0-.1.036 2.664 2.664 0 0 0-.406.214 1.088 1.088 0 0 0-.211.172.89.89 0 0 0-.173.2.405.405 0 0 0-.049.073l-.006.01a.679.679 0 0 0-.058.129l-.005.008v.007c-.018.05-.032.102-.042.155a1.087 1.087 0 0 0-.012.214 1.111 1.111 0 0 0 .609.819 3.356 3.356 0 0 0 3.055.031 1.124 1.124 0 0 0 .652-.839v-.014l-.006-.001zm-.8.592a3.046 3.046 0 0 1-2.762-.028c-.749-.449-.733-1.166.041-1.6a3.038 3.038 0 0 1 2.758.029c.753.454.736 1.168-.033 1.602l-.004-.003z"
            fill="#B9DBD8"
        />
        <path
            d="M532.98 872.53a1.107 1.107 0 0 1-.652.84 3.357 3.357 0 0 1-3.055-.031 1.105 1.105 0 0 1-.609-.819l.326 4.541v.007-.005c0 .016 0 .036.007.053s.01.045.013.066a.736.736 0 0 0 .026.1c0 .012.008.024.011.033s.006.009.006.009v.012c.006.011.007.019.013.028.052.113.123.217.211.306l.023.02.01.009a2.033 2.033 0 0 0 .264.2c.039.025.1.054.171.091l.042.018c.077.032.155.061.235.086h.009l.112.034h.011c.043.009.108.024.184.036h.008c.027 0 .056.01.084.012h.031l.072.01h.031c.029 0 .059 0 .089.007H530.961c.078 0 .156-.011.226-.02l.069-.008a.274.274 0 0 1 .039-.009c.012 0 .024-.005.037-.007s.052-.01.076-.013h.01c.044-.009.087-.021.129-.034l.032-.01c.036-.011.072-.024.1-.035a1.186 1.186 0 0 0 .214-.086c.032-.015.071-.035.1-.053.047-.025.093-.053.137-.083.047-.035.1-.084.15-.123.061-.054.114-.114.16-.18a1.02 1.02 0 0 0 .114-.2c.016-.044.03-.088.042-.132.007-.035.008-.043.014-.085a.22.22 0 0 0 .006-.05c.13-1.506.247-3.023.364-4.535z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M578.83 881.99c.761.458.734 1.189-.058 1.631a3.11 3.11 0 0 1-2.817-.027c-.761-.457-.736-1.189.06-1.631a3.107 3.107 0 0 1 2.815.027z"
            fill="#B9DBD8"
        />
        <path
            d="M575.95 883.59a1.778 1.778 0 0 1-.571-.534 1.414 1.414 0 0 1-.236-.75 1.09 1.09 0 0 0 .624.885 3.483 3.483 0 0 0 3.171.03 1.131 1.131 0 0 0 .689-.928 1.531 1.531 0 0 1-.784 1.279c-.025.016-.05.031-.076.045a3.105 3.105 0 0 1-2.817-.027z"
            fill="#B9DBD8"
        />
        <path
            d="M578.53 875.33c.017.01.039.02.055.031h-.007a.144.144 0 0 0-.048-.028v-.003zM578.56 875.34a.06.06 0 0 0-.024-.015.126.126 0 0 1 .044.024.072.072 0 0 0-.02-.009z"
            fill="#171F28"
        />
        <path
            d="m575.14 882.31-.047-5.069a1.106 1.106 0 0 0 .632.9 3.543 3.543 0 0 0 3.218.034 1.158 1.158 0 0 0 .7-.95l-.02 5.069a1.14 1.14 0 0 1-.689.934 3.492 3.492 0 0 1-3.171-.03 1.101 1.101 0 0 1-.624-.89l.001.002z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M578.13 872.76c.406.245.393.636-.031.872a1.66 1.66 0 0 1-1.506-.016c-.408-.242-.391-.634.031-.869a1.648 1.648 0 0 1 1.506.013z"
            fill="#273545"
        />
        <path
            d="M578.61 875.38a.872.872 0 0 1-.182-.551v-1.64a.538.538 0 0 1-.327.448 1.664 1.664 0 0 1-1.506-.016.526.526 0 0 1-.3-.424l.006 1.639c0 .035-.006.071-.008.107a.845.845 0 0 1-.175.445c.03-.023.063-.039.09-.056a2.152 2.152 0 0 0-1.112 1.906 1.11 1.11 0 0 0 .632.9 3.556 3.556 0 0 0 3.218.034 1.168 1.168 0 0 0 .7-.963 2.179 2.179 0 0 0-1.036-1.829z"
            fill="#E9FFFD"
            opacity={0.77}
        />
        <path
            d="M578.59 872.98v.769a.598.598 0 0 1-.351.487 1.863 1.863 0 0 1-1.7 0 .595.595 0 0 1-.354-.495v-.767a.596.596 0 0 0 .354.494 1.86 1.86 0 0 0 1.7 0 .59.59 0 0 0 .349-.488h.002z"
            fill="#70AD40"
        />
        <path
            d="M578.23 872.49c.471.275.473.714.005.985a1.863 1.863 0 0 1-1.7 0 .52.52 0 0 1-.006-.985 1.874 1.874 0 0 1 1.701 0z"
            fill="#85C44E"
        />
        <path
            d="M523.52 850.52c.762.459.737 1.189-.056 1.631a3.101 3.101 0 0 1-2.818-.026c-.76-.459-.734-1.189.058-1.632a3.097 3.097 0 0 1 2.816.027z"
            fill="#B9DBD8"
        />
        <path
            d="M520.65 852.12a1.888 1.888 0 0 1-.571-.533 1.429 1.429 0 0 1-.234-.749 1.103 1.103 0 0 0 .625.882 3.493 3.493 0 0 0 3.168.033 1.15 1.15 0 0 0 .69-.93 1.526 1.526 0 0 1-.784 1.278c-.026.017-.049.03-.076.045a3.105 3.105 0 0 1-2.818-.026z"
            fill="#B9DBD8"
        />
        <path
            d="M523.23 843.85c.014.008.037.022.052.029h-.01c-.015-.008-.028-.018-.042-.026v-.003z"
            fill="#171F28"
        />
        <path
            d="m523.26 843.87-.023-.016c.014.008.027.018.042.026l-.012-.008-.007-.002z"
            fill="#171F28"
        />
        <path
            d="m519.85 850.83-.051-5.069a1.132 1.132 0 0 0 .636.9 3.549 3.549 0 0 0 3.217.031 1.154 1.154 0 0 0 .7-.951l-.021 5.072a1.143 1.143 0 0 1-.69.936 3.496 3.496 0 0 1-3.168-.033 1.097 1.097 0 0 1-.625-.891l.002.005z"
            fill="#CAEDEB"
            opacity={0.73}
        />
        <path
            d="M522.83 841.29c.4.245.392.635-.033.872a1.649 1.649 0 0 1-1.505-.018c-.409-.244-.4-.631.032-.87a1.659 1.659 0 0 1 1.506.016z"
            fill="#273545"
        />
        <path
            d="M523.31 843.91a.84.84 0 0 1-.184-.551l-.006-1.638a.543.543 0 0 1-.326.446 1.646 1.646 0 0 1-1.505-.018.514.514 0 0 1-.3-.422v1.638c0 .037 0 .073-.005.108a.844.844 0 0 1-.177.445c.033-.022.062-.041.092-.057a2.159 2.159 0 0 0-1.116 1.906 1.13 1.13 0 0 0 .636.9 3.536 3.536 0 0 0 3.217.031 1.145 1.145 0 0 0 .7-.962 2.168 2.168 0 0 0-1.026-1.826z"
            fill="#E9FFFD"
            opacity={0.77}
        />
        <path
            d="M523.29 841.51v.767a.602.602 0 0 1-.348.489 1.889 1.889 0 0 1-1.7 0 .602.602 0 0 1-.352-.5v-.766a.605.605 0 0 0 .352.5 1.883 1.883 0 0 0 1.7 0 .6.6 0 0 0 .347-.49h.001z"
            fill="#70AD40"
        />
        <path
            d="M522.94 841.01a.53.53 0 0 1 .254.191.531.531 0 0 1 0 .606.526.526 0 0 1-.254.192 1.889 1.889 0 0 1-1.7 0 .52.52 0 0 1-.254-.191.518.518 0 0 1-.004-.605.524.524 0 0 1 .252-.193 1.884 1.884 0 0 1 1.706 0z"
            fill="#85C44E"
        />
        <path
            d="M579.12 865.5v-.015c0-.013-.006-.026-.009-.04l-.006-.017a.166.166 0 0 0-.017-.047v-.008a.226.226 0 0 1-.025-.049l-.007-.01c-.012-.016-.019-.033-.029-.047h-.005a.139.139 0 0 0-.029-.035v-.008l-.007-.007c-.017-.013-.028-.027-.044-.039-.016-.014-.031-.023-.045-.034a.16.16 0 0 0-.084-.031.172.172 0 0 0-.089.015l-.494.29a.163.163 0 0 1 .17.016.13.13 0 0 1 .044.033h.007a.208.208 0 0 1 .041.037l.01.014a.15.15 0 0 1 .028.034.355.355 0 0 1 .032.047l.006.007c.009.022.019.036.025.054v.006l.018.051v.012a.19.19 0 0 1 .011.041v.015a.262.262 0 0 1 0 .056.16.16 0 0 1-.013.084.151.151 0 0 1-.053.067c.164-.093.327-.191.492-.284a.176.176 0 0 0 .058-.069.176.176 0 0 0 .014-.088.146.146 0 0 0 0-.051z"
            fill="#FC6B6B"
        />
        <path
            d="M578.76 865.71v-.017c0-.013-.007-.025-.011-.041v-.009a.352.352 0 0 0-.019-.051v-.011l-.027-.048-.008-.013a.128.128 0 0 0-.029-.04v-.006a.146.146 0 0 0-.027-.038l-.009-.01-.007-.006a.24.24 0 0 0-.041-.037.215.215 0 0 0-.046-.033.162.162 0 0 0-.082-.034.169.169 0 0 0-.088.016l-7.55 4.378a.17.17 0 0 1 .171.02.103.103 0 0 1 .046.03h.005a.304.304 0 0 1 .041.039l.006.009c.013.012.024.027.035.039v.009a.26.26 0 0 1 .028.045l.005.007a.157.157 0 0 1 .029.054v.009c0 .014.01.03.016.048l.006.012a.271.271 0 0 1 .009.041l.005.017a.469.469 0 0 1 0 .053.168.168 0 0 1-.014.086.168.168 0 0 1-.057.067l7.536-4.377a.166.166 0 0 0 .057-.069.157.157 0 0 0 .014-.088c.01-.016.007-.031.006-.051z"
            fill="#0E3C55"
        />
        <path
            d="M578.63 865.78v-.009c0-.017-.007-.032-.01-.044v-.015l-.018-.051v-.006c-.006-.018-.016-.032-.023-.05l-.008-.011a.346.346 0 0 0-.032-.046.18.18 0 0 0-.028-.034l-.006-.011-.008-.005a.24.24 0 0 0-.041-.037h-.007a.13.13 0 0 0-.044-.033.163.163 0 0 0-.17-.016c-2.511 1.46-5.024 2.919-7.538 4.377a.176.176 0 0 1 .173.018c.016.01.03.021.043.033h.008a.334.334 0 0 1 .038.037l.007.008a.838.838 0 0 0 .039.045v.006l.031.043v.013c.011.016.02.032.028.049v.009a.158.158 0 0 1 .018.05l.005.014a.19.19 0 0 1 .008.04v.016a.226.226 0 0 1 0 .052.184.184 0 0 1-.015.087.185.185 0 0 1-.056.068l7.538-4.381a.163.163 0 0 0 .068-.153.222.222 0 0 0 0-.063z"
            fill="#FC6B6B"
        />
        <path
            d="m571.02 869.99 7.561-4.34c.027.06.042.125.043.191a.163.163 0 0 1-.068.153l-7.538 4.381a.18.18 0 0 0 .056-.069.18.18 0 0 0 .015-.086.492.492 0 0 0-.041-.181l-.028-.049z"
            fill="#ED4A4A"
        />
        <path
            d="M570.68 869.78c-.035.024-.335.588-.335.588.23.013.46.011.69-.007a.175.175 0 0 0 .058-.145.526.526 0 0 0-.242-.417.168.168 0 0 0-.173-.018l.002-.001z"
            fill="#FFC892"
        />
        <path
            d="m570.35 870.37.174.007c.008-.005-.005-.045-.031-.087s-.054-.073-.061-.069l-.082.149z"
            fill="#FC6B6B"
        />
        <path
            d="M582.2 893.22v-.016l-.007-.038v-.013c-.008-.019-.012-.037-.021-.054v-.006a.238.238 0 0 1-.024-.051l-.008-.006c-.012-.017-.018-.035-.029-.047l-.033-.037v-.006l-.012-.012a.38.38 0 0 0-.037-.033l-.008-.006a.32.32 0 0 0-.043-.032.173.173 0 0 0-.174-.017l-.492.289a.163.163 0 0 1 .168.017.15.15 0 0 1 .046.033h.007a.44.44 0 0 1 .038.037l.01.006v.006l.031.039h.006a.146.146 0 0 0 .028.046l.005.011c.009.016.016.035.025.05a.1.1 0 0 1 .018.047l.007.013a.203.203 0 0 0 .007.043.434.434 0 0 1 0 .07.176.176 0 0 1-.012.085.174.174 0 0 1-.053.067c.165-.093.329-.189.493-.285a.185.185 0 0 0 .056-.068.185.185 0 0 0 .008-.132z"
            fill="#6CBA5A"
        />
        <path
            d="M581.83 893.43v-.013c0-.019-.008-.031-.01-.045l-.005-.017a.203.203 0 0 0-.02-.048v-.006l-.025-.047a.029.029 0 0 0-.008-.014c-.008-.014-.019-.028-.028-.041v-.005l-.03-.04-.009-.007v-.009c-.012-.009-.027-.024-.04-.035h-.005l-.046-.031a.168.168 0 0 0-.171-.018l-7.537 4.378a.17.17 0 0 1 .089-.013c.03.003.059.014.083.031.016.01.031.021.045.032.015.013.027.028.038.039l.01.005c.014.014.023.032.034.045.013.014.023.03.031.047l.007.011.027.052v.008a.172.172 0 0 1 .016.045.043.043 0 0 0 .005.012c.005.018.006.032.009.045v.009c.003.02.005.039.005.059a.162.162 0 0 1-.07.155l7.537-4.377a.17.17 0 0 0 .056-.069.168.168 0 0 0 .015-.088c.001-.017-.003-.034-.003-.05z"
            fill="#3E0F36"
        />
        <path
            d="M581.7 893.51v-.012a.105.105 0 0 1-.009-.046l-.009-.017a.1.1 0 0 0-.018-.047c-.009-.015-.016-.034-.025-.05l-.005-.011a.146.146 0 0 1-.028-.046h-.006a.318.318 0 0 1-.027-.037l-.008-.008-.005-.006-.043-.037a.145.145 0 0 0-.048-.034.164.164 0 0 0-.082-.033.161.161 0 0 0-.086.016 11352.61 11352.61 0 0 1-7.538 4.38.16.16 0 0 1 .089-.018c.03.003.06.015.084.034.015.01.03.02.045.032h.005a.304.304 0 0 1 .039.041h.005a.445.445 0 0 0 .041.047l.027.044.008.013c.01.016.019.035.028.051v.008c0 .015.011.029.016.045v.017a.148.148 0 0 1 .014.042v.013a.224.224 0 0 1 .006.052.19.19 0 0 1-.015.088.186.186 0 0 1-.055.07l7.534-4.384a.159.159 0 0 0 .057-.066c.012-.027.016-.057.012-.086a.493.493 0 0 0-.003-.055z"
            fill="#6CBA5A"
        />
        <path
            d="m574.1 897.71 7.561-4.337a.431.431 0 0 1 .04.187.15.15 0 0 1-.013.086.15.15 0 0 1-.056.066l-7.534 4.384a.179.179 0 0 0 .07-.158.563.563 0 0 0-.04-.177l-.028-.051z"
            fill="#56AE42"
        />
        <path
            d="M573.75 897.51c-.034.02-.332.586-.332.586.229.011.458.009.687-.007h.005a.183.183 0 0 0 .059-.147.532.532 0 0 0-.242-.414.167.167 0 0 0-.085-.034.176.176 0 0 0-.09.018l-.002-.002z"
            fill="#FFC892"
        />
        <path
            d="M573.42 898.1h.174a.294.294 0 0 0-.035-.086c-.027-.043-.052-.075-.052-.075l-.087.161z"
            fill="#6CBA5A"
        />
        <path
            d="M541.65 844.22v-.017a.359.359 0 0 0-.008-.035v-.019a.317.317 0 0 1-.017-.049l-.006-.006c-.008-.017-.016-.034-.025-.049v-.008a.28.28 0 0 1-.03-.049l-.029-.035-.007-.009-.008-.006a.63.63 0 0 0-.039-.037l-.007-.006a.48.48 0 0 1-.043-.032.18.18 0 0 0-.175-.017l-.493.293c.026-.016.056-.022.086-.02s.059.014.083.033c.016.009.031.02.046.032l.008.005c.014.01.027.022.038.037h.01l.007.009c.008.013.019.024.029.038l.029.047.005.009c.01.016.018.033.025.052a.267.267 0 0 1 .017.05l.006.014a.338.338 0 0 0 .009.041l.006.018v.051a.178.178 0 0 1-.015.085.184.184 0 0 1-.054.067c.164-.098.329-.193.493-.285a.185.185 0 0 0 .056-.068.189.189 0 0 0 .015-.087.36.36 0 0 0-.012-.047z"
            fill="#FC6B6B"
        />
        <path
            d="M541.29 844.43v-.016a.258.258 0 0 0-.01-.042v-.015c0-.016-.013-.032-.017-.049l-.026-.051-.008-.013a.146.146 0 0 0-.029-.041v-.008a.509.509 0 0 0-.028-.034l-.01-.011v-.005l-.04-.039h-.005l-.044-.031a.154.154 0 0 0-.173-.017 6392.795 6392.795 0 0 0-7.535 4.38.157.157 0 0 1 .088-.017c.03.002.059.013.083.031a.207.207 0 0 1 .044.034h.005l.04.039.009.008a.34.34 0 0 1 .033.042l.006.006c.008.014.021.03.029.047a.02.02 0 0 1 .006.011c.01.015.018.034.027.05v.006l.016.048v.012c.005.015.009.03.012.046l.005.014v.051a.158.158 0 0 1-.014.088.166.166 0 0 1-.057.069l7.535-4.377a.169.169 0 0 0 .057-.07.161.161 0 0 0 .014-.089c-.013-.022-.013-.041-.013-.057z"
            fill="#0E3C55"
        />
        <path
            d="M541.16 844.51v-.012l-.011-.047-.006-.01a.2.2 0 0 0-.017-.054.192.192 0 0 0-.025-.052l-.005-.009-.029-.047c-.01-.014-.021-.025-.029-.038h-.006l-.011-.01a.149.149 0 0 0-.038-.037v-.005l-.05-.032a.15.15 0 0 0-.169-.013l-7.534 4.375c.028-.013.058-.018.088-.015s.058.014.082.033l.044.031h.009c.01.012.025.024.037.04v.006c.02.017.028.032.041.044v.008a.145.145 0 0 1 .03.039l.007.01a.366.366 0 0 1 .045.105v.016c.006.013.01.027.009.042v.016a.224.224 0 0 1 .006.052.16.16 0 0 1-.015.086.164.164 0 0 1-.056.069l7.535-4.381a.157.157 0 0 0 .057-.068.151.151 0 0 0 .014-.086l-.003-.056z"
            fill="#FC6B6B"
        />
        <path
            d="m533.56 848.71 7.56-4.339a.489.489 0 0 1 .044.189.16.16 0 0 1-.015.086.16.16 0 0 1-.056.067l-7.535 4.382a.18.18 0 0 0 .056-.069.182.182 0 0 0 .015-.086.522.522 0 0 0-.043-.18l-.026-.05z"
            fill="#ED4A4A"
        />
        <path
            d="M533.22 848.5c-.037.022-.335.588-.335.588.23.012.46.01.69-.007a.178.178 0 0 0 .061-.146.537.537 0 0 0-.244-.417.167.167 0 0 0-.172-.018z"
            fill="#FFC892"
        />
        <path
            d="m532.88 849.1.172.005c.011-.005 0-.047-.033-.085s-.051-.075-.058-.07l-.081.15z"
            fill="#FC6B6B"
        />
        <path
            d="m562.02 864.11-13.33-7.675v.384a.754.754 0 0 0 .376.651l12.574 7.24a.744.744 0 0 0 .753 0l9.2-5.427a.573.573 0 0 0 .283-.491v-.247l-9.856 5.565z"
            fill="#848484"
        />
        <path
            d="M571.65 858.23a.4.4 0 0 1 .01.71l-9.642 5.164-13.33-7.675 9.62-4.34a1.568 1.568 0 0 1 1.373.033l11.969 6.108z"
            fill="#E2E1E0"
        />
        <path
            d="M567.23 860.26c.119.074.244.36-.23.559l-4.272 2.335c-.352.217-.653.021-.982-.166l-11.26-6.486a.253.253 0 0 1-.117-.095.251.251 0 0 1 0-.286.251.251 0 0 1 .117-.094l4.116-2.6a.712.712 0 0 1 .318-.13.712.712 0 0 1 .342.037l11.968 6.926z"
            fill="#898686"
        />
        <path
            d="M557.72 854.86c.056.033.055.086 0 .116l-.569.332a.233.233 0 0 1-.1.024.23.23 0 0 1-.1-.024l-.572-.332c-.057-.03-.057-.083 0-.116l.57-.327a.198.198 0 0 1 .2 0l.571.327zM554.92 857.84c.055.033.055.082 0 .113l-.568.331a.217.217 0 0 1-.2 0l-.572-.332c-.056-.029-.056-.079 0-.112l.568-.331a.217.217 0 0 1 .2 0l.572.331zM555.91 858.41c.056.032.056.083 0 .114l-.569.33a.207.207 0 0 1-.2 0l-.576-.328a.06.06 0 0 1-.03-.022.06.06 0 0 1-.012-.035.06.06 0 0 1 .042-.057l.572-.334a.218.218 0 0 1 .1-.025c.034 0 .069.009.1.025l.573.332zM556.91 858.99c.056.032.056.082 0 .114l-.572.332a.217.217 0 0 1-.2 0l-.575-.332c-.012-.004-.021-.013-.028-.023s-.011-.022-.011-.035a.06.06 0 0 1 .011-.034.06.06 0 0 1 .028-.024l.572-.328a.217.217 0 0 1 .2 0l.575.33zM555.74 854.92c.054.028.054.081 0 .114l-.568.332a.22.22 0 0 1-.2 0l-1.575-.913c-.055-.028-.055-.081 0-.112l.57-.332a.204.204 0 0 1 .2 0l1.573.911zM556.7 855.44a.06.06 0 0 1 .041.057.063.063 0 0 1-.011.035.065.065 0 0 1-.03.022l-.571.33c-.031.017-.065.025-.1.025s-.069-.008-.1-.025l-.574-.332c-.055-.032-.055-.083 0-.114l.571-.333a.217.217 0 0 1 .2 0l.574.335zM557.77 856.06c.054.036.054.085 0 .118l-.573.332c-.031.015-.065.022-.1.022s-.069-.007-.1-.022l-.574-.33c-.055-.033-.055-.082 0-.118l.568-.328c.031-.016.065-.025.1-.025s.069.009.1.025l.579.326zM558.77 856.64c.055.03.055.08 0 .112l-.57.333a.232.232 0 0 1-.2 0l-.573-.333c-.057-.032-.057-.082 0-.114l.569-.331a.204.204 0 0 1 .2 0l.574.333zM559.77 857.22c.055.031.055.082 0 .114l-.569.331a.22.22 0 0 1-.2 0l-.574-.334c-.057-.029-.057-.08 0-.113l.573-.329a.203.203 0 0 1 .194 0l.576.331zM554.77 855.48c.056.03.056.083 0 .115l-.567.33a.23.23 0 0 1-.2 0l-1.572-.909c-.057-.031-.057-.082 0-.115l.568-.33c.031-.017.065-.025.1-.025s.07.008.1.025l1.571.909zM555.78 856.06a.051.051 0 0 1 .029.021.055.055 0 0 1 0 .069.058.058 0 0 1-.029.022l-.568.334a.243.243 0 0 1-.2 0l-.573-.334c-.058-.029-.058-.082 0-.115l.57-.328a.198.198 0 0 1 .2 0l.571.331zM556.81 856.66c.011.004.021.013.028.023s.01.022.01.035a.065.065 0 0 1-.038.058l-.57.331c-.031.015-.065.024-.1.024s-.069-.009-.1-.024l-.575-.331a.066.066 0 0 1-.029-.023.066.066 0 0 1-.011-.035c0-.013.004-.025.011-.036a.058.058 0 0 1 .029-.022l.572-.332a.216.216 0 0 1 .1-.023c.034 0 .069.007.1.023l.573.332zM557.81 857.24c.011.004.021.013.028.023s.011.022.011.035a.06.06 0 0 1-.011.034.065.065 0 0 1-.028.024l-.572.329a.204.204 0 0 1-.2 0l-.575-.329c-.055-.034-.055-.087 0-.116l.569-.33a.217.217 0 0 1 .2 0l.578.33zM557.91 859.56a.063.063 0 0 1 .029.094.066.066 0 0 1-.029.023l-.571.33c-.031.016-.065.025-.1.025s-.069-.009-.1-.025l-.574-.33a.066.066 0 0 1-.029-.023.063.063 0 0 1 .029-.094l.57-.332a.217.217 0 0 1 .2 0l.575.332zM560.77 857.8c.055.028.055.08 0 .114l-.57.33c-.031.016-.065.025-.1.025s-.069-.009-.1-.025l-.574-.33c-.054-.034-.059-.086 0-.116l.568-.332a.217.217 0 0 1 .2 0l.576.334zM558.81 857.82c.011.004.021.012.028.022a.06.06 0 0 1 0 .069.07.07 0 0 1-.028.023l-.571.332a.243.243 0 0 1-.2 0l-.572-.332c-.057-.031-.057-.084 0-.114l.568-.332a.215.215 0 0 1 .2 0l.575.332zM559.81 858.4c.055.032.055.082 0 .114l-.571.329c-.031.017-.065.025-.1.025s-.069-.008-.1-.025l-.574-.329c-.055-.032-.055-.082 0-.114l.57-.334a.231.231 0 0 1 .1-.022c.035 0 .069.007.1.022l.575.334zM555.85 857.26c.055.028.055.082 0 .114l-.57.33a.23.23 0 0 1-.2 0l-.573-.33c-.054-.032-.054-.086 0-.114l.57-.335c.031-.016.065-.025.1-.025s.069.009.1.025l.573.335zM556.85 857.83c.054.032.056.085 0 .115l-.569.33a.209.209 0 0 1-.2 0l-.572-.332c-.057-.029-.057-.081 0-.113l.57-.328a.201.201 0 0 1 .2 0l.571.328zM557.85 858.41c.055.03.055.081 0 .115l-.569.328a.204.204 0 0 1-.2 0l-.573-.33c-.054-.032-.054-.083 0-.113l.569-.334a.22.22 0 0 1 .2 0l.573.334zM558.85 858.99c.055.032.055.082 0 .114l-.57.332a.217.217 0 0 1-.2 0l-.573-.332c-.056-.032-.056-.082 0-.114l.57-.33c.031-.016.065-.025.1-.025s.069.009.1.025l.573.33zM558.91 860.14c.055.031.055.083 0 .113l-.569.332c-.031.017-.065.025-.1.025s-.069-.008-.1-.025l-.576-.332a.06.06 0 0 1-.029-.091.07.07 0 0 1 .029-.022l.571-.332a.215.215 0 0 1 .2 0l.574.332zM561.91 858.45a.054.054 0 0 1 .03.021.057.057 0 0 1 0 .07.055.055 0 0 1-.03.022l-.57.332a.207.207 0 0 1-.2 0l-.574-.332c-.054-.031-.054-.085 0-.113l.571-.332a.207.207 0 0 1 .2 0l.573.332zM560.81 858.98a.07.07 0 0 1 .028.023c.006.01.01.022.01.034s-.004.024-.01.034a.07.07 0 0 1-.028.023l-.573.332a.215.215 0 0 1-.2 0l-.575-.332c-.055-.032-.055-.081 0-.114l.569-.332a.204.204 0 0 1 .2 0l.579.332zM559.85 859.56a.066.066 0 0 1 .038.058.063.063 0 0 1-.011.035.063.063 0 0 1-.027.024l-.571.33a.23.23 0 0 1-.2 0l-.572-.33c-.056-.033-.058-.083 0-.117l.569-.332a.217.217 0 0 1 .2 0l.574.332zM551.95 856.1c.057.029.057.08 0 .113l-.57.33a.22.22 0 0 1-.195 0l-.576-.328c-.05-.035-.05-.086 0-.115l.57-.334c.031-.016.065-.025.1-.025s.069.009.1.025l.571.334zM552.9 856.64c.058.033.058.085 0 .115l-.572.332c-.031.017-.065.025-.1.025s-.069-.008-.1-.025l-.575-.332c-.054-.03-.054-.082 0-.115l.572-.33a.217.217 0 0 1 .2 0l.575.33zM553.91 857.22c.054.034.056.083 0 .116l-.569.332a.23.23 0 0 1-.2 0l-.575-.332a.066.066 0 0 1-.041-.058.06.06 0 0 1 .012-.036.058.058 0 0 1 .029-.022l.571-.329a.204.204 0 0 1 .2 0l.573.329zM562.87 857.88c.054.032.054.079 0 .113l-.57.331a.233.233 0 0 1-.1.024.23.23 0 0 1-.1-.024l-4.576-2.644c-.055-.029-.055-.081 0-.113l.571-.333a.23.23 0 0 1 .2 0l4.575 2.646zM563.89 858.48a.057.057 0 0 1 .027.024.06.06 0 0 1 0 .07.07.07 0 0 1-.027.024l-.571.328c-.031.015-.065.024-.1.024s-.069-.009-.1-.024l-.575-.33c-.056-.033-.056-.083 0-.116l.571-.33a.209.209 0 0 1 .195 0l.58.33zM564.9 859.07a.057.057 0 0 1 .03.021.066.066 0 0 1 .011.036.066.066 0 0 1-.011.035.065.065 0 0 1-.03.022l-.568.334c-.031.015-.065.024-.1.024s-.069-.009-.1-.024l-.572-.334c-.059-.031-.059-.083 0-.114l.568-.329c.031-.017.065-.025.1-.025s.069.008.1.025l.572.329zM562.89 859.05a.065.065 0 0 1 .03.022.06.06 0 0 1 0 .07.068.068 0 0 1-.03.023l-.569.33a.217.217 0 0 1-.2 0l-.572-.33c-.056-.032-.057-.085 0-.115l.569-.332c.031-.016.065-.025.1-.025s.069.009.1.025l.572.332zM552.87 855.46a.06.06 0 0 1 .031.021c.007.011.012.023.012.036s-.005.026-.012.036a.068.068 0 0 1-.031.022l-.568.329a.232.232 0 0 1-.2 0l-.574-.329c-.054-.033-.054-.086 0-.115l.571-.332a.217.217 0 0 1 .2 0l.571.332zM553.87 856.04a.058.058 0 0 1 .029.022.057.057 0 0 1 0 .07.06.06 0 0 1-.029.023l-.569.332c-.031.016-.065.025-.1.025s-.069-.009-.1-.025l-.575-.332a.06.06 0 0 1-.029-.023.057.057 0 0 1 0-.07.058.058 0 0 1 .029-.022l.572-.329c.03-.017.063-.025.097-.025s.067.008.097.025l.578.329zM554.88 856.62c.053.035.053.083 0 .116l-.571.332a.232.232 0 0 1-.2 0l-.573-.332a.055.055 0 0 1-.028-.024.06.06 0 0 1 0-.069.053.053 0 0 1 .028-.023l.57-.33a.217.217 0 0 1 .2 0l.574.33zM561.83 859.62c.056.032.056.085 0 .115l-.571.329a.215.215 0 0 1-.2 0l-.574-.329c-.055-.03-.055-.083 0-.115l.572-.331a.216.216 0 0 1 .194 0l.579.331zM562.95 860.19c.053.036.053.086 0 .116l-.571.328a.194.194 0 0 1-.2.005l-.575-.333a.053.053 0 0 1-.028-.023.06.06 0 0 1 0-.069.06.06 0 0 1 .028-.024l.573-.328c.031-.016.065-.025.1-.025s.069.009.1.025l.573.328zM564.88 861.33c.055.034.055.084 0 .115l-.57.331a.217.217 0 0 1-.2 0l-1.573-.91c-.055-.03-.055-.084 0-.112l.57-.333a.233.233 0 0 1 .1-.024.23.23 0 0 1 .1.024l1.573.909zM560.85 860.14c.055.031.055.083 0 .113l-.569.332a.217.217 0 0 1-.2 0l-.572-.332c-.056-.031-.056-.082 0-.113l.568-.332a.215.215 0 0 1 .2 0l.573.332zM561.87 860.76c.055.028.055.082 0 .112l-.567.331a.22.22 0 0 1-.2 0l-.574-.331c-.012-.005-.022-.013-.029-.023a.06.06 0 0 1 .029-.091l.571-.331a.217.217 0 0 1 .2 0l.57.333zM563.85 861.88a.066.066 0 0 1 .029.023.066.066 0 0 1 .011.035.066.066 0 0 1-.011.036.058.058 0 0 1-.029.022l-.57.33a.217.217 0 0 1-.2 0l-1.573-.91c-.056-.032-.056-.086 0-.115l.571-.331c.031-.015.065-.024.1-.024s.069.009.1.024l1.572.91zM559.91 860.69c.057.035.057.082 0 .117l-.569.329c-.031.015-.065.024-.1.024s-.069-.009-.1-.024l-.574-.331a.06.06 0 0 1-.029-.023c-.008-.01-.012-.022-.012-.035s.004-.025.012-.035a.058.058 0 0 1 .029-.022l.569-.332a.23.23 0 0 1 .2 0l.574.332zM562.91 862.42c.059.031.059.082 0 .114l-.568.328a.217.217 0 0 1-.2 0l-1.573-.907c-.054-.032-.054-.083 0-.113l.571-.332a.204.204 0 0 1 .2 0l1.57.91zM565.9 859.65a.063.063 0 0 1 .04.058.063.063 0 0 1-.011.035.08.08 0 0 1-.029.023l-.57.331a.23.23 0 0 1-.2 0l-.575-.332a.06.06 0 0 1-.039-.058c0-.012.003-.024.01-.034a.055.055 0 0 1 .029-.023l.57-.33a.204.204 0 0 1 .2 0l.575.33zM566.92 860.22c.056.033.056.082 0 .115l-.569.332c-.031.015-.066.022-.1.022s-.069-.007-.1-.022l-.574-.332a.06.06 0 0 1-.028-.022c-.007-.011-.011-.023-.011-.035a.063.063 0 0 1 .039-.058l.571-.331c.031-.016.065-.025.1-.025s.069.009.1.025l.572.331z"
            fill="#4A4A4A"
        />
        <path
            d="m565.13 860.1-.575-.332a.06.06 0 0 1-.04-.056v.112a.06.06 0 0 0 .011.035.062.062 0 0 0 .029.024l.573.332.002-.115z"
            fill="#636363"
        />
        <path
            d="M565.94 859.71a.078.078 0 0 1-.04.056l-.57.331c-.031.015-.065.022-.1.022s-.069-.007-.1-.022v.114a.23.23 0 0 0 .2 0l.57-.332a.087.087 0 0 0 .027-.023.079.079 0 0 0 .013-.033v-.113z"
            fill="#3D3D3D"
        />
        <path
            d="m566.15 860.66-.574-.332a.07.07 0 0 1-.028-.023.069.069 0 0 1-.014-.034v.115a.07.07 0 0 0 .013.035c.008.01.018.018.029.022l.574.33v-.113z"
            fill="#636363"
        />
        <path
            d="M566.96 860.27a.08.08 0 0 1-.014.034.07.07 0 0 1-.029.022l-.569.332a.217.217 0 0 1-.2 0v.113a.204.204 0 0 0 .2 0l.571-.33c.012-.004.022-.012.029-.022s.012-.022.012-.035v-.114z"
            fill="#3D3D3D"
        />
        <path
            d="m556.95 855.3-.572-.332a.067.067 0 0 1-.028-.022.069.069 0 0 1-.014-.034v.112a.07.07 0 0 0 .012.035c.008.01.018.018.03.022l.572.333v-.114z"
            fill="#636363"
        />
        <path
            d="M557.76 854.92c0 .019-.013.038-.042.055l-.569.332a.23.23 0 0 1-.2 0v.114a.215.215 0 0 0 .2 0l.569-.331a.076.076 0 0 0 .03-.023.067.067 0 0 0 .012-.035v-.112z"
            fill="#3D3D3D"
        />
        <path
            d="m554.14 858.28-.575-.332a.073.073 0 0 1-.041-.055v.114a.068.068 0 0 0 .041.055l.575.333v-.115z"
            fill="#636363"
        />
        <path
            d="M554.95 857.89c0 .023-.011.042-.043.057l-.567.33a.217.217 0 0 1-.2 0v.115a.217.217 0 0 0 .2 0l.567-.333a.063.063 0 0 0 .043-.054v-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m555.14 858.85-.575-.33a.076.076 0 0 1-.028-.022.071.071 0 0 1-.013-.034v.114c0 .02.013.04.041.066l.574.33.001-.124z"
            fill="#636363"
        />
        <path
            d="M555.95 858.47a.077.077 0 0 1-.012.035.07.07 0 0 1-.028.023l-.57.328c-.031.017-.065.027-.1.027s-.07-.01-.1-.027v.115a.23.23 0 0 0 .1.024.233.233 0 0 0 .1-.024l.57-.333c.011-.005.02-.013.027-.023s.012-.021.013-.033v-.112z"
            fill="#3D3D3D"
        />
        <path
            d="m556.14 859.43-.575-.332a.064.064 0 0 1-.026-.023.083.083 0 0 1-.013-.034v.113a.081.081 0 0 0 .012.035.07.07 0 0 0 .027.024l.575.332v-.115z"
            fill="#636363"
        />
        <path
            d="M556.95 859.04c-.001.013-.005.025-.012.035s-.017.018-.028.022l-.572.332a.22.22 0 0 1-.2 0v.115a.217.217 0 0 0 .2 0l.57-.332a.053.053 0 0 0 .029-.022.063.063 0 0 0 .013-.035v-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m554.98 855.36-1.575-.913a.067.067 0 0 1-.028-.022.07.07 0 0 1-.014-.033v.115a.074.074 0 0 0 .013.033.08.08 0 0 0 .029.023l1.575.909v-.112z"
            fill="#636363"
        />
        <path
            d="M555.78 854.97a.083.083 0 0 1-.013.034.104.104 0 0 1-.028.023l-.568.332a.22.22 0 0 1-.2 0v.112a.217.217 0 0 0 .2 0l.568-.332a.082.082 0 0 0 .027-.022.083.083 0 0 0 .014-.032v-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m555.93 855.89-.573-.332a.076.076 0 0 1-.028-.022.085.085 0 0 1-.014-.034v.112c.002.013.007.025.014.035s.017.019.028.024l.573.329v-.112z"
            fill="#636363"
        />
        <path
            d="M556.73 855.5a.063.063 0 0 1-.012.033.064.064 0 0 1-.026.023l-.571.33a.207.207 0 0 1-.2 0v.112c.031.017.065.025.1.025s.069-.008.1-.025l.573-.329a.067.067 0 0 0 .027-.023.085.085 0 0 0 .011-.035l-.002-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m557 856.51-.574-.33c-.028-.018-.043-.037-.043-.057v.113a.076.076 0 0 0 .043.059l.574.329v-.114z"
            fill="#636363"
        />
        <path
            d="M557.81 856.12c0 .02-.014.037-.04.055l-.573.332c-.031.015-.065.022-.1.022s-.069-.007-.1-.022v.114c.031.016.065.025.1.025s.069-.009.1-.025l.573-.329c.026-.018.04-.036.04-.057v-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m558 857.09-.573-.333a.067.067 0 0 1-.03-.022.068.068 0 0 1-.013-.035v.116c0 .02.013.039.043.057l.573.33v-.113z"
            fill="#636363"
        />
        <path
            d="M558.81 856.7a.07.07 0 0 1-.012.034.073.073 0 0 1-.029.023l-.57.333a.23.23 0 0 1-.2 0v.113c.031.015.065.024.1.024s.069-.009.1-.024l.57-.33a.091.091 0 0 0 .028-.023.071.071 0 0 0 .013-.034v-.116z"
            fill="#3D3D3D"
        />
        <path
            d="m559 857.66-.574-.334c-.012-.004-.022-.012-.029-.022s-.012-.021-.013-.034v.116c.001.013.006.024.013.034s.017.018.028.023l.575.331v-.114z"
            fill="#636363"
        />
        <path
            d="M559.81 857.28c0 .021-.014.039-.043.057l-.569.331a.217.217 0 0 1-.2 0v.114a.217.217 0 0 0 .2 0l.569-.331a.058.058 0 0 0 .029-.022.064.064 0 0 0 .014-.035v-.114z"
            fill="#3D3D3D"
        />
        <path
            d="m554.01 855.92-1.572-.909a.076.076 0 0 1-.03-.023.066.066 0 0 1-.011-.035v.115a.06.06 0 0 0 .011.034c.008.01.018.018.03.022l1.572.909v-.113z"
            fill="#636363"
        />
        <path
            d="M554.82 855.53c-.002.012-.006.024-.013.034s-.017.018-.028.024l-.567.33a.232.232 0 0 1-.2 0v.113a.23.23 0 0 0 .2 0l.567-.329a.075.075 0 0 0 .04-.061l.001-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m555.01 856.51-.573-.334a.092.092 0 0 1-.028-.024.083.083 0 0 1-.013-.034v.114a.093.093 0 0 0 .013.035c.007.01.017.018.028.024l.572.33.001-.111z"
            fill="#636363"
        />
        <path
            d="M555.82 856.1a.066.066 0 0 1-.012.034.066.066 0 0 1-.028.022l-.568.334a.23.23 0 0 1-.2 0v.111c.031.017.065.025.1.025s.069-.008.1-.025l.57-.33c.011-.004.02-.012.027-.022s.012-.021.013-.034l-.002-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m556.04 857.11-.575-.331c-.011-.005-.021-.013-.028-.023s-.011-.022-.012-.034v.113a.06.06 0 0 0 .011.034c.008.01.017.018.029.023l.575.331v-.113z"
            fill="#636363"
        />
        <path
            d="M556.85 856.72c-.001.012-.005.023-.012.033s-.016.018-.026.024l-.57.331c-.031.015-.065.024-.1.024s-.069-.009-.1-.024v.113a.204.204 0 0 0 .2 0l.572-.329a.067.067 0 0 0 .026-.024.066.066 0 0 0 .012-.033l-.002-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m557.04 857.69-.575-.329a.07.07 0 0 1-.04-.058v.112c0 .024.012.042.039.061l.574.327.002-.113z"
            fill="#636363"
        />
        <path
            d="M557.85 857.31a.078.078 0 0 1-.04.056l-.572.329a.204.204 0 0 1-.2 0v.113a.204.204 0 0 0 .2 0l.572-.327c.025-.019.039-.037.039-.057l.001-.114z"
            fill="#3D3D3D"
        />
        <path
            d="m557.14 860.01-.574-.33a.078.078 0 0 1-.03-.024.078.078 0 0 1-.013-.036v.116a.093.093 0 0 0 .013.035c.007.01.017.018.028.024l.576.329v-.114z"
            fill="#636363"
        />
        <path
            d="M557.95 859.62a.07.07 0 0 1-.04.058l-.571.33a.215.215 0 0 1-.2 0v.114a.217.217 0 0 0 .2 0l.571-.329a.072.072 0 0 0 .027-.025.071.071 0 0 0 .013-.034v-.114z"
            fill="#3D3D3D"
        />
        <path
            d="m560 858.24-.574-.33a.071.071 0 0 1-.03-.024.07.07 0 0 1-.012-.036v.115c0 .012.004.024.011.035.007.01.017.018.029.023l.576.33v-.113z"
            fill="#636363"
        />
        <path
            d="M560.81 857.85a.085.085 0 0 1-.014.034.08.08 0 0 1-.029.023l-.57.331c-.031.016-.065.025-.1.025s-.069-.009-.1-.025v.112c.031.017.065.025.1.025s.069-.008.1-.025l.571-.329a.08.08 0 0 0 .029-.023.08.08 0 0 0 .014-.033l-.001-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m558.04 858.26-.572-.332a.065.065 0 0 1-.03-.022.077.077 0 0 1-.012-.036v.113c0 .013.004.026.012.036a.057.057 0 0 0 .03.023l.572.332v-.114z"
            fill="#636363"
        />
        <path
            d="M558.85 857.88a.073.073 0 0 1-.012.035.067.067 0 0 1-.027.023l-.571.332a.23.23 0 0 1-.2 0v.114a.207.207 0 0 0 .2 0l.571-.328a.066.066 0 0 0 .039-.055v-.121z"
            fill="#3D3D3D"
        />
        <path
            d="m559.04 858.84-.574-.329a.062.062 0 0 1-.029-.024.062.062 0 0 1-.013-.034v.113c0 .023.014.041.042.06l.574.331v-.117z"
            fill="#636363"
        />
        <path
            d="M559.85 858.45a.07.07 0 0 1-.04.058l-.571.329c-.031.016-.065.025-.1.025s-.069-.009-.1-.025v.117a.23.23 0 0 0 .2 0l.571-.331a.084.084 0 0 0 .028-.025.077.077 0 0 0 .012-.035v-.113z"
            fill="#3D3D3D"
        />
        <path
            d="m555.08 857.7-.573-.33a.076.076 0 0 1-.029-.024.077.077 0 0 1-.012-.035v.115c.001.012.006.023.013.033s.017.018.028.023l.573.331v-.113z"
            fill="#636363"
        />
        <path
            d="M555.89 857.31a.077.077 0 0 1-.012.035.081.081 0 0 1-.028.024l-.57.33a.23.23 0 0 1-.2 0v.113a.23.23 0 0 0 .2 0l.57-.331c.011-.006.02-.013.027-.023s.012-.021.013-.033v-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m556.08 858.28-.572-.332a.076.076 0 0 1-.03-.023.071.071 0 0 1-.013-.034v.116a.068.068 0 0 0 .013.033c.008.01.018.017.029.022l.573.333v-.115z"
            fill="#636363"
        />
        <path
            d="M556.9 857.89a.085.085 0 0 1-.014.034.076.076 0 0 1-.03.023l-.569.33a.217.217 0 0 1-.2 0v.115a.217.217 0 0 0 .2 0l.569-.332a.064.064 0 0 0 .029-.022.057.057 0 0 0 .013-.033l.002-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m557.08 858.85-.573-.33a.064.064 0 0 1-.029-.022.062.062 0 0 1-.013-.034v.114a.062.062 0 0 0 .013.034c.007.01.017.017.029.022l.573.331v-.115z"
            fill="#636363"
        />
        <path
            d="M557.9 858.47a.071.071 0 0 1-.013.034.083.083 0 0 1-.029.024l-.569.328c-.03.017-.065.027-.1.027s-.07-.01-.1-.027v.115a.217.217 0 0 0 .2 0l.569-.331c.011-.005.02-.013.027-.023s.012-.021.013-.033l.002-.114z"
            fill="#3D3D3D"
        />
        <path
            d="m558.08 859.43-.573-.332a.066.066 0 0 1-.04-.057v.113a.07.07 0 0 0 .012.035.06.06 0 0 0 .028.024l.573.332v-.115z"
            fill="#636363"
        />
        <path
            d="M558.9 859.04c-.002.013-.007.024-.014.034s-.016.018-.027.023l-.57.332a.217.217 0 0 1-.2 0v.115a.217.217 0 0 0 .2 0l.569-.332c.026-.016.043-.035.043-.057l-.001-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m558.14 860.59-.576-.332a.081.081 0 0 1-.028-.024.079.079 0 0 1-.013-.035v.114c0 .023.015.041.041.06l.576.33v-.113z"
            fill="#636363"
        />
        <path
            d="M558.95 860.2a.063.063 0 0 1-.012.033.07.07 0 0 1-.028.023l-.569.332a.22.22 0 0 1-.2 0v.117a.22.22 0 0 0 .2 0l.569-.33a.075.075 0 0 0 .04-.06v-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m561 858.82-.571-.331a.07.07 0 0 1-.041-.058v.115a.062.062 0 0 0 .013.034c.007.01.016.018.028.023l.571.331v-.114z"
            fill="#636363"
        />
        <path
            d="M561.95 858.5a.067.067 0 0 1-.013.034.068.068 0 0 1-.029.022l-.57.332a.207.207 0 0 1-.2 0v.114c.03.017.065.025.1.025s.069-.008.1-.025l.57-.332a.073.073 0 0 0 .029-.024.082.082 0 0 0 .013-.035v-.111z"
            fill="#3D3D3D"
        />
        <path
            d="m560.04 859.42-.575-.332c-.026-.016-.041-.034-.041-.056v.111c0 .012.004.025.012.035.007.01.017.018.029.023l.575.332v-.113z"
            fill="#636363"
        />
        <path
            d="M560.85 859.03a.076.076 0 0 1-.011.033.067.067 0 0 1-.027.023l-.573.332a.207.207 0 0 1-.2 0v.113a.207.207 0 0 0 .2 0l.573-.332a.067.067 0 0 0 .027-.023.076.076 0 0 0 .011-.033v-.113z"
            fill="#3D3D3D"
        />
        <path
            d="m559.08 860.01-.572-.33a.078.078 0 0 1-.03-.024.067.067 0 0 1-.012-.036v.116a.085.085 0 0 0 .014.034.078.078 0 0 0 .029.025l.573.329-.002-.114z"
            fill="#636363"
        />
        <path
            d="M559.89 859.62a.07.07 0 0 1-.041.058l-.571.33a.23.23 0 0 1-.2 0v.114c.031.015.065.024.1.024s.069-.009.1-.024l.571-.329a.075.075 0 0 0 .028-.025.068.068 0 0 0 .011-.034l.002-.114z"
            fill="#3D3D3D"
        />
        <path
            d="m551.18 856.54-.576-.328a.095.095 0 0 1-.028-.025.095.095 0 0 1-.014-.035v.113a.085.085 0 0 0 .042.059l.576.331v-.115z"
            fill="#636363"
        />
        <path
            d="M552 856.14c0 .022-.015.041-.043.058l-.567.332a.232.232 0 0 1-.2 0v.113c.03.015.063.024.097.024s.067-.009.098-.024l.57-.33a.081.081 0 0 0 .028-.024.079.079 0 0 0 .013-.035l.004-.114z"
            fill="#3D3D3D"
        />
        <path
            d="m552.14 857.09-.575-.332a.077.077 0 0 1-.028-.023.07.07 0 0 1-.012-.034v.114a.085.085 0 0 0 .014.034c.008.01.017.018.028.024l.575.332-.002-.115z"
            fill="#636363"
        />
        <path
            d="M552.95 856.71a.071.071 0 0 1-.041.057l-.572.332c-.031.016-.065.025-.1.025s-.069-.009-.1-.025v.115a.217.217 0 0 0 .2 0l.572-.332a.078.078 0 0 0 .04-.058l.001-.114z"
            fill="#3D3D3D"
        />
        <path
            d="m553.14 857.67-.575-.332a.071.071 0 0 1-.041-.057v.114c0 .023.014.041.041.059l.575.328v-.112z"
            fill="#636363"
        />
        <path
            d="M553.95 857.28a.071.071 0 0 1-.013.034.08.08 0 0 1-.029.023l-.569.332a.232.232 0 0 1-.2 0v.112a.23.23 0 0 0 .2 0l.569-.328a.072.072 0 0 0 .028-.024.073.073 0 0 0 .014-.034v-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m562.1 858.33-4.594-2.665c-.027-.019-.04-.038-.04-.059v.116c0 .015.013.039.056.079l4.578 2.641v-.112zM563.12 858.92l-.575-.33c-.028-.019-.042-.039-.042-.058v.113a.075.075 0 0 0 .042.06l.575.329v-.114z"
            fill="#636363"
        />
        <path
            d="M563.93 858.53c0 .021-.014.039-.039.06l-.571.328c-.031.015-.065.024-.1.024s-.069-.009-.1-.024v.114a.243.243 0 0 0 .2 0l.574-.33a.075.075 0 0 0 .027-.026.07.07 0 0 0 .012-.034l-.003-.112zM562.91 857.94c0 .021-.016.039-.04.056l-.571.332a.209.209 0 0 1-.2 0v.112a.198.198 0 0 0 .2 0l.57-.328a.067.067 0 0 0 .026-.024.078.078 0 0 0 .013-.034l.002-.114z"
            fill="#3D3D3D"
        />
        <path
            d="m564.14 859.52-.572-.334c-.012-.004-.022-.011-.03-.021s-.012-.022-.014-.034v.114a.062.062 0 0 0 .013.034.07.07 0 0 0 .028.023l.575.332v-.114z"
            fill="#636363"
        />
        <path
            d="M564.94 859.13a.06.06 0 0 1-.041.054l-.568.334a.217.217 0 0 1-.2 0v.114c.031.016.065.025.1.025s.069-.009.1-.025l.568-.332a.065.065 0 0 0 .029-.023.07.07 0 0 0 .012-.034v-.113z"
            fill="#3D3D3D"
        />
        <path
            d="M556.74 854.28c.056.03.057.081 0 .113l-.568.33c-.031.016-.065.025-.1.025s-.069-.009-.1-.025l-1.574-.907a.057.057 0 0 1-.03-.023.06.06 0 0 1 0-.072.06.06 0 0 1 .03-.022l.571-.33a.217.217 0 0 1 .2 0l1.571.911z"
            fill="#4A4A4A"
        />
        <path
            d="m555.97 854.73-1.574-.907a.073.073 0 0 1-.042-.059v.113a.078.078 0 0 0 .013.036c.008.01.018.018.029.024l1.572.91.002-.117z"
            fill="#636363"
        />
        <path
            d="M556.78 854.34c-.002.012-.006.024-.013.034s-.017.019-.028.024l-.568.33a.215.215 0 0 1-.2 0v.117a.242.242 0 0 0 .2 0l.57-.332a.086.086 0 0 0 .029-.025.082.082 0 0 0 .013-.035l-.003-.113z"
            fill="#3D3D3D"
        />
        <path
            d="m562.12 859.49-.572-.329a.084.084 0 0 1-.042-.059v.116a.068.068 0 0 0 .013.033.08.08 0 0 0 .029.023l.572.329v-.113z"
            fill="#636363"
        />
        <path
            d="M562.93 859.1a.063.063 0 0 1-.013.035.065.065 0 0 1-.028.024l-.569.33c-.031.016-.065.025-.1.025s-.069-.009-.1-.025v.113a.198.198 0 0 0 .2 0l.568-.33a.064.064 0 0 0 .042-.054v-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m552.1 855.91-.574-.329a.096.096 0 0 1-.029-.024.083.083 0 0 1-.013-.034v.113a.071.071 0 0 0 .013.034.08.08 0 0 0 .029.023l.574.331v-.114z"
            fill="#636363"
        />
        <path
            d="M552.91 855.52a.106.106 0 0 1-.012.034.088.088 0 0 1-.027.024l-.568.329a.23.23 0 0 1-.2 0v.114a.22.22 0 0 0 .2 0l.568-.33c.011-.006.02-.014.027-.024s.011-.022.012-.034v-.113z"
            fill="#3D3D3D"
        />
        <path
            d="m553.1 856.49-.575-.332a.07.07 0 0 1-.028-.023.073.073 0 0 1-.014-.034v.115a.064.064 0 0 0 .013.033c.008.01.018.018.029.022l.575.334v-.115z"
            fill="#636363"
        />
        <path
            d="M553.91 856.1a.068.068 0 0 1-.042.055l-.569.332a.215.215 0 0 1-.199 0v.115a.228.228 0 0 0 .199 0l.572-.334a.071.071 0 0 0 .028-.021.063.063 0 0 0 .012-.032l-.001-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m554.1 857.06-.573-.332a.083.083 0 0 1-.029-.024.092.092 0 0 1-.013-.036v.117c.002.013.007.024.014.034s.017.018.028.023l.573.331v-.113z"
            fill="#636363"
        />
        <path
            d="M554.92 856.68a.07.07 0 0 1-.012.034.076.076 0 0 1-.028.022l-.572.332a.23.23 0 0 1-.199 0v.113c.03.017.064.027.099.027.036 0 .07-.01.1-.027l.572-.327a.077.077 0 0 0 .028-.023.07.07 0 0 0 .012-.034v-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m561.04 860-.576-.329a.063.063 0 0 1-.039-.059v.114c0 .013.004.025.012.035.007.01.016.018.028.022l.576.33-.001-.113z"
            fill="#636363"
        />
        <path
            d="M561.87 859.68c-.001.012-.004.024-.011.034s-.016.018-.027.023l-.571.329a.207.207 0 0 1-.2 0v.117a.23.23 0 0 0 .1.024.233.233 0 0 0 .1-.024l.569-.332a.073.073 0 0 0 .027-.022.068.068 0 0 0 .013-.033v-.116z"
            fill="#3D3D3D"
        />
        <path
            d="m562.18 860.64-.575-.333a.071.071 0 0 1-.026-.023.093.093 0 0 1-.012-.033v.111a.08.08 0 0 0 .011.035.062.062 0 0 0 .027.024l.575.333v-.114z"
            fill="#636363"
        />
        <path
            d="M562.99 860.25c-.001.012-.005.024-.012.034s-.016.018-.027.022l-.571.328a.195.195 0 0 1-.2.005v.114a.216.216 0 0 0 .1.023.219.219 0 0 0 .1-.023l.571-.333a.061.061 0 0 0 .025-.023.07.07 0 0 0 .012-.034l.002-.113z"
            fill="#3D3D3D"
        />
        <path
            d="m564.11 861.78-1.573-.91a.076.076 0 0 1-.03-.023.083.083 0 0 1-.014-.035v.116a.065.065 0 0 0 .014.033.074.074 0 0 0 .028.021l1.575.911v-.113z"
            fill="#636363"
        />
        <path
            d="M564.92 861.39c-.001.012-.005.023-.012.033s-.017.018-.028.024l-.57.331a.23.23 0 0 1-.2 0v.114a.215.215 0 0 0 .2 0l.573-.332c.011-.005.021-.013.028-.023s.011-.021.012-.033l-.003-.114z"
            fill="#3D3D3D"
        />
        <path
            d="m560.08 860.59-.572-.332a.076.076 0 0 1-.03-.023.066.066 0 0 1-.011-.036v.114c0 .023.011.041.041.06l.572.33v-.113z"
            fill="#636363"
        />
        <path
            d="M560.9 860.2c0 .021-.014.04-.04.056l-.569.332c-.031.015-.065.024-.1.024s-.069-.009-.1-.024v.117c.031.015.065.024.1.024s.069-.009.1-.024l.569-.33a.072.072 0 0 0 .027-.025.079.079 0 0 0 .013-.033v-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m561.08 861.16-.571-.33a.057.057 0 0 1-.03-.023.059.059 0 0 1-.013-.036v.116c0 .021.015.04.045.056l.571.333-.002-.116z"
            fill="#636363"
        />
        <path
            d="M561.91 860.81c0 .022-.014.042-.043.058l-.567.331a.22.22 0 0 1-.2 0v.114a.215.215 0 0 0 .2 0l.567-.333a.062.062 0 0 0 .041-.054l.002-.116z"
            fill="#3D3D3D"
        />
        <path
            d="m563.08 862.32-1.573-.91a.073.073 0 0 1-.027-.022.071.071 0 0 1-.013-.034v.113c0 .012.004.024.011.034s.016.018.027.022l1.575.908v-.111z"
            fill="#636363"
        />
        <path
            d="M563.9 861.93a.085.085 0 0 1-.041.059l-.57.33a.23.23 0 0 1-.2 0v.111a.204.204 0 0 0 .2 0l.57-.33a.073.073 0 0 0 .027-.022.07.07 0 0 0 .012-.033l.002-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m559.14 861.14-.574-.331c-.026-.018-.042-.037-.042-.056v.112a.073.073 0 0 0 .014.034c.007.01.017.018.028.024l.574.333v-.116z"
            fill="#636363"
        />
        <path
            d="M559.95 860.75c0 .019-.013.039-.043.058l-.569.329a.217.217 0 0 1-.2 0v.116a.23.23 0 0 0 .2 0l.569-.333a.07.07 0 0 0 .043-.056v-.114z"
            fill="#3D3D3D"
        />
        <path
            d="m560.14 861.72-.577-.333c-.011-.005-.02-.013-.027-.023s-.012-.022-.013-.034v.111a.069.069 0 0 0 .013.036c.007.011.017.02.028.026l.577.33-.001-.113z"
            fill="#636363"
        />
        <path
            d="M560.95 861.32a.06.06 0 0 1-.011.034.058.058 0 0 1-.026.023l-.57.333a.235.235 0 0 1-.2 0v.113a.217.217 0 0 0 .2 0l.568-.33a.075.075 0 0 0 .028-.025.072.072 0 0 0 .011-.035v-.113z"
            fill="#3D3D3D"
        />
        <path
            d="M560.91 861.27a.068.068 0 0 1 .03.023.06.06 0 0 1-.03.092l-.57.333a.23.23 0 0 1-.2 0l-.577-.333a.058.058 0 0 1-.029-.022c-.008-.01-.012-.022-.012-.035s.004-.025.012-.035a.06.06 0 0 1 .029-.023l.571-.331a.23.23 0 0 1 .2 0l.576.331z"
            fill="#4A4A4A"
        />
        <path
            d="m562.14 862.87-1.573-.907a.07.07 0 0 1-.041-.059v.116a.07.07 0 0 0 .015.034.06.06 0 0 0 .028.022l1.573.909-.002-.115z"
            fill="#636363"
        />
        <path
            d="M562.95 862.48c-.002.013-.007.024-.014.034s-.016.018-.027.023l-.568.328a.209.209 0 0 1-.2 0v.115a.198.198 0 0 0 .2 0l.566-.331a.06.06 0 0 0 .029-.021.064.064 0 0 0 .014-.035v-.113z"
            fill="#3D3D3D"
        />
        <path
            d="M565.88 860.77c.055.032.055.084 0 .113l-.57.333c-.031.015-.065.024-.1.024s-.069-.009-.1-.024l-2.525-1.465c-.055-.03-.055-.08 0-.113l.568-.33a.207.207 0 0 1 .2 0l2.527 1.462z"
            fill="#4A4A4A"
        />
        <path
            d="m565.11 861.22-2.525-1.465c-.012-.005-.022-.012-.029-.022s-.012-.022-.013-.034v.114a.062.062 0 0 0 .013.034c.007.01.017.017.029.022l2.525 1.462v-.111z"
            fill="#636363"
        />
        <path
            d="M565.92 860.83a.069.069 0 0 1-.041.055l-.57.332a.217.217 0 0 1-.2 0v.115a.232.232 0 0 0 .2 0l.57-.33c.025-.019.041-.037.041-.06v-.112z"
            fill="#3D3D3D"
        />
        <path
            d="M560.55 856.07a.383.383 0 0 1-.022-.726l1.547-.948a1.398 1.398 0 0 1 1.26-.031l2.5 1.365a.385.385 0 0 1 .206.584.391.391 0 0 1-.184.147l-1.545.948a1.401 1.401 0 0 1-1.26.028l-2.502-1.367z"
            fill="#9E9D9D"
        />
        <path
            d="m563.88 863.53.531-.308v-.177l-.531.306v.179zM564.76 863.03l.528-.306v-.178l-.53.3.002.184z"
            fill="#1C1C1C"
        />
        <path
            d="M549.64 847.08a.553.553 0 0 0-.565 0l-.15.087 12.831 7.556.264 9.378.3-.178v-8.9a1.114 1.114 0 0 0-.567-.978l-12.113-6.965z"
            fill="#8E8D8D"
        />
        <path
            d="M561.45 854.22a1.137 1.137 0 0 1 .57.984v8.9l-13.33-7.675v-8.9a.387.387 0 0 1 .188-.326.376.376 0 0 1 .376-.001l12.196 7.018z"
            fill="#C1BFBD"
        />
        <path
            d="m569.8 858.81.555-.606-.989-.874-3.459.5-1.863 1.2s-.267.252-.065.482c.077.087.3.013.424-.043.315-.145.827-.4.913-.459.254-.164.4.148.4.148.048.118.407.688.55.934.174.3.446.376.83.474.523.135.555-.024.686-.158.032-.034-.035-.184-.035-.184.982-.127 2.143-.677 2.053-1.414z"
            fill="#FFE8D9"
        />
        <path
            d="M569.17 857.33s.239-.157.562.792a1.403 1.403 0 0 1-.185 1.324s6.207-1.06 7.142-1.42a5.162 5.162 0 0 0 1.817-1c.47-.582.7-1.321.644-2.066l.005-7.9c-.122-2.138-1.062-3.233-2.475-2.944-1.952.4-1.356 3.258-1.13 4.557.149.849.441 4.413.559 5.562a1.071 1.071 0 0 1-.713 1.051l-6.226 2.044z"
            fill="#D32A1E"
        />
        <path
            d="M565.52 854.69c.4.286 1.042-.061 1.3-.422.09-.123.7.8 1.114.815.433.018.261-.306.209-.417a3.45 3.45 0 0 0-1.321-1.208c-1.256-.395-1.372-.1-1.633.263s-.064.688.331.969z"
            fill="#FFE8D9"
        />
        <path
            d="m564.5 853.99.6-.861 1.906.955.58.347 1.278 1.626s.232.324-.674.7c-.443.18-1.58-.421-1.58-.421l-1.425-.589c-.443-.307-1.02-1.279-.685-1.757z"
            fill="#FFE8D9"
        />
        <path
            d="M565.7 853.27s-1.031-1.28-1.671-1.951c-.464-.487-1.643-1.066-2.371-.1-.775 1.026.269 2.152.687 2.519a12.387 12.387 0 0 0 2.405 1.621 1.622 1.622 0 0 1 0-1.254 1.412 1.412 0 0 1 .95-.835z"
            fill="#B21B0B"
        />
        <path
            d="m571.02 862.86 1.189.751.108-.212-1.162-.772-.135.233z"
            fill="#898B8C"
        />
        <path
            d="M572.22 863.51a.058.058 0 0 1-.016.019c-.006.006-.014.009-.022.011s-.017.002-.025.001a.067.067 0 0 1-.023-.01l-1.009-.585a.066.066 0 0 1-.022-.087.061.061 0 0 1 .039-.029c.008-.002.017-.003.025-.002a.092.092 0 0 1 .023.009l1.009.589a.07.07 0 0 1 .019.015c.005.007.008.014.01.022s.003.016.001.024a.05.05 0 0 1-.009.023z"
            fill="#616465"
        />
        <path
            d="m570.32 862.69-3.337 1.941v.385l3.337-1.94 2.164 1.25v-.384l-2.164-1.252z"
            fill="#8B8D8E"
        />
        <path
            d="M569.14 865.88v.387l-2.157-1.252v-.386l2.157 1.251z"
            fill="#C1C1C1"
        />
        <path d="M572.48 863.94v.384l-3.344 1.943v-.387l3.344-1.94z" fill="gray" />
        <path
            d="m572.48 864.02-3.343 1.94-2.159-1.253 3.337-1.94 2.165 1.253z"
            fill="#DBDDDD"
        />
        <path
            d="m573 863.91-4.076 2.37a.601.601 0 0 1-.556 0l-2.074-1.197a.2.2 0 0 1-.113-.162v.383a.194.194 0 0 0 .036.096.208.208 0 0 0 .081.066l2.071 1.194a.595.595 0 0 0 .556 0l4.078-2.366c.031-.015.059-.038.079-.066s.032-.062.036-.096v-.384c-.002.035-.015.069-.036.098s-.049.051-.082.064z"
            fill="#C1C7C8"
        />
        <path
            d="m573 863.58-2.073-1.2a.607.607 0 0 0-.555 0l-4.072 2.371c-.154.09-.154.232 0 .324l2.073 1.194a.598.598 0 0 0 .556 0l4.076-2.37a.173.173 0 0 0 .083-.063.17.17 0 0 0-.003-.196.165.165 0 0 0-.085-.06zm-3.861 2.3-2.16-1.251 3.336-1.941 2.166 1.251-3.342 1.941z"
            fill="#A0A5A6"
        />
        <path
            d="M572 863.15v.031a.142.142 0 0 1-.083.119.458.458 0 0 1-.411 0 .142.142 0 0 1-.084-.12v-.032c.002.026.011.05.026.071s.035.038.058.048a.445.445 0 0 0 .411 0 .13.13 0 0 0 .057-.047.133.133 0 0 0 .026-.07z"
            fill="#616464"
        />
        <path
            d="M571.91 863.03c.113.068.113.172 0 .238a.458.458 0 0 1-.411 0 .122.122 0 0 1-.06-.047c-.015-.021-.023-.046-.023-.072s.008-.051.023-.073a.12.12 0 0 1 .06-.046.458.458 0 0 1 .411 0z"
            fill="#C1C7C8"
        />
        <path d="M493.62 841.36v.078l9.3 5.4v-.08l-9.3-5.398z" fill="#AAA9A9" />
        <path
            d="M502.92 846.76v.08l7.078-4.088v-.08l-7.078 4.088z"
            fill="#676767"
        />
        <path
            d="m493.62 841.36 9.3 5.4 7.078-4.088-9.275-5.392-7.103 4.08z"
            fill="#fff"
        />
        <path d="M493.62 840.95v.078l9.3 5.4v-.081l-9.3-5.397z" fill="#AAA9A9" />
        <path
            d="M502.92 846.35v.081l7.078-4.087v-.081l-7.078 4.087z"
            fill="#676767"
        />
        <path
            d="m493.62 840.95 9.3 5.4 7.078-4.087-9.275-5.389-7.103 4.076z"
            fill="#fff"
        />
        <path d="M493.62 840.55v.078l9.3 5.4v-.079l-9.3-5.399z" fill="#AAA9A9" />
        <path
            d="M502.92 845.95v.079l7.078-4.086v-.082l-7.078 4.089z"
            fill="#676767"
        />
        <path
            d="m493.62 840.55 9.3 5.4 7.078-4.089-9.275-5.389-7.103 4.078z"
            fill="#fff"
        />
        <path d="M493.62 840.14v.08l9.3 5.4v-.077l-9.3-5.403z" fill="#AAA9A9" />
        <path
            d="M502.92 845.54v.077l7.078-4.086v-.08l-7.078 4.089z"
            fill="#676767"
        />
        <path
            d="m493.62 840.14 9.3 5.405 7.078-4.089-9.275-5.39-7.103 4.074z"
            fill="#fff"
        />
        <path d="M493.62 839.73v.08l9.3 5.4v-.078l-9.3-5.402z" fill="#AAA9A9" />
        <path
            d="M502.92 845.14v.078l7.078-4.085v-.079l-7.078 4.086z"
            fill="#676767"
        />
        <path
            d="m493.62 839.73 9.3 5.4 7.078-4.086-9.275-5.389-7.103 4.075z"
            fill="#fff"
        />
        <path d="M493.62 839.33v.08l9.3 5.4v-.082l-9.3-5.398z" fill="#AAA9A9" />
        <path
            d="M502.92 844.73v.082l7.078-4.086v-.078l-7.078 4.082z"
            fill="#676767"
        />
        <path
            d="m493.62 839.33 9.3 5.4 7.078-4.082-9.275-5.393-7.103 4.075z"
            fill="#fff"
        />
        <path d="M493.62 838.92v.079l9.3 5.4v-.078l-9.3-5.401z" fill="#AAA9A9" />
        <path
            d="M502.92 844.32v.078l7.078-4.085v-.082l-7.078 4.089z"
            fill="#676767"
        />
        <path
            d="m493.62 838.92 9.3 5.4 7.078-4.089-9.275-5.388-7.103 4.077z"
            fill="#fff"
        />
        <path d="M493.62 838.52v.078l9.3 5.4v-.077l-9.3-5.401z" fill="#AAA9A9" />
        <path
            d="M502.92 843.92v.077l7.078-4.087v-.079l-7.078 4.089z"
            fill="#676767"
        />
        <path
            d="m493.62 838.52 9.3 5.4 7.078-4.089-9.275-5.391-7.103 4.08z"
            fill="#fff"
        />
        <path d="M493.62 838.11v.079l9.3 5.4v-.078l-9.3-5.401z" fill="#AAA9A9" />
        <path
            d="M502.92 843.51v.078l7.078-4.087v-.079l-7.078 4.088z"
            fill="#676767"
        />
        <path
            d="m493.62 838.11 9.3 5.405 7.078-4.088-9.275-5.391-7.103 4.074z"
            fill="#fff"
        />
        <path d="M493.62 837.71v.078l9.3 5.4v-.078l-9.3-5.4z" fill="#AAA9A9" />
        <path
            d="M502.92 843.11v.079l7.078-4.086v-.079l-7.078 4.086z"
            fill="#676767"
        />
        <path
            d="m493.62 837.71 9.3 5.4 7.078-4.086-9.275-5.39-7.103 4.076z"
            fill="#fff"
        />
        <path d="M493.6 837.28v.08l9.335 5.414v-.08l-9.335-5.414z" fill="#AAA9A9" />
        <path
            d="M502.94 842.69v.08l5.072-2.961.019-.082-5.091 2.963z"
            fill="#787878"
        />
        <path
            d="m493.6 837.28 9.335 5.414 1.3-.754 3.8-2.209.5-1.976-7.856-4.562-7.079 4.087z"
            fill="#fff"
        />
        <path d="M495.46 837.64v.019l.951.553v-.022l-.951-.55z" fill="#A0A0A0" />
        <path
            d="M496.41 838.18v.022l6.054-3.5v-.021l-6.054 3.499z"
            fill="#616161"
        />
        <path
            d="m495.46 837.64.951.55 6.054-3.5-.948-.553-6.057 3.503z"
            fill="#B9B9B9"
        />
        <path d="M496.9 838.48v.022l.95.551v-.021l-.95-.552z" fill="#A0A0A0" />
        <path d="M497.84 839.04v.021l6.056-3.5v-.02l-6.056 3.499z" fill="#616161" />
        <path
            d="m496.9 838.48.951.553 6.056-3.5-.948-.553-6.059 3.5z"
            fill="#B9B9B9"
        />
        <path d="M498.36 839.34v.021l.95.552v-.018l-.95-.555z" fill="#A0A0A0" />
        <path d="M499.31 839.89v.018l6.058-3.5v-.018l-6.058 3.5z" fill="#616161" />
        <path
            d="m498.36 839.34.95.554 6.058-3.5-.947-.553-6.061 3.499z"
            fill="#B9B9B9"
        />
        <path d="M499.88 840.22v.02l.95.551v-.019l-.95-.552z" fill="#A0A0A0" />
        <path d="M500.83 840.77v.019l6.058-3.5v-.02l-6.058 3.501z" fill="#616161" />
        <path
            d="m499.88 840.22.95.552 6.058-3.5-.951-.549-6.057 3.497z"
            fill="#B9B9B9"
        />
        <path d="M501.42 841.11v.021l.948.554v-.022l-.948-.553z" fill="#A0A0A0" />
        <path
            d="M502.36 841.67v.022l5.834-3.37v-.02l-5.834 3.368z"
            fill="#616161"
        />
        <path
            d="m501.42 841.11.948.553 5.836-3.367.058-.225-.786-.457-6.056 3.496z"
            fill="#B9B9B9"
        />
        <path d="m508.03 839.73.5-1.976-1.24.736.74 1.24z" fill="#fff" />
        <path d="m507.98 839.76.051-.028-.734-1.24v.105l.683 1.163z" fill="#999" />
        <path
            d="m502.48 870.73-13.28-7.6v.3a.58.58 0 0 0 .294.505l12.3 7.085a1.34 1.34 0 0 0 1.352 0l8.7-5.053a.79.79 0 0 0 .389-.676v-.388l-9.755 5.827z"
            fill="#9E9D9D"
        />
        <path
            d="m512.23 864.91-9.191 5.874a1.116 1.116 0 0 1-1.15.023l-12.49-7.184a.396.396 0 0 1-.206-.343.399.399 0 0 1 .194-.349l9.195-5.875 13.648 7.854z"
            fill="#D3D3D3"
        />
        <path
            d="M499.28 847.67a.552.552 0 0 0-.575 0l-.153.091 13.1 7.755.272 9.611.313-.18v-9.132a1.175 1.175 0 0 0-.579-1.007l-12.378-7.138z"
            fill="#8E8D8D"
        />
        <path
            d="M511.34 855a1.17 1.17 0 0 1 .583 1.007v9.128l-13.616-7.872v-9.13a.387.387 0 0 1 .387-.387c.068 0 .134.019.193.054l12.453 7.2z"
            fill="#C1BFBD"
        />
        <path
            d="M510.63 864.76a.296.296 0 0 1 .108.214.296.296 0 0 1-.088.223l-4.289 2.736c-.36.224-.669.024-1.006-.169l-11.546-6.65a.26.26 0 0 1-.166-.243.26.26 0 0 1 .166-.242l4.219-2.665a.725.725 0 0 1 .678-.093l11.924 6.889z"
            fill="#898686"
        />
        <path
            d="M502.4 864.87a.067.067 0 0 1-.012.036.076.076 0 0 1-.029.024l-.58.341a.23.23 0 0 1-.2 0v.118a.232.232 0 0 0 .2 0l.58-.341c.012-.006.022-.015.029-.026s.012-.023.012-.036v-.116z"
            fill="#737373"
        />
        <path
            d="M500.45 865.56a.416.416 0 0 1 .205.64.417.417 0 0 1-.205.153l-1.7.987a1.51 1.51 0 0 1-1.369 0l-2.679-1.545a.423.423 0 0 1-.283-.397.417.417 0 0 1 .283-.397l1.705-.988a1.498 1.498 0 0 1 1.366 0l2.677 1.547z"
            fill="#9E9D9D"
        />
        <path
            d="M510.88 856.03v7.342l-11.814-6.821v-7.341l11.814 6.82z"
            fill="#8E8D8D"
        />
        <path
            d="m499.18 856.43 11.693 6.751v-7.151l-11.693-6.746v7.146z"
            fill="#4AACEE"
        />
        <path
            d="M499.15 858.25c.057.032.057.082 0 .116l-.582.341a.25.25 0 0 1-.2 0l-.59-.341a.06.06 0 0 1-.028-.024.06.06 0 0 1 0-.069.058.058 0 0 1 .028-.023l.584-.343a.242.242 0 0 1 .2 0l.588.343zM501.22 859.43c.06.034.057.087 0 .118l-.583.341a.23.23 0 0 1-.2 0l-.588-.341c-.058-.031-.058-.084 0-.118l.582-.338a.219.219 0 0 1 .206 0l.583.338zM500.13 858.8c.057.031.057.084 0 .118l-.584.337a.207.207 0 0 1-.2 0l-.588-.339c-.056-.032-.056-.085 0-.116l.585-.342a.228.228 0 0 1 .1-.022c.034 0 .069.007.1.022l.587.342zM502.26 860.03c.057.033.057.084 0 .121l-.585.336c-.031.016-.065.025-.1.025s-.069-.009-.1-.025l-.584-.34c-.06-.033-.06-.084 0-.117l.585-.338a.217.217 0 0 1 .2 0l.584.338zM503.28 860.62c.06.033.06.087 0 .118l-.583.338c-.031.015-.065.024-.1.024s-.069-.009-.1-.024l-.589-.338a.07.07 0 0 1-.03-.024.063.063 0 0 1 0-.071.061.061 0 0 1 .03-.023l.584-.34a.23.23 0 0 1 .205 0l.583.34zM504.3 861.21a.06.06 0 0 1 .03.022.064.064 0 0 1 0 .072.057.057 0 0 1-.03.023l-.585.339a.23.23 0 0 1-.2 0l-.588-.341c-.059-.031-.059-.084 0-.115l.583-.34a.207.207 0 0 1 .2 0l.59.34zM499.2 859.49c.057.033.057.088 0 .119l-.585.341a.23.23 0 0 1-.2 0l-1.614-.932c-.057-.036-.057-.085 0-.118l.583-.342a.235.235 0 0 1 .2 0l1.616.932zM500.17 860.03c.057.033.057.085 0 .118l-.582.34a.243.243 0 0 1-.2 0l-.589-.34a.07.07 0 0 1-.03-.023.064.064 0 0 1 0-.072.057.057 0 0 1 .03-.023l.583-.338a.217.217 0 0 1 .2 0l.588.338zM501.28 860.67c.053.031.055.083 0 .113l-.585.343a.243.243 0 0 1-.2 0l-.588-.341c-.012-.004-.022-.012-.03-.022s-.012-.022-.012-.035.004-.025.012-.035.018-.018.03-.021l.585-.341a.22.22 0 0 1 .2 0l.588.339zM502.3 861.26c.055.031.057.081 0 .113l-.583.341a.217.217 0 0 1-.2 0l-.587-.341c-.058-.032-.058-.086 0-.113l.584-.343a.217.217 0 0 1 .2 0l.586.343zM503.33 861.85a.055.055 0 0 1 .029.023c.008.011.011.023.011.036s-.003.025-.011.036a.062.062 0 0 1-.029.024l-.587.34c-.031.015-.065.022-.1.022s-.069-.007-.1-.022l-.59-.34c-.054-.035-.055-.085 0-.119l.587-.34a.23.23 0 0 1 .2 0l.59.34zM498.2 860.06c.058.034.058.086 0 .12l-.585.337a.217.217 0 0 1-.2 0l-1.617-.931a.065.065 0 0 1-.03-.022c-.007-.011-.011-.023-.011-.036s.004-.025.011-.036a.076.076 0 0 1 .03-.023l.586-.339a.217.217 0 0 1 .2 0l1.616.93zM499.23 860.66c.055.032.055.084 0 .114l-.586.341a.223.223 0 0 1-.2 0l-.588-.341a.06.06 0 0 1-.04-.057c0-.012.004-.024.011-.034s.017-.018.029-.023l.584-.34a.23.23 0 0 1 .2 0l.59.34zM500.3 861.28a.063.063 0 0 1 .043.06.058.058 0 0 1-.012.036.06.06 0 0 1-.031.023l-.584.338a.217.217 0 0 1-.2 0l-.588-.338c-.058-.033-.058-.086 0-.119l.585-.341a.25.25 0 0 1 .2 0l.587.341zM501.32 861.88a.06.06 0 0 1 .03.022.06.06 0 0 1 0 .072.057.057 0 0 1-.03.023l-.584.34a.242.242 0 0 1-.2 0l-.588-.34c-.056-.033-.056-.085 0-.117l.587-.342a.23.23 0 0 1 .2 0l.585.342zM505.33 861.81c.058.034.058.085 0 .118l-.583.339a.246.246 0 0 1-.2 0l-.589-.339a.07.07 0 0 1-.03-.024.063.063 0 0 1 0-.071.061.061 0 0 1 .03-.023l.583-.34a.228.228 0 0 1 .205 0l.584.34zM504.35 862.44a.057.057 0 0 1 .03.023.064.064 0 0 1 0 .072.07.07 0 0 1-.03.023l-.586.341a.23.23 0 0 1-.1.024.233.233 0 0 1-.1-.024l-.586-.341a.064.064 0 0 1-.031-.023c-.007-.01-.011-.023-.011-.036s.004-.026.011-.037a.068.068 0 0 1 .031-.022l.585-.337a.215.215 0 0 1 .2 0l.587.337zM502.34 862.47a.062.062 0 0 1 .029.024.06.06 0 0 1 0 .07.062.062 0 0 1-.029.024l-.586.337c-.031.016-.065.025-.1.025s-.069-.009-.1-.025l-.59-.337a.076.076 0 0 1-.03-.023c-.007-.011-.011-.023-.011-.036s.004-.025.011-.036a.076.076 0 0 1 .03-.023l.588-.339a.23.23 0 0 1 .2 0l.588.339zM503.37 863.06c.055.033.057.085 0 .121l-.583.337c-.031.015-.065.024-.1.024s-.069-.009-.1-.024l-.59-.337c-.056-.036-.056-.088 0-.122l.584-.337a.207.207 0 0 1 .2 0l.589.338zM498.3 861.29c.012.004.023.012.03.022s.011.023.011.035a.062.062 0 0 1-.041.058l-.586.342a.22.22 0 0 1-.2 0l-2.639-1.523c-.058-.034-.058-.085 0-.121l.581-.338a.23.23 0 0 1 .2 0l2.644 1.525zM499.31 861.89c.057.035.057.09 0 .119l-.583.34a.217.217 0 0 1-.2 0l-.588-.338c-.059-.031-.059-.084 0-.119l.582-.338a.217.217 0 0 1 .102-.025c.036 0 .071.008.103.025l.584.336zM500.33 862.48c.057.031.059.083 0 .115l-.582.34a.232.232 0 0 1-.2 0l-.589-.34c-.057-.032-.057-.084 0-.119l.583-.338a.23.23 0 0 1 .2 0l.588.342zM501.36 863.07c.056.032.056.087 0 .114l-.584.342a.235.235 0 0 1-.2 0l-.588-.342c-.056-.027-.056-.082 0-.114l.585-.342a.228.228 0 0 1 .103-.023c.035 0 .07.007.102.023l.582.342zM502.38 863.67a.055.055 0 0 1 .03.022.058.058 0 0 1 0 .071.057.057 0 0 1-.03.023l-.583.339a.217.217 0 0 1-.2 0l-.589-.339c-.059-.031-.059-.086 0-.116l.583-.341a.222.222 0 0 1 .104-.025.22.22 0 0 1 .103.025l.582.341zM506.35 862.4c.054.031.054.082 0 .116l-.583.34a.242.242 0 0 1-.206 0l-.586-.342c-.057-.032-.057-.083 0-.114l.584-.34a.232.232 0 0 1 .2 0l.591.34zM505.38 863.03c.057.033.057.086 0 .118l-.586.34a.221.221 0 0 1-.1.025.218.218 0 0 1-.1-.025l-.588-.34c-.057-.032-.057-.085 0-.118l.584-.341a.23.23 0 0 1 .1-.024c.034 0 .069.009.1.024l.59.341zM504.4 863.65a.065.065 0 0 1 .03.022c.007.011.011.023.011.036s-.004.025-.011.036a.076.076 0 0 1-.03.023l-.586.338a.215.215 0 0 1-.2 0l-.587-.337c-.06-.033-.06-.087 0-.12l.584-.338a.204.204 0 0 1 .2 0l.589.34zM503.41 864.26c.057.031.057.084 0 .116l-.582.341a.257.257 0 0 1-.205 0l-.586-.341c-.057-.034-.057-.085 0-.116l.582-.34c.031-.016.065-.023.1-.023s.069.007.1.023l.591.34zM495.31 860.71a.055.055 0 0 1 .03.022.06.06 0 0 1 0 .072.06.06 0 0 1-.03.022l-.583.339a.223.223 0 0 1-.205 0l-.588-.339a.063.063 0 0 1-.031-.022.064.064 0 0 1 0-.072.058.058 0 0 1 .031-.022l.585-.34c.03-.017.065-.025.1-.025s.069.008.1.025l.591.34zM496.29 861.26a.064.064 0 0 1 .043.059.06.06 0 0 1-.043.059l-.582.34a.232.232 0 0 1-.2 0l-.588-.34a.057.057 0 0 1-.03-.023.063.063 0 0 1 0-.071.064.064 0 0 1 .03-.024l.586-.34a.23.23 0 0 1 .2 0l.584.34zM497.32 861.86c.056.031.056.085 0 .119l-.586.337a.217.217 0 0 1-.2 0l-.59-.337a.073.073 0 0 1-.031-.024.07.07 0 0 1-.012-.037.066.066 0 0 1 .043-.061l.585-.337a.217.217 0 0 1 .2 0l.591.34zM502.44 864.82c.061.034.061.087 0 .118l-.584.338a.215.215 0 0 1-.2 0l-4.691-2.709c-.057-.031-.057-.083 0-.117l.586-.338a.198.198 0 0 1 .2 0l4.689 2.708zM507.38 862.98c.058.034.058.085 0 .118l-.582.339c-.032.016-.067.025-.103.025s-.071-.009-.103-.025l-.584-.339c-.059-.033-.059-.084 0-.118l.584-.338a.217.217 0 0 1 .2 0l.588.338zM508.4 863.58c.057.033.057.087 0 .118l-.584.341a.267.267 0 0 1-.1.021.26.26 0 0 1-.1-.021l-.586-.341c-.058-.031-.058-.087 0-.116l.585-.34a.217.217 0 0 1 .2 0l.585.338zM510.46 864.76a.055.055 0 0 1 .032.022c.008.01.012.023.012.036s-.004.026-.012.037a.066.066 0 0 1-.032.022l-.585.34c-.031.015-.065.024-.1.024s-.069-.009-.1-.024l-1.614-.931c-.058-.034-.058-.087 0-.118l.583-.34a.217.217 0 0 1 .2 0l1.616.932zM506.4 863.63c.055.034.056.084 0 .118l-.584.34a.23.23 0 0 1-.2 0l-.59-.34a.076.076 0 0 1-.03-.023.064.064 0 0 1 0-.072.061.061 0 0 1 .03-.023l.584-.34a.219.219 0 0 1 .205 0l.585.34zM507.43 864.22a.07.07 0 0 1 .028.023.063.063 0 0 1 0 .071.065.065 0 0 1-.028.024l-.584.337a.215.215 0 0 1-.2 0l-.588-.339a.066.066 0 0 1-.029-.023.056.056 0 0 1-.011-.035c0-.013.003-.025.011-.035a.055.055 0 0 1 .029-.023l.587-.34a.209.209 0 0 1 .2 0l.585.34zM508.46 864.81a.06.06 0 0 1 .043.059c0 .013-.004.025-.012.036s-.018.019-.031.023l-.584.339c-.031.016-.065.025-.1.025s-.069-.009-.1-.025l-.59-.339c-.055-.033-.057-.085 0-.118l.585-.338a.217.217 0 0 1 .2 0l.589.338zM509.48 865.41a.058.058 0 0 1 .031.022c.008.01.013.023.013.036a.063.063 0 0 1-.044.059l-.584.342a.23.23 0 0 1-.2 0l-.588-.342a.057.057 0 0 1-.03-.023.058.058 0 0 1 0-.071.057.057 0 0 1 .03-.023l.584-.338a.217.217 0 0 1 .2 0l.588.338zM505.42 864.24c.057.036.057.087 0 .118l-.587.34c-.031.015-.065.024-.1.024s-.069-.009-.1-.024l-.589-.34c-.056-.031-.056-.082 0-.118l.585-.337a.217.217 0 0 1 .2 0l.591.337zM506.45 864.84c.054.029.054.082 0 .115l-.585.341a.232.232 0 0 1-.2 0l-.588-.341c-.058-.033-.058-.086 0-.117l.583-.338c.031-.017.065-.025.1-.025s.069.008.1.025l.59.34zM508.5 866.02a.063.063 0 0 1 .029.094.066.066 0 0 1-.029.023l-.585.339a.235.235 0 0 1-.2 0l-1.611-.931c-.061-.033-.061-.086 0-.119l.584-.338a.23.23 0 0 1 .2 0l1.612.932zM504.44 864.85c.056.029.056.083 0 .116l-.583.34a.22.22 0 0 1-.207 0l-.585-.34c-.059-.033-.059-.087 0-.116l.582-.341a.23.23 0 0 1 .2 0l.593.341zM505.46 865.44c.057.031.057.081 0 .114l-.582.34a.22.22 0 0 1-.2 0l-.588-.34c-.057-.033-.057-.083 0-.119l.587-.339a.217.217 0 0 1 .2 0l.583.344zM507.52 866.63a.066.066 0 0 1 .04.06c0 .013-.004.025-.011.036s-.017.019-.029.023l-.586.335a.209.209 0 0 1-.2 0l-1.613-.931c-.056-.033-.057-.085 0-.117l.582-.339a.23.23 0 0 1 .2 0l1.617.933zM503.47 865.41c.057.034.057.084 0 .117l-.585.34a.23.23 0 0 1-.2 0l-.589-.34c-.055-.033-.055-.083 0-.117l.585-.339c.031-.016.065-.025.1-.025s.069.009.1.025l.589.339zM506.55 867.19c.054.036.056.086 0 .119l-.583.341a.23.23 0 0 1-.2 0l-1.614-.932c-.057-.034-.057-.086 0-.117l.584-.34a.217.217 0 0 1 .2 0l1.613.929z"
            fill="#4A4A4A"
        />
        <path
            d="m498.36 858.71-.59-.341a.072.072 0 0 1-.028-.024.065.065 0 0 1-.013-.035v.116a.08.08 0 0 0 .014.036c.008.01.018.019.029.025l.59.338-.002-.115z"
            fill="#636363"
        />
        <path
            d="M499.2 858.31a.075.075 0 0 1-.013.035.078.078 0 0 1-.03.024l-.582.341a.242.242 0 0 1-.2 0v.115c.031.015.065.024.1.024s.069-.009.1-.024l.582-.338a.086.086 0 0 0 .029-.025.085.085 0 0 0 .014-.034v-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m499.34 859.25-.589-.339a.088.088 0 0 1-.029-.025.079.079 0 0 1-.013-.035v.117a.079.079 0 0 0 .013.035c.007.01.017.018.029.024l.589.338v-.115z"
            fill="#636363"
        />
        <path
            d="M500.17 858.85a.082.082 0 0 1-.012.034.08.08 0 0 1-.027.025l-.585.339a.23.23 0 0 1-.2 0v.115a.215.215 0 0 0 .2 0l.584-.336c.028-.019.043-.04.043-.058l-.003-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m500.44 859.89-.588-.341a.066.066 0 0 1-.03-.024.063.063 0 0 1-.012-.037v.119a.063.063 0 0 0 .013.035.07.07 0 0 0 .029.025l.588.339v-.116z"
            fill="#636363"
        />
        <path
            d="M501.27 859.49a.066.066 0 0 1-.013.036.07.07 0 0 1-.031.025l-.583.341a.23.23 0 0 1-.2 0v.116a.23.23 0 0 0 .2 0l.583-.339a.08.08 0 0 0 .03-.025.064.064 0 0 0 .014-.035v-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m501.46 860.48-.586-.34a.079.079 0 0 1-.041-.06v.117c0 .012.004.024.011.035.008.01.018.018.03.022l.586.342v-.116z"
            fill="#636363"
        />
        <path
            d="M502.3 860.08a.075.075 0 0 1-.042.06l-.583.34c-.032.015-.067.024-.103.024s-.071-.009-.103-.024v.116a.241.241 0 0 0 .205 0l.584-.342a.08.08 0 0 0 .029-.023.071.071 0 0 0 .013-.034v-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m502.49 861.07-.587-.339a.073.073 0 0 1-.029-.023.073.073 0 0 1-.015-.035v.116c0 .021.016.042.044.07l.588.339-.001-.128z"
            fill="#636363"
        />
        <path
            d="M503.32 860.67a.078.078 0 0 1-.013.036.078.078 0 0 1-.03.024l-.582.337a.212.212 0 0 1-.205 0v.119a.23.23 0 0 0 .205 0l.582-.339a.068.068 0 0 0 .041-.059l.002-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m503.52 861.67-.588-.341a.071.071 0 0 1-.043-.06v.119a.065.065 0 0 0 .013.035.07.07 0 0 0 .03.023l.588.338v-.114z"
            fill="#636363"
        />
        <path
            d="M504.34 861.27a.083.083 0 0 1-.04.06l-.585.339a.23.23 0 0 1-.2 0v.114a.22.22 0 0 0 .2 0l.585-.338c.011-.006.02-.014.027-.024s.011-.022.013-.034v-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m498.41 859.95-1.614-.932a.083.083 0 0 1-.03-.026.077.077 0 0 1-.012-.036v.117a.093.093 0 0 0 .014.036c.008.01.018.019.03.025l1.614.932-.002-.116z"
            fill="#636363"
        />
        <path
            d="M499.24 859.55a.071.071 0 0 1-.013.034.067.067 0 0 1-.029.024l-.585.341a.23.23 0 0 1-.2 0v.116c.031.016.065.025.1.025s.069-.009.1-.025l.585-.34a.08.08 0 0 0 .029-.023.071.071 0 0 0 .013-.034v-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m499.39 860.49-.589-.34a.07.07 0 0 1-.028-.023.073.073 0 0 1-.014-.034v.115a.069.069 0 0 0 .013.036c.007.01.017.018.029.024l.589.338v-.116z"
            fill="#636363"
        />
        <path
            d="M500.22 860.09a.077.077 0 0 1-.044.056l-.582.34a.243.243 0 0 1-.2 0v.116a.23.23 0 0 0 .2 0l.584-.338a.073.073 0 0 0 .029-.024.074.074 0 0 0 .015-.034l-.002-.116z"
            fill="#3D3D3D"
        />
        <path
            d="m500.49 861.12-.588-.341a.077.077 0 0 1-.029-.022.071.071 0 0 1-.013-.034v.116a.083.083 0 0 0 .013.034.073.073 0 0 0 .029.024l.587.343.001-.12z"
            fill="#636363"
        />
        <path
            d="M501.32 860.73a.066.066 0 0 1-.012.033.068.068 0 0 1-.029.021l-.585.343a.243.243 0 0 1-.2 0v.12a.25.25 0 0 0 .2 0l.585-.343a.08.08 0 0 0 .029-.023.066.066 0 0 0 .012-.033v-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m501.52 861.71-.587-.341a.062.062 0 0 1-.042-.057v.117c0 .013.004.025.011.036a.06.06 0 0 0 .03.022l.588.339v-.116z"
            fill="#636363"
        />
        <path
            d="M502.35 861.32a.064.064 0 0 1-.014.035.06.06 0 0 1-.03.022l-.583.341a.209.209 0 0 1-.2 0v.116a.215.215 0 0 0 .2 0l.583-.339a.068.068 0 0 0 .043-.057l.001-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m502.54 862.31-.59-.34a.082.082 0 0 1-.041-.061v.12a.079.079 0 0 0 .013.033.096.096 0 0 0 .026.023l.592.341v-.116z"
            fill="#636363"
        />
        <path
            d="M503.37 861.91a.077.077 0 0 1-.012.036.076.076 0 0 1-.028.025l-.587.34a.23.23 0 0 1-.2 0v.116a.23.23 0 0 0 .2 0l.587-.339a.07.07 0 0 0 .04-.058v-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m497.42 860.52-1.617-.931a.066.066 0 0 1-.028-.024.066.066 0 0 1-.011-.035v.114c0 .025.011.044.039.064l1.617.929v-.117z"
            fill="#636363"
        />
        <path
            d="M498.25 860.12a.077.077 0 0 1-.012.035.084.084 0 0 1-.028.025l-.585.337a.23.23 0 0 1-.2 0v.117c.031.016.065.025.1.025s.069-.009.1-.025l.585-.337a.075.075 0 0 0 .04-.059v-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m498.44 861.11-.588-.341a.066.066 0 0 1-.029-.021.071.071 0 0 1-.013-.034v.115a.069.069 0 0 0 .013.036.078.078 0 0 0 .029.025l.588.337v-.117z"
            fill="#636363"
        />
        <path
            d="M499.27 860.72a.057.057 0 0 1-.011.033.059.059 0 0 1-.027.022l-.586.341a.23.23 0 0 1-.2 0v.117a.217.217 0 0 0 .2 0l.586-.337a.072.072 0 0 0 .038-.06v-.116z"
            fill="#3D3D3D"
        />
        <path
            d="m499.5 861.74-.588-.338a.076.076 0 0 1-.029-.024.078.078 0 0 1-.015-.035v.116a.083.083 0 0 0 .014.035c.008.01.018.019.03.024l.586.34.002-.118z"
            fill="#636363"
        />
        <path
            d="M500.33 861.34c-.001.012-.005.024-.012.034s-.016.019-.027.025l-.584.338c-.031.015-.065.024-.1.024s-.069-.009-.1-.024v.118a.228.228 0 0 0 .1.022.231.231 0 0 0 .1-.022l.586-.34a.078.078 0 0 0 .027-.024.077.077 0 0 0 .012-.035l-.002-.116z"
            fill="#3D3D3D"
        />
        <path
            d="m500.53 862.33-.588-.34c-.027-.017-.043-.039-.041-.059v.115a.065.065 0 0 0 .013.035.07.07 0 0 0 .028.026l.59.339-.002-.116z"
            fill="#636363"
        />
        <path
            d="M501.36 861.93a.068.068 0 0 1-.013.035.076.076 0 0 1-.029.024l-.584.34a.259.259 0 0 1-.2 0v.116a.23.23 0 0 0 .2 0l.584-.339a.066.066 0 0 0 .041-.057l.001-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m504.54 862.26-.589-.339c-.011-.006-.021-.015-.028-.025s-.011-.023-.013-.035v.117a.07.07 0 0 0 .013.035.075.075 0 0 0 .028.025l.589.338v-.116z"
            fill="#636363"
        />
        <path
            d="M505.37 861.86a.073.073 0 0 1-.015.035.07.07 0 0 1-.029.025l-.583.339a.243.243 0 0 1-.2 0v.116a.23.23 0 0 0 .2 0l.583-.338a.078.078 0 0 0 .029-.025.07.07 0 0 0 .013-.035l.002-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m503.57 862.9-.586-.341a.076.076 0 0 1-.03-.023.06.06 0 0 1-.012-.036v.12c0 .022.013.038.042.057l.586.34v-.117z"
            fill="#636363"
        />
        <path
            d="M504.4 862.51a.055.055 0 0 1-.011.033.056.056 0 0 1-.028.022l-.586.341a.217.217 0 0 1-.2 0v.117c.031.016.065.025.1.025s.069-.009.1-.025l.584-.339c.03-.018.041-.036.041-.058v-.116z"
            fill="#3D3D3D"
        />
        <path
            d="m501.56 862.92-.59-.337a.078.078 0 0 1-.04-.058v.117a.063.063 0 0 0 .012.033.07.07 0 0 0 .028.023l.59.343v-.121z"
            fill="#636363"
        />
        <path
            d="M502.39 862.53c-.001.012-.005.024-.012.034s-.017.018-.027.024l-.586.337a.215.215 0 0 1-.2 0v.121a.242.242 0 0 0 .2 0l.586-.343a.064.064 0 0 0 .026-.023.079.079 0 0 0 .013-.033v-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m502.58 863.52-.59-.337a.083.083 0 0 1-.03-.026.077.077 0 0 1-.015-.036v.116c0 .025.016.044.045.06l.59.341v-.118z"
            fill="#636363"
        />
        <path
            d="M503.41 863.12c-.001.013-.006.025-.013.036s-.017.019-.028.026l-.583.337a.217.217 0 0 1-.2 0v.118c.031.016.065.025.1.025s.069-.009.1-.025l.583-.341a.065.065 0 0 0 .028-.024.062.062 0 0 0 .013-.034v-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m497.52 861.75-2.639-1.523c-.012-.006-.023-.014-.031-.025s-.012-.024-.013-.037v.118a.073.073 0 0 0 .043.061l2.64 1.525v-.119zM498.52 862.34l-.588-.338c-.03-.016-.044-.036-.042-.06v.116a.078.078 0 0 0 .013.036.073.073 0 0 0 .031.024l.588.34-.002-.118z"
            fill="#636363"
        />
        <path
            d="M499.35 861.94a.067.067 0 0 1-.012.036.078.078 0 0 1-.03.024l-.583.34a.217.217 0 0 1-.2 0v.118a.23.23 0 0 0 .2 0l.583-.34a.078.078 0 0 0 .03-.024.067.067 0 0 0 .012-.036v-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m499.55 862.94-.589-.34c-.029-.016-.044-.038-.042-.058v.116c0 .023.015.041.044.057l.586.344.001-.119z"
            fill="#636363"
        />
        <path
            d="M500.37 862.54a.073.073 0 0 1-.043.057l-.582.34a.23.23 0 0 1-.2 0v.119a.26.26 0 0 0 .1.021.267.267 0 0 0 .1-.021l.584-.34c.029-.02.043-.038.043-.059l-.002-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m500.57 863.53-.588-.342a.073.073 0 0 1-.029-.023.074.074 0 0 1-.015-.034v.117c0 .022.016.041.042.062l.588.338.002-.118z"
            fill="#636363"
        />
        <path
            d="M501.4 863.13a.066.066 0 0 1-.012.033.07.07 0 0 1-.029.022l-.584.342a.235.235 0 0 1-.2 0v.118a.226.226 0 0 0 .205 0l.584-.338c.012-.006.022-.015.029-.026s.011-.023.012-.036l-.005-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m501.6 864.12-.589-.339a.064.064 0 0 1-.031-.025.073.073 0 0 1-.014-.037v.119c0 .023.015.043.045.06l.589.34v-.118z"
            fill="#636363"
        />
        <path
            d="M502.43 863.72a.08.08 0 0 1-.014.036.078.078 0 0 1-.03.024l-.583.339a.22.22 0 0 1-.2 0v.118a.23.23 0 0 0 .1.024.233.233 0 0 0 .1-.024l.583-.339c.027-.018.044-.038.044-.058v-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m505.56 862.85-.586-.342c-.012-.005-.022-.013-.03-.023s-.012-.022-.013-.034v.115c0 .024.014.042.043.061l.586.339v-.116z"
            fill="#636363"
        />
        <path
            d="M506.4 862.45a.067.067 0 0 1-.012.035.076.076 0 0 1-.029.024l-.583.34a.242.242 0 0 1-.206 0v.116a.232.232 0 0 0 .206 0l.583-.339a.08.08 0 0 0 .03-.025.066.066 0 0 0 .011-.036v-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m504.6 863.49-.588-.34a.076.076 0 0 1-.029-.024.069.069 0 0 1-.013-.036v.119a.073.073 0 0 0 .012.035c.008.01.018.018.03.023l.588.338v-.115z"
            fill="#636363"
        />
        <path
            d="M505.42 863.1a.07.07 0 0 1-.04.058l-.586.34a.217.217 0 0 1-.2 0v.115a.217.217 0 0 0 .2 0l.584-.338a.073.073 0 0 0 .042-.058v-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m503.61 864.1-.587-.337c-.011-.005-.022-.013-.029-.024s-.012-.023-.013-.036v.119c.002.012.007.024.014.034s.017.018.028.023l.589.34-.002-.119z"
            fill="#636363"
        />
        <path
            d="M504.44 863.71a.064.064 0 0 1-.014.034.073.073 0 0 1-.028.024l-.586.338a.215.215 0 0 1-.2 0v.118a.22.22 0 0 0 .2 0l.584-.339c.028-.017.044-.036.044-.058v-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m502.62 864.72-.586-.341a.062.062 0 0 1-.029-.024.067.067 0 0 1-.014-.036v.118a.083.083 0 0 0 .014.035.08.08 0 0 0 .029.023l.586.338v-.113z"
            fill="#636363"
        />
        <path
            d="M503.45 864.31a.07.07 0 0 1-.043.06l-.582.341a.241.241 0 0 1-.205 0v.113a.207.207 0 0 0 .2 0l.584-.338a.058.058 0 0 0 .029-.022.064.064 0 0 0 .014-.035l.003-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m494.52 861.16-.588-.339a.062.062 0 0 1-.029-.024.062.062 0 0 1-.013-.034v.118a.064.064 0 0 0 .013.033c.008.01.017.018.029.023l.588.343v-.12z"
            fill="#636363"
        />
        <path
            d="M495.35 860.75c-.001.012-.006.024-.013.034s-.017.019-.028.025l-.585.339a.212.212 0 0 1-.205 0v.116c.032.017.067.025.103.025s.071-.008.102-.025l.583-.337a.074.074 0 0 0 .043-.057v-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m495.5 861.72-.588-.34c-.011-.006-.02-.014-.027-.024s-.011-.022-.011-.034v.115a.073.073 0 0 0 .04.06l.588.34-.002-.117z"
            fill="#636363"
        />
        <path
            d="M496.33 861.32a.073.073 0 0 1-.014.034.081.081 0 0 1-.028.024l-.582.34a.243.243 0 0 1-.2 0v.117c.031.015.065.024.1.024s.069-.009.1-.024l.582-.34a.068.068 0 0 0 .041-.06l.001-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m496.53 862.31-.59-.337a.099.099 0 0 1-.028-.026.093.093 0 0 1-.013-.035v.113a.07.07 0 0 0 .041.062l.587.338.003-.115z"
            fill="#636363"
        />
        <path
            d="M497.36 861.92c-.001.012-.006.024-.013.035s-.016.019-.028.026l-.586.337a.23.23 0 0 1-.1.024.233.233 0 0 1-.1-.024v.115a.207.207 0 0 0 .2 0l.586-.338a.07.07 0 0 0 .029-.025.064.064 0 0 0 .012-.035v-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m501.66 865.27-4.691-2.709c-.012-.005-.022-.013-.03-.023s-.013-.022-.014-.035v.116a.063.063 0 0 0 .013.035.062.062 0 0 0 .029.024l4.693 2.71v-.118zM506.59 863.44l-.584-.34c-.029-.017-.045-.036-.045-.058v.117a.083.083 0 0 0 .014.035c.008.01.019.018.031.022l.584.342v-.118z"
            fill="#636363"
        />
        <path
            d="M507.42 863.05a.066.066 0 0 1-.015.034.06.06 0 0 1-.03.022l-.582.34a.23.23 0 0 1-.206 0v.118c.032.016.067.025.103.025s.071-.009.103-.025l.582-.339a.068.068 0 0 0 .029-.024.078.078 0 0 0 .013-.036l.003-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m507.62 864.04-.586-.341a.079.079 0 0 1-.031-.023.08.08 0 0 1-.014-.036v.115a.072.072 0 0 0 .013.037.07.07 0 0 0 .029.025l.587.339.002-.116z"
            fill="#636363"
        />
        <path
            d="M508.45 863.64a.071.071 0 0 1-.013.034.076.076 0 0 1-.03.023l-.584.341a.242.242 0 0 1-.2 0v.116a.23.23 0 0 0 .2 0l.584-.339a.07.07 0 0 0 .043-.059v-.116z"
            fill="#3D3D3D"
        />
        <path
            d="m509.67 865.22-1.614-.931a.073.073 0 0 1-.03-.025.061.061 0 0 1-.013-.036v.117a.075.075 0 0 0 .013.035.073.073 0 0 0 .031.024l1.614.934-.001-.118z"
            fill="#636363"
        />
        <path
            d="M510.5 864.82a.062.062 0 0 1-.013.034.066.066 0 0 1-.029.023l-.585.34a.217.217 0 0 1-.2 0v.118c.031.016.065.025.1.025s.069-.009.1-.025l.585-.341a.085.085 0 0 0 .029-.024.079.079 0 0 0 .013-.035v-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m505.62 864.09-.59-.34a.1.1 0 0 1-.028-.026.098.098 0 0 1-.013-.036v.121a.085.085 0 0 0 .041.059l.59.338v-.116z"
            fill="#636363"
        />
        <path
            d="M506.45 863.69a.077.077 0 0 1-.012.035.078.078 0 0 1-.029.025l-.584.34a.23.23 0 0 1-.2 0v.116a.23.23 0 0 0 .2 0l.586-.338c.011-.006.021-.014.028-.024s.012-.021.013-.033l-.002-.121z"
            fill="#3D3D3D"
        />
        <path
            d="m506.64 864.68-.588-.339c-.026-.017-.044-.037-.044-.058v.116a.095.095 0 0 0 .014.035c.008.01.018.018.03.024l.588.339v-.117z"
            fill="#636363"
        />
        <path
            d="M507.47 864.28c0 .023-.011.041-.042.06l-.584.337a.22.22 0 0 1-.2 0v.117a.209.209 0 0 0 .2 0l.584-.339a.06.06 0 0 0 .03-.022.066.066 0 0 0 .011-.035l.001-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m507.67 865.27-.59-.339a.077.077 0 0 1-.04-.062v.119a.069.069 0 0 0 .013.036.07.07 0 0 0 .029.025l.589.339-.001-.118z"
            fill="#636363"
        />
        <path
            d="M508.5 864.87a.089.089 0 0 1-.014.035.089.089 0 0 1-.03.024l-.584.339c-.031.016-.065.025-.1.025s-.069-.009-.1-.025v.118a.23.23 0 0 0 .2 0l.584-.339c.028-.017.044-.037.044-.058v-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m508.7 865.86-.588-.342a.073.073 0 0 1-.042-.059v.115a.08.08 0 0 0 .012.037c.008.011.018.02.03.025l.588.338v-.114z"
            fill="#636363"
        />
        <path
            d="M509.52 865.47c-.001.012-.006.024-.014.034s-.018.017-.03.022l-.584.342a.23.23 0 0 1-.2 0v.114c.031.016.065.025.1.025s.069-.009.1-.025l.584-.338a.068.068 0 0 0 .03-.023.07.07 0 0 0 .012-.034l.002-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m504.63 864.7-.589-.34c-.011-.005-.021-.013-.028-.023s-.011-.022-.012-.034v.117a.077.077 0 0 0 .012.035c.007.01.016.018.028.024l.589.341v-.12z"
            fill="#636363"
        />
        <path
            d="M505.46 864.31c-.001.012-.005.023-.012.033s-.016.018-.027.023l-.587.34a.217.217 0 0 1-.2 0v.12a.215.215 0 0 0 .2 0l.585-.338a.081.081 0 0 0 .028-.024.079.079 0 0 0 .013-.035v-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m505.66 865.29-.588-.341a.065.065 0 0 1-.03-.022.075.075 0 0 1-.013-.035v.118a.07.07 0 0 0 .013.035c.008.01.018.018.03.023l.587.338.001-.116z"
            fill="#636363"
        />
        <path
            d="M506.49 864.9a.07.07 0 0 1-.012.035.068.068 0 0 1-.029.022l-.585.341a.23.23 0 0 1-.2 0v.116c.031.017.065.025.1.025s.069-.008.1-.025l.585-.339c.011-.005.021-.013.028-.023s.012-.021.013-.034v-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m507.71 866.48-1.611-.931c-.03-.018-.046-.037-.046-.059v.118c0 .022.016.039.043.058l1.614.932v-.118z"
            fill="#636363"
        />
        <path
            d="M508.54 866.08a.068.068 0 0 1-.013.035.081.081 0 0 1-.028.024l-.585.339a.243.243 0 0 1-.2 0v.118c.031.016.065.025.1.025s.069-.009.1-.025l.586-.34a.086.086 0 0 0 .029-.025.073.073 0 0 0 .012-.035l-.001-.116z"
            fill="#3D3D3D"
        />
        <path
            d="m503.65 865.31-.585-.339a.072.072 0 0 1-.031-.023.067.067 0 0 1-.012-.036v.114c0 .013.004.026.012.037.008.01.018.019.031.024l.585.34v-.117z"
            fill="#636363"
        />
        <path
            d="M504.48 864.91a.06.06 0 0 1-.011.034.06.06 0 0 1-.029.023l-.583.339a.216.216 0 0 1-.207 0v.117a.23.23 0 0 0 .205 0l.585-.34c.012-.006.022-.014.029-.025s.011-.023.011-.036v-.112z"
            fill="#3D3D3D"
        />
        <path
            d="m504.68 865.9-.588-.34a.075.075 0 0 1-.031-.025.07.07 0 0 1-.012-.037v.121a.076.076 0 0 0 .043.059l.588.338v-.116z"
            fill="#636363"
        />
        <path
            d="M505.5 865.51a.07.07 0 0 1-.012.034.07.07 0 0 1-.029.023l-.582.34a.22.22 0 0 1-.2 0v.116a.204.204 0 0 0 .2 0l.584-.338a.07.07 0 0 0 .041-.058l-.002-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m506.73 867.08-1.613-.931a.077.077 0 0 1-.029-.022.071.071 0 0 1-.013-.034v.116a.073.073 0 0 0 .014.034c.007.01.017.019.028.024l1.612.931.001-.118z"
            fill="#636363"
        />
        <path
            d="M507.56 866.69c0 .012-.004.024-.011.035s-.016.019-.028.026l-.586.335a.22.22 0 0 1-.2 0v.118a.232.232 0 0 0 .2 0l.586-.34c.011-.006.021-.014.028-.024s.011-.021.011-.033v-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m502.68 865.87-.589-.34a.068.068 0 0 1-.029-.024.065.065 0 0 1-.013-.035v.119a.062.062 0 0 0 .013.034c.007.01.017.018.029.023l.589.339v-.116z"
            fill="#636363"
        />
        <path
            d="M503.51 865.47a.079.079 0 0 1-.013.033.082.082 0 0 1-.027.022l-.585.34a.23.23 0 0 1-.2 0v.116a.22.22 0 0 0 .2 0l.585-.339c.011-.005.02-.013.027-.023s.012-.022.013-.034v-.115z"
            fill="#3D3D3D"
        />
        <path
            d="m503.71 866.46-.59-.34a.077.077 0 0 1-.028-.026.075.075 0 0 1-.013-.035v.118a.079.079 0 0 0 .041.06l.59.337v-.114z"
            fill="#636363"
        />
        <path
            d="M504.54 866.06c-.001.012-.005.024-.012.035s-.016.019-.027.026l-.587.34a.23.23 0 0 1-.2 0v.114a.23.23 0 0 0 .2 0l.585-.337c.011-.006.021-.014.028-.024s.012-.022.013-.034v-.12z"
            fill="#3D3D3D"
        />
        <path
            d="M504.5 866.01a.06.06 0 0 1 .029.023.07.07 0 0 1 .011.037.069.069 0 0 1-.011.036.068.068 0 0 1-.029.024l-.587.34a.23.23 0 0 1-.2 0l-.59-.34a.064.064 0 0 1-.03-.024.06.06 0 0 1-.012-.036.06.06 0 0 1 .012-.037.057.057 0 0 1 .03-.023l.584-.339c.031-.016.065-.023.1-.023s.069.007.1.023l.593.339z"
            fill="#4A4A4A"
        />
        <path
            d="m505.76 867.65-1.614-.932a.072.072 0 0 1-.028-.024.069.069 0 0 1-.013-.036v.117a.078.078 0 0 0 .013.036c.007.01.018.019.029.024l1.614.933-.001-.118z"
            fill="#636363"
        />
        <path
            d="M506.59 867.25a.071.071 0 0 1-.041.057l-.583.341a.23.23 0 0 1-.2 0v.118a.23.23 0 0 0 .2 0l.585-.341a.08.08 0 0 0 .041-.057l-.002-.118zM498.35 861.35a.067.067 0 0 1-.013.034.081.081 0 0 1-.03.021l-.582.342a.235.235 0 0 1-.2 0v.116a.23.23 0 0 0 .2 0l.582-.337a.08.08 0 0 0 .03-.025.063.063 0 0 0 .011-.035l.002-.116z"
            fill="#3D3D3D"
        />
        <path
            d="m510.72 866.15.013.256-.584.372-.012-.257.583-.371zM511.6 865.6l.012.258-.584.371-.012-.258.584-.371z"
            fill="#393939"
        />
        <path
            d="m511.56 865.83-.53.336-.011-.2.531-.337.01.201zM510.68 866.37l-.537.343-.009-.191.535-.342.011.19z"
            fill="#000"
        />
        <path
            d="M491.92 860.53s2.925-.656 3.468-.752a7.284 7.284 0 0 1 3.072.752l1.24 1.147s.163.259-.28.353-1.112-.7-1.112-.7l-1.3-.377s-.836-.028-.867.377c-.023.3.7.462 1.008.515.212.037.689.181.773.4a.355.355 0 0 1-.164.468c-.395 0-.79-.047-1.174-.139-.8-.141-1.392-.172-1.848-.258a1.861 1.861 0 0 1-1.011-.586l-1.451.376-.354-1.576zM499.67 867.43a15.46 15.46 0 0 1 2.772 0c.766.162 3.014 1.045 3.014 1.045s.644.241.282.645c-.284.228-.578.442-.883.642-.2.16-.8.2-2.008-.04a4.238 4.238 0 0 0-1.649-.039 4.012 4.012 0 0 1-1.569-.241l.041-2.012z"
            fill="#FFE1CC"
        />
        <path
            d="M481.85 855.05s-1.931-.419-2.057 2.893c-.021.613 1.3 3.12 2.133 4.585a4.263 4.263 0 0 0 3.48 1.777 30.51 30.51 0 0 0 7.864-2.226 1.16 1.16 0 0 0 .072-.941c-.19-.79-.544-.882-.544-.882l-7.392.89-3.556-6.096z"
            fill="#911309"
        />
        <path
            d="m485.78 856.03 2.959 6.263c.148.235.236.503.256.781a2.472 2.472 0 0 1-.464 1.495 2.308 2.308 0 0 1-.148.208 3.626 3.626 0 0 0-.981 2.107l.126 5.3s-.066.829-.09 1.351a4.362 4.362 0 0 1-3.443 1.456 11.874 11.874 0 0 1-5.955-2.311l1.318-4.941a4.87 4.87 0 0 0 .094-1.357l-.563-5.206a13.789 13.789 0 0 1 .19-3.143 5.03 5.03 0 0 1 2.823-3.464s3.654 1.073 3.878 1.461z"
            fill="#B21B0B"
        />
        <path
            d="M481.62 854.47c.14-.61.259-.518.54-.3l2.272.681c.278.255 1.641.912 1.877 1.589l.468 1.5c-.379-.39-.787-.75-1.221-1.076a15.673 15.673 0 0 0-4.4-1.925c-.097-.002.464-.469.464-.469z"
            fill="#EDEDED"
        />
        <path
            d="m486.38 845.21 2.842.137-1.452 7.508c-.281 1.4-1.113 2.01-1.747 2.031-1.237.039-2.1-.9-3.221-2.4a3.2 3.2 0 0 1-.8-2.369l-.425-4.9 4.803-.007z"
            fill="#FFE1CC"
        />
        <path
            d="M487.18 856.48s-7.069-.36-8.284-5.567c-.658-2.81.468-6.968 3.657-7.935a5.613 5.613 0 0 1 6.468 2.217 4.912 4.912 0 0 1-.185 5.25c-1.578 1.867-2.064 1.875-2.44 3.187a2.63 2.63 0 0 0 .784 2.848z"
            fill="#684005"
        />
        <path
            d="M500.33 868.63c-.051 1.076-.588 1.082-.588 1.082s-5.795-.149-6.553-.094a3.83 3.83 0 0 1-2.547-.907c-.8-.484-5.642-5.577-5.642-5.577s-1.985-1.838-1.178-3.285c.883-1.583 2.716-1.179 3.7.066.919 1.164 2.991 4.285 4.174 5.686a1.947 1.947 0 0 0 1.577.865l6.213.864a.996.996 0 0 1 .474.344c.222.271.351.606.37.956z"
            fill="#D32A1E"
        />
        <path
            d="M516.64 887.66c-.006.586.753.979 1.268.985.181 0 .278 1.1.536 1.513a.457.457 0 0 0 .374.241.465.465 0 0 0 .404-.187 20.5 20.5 0 0 0-.5-2.119c-.334-1.366-.866-1.423-1.381-1.427s-.695.406-.701.994z"
            fill="#FFE8D9"
        />
        <path
            d="M516.01 886.66h1.487l.546 1.826-.005.3-.253 2.384a1.181 1.181 0 0 1-1.219 1.155h-.084c-1.062 0-1.344-1.183-1.344-1.183l-.242-3.083c-.014-.658.431-1.399 1.114-1.399z"
            fill="#FFE8D9"
        />
        <path
            d="M517.83 886.97h-2.388l-1.16-8.836.306-5.181c-.046-1.641.8-4.567 2.456-4.816 1.943-.3 1.391 3.023 1.391 3.023l-.81 6.84.205 8.97z"
            fill="#01797F"
        />
        <path
            d="M514.36 893.57c-.009-1.043-.36-6.679-.189-7.435l7.308 3.816c-.023.25-.037.337-.037.337l-2.811 17.346-.027.041a2.244 2.244 0 0 0 1.182 1.984c.29.2 1.935 1.264 1.96 1.273l.022.007c-.036.02-.071.069-.071.193 0 .428-4.328.05-4.328.05a2.872 2.872 0 0 1-1.562-.3c-.43-.322-.541-.37-.541-.767l-.906-16.545z"
            fill="#E8C5AC"
        />
        <path
            d="m516.7 911.25-.1 1.007a.967.967 0 0 1-1.2-.143l-.326-1.58a1.722 1.722 0 0 0 1.187.691c.145.03.292.038.439.025z"
            fill="#7C7676"
        />
        <path
            d="M517.57 909.92c1.655 1.053 2.686.483 2.832.4.6-.319.35-.7.025-.925a1.24 1.24 0 0 0-.326-.14 5.101 5.101 0 0 1 2.03.18c.15.1.289.247.3.36a.583.583 0 0 1-.158.418s-.952.384-1.614.721c-1.119.577-3.843.226-4.861.271-.347.016-.819-.521-.854-1.192a1.95 1.95 0 0 1 .261-1.322c.435.029.849.194 1.183.472.18.124.838.538 1.182.757z"
            fill="#070707"
        />
        <path
            d="M515.9 911.04c.151.032.7.058 1.545.141a5.742 5.742 0 0 0 3.17-.321 9.699 9.699 0 0 0 1.345-.633c.165-.1.506-.293.466-.437a.488.488 0 0 1-.067.414c-.644.396-1.321.733-2.025 1.007a12.945 12.945 0 0 1-3.219.1 13.404 13.404 0 0 1-1.564-.1c-.342-.065-.4-.479-.425-.534.236.164.497.286.774.363z"
            fill="#7C7676"
        />
        <path
            d="m518.96 885.72-.454 22.935h-3.33l-.823-15.089c-.009-1.043-.553-7.66.009-8.783l4.598.937z"
            fill="#423B3B"
        />
        <path d="M521.77 910.94c.063-.034.121.034 0 0z" fill="#E8C5AC" />
        <path d="M521.77 910.94c.063-.034.121.034 0 0z" fill="#E8C5AC" />
        <path
            d="M515.14 887.48a8.887 8.887 0 0 1 .537-2.33l7.851.84v1.063l-.107 1.7s-1.943 21.171-1.943 21.352c-.008.7.691 1.079 2.031 1.5.361.132.715.285 1.06.457.241.08.688.77.1 1a15.669 15.669 0 0 1-4.178.421s-1.48-.321-1.9-.353c-.536-.044-.433-1.528-.433-1.528-.154-1.684-1.785-19.465-1.855-20.087-.134-1.066-1.006-1.928-1.163-4.035z"
            fill="#FFE1CC"
        />
        <path
            d="m519.33 913.41-.223.987a.984.984 0 0 1-.641.068 1 1 0 0 1-.57-.352l-.16-1.612a1.854 1.854 0 0 0 1.3.886c.29.009.294.023.294.023z"
            fill="#7C7676"
        />
        <path
            d="M520.77 912.27a3.418 3.418 0 0 0 2.84.465c.809-.3.887-.756-.119-1.137-.151-.058 1.887.307 2.1.749a.94.94 0 0 1 .147.392.594.594 0 0 1-.21.4s-1.023.268-1.74.522c-1.217.433-4.319-.33-5.373-.414-.359-.027-.794-.621-.744-1.29a2.024 2.024 0 0 1 .42-1.252c.443.059.852.266 1.161.588.174.14 1.253.821 1.518.977z"
            fill="#070707"
        />
        <path
            d="M518.37 912.96c.152.048.92.178 1.766.319 1.808.3 1.968.516 3.21.4a5.86 5.86 0 0 0 1.793-.493c.2-.094.6-.358.6-.446.009.321-.115.4-.115.4a4.455 4.455 0 0 1-2.252.863c-1.639.232-2.97-.453-3.872-.553a3.499 3.499 0 0 1-1.29-.253.738.738 0 0 1-.421-.56c.169.148.367.258.581.323z"
            fill="#7C7676"
        />
        <path
            d="M523.52 885.99v1.063l-.107 1.7s-1.943 21.171-1.943 21.352a.771.771 0 0 0 .055.3h-3.492c-.406-4.4-1.849-18.272-1.914-18.821-.123-1.066-.945-1.921-1.1-4.025-.006-.831.077-1.659.247-2.472l8.254.903z"
            fill="#5B5353"
        />
        <path
            d="M523.52 886.66s-.284 1.768-4.407 1.381a8.785 8.785 0 0 1-4.93-2.179c.017-.308.062-.613.132-.913l9.106.2c0 .159.113.208.099.386-.026.318.015 1.001 0 1.125z"
            fill="#3A3535"
            opacity={0.52}
        />
        <path
            d="m521.99 868.79 2.956 6.262a1.7 1.7 0 0 1 .255.782 2.47 2.47 0 0 1-.46 1.49c-.05.075-.1.144-.148.207a3.637 3.637 0 0 0-.982 2.106l.128 5.3s0 .77-.031.869a4.625 4.625 0 0 1-3.477 1.388c-2.707.029-5.954-2.063-6.006-1.921l1.253-4.457a5.192 5.192 0 0 0 .186-1.678l-.563-5.2c-.057-1.05.006-2.104.187-3.14a5.028 5.028 0 0 1 2.822-3.466s3.658 1.073 3.88 1.458z"
            fill="#0592A0"
        />
        <path
            d="M521.57 890.39c-.006.537.69.9 1.162.9.166 0 .255 1.01.493 1.389a.43.43 0 0 0 .343.22.422.422 0 0 0 .37-.171 18.239 18.239 0 0 0-.461-1.944c-.308-1.255-.792-1.3-1.267-1.307a.544.544 0 0 0-.546.349c-.068.18-.1.372-.094.564z"
            fill="#FFE8D9"
        />
        <path
            d="M520.99 889.48h1.364l.5 1.676v.273l-.233 2.185a1.087 1.087 0 0 1-1.119 1.062h-.076c-.975 0-1.1-1.369-1.1-1.369l-.119-2.343c-.021-.599.156-1.484.783-1.484z"
            fill="#FFE8D9"
        />
        <path
            d="M522.93 889.68a3.887 3.887 0 0 1-1.45.274 2.654 2.654 0 0 1-1-.183l-.167-1.637-.653-7.147.1-5.6c-.1-1.5.354-3.843 1.994-3.843 1.966 0 1.654 2.656 1.654 2.656l-.813 6.842.335 8.638z"
            fill="#14AAB2"
        />
        <path
            d="m522.6 857.97 2.837.132-1.446 7.505c-.281 1.407-1.114 2.011-1.748 2.032-1.231.038-2.1-.9-3.219-2.407a3.163 3.163 0 0 1-.8-2.368l-.424-4.9 4.8.006z"
            fill="#FFE1CC"
        />
        <path
            d="M515.68 862.81c-.242-2.252.023-5.736 3.211-6.7 2.783-.847 5.132-.023 6.353 1.851a4.279 4.279 0 0 1 .522 3.367 2.642 2.642 0 0 1-.476.183 3.41 3.41 0 0 0 .036-.494 3.709 3.709 0 0 0-.125-1.064 6.062 6.062 0 0 1-.253 1.638c-1.425.5-1.867 2.593-1.714 4.174a5.83 5.83 0 0 0 1.525 3.1s-.1.031-.28.072c-.2-.117-.589.114-.79-.115a8.388 8.388 0 0 1-.892-1.235c.105.471.264.928.473 1.363.087.2.367.033.443.183a12.827 12.827 0 0 1-5.906-.68 7.343 7.343 0 0 1-3.126-2.376c1.149-.686 1.093-2.393.999-3.267z"
            fill="#684005"
        />
        <path
            d="M531.05 915.26c-1.734-1.35-1.781-4.869-1.781-4.869l.964-7.421 7.422 3.854 2.411 3.664 7.134-1.784c2.362-.723 6.072-.434 5.977 3.471l-.194 2.266s-.233 1.1-1.445-.289c-.674-.771-2.263-.384-2.263-.384s-7.39 3.021-9.546 3.758c-3.665 1.254-7.021-.978-8.679-2.266z"
            fill="#383736"
        />
        <path
            d="m555.53 906.37-13.658-7.819v.309a.595.595 0 0 0 .3.516l12.651 7.287a1.396 1.396 0 0 0 1.393 0l8.944-5.2a.794.794 0 0 0 .4-.691v-.406l-10.03 6.004z"
            fill="#9E9D9D"
        />
        <path
            d="m565.56 900.36-9.455 6.045a1.146 1.146 0 0 1-1.18.021l-12.842-7.388a.41.41 0 0 1-.149-.149.411.411 0 0 1-.009-.407.429.429 0 0 1 .143-.156l9.455-6.039 14.037 8.073z"
            fill="#D3D3D3"
        />
        <path
            d="M552.23 882.65a.575.575 0 0 0-.593.005l-.158.093 13.472 7.972.277 9.887.324-.187v-9.389a1.2 1.2 0 0 0-.6-1.035l-12.722-7.346z"
            fill="#8E8D8D"
        />
        <path
            d="M564.63 890.18a1.198 1.198 0 0 1 .6 1.035v9.388l-14-8.1v-9.388a.403.403 0 0 1 .4-.4c.071 0 .14.018.2.053l12.8 7.412z"
            fill="#C1BFBD"
        />
        <path
            d="M563.9 900.22c.034.026.061.059.08.097s.031.08.033.122a.297.297 0 0 1-.091.23l-4.413 2.817c-.369.227-.685.022-1.032-.176l-11.875-6.837a.277.277 0 0 1-.122-.1.268.268 0 0 1 .122-.4l4.337-2.738a.748.748 0 0 1 .7-.1l12.261 7.085z"
            fill="#898686"
        />
        <path
            d="M555.44 900.34c-.001.013-.006.025-.013.035s-.017.019-.028.024l-.6.35a.238.238 0 0 1-.209 0v.122a.238.238 0 0 0 .209 0l.6-.355a.058.058 0 0 0 .029-.022.06.06 0 0 0 .012-.036v-.118z"
            fill="#737373"
        />
        <path
            d="M553.44 901.04c.392.228.393.588.006.813l-1.752 1.019a1.549 1.549 0 0 1-1.406 0l-2.754-1.588a.428.428 0 0 1-.293-.406.434.434 0 0 1 .288-.41l1.752-1.018a1.559 1.559 0 0 1 1.406 0l2.753 1.59z"
            fill="#9E9D9D"
        />
        <path
            d="M564.16 891.25v7.548l-12.151-7.014v-7.551l12.151 7.017z"
            fill="#8E8D8D"
        />
        <path
            d="m552.14 891.66 12.024 6.94v-7.349l-12.024-6.945v7.354z"
            fill="#80F9E4"
        />
        <path
            d="M552.1 893.52c.057.033.057.086 0 .12l-.6.347a.209.209 0 0 1-.207 0l-.606-.347a.057.057 0 0 1-.03-.023c-.008-.011-.012-.024-.012-.037s.004-.026.012-.036a.064.064 0 0 1 .03-.024l.6-.348c.032-.016.067-.025.103-.025s.071.009.103.025l.607.348zM554.24 894.74a.067.067 0 0 1 .041.062.064.064 0 0 1-.041.062l-.6.349a.252.252 0 0 1-.208 0l-.606-.349c-.013-.004-.024-.013-.032-.024s-.012-.024-.012-.038c0-.013.004-.027.012-.038s.019-.019.032-.024l.6-.349a.24.24 0 0 1 .209 0l.605.349zM553.11 894.09a.063.063 0 0 1 .046.059.06.06 0 0 1-.013.037.057.057 0 0 1-.033.022l-.6.352a.233.233 0 0 1-.207 0l-.606-.352a.068.068 0 0 1-.031-.022c-.008-.011-.012-.024-.012-.037s.004-.026.012-.036a.064.064 0 0 1 .031-.023l.6-.35a.23.23 0 0 1 .212 0l.601.35zM555.3 895.36c.06.032.06.087 0 .121l-.6.347a.216.216 0 0 1-.206 0l-.607-.349a.057.057 0 0 1-.03-.023c-.008-.01-.012-.023-.012-.036s.004-.026.012-.037a.07.07 0 0 1 .03-.023l.6-.349a.214.214 0 0 1 .211 0l.602.349zM556.35 895.96c.058.035.058.09 0 .121l-.6.349a.23.23 0 0 1-.207 0l-.6-.349c-.057-.032-.057-.086 0-.121l.6-.348c.032-.017.068-.025.104-.025s.072.008.104.025l.599.348zM557.4 896.57c.057.037.057.089 0 .122l-.6.349a.227.227 0 0 1-.209 0l-.6-.349c-.013-.004-.023-.013-.031-.024s-.012-.023-.012-.037a.067.067 0 0 1 .043-.061l.6-.347a.23.23 0 0 1 .212 0l.597.347zM552.15 894.8a.073.073 0 0 1 .031.024.07.07 0 0 1 0 .075.064.064 0 0 1-.031.023l-.6.348a.22.22 0 0 1-.211 0l-1.66-.957c-.055-.036-.055-.089 0-.121l.6-.35a.233.233 0 0 1 .208 0l1.663.958zM553.15 895.36c.059.032.059.087 0 .119l-.6.349a.229.229 0 0 1-.209 0l-.6-.349c-.059-.032-.059-.087 0-.119l.6-.349a.196.196 0 0 1 .208 0l.601.349zM554.28 896.01c.059.033.059.087 0 .119l-.6.349a.237.237 0 0 1-.207 0l-.606-.349a.057.057 0 0 1-.03-.023c-.008-.01-.012-.023-.012-.036s.004-.026.012-.037a.07.07 0 0 1 .03-.023l.6-.353a.257.257 0 0 1 .206 0l.607.353zM555.34 896.62a.063.063 0 0 1 .046.059.06.06 0 0 1-.013.037.057.057 0 0 1-.033.022l-.6.352a.243.243 0 0 1-.212 0l-.6-.352a.064.064 0 0 1-.031-.023.066.066 0 0 1 0-.073.064.064 0 0 1 .031-.023l.6-.351a.238.238 0 0 1 .209 0l.603.352zM556.39 897.23c.059.036.059.085 0 .12l-.6.349a.223.223 0 0 1-.207 0l-.6-.349c-.058-.035-.058-.084 0-.12l.6-.348a.224.224 0 0 1 .21 0l.597.348zM551.13 895.39a.066.066 0 0 1 .04.06c0 .013-.004.025-.011.036s-.017.019-.029.023l-.6.351a.233.233 0 0 1-.207 0l-1.662-.959a.064.064 0 0 1-.041-.061.066.066 0 0 1 .041-.061l.6-.349a.233.233 0 0 1 .208 0l1.661.96zM552.19 896a.078.078 0 0 1 .03.024c.007.011.011.024.011.037s-.004.026-.011.037a.07.07 0 0 1-.03.024l-.6.35a.24.24 0 0 1-.21 0l-.6-.35c-.013-.004-.023-.013-.031-.024a.063.063 0 0 1 0-.074.067.067 0 0 1 .031-.024l.6-.347a.227.227 0 0 1 .211 0l.599.347zM553.28 896.65a.067.067 0 0 1 .044.06.065.065 0 0 1-.044.06l-.6.35a.237.237 0 0 1-.207 0l-.606-.35c-.058-.034-.058-.087 0-.12l.6-.35a.224.224 0 0 1 .21 0l.603.35zM554.33 897.26c.06.031.063.085 0 .12l-.6.349a.227.227 0 0 1-.209 0l-.6-.349c-.057-.035-.057-.091 0-.12l.6-.35a.235.235 0 0 1 .21 0l.599.35zM558.46 897.18c.058.031.058.086 0 .12l-.6.35a.24.24 0 0 1-.21 0l-.6-.35c-.057-.034-.057-.089 0-.12l.6-.352a.233.233 0 0 1 .208 0l.602.352zM557.45 897.84c.058.033.058.086 0 .12l-.6.347c-.032.016-.068.025-.104.025s-.072-.009-.104-.025l-.6-.347c-.061-.034-.061-.087 0-.12l.6-.349a.197.197 0 0 1 .103-.028.2.2 0 0 1 .104.028l.601.349zM555.39 897.87a.068.068 0 0 1 .03.023c.007.011.011.024.011.037s-.004.026-.011.037a.078.078 0 0 1-.03.024l-.6.349a.255.255 0 0 1-.21 0l-.6-.349c-.013-.005-.024-.013-.032-.024s-.012-.024-.012-.038.004-.027.012-.038.019-.019.032-.024l.6-.349a.24.24 0 0 1 .21 0l.6.352zM556.44 898.47a.062.062 0 0 1 .029.024c.008.011.012.024.012.037s-.004.026-.012.036a.057.057 0 0 1-.029.024l-.6.349a.225.225 0 0 1-.207 0l-.606-.349a.055.055 0 0 1-.03-.024c-.008-.01-.012-.023-.012-.036s.004-.026.012-.037a.06.06 0 0 1 .03-.024l.6-.349a.237.237 0 0 1 .208 0l.605.349zM551.23 896.66c.06.033.06.086 0 .119l-.6.351a.223.223 0 0 1-.209 0l-2.715-1.567c-.058-.034-.058-.087 0-.12l.6-.349a.23.23 0 0 1 .207 0l2.717 1.566zM552.26 897.27c.058.033.06.087 0 .121l-.6.348a.229.229 0 0 1-.21 0l-.6-.347c-.059-.035-.059-.088 0-.121l.6-.351a.255.255 0 0 1 .21 0l.6.35zM553.32 897.88c.059.032.059.086 0 .121l-.6.349a.224.224 0 0 1-.209 0l-.6-.35a.062.062 0 0 1-.03-.023c-.008-.011-.012-.024-.012-.037s.004-.026.012-.036a.064.064 0 0 1 .03-.024l.6-.35c.033-.016.069-.025.105-.025s.072.009.105.025l.599.35zM554.37 898.49c.06.032.06.085 0 .118l-.6.351a.25.25 0 0 1-.208 0l-.6-.353c-.059-.031-.059-.084 0-.116l.6-.352c.032-.016.068-.025.104-.025s.072.009.104.025l.6.352zM555.43 899.1a.064.064 0 0 1 .029.025c.008.011.011.024.011.037s-.003.026-.011.037a.068.068 0 0 1-.029.024l-.6.347a.223.223 0 0 1-.208 0l-.605-.35c-.059-.032-.059-.087 0-.12l.6-.349a.247.247 0 0 1 .208 0l.605.349zM559.51 897.79a.061.061 0 0 1 .041.06.066.066 0 0 1-.011.036.07.07 0 0 1-.03.024l-.6.348a.23.23 0 0 1-.207 0l-.6-.35c-.06-.031-.06-.087 0-.118l.6-.351a.242.242 0 0 1 .207 0l.6.351zM558.51 898.45a.072.072 0 0 1 .032.025.07.07 0 0 1 0 .076.07.07 0 0 1-.032.024l-.6.347a.223.223 0 0 1-.209 0l-.6-.347c-.057-.037-.057-.091 0-.125l.6-.347c.032-.017.068-.025.104-.025s.072.008.103.025l.602.347zM557.5 899.08c.058.035.058.088 0 .122l-.6.349a.224.224 0 0 1-.209 0l-.6-.349c-.06-.034-.059-.087 0-.122l.6-.35c.032-.016.068-.025.104-.025s.071.009.104.025l.601.35zM556.48 899.7a.064.064 0 0 1 .046.061c0 .013-.005.027-.013.038s-.02.019-.033.022l-.6.348a.212.212 0 0 1-.208 0l-.606-.348a.059.059 0 0 1-.03-.024.063.063 0 0 1 0-.074.067.067 0 0 1 .03-.025l.6-.349a.237.237 0 0 1 .208 0l.606.351zM548.15 896.05c.058.033.058.088 0 .119l-.6.352a.24.24 0 0 1-.21 0l-.6-.352c-.013-.004-.024-.011-.032-.022s-.013-.024-.013-.037c0-.014.005-.027.013-.038a.066.066 0 0 1 .032-.022l.6-.35a.227.227 0 0 1 .211 0l.599.35zM549.16 896.63c.058.035.06.088 0 .122l-.6.346a.212.212 0 0 1-.208 0l-.609-.346a.07.07 0 0 1-.03-.024.07.07 0 0 1-.011-.037c0-.013.004-.026.011-.036a.072.072 0 0 1 .03-.025l.6-.351a.243.243 0 0 1 .2 0l.617.351zM550.22 897.23c.058.036.058.087 0 .123l-.6.349c-.032.017-.067.025-.103.025s-.072-.008-.104-.025l-.605-.349c-.058-.036-.058-.087 0-.125l.6-.345c.032-.018.068-.027.105-.027s.073.009.105.027l.602.347zM555.49 900.28c.058.033.058.088 0 .119l-.6.351a.23.23 0 0 1-.211 0l-4.822-2.785a.066.066 0 0 1-.043-.061.07.07 0 0 1 .012-.037.073.073 0 0 1 .031-.024l.6-.348a.223.223 0 0 1 .105-.025c.036 0 .072.008.104.025l4.824 2.785zM560.56 898.4c.057.032.057.086 0 .12l-.6.35a.231.231 0 0 1-.103.023.235.235 0 0 1-.104-.023l-.608-.35c-.057-.034-.057-.088 0-.12l.6-.351a.235.235 0 0 1 .21 0l.605.351zM561.62 899c.059.033.059.088 0 .122l-.6.348a.234.234 0 0 1-.209 0l-.6-.348c-.059-.034-.059-.089 0-.122l.6-.348a.224.224 0 0 1 .209 0l.6.348zM563.73 900.22a.062.062 0 0 1 .031.024.068.068 0 0 1 .012.038.064.064 0 0 1-.012.038.057.057 0 0 1-.031.024l-.6.347a.224.224 0 0 1-.209 0l-1.659-.959a.056.056 0 0 1-.031-.023.063.063 0 0 1-.012-.037c0-.014.004-.027.012-.037a.062.062 0 0 1 .031-.024l.6-.349a.238.238 0 0 1 .209 0l1.659.958zM559.56 899.06c.059.032.059.086 0 .12l-.6.349a.235.235 0 0 1-.211 0l-.6-.348a.066.066 0 0 1-.03-.024.063.063 0 0 1 0-.074.058.058 0 0 1 .03-.023l.6-.348a.217.217 0 0 1 .208 0l.603.348zM560.62 899.67c.057.033.057.086 0 .122l-.6.348a.224.224 0 0 1-.209 0l-.607-.348c-.057-.036-.057-.089 0-.122l.6-.348a.257.257 0 0 1 .106-.024c.036 0 .072.009.105.024l.605.348zM561.67 900.28c.057.034.057.085 0 .12l-.6.349a.234.234 0 0 1-.209 0l-.6-.349c-.057-.035-.058-.086 0-.12l.6-.35a.23.23 0 0 1 .207 0l.602.35zM562.72 900.88c.059.033.059.089 0 .124l-.6.348a.24.24 0 0 1-.105.023.241.241 0 0 1-.106-.023l-.6-.348c-.061-.035-.061-.091 0-.126l.6-.346a.222.222 0 0 1 .104-.025c.037 0 .072.008.104.025l.603.348zM558.55 899.69a.064.064 0 0 1 .041.061.064.064 0 0 1-.041.06l-.6.349a.219.219 0 0 1-.207 0l-.606-.349c-.059-.033-.059-.087 0-.121l.6-.346a.219.219 0 0 1 .206 0l.607.346zM559.6 900.3c.059.035.059.09 0 .119l-.6.351a.226.226 0 0 1-.208 0l-.6-.351c-.059-.029-.059-.084 0-.119l.6-.349a.246.246 0 0 1 .214 0l.594.349zM561.72 901.52c.057.031.057.086 0 .119l-.6.35c-.032.016-.068.025-.104.025s-.072-.009-.104-.025l-1.658-.959a.063.063 0 0 1 0-.12l.6-.352a.24.24 0 0 1 .211 0l1.655.962zM557.54 900.31c.056.036.057.088 0 .122l-.6.347a.22.22 0 0 1-.212 0l-.606-.347c-.057-.034-.057-.086 0-.122l.6-.347a.242.242 0 0 1 .105-.025c.037 0 .073.009.106.025l.607.347zM558.6 900.92c.058.035.058.09 0 .12l-.6.351a.23.23 0 0 1-.21 0l-.6-.352c-.06-.029-.06-.084 0-.119l.6-.35c.032-.015.068-.024.104-.024s.071.009.104.024l.602.35zM560.7 902.14c.057.034.057.087 0 .124l-.6.344a.224.224 0 0 1-.104.027.22.22 0 0 1-.104-.027l-1.658-.959c-.058-.033-.06-.087 0-.12l.6-.349a.235.235 0 0 1 .211 0l1.655.96zM556.54 900.89c.057.033.057.086 0 .123l-.6.347a.223.223 0 0 1-.209 0l-.6-.347c-.061-.037-.061-.09 0-.123l.6-.349a.225.225 0 0 1 .208 0l.601.349zM559.71 902.72c.059.034.061.087 0 .121l-.6.348a.235.235 0 0 1-.21 0l-1.661-.959c-.013-.004-.023-.012-.031-.023s-.012-.023-.012-.036.004-.026.012-.037.018-.019.031-.023l.6-.35c.032-.016.068-.025.104-.025s.071.009.104.025l1.663.959z"
            fill="#4A4A4A"
        />
        <path
            d="m551.29 893.99-.605-.347a.062.062 0 0 1-.029-.024.072.072 0 0 1-.014-.035v.119a.08.08 0 0 0 .014.037.08.08 0 0 0 .029.026l.607.347-.002-.123z"
            fill="#636363"
        />
        <path
            d="M552.15 893.59a.078.078 0 0 1-.013.036.066.066 0 0 1-.029.023l-.6.347a.21.21 0 0 1-.207 0v.121a.209.209 0 0 0 .207 0l.6-.347a.064.064 0 0 0 .029-.025.072.072 0 0 0 .013-.038v-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m552.3 894.56-.606-.35a.068.068 0 0 1-.03-.023.08.08 0 0 1-.012-.037v.117c0 .026.015.044.044.063l.606.348-.002-.118z"
            fill="#636363"
        />
        <path
            d="M553.15 894.15a.067.067 0 0 1-.014.036.066.066 0 0 1-.029.023l-.6.35a.223.223 0 0 1-.207 0v.118a.219.219 0 0 0 .207 0l.6-.348a.076.076 0 0 0 .043-.06v-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m553.43 895.21-.606-.349c-.012-.005-.022-.014-.03-.025s-.013-.024-.014-.038v.119a.072.072 0 0 0 .044.063l.606.349v-.119z"
            fill="#636363"
        />
        <path
            d="M554.28 894.8a.08.08 0 0 1-.012.037.09.09 0 0 1-.029.026l-.6.349c-.033.014-.068.022-.104.022s-.071-.008-.104-.022v.119c.032.016.068.025.104.025s.071-.009.104-.025l.6-.349a.072.072 0 0 0 .028-.024.078.078 0 0 0 .013-.036v-.122z"
            fill="#3D3D3D"
        />
        <path
            d="m554.48 895.82-.6-.349a.073.073 0 0 1-.031-.024.075.075 0 0 1-.013-.036v.12a.078.078 0 0 0 .013.036c.007.01.017.019.029.024l.605.349-.003-.12z"
            fill="#636363"
        />
        <path
            d="M555.33 895.41a.07.07 0 0 1-.012.037.068.068 0 0 1-.032.023l-.6.349a.22.22 0 0 1-.208 0v.12a.226.226 0 0 0 .208 0l.6-.349a.072.072 0 0 0 .031-.023.064.064 0 0 0 .013-.037v-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m555.54 896.43-.605-.347a.076.076 0 0 1-.028-.025.077.077 0 0 1-.012-.035v.121a.092.092 0 0 0 .042.068l.605.349-.002-.131z"
            fill="#636363"
        />
        <path
            d="M556.39 896.02a.07.07 0 0 1-.014.036.081.081 0 0 1-.029.026l-.6.345a.212.212 0 0 1-.209 0v.121a.212.212 0 0 0 .208 0l.6-.347a.096.096 0 0 0 .029-.024.083.083 0 0 0 .014-.035l.001-.122z"
            fill="#3D3D3D"
        />
        <path
            d="m556.6 897.04-.6-.349a.072.072 0 0 1-.044-.063v.122c0 .022.013.042.044.059l.6.352v-.121z"
            fill="#636363"
        />
        <path
            d="M557.44 896.63a.066.066 0 0 1-.013.036.061.061 0 0 1-.03.023l-.6.349a.224.224 0 0 1-.209 0v.121a.222.222 0 0 0 .104.025.226.226 0 0 0 .105-.025l.6-.352a.065.065 0 0 0 .03-.022.078.078 0 0 0 .013-.036v-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m551.34 895.27-1.66-.957a.07.07 0 0 1-.029-.025.072.072 0 0 1-.013-.037v.119a.077.077 0 0 0 .012.037c.008.011.018.02.03.025l1.66.958v-.12z"
            fill="#636363"
        />
        <path
            d="M552.2 894.86c-.002.013-.007.025-.015.035s-.018.018-.029.023l-.6.348a.23.23 0 0 1-.211 0v.12a.223.223 0 0 0 .209 0l.6-.35a.072.072 0 0 0 .044-.058l.002-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m552.35 895.83-.6-.349a.073.073 0 0 1-.032-.023.084.084 0 0 1-.015-.038v.12a.08.08 0 0 0 .014.037c.007.011.017.02.029.025l.608.35-.004-.122z"
            fill="#636363"
        />
        <path
            d="M553.2 895.42a.07.07 0 0 1-.014.036.066.066 0 0 1-.029.023l-.6.349a.224.224 0 0 1-.209 0v.122a.212.212 0 0 0 .209 0l.6-.35c.011-.005.021-.013.029-.023s.013-.022.015-.035l-.001-.122z"
            fill="#3D3D3D"
        />
        <path
            d="m553.48 896.48-.606-.349a.07.07 0 0 1-.04-.059v.12a.08.08 0 0 0 .042.063l.606.348-.002-.123z"
            fill="#636363"
        />
        <path
            d="M554.33 896.07a.06.06 0 0 1-.012.036.07.07 0 0 1-.03.023l-.6.349a.237.237 0 0 1-.207 0v.123a.223.223 0 0 0 .207 0l.6-.348a.08.08 0 0 0 .03-.025.093.093 0 0 0 .014-.036l-.002-.122z"
            fill="#3D3D3D"
        />
        <path
            d="m554.53 897.09-.6-.352a.07.07 0 0 1-.043-.06v.12c0 .013.005.026.012.036a.073.073 0 0 0 .031.024l.6.35v-.118z"
            fill="#636363"
        />
        <path
            d="M555.39 896.68a.065.065 0 0 1-.015.035.06.06 0 0 1-.031.023l-.6.352a.243.243 0 0 1-.212 0v.118a.23.23 0 0 0 .21 0l.6-.348c.013-.005.024-.013.032-.024s.013-.023.014-.037l.002-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m555.59 897.7-.6-.349c-.031-.015-.046-.038-.042-.061v.123c0 .021.015.041.046.059l.6.349-.004-.121z"
            fill="#636363"
        />
        <path
            d="M556.44 897.29c-.001.013-.005.026-.013.037s-.019.019-.031.024l-.6.349a.23.23 0 0 1-.207 0v.121c.032.015.067.024.103.024s.072-.009.104-.024l.6-.347c.029-.02.044-.04.044-.059v-.125z"
            fill="#3D3D3D"
        />
        <path
            d="m550.32 895.86-1.662-.959a.075.075 0 0 1-.031-.025.075.075 0 0 1-.013-.037v.12c0 .024.017.045.044.063l1.66.959.002-.121z"
            fill="#636363"
        />
        <path
            d="M551.17 895.45a.07.07 0 0 1-.012.035.075.075 0 0 1-.029.024l-.6.351a.233.233 0 0 1-.207 0v.121a.238.238 0 0 0 .209 0l.6-.347a.069.069 0 0 0 .029-.027.08.08 0 0 0 .012-.037l-.002-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m551.38 896.47-.6-.35a.093.093 0 0 1-.032-.024.084.084 0 0 1-.015-.038v.12c.002.013.007.026.015.037s.019.02.031.026l.6.347.001-.118z"
            fill="#636363"
        />
        <path
            d="M552.23 896.06a.077.077 0 0 1-.04.062l-.6.35a.255.255 0 0 1-.21 0v.118a.224.224 0 0 0 .21 0l.6-.347a.077.077 0 0 0 .04-.061v-.122z"
            fill="#3D3D3D"
        />
        <path
            d="m552.47 897.12-.606-.35a.072.072 0 0 1-.03-.025.088.088 0 0 1-.014-.036v.121a.09.09 0 0 0 .044.063l.605.345.001-.118z"
            fill="#636363"
        />
        <path
            d="M553.32 896.7a.077.077 0 0 1-.012.036.072.072 0 0 1-.028.024l-.6.35a.25.25 0 0 1-.207 0v.118a.208.208 0 0 0 .208 0l.6-.345a.077.077 0 0 0 .04-.063l-.001-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m553.52 897.72-.6-.349a.067.067 0 0 1-.03-.025.07.07 0 0 1-.014-.037v.12c.001.014.005.027.013.038s.019.019.031.024l.6.351v-.122z"
            fill="#636363"
        />
        <path
            d="M554.38 897.31a.073.073 0 0 1-.014.038.062.062 0 0 1-.031.024l-.6.349a.223.223 0 0 1-.209 0v.122a.24.24 0 0 0 .209 0l.6-.351a.065.065 0 0 0 .031-.023.07.07 0 0 0 .012-.037l.002-.122z"
            fill="#3D3D3D"
        />
        <path
            d="m557.64 897.65-.6-.35a.086.086 0 0 1-.029-.025.083.083 0 0 1-.014-.035v.117a.082.082 0 0 0 .013.037c.008.01.018.019.03.024l.6.348v-.116z"
            fill="#636363"
        />
        <path
            d="M558.5 897.24a.088.088 0 0 1-.014.036.07.07 0 0 1-.03.024l-.6.35a.24.24 0 0 1-.21 0v.116a.225.225 0 0 0 .105.027.23.23 0 0 0 .105-.027l.6-.346c.029-.018.044-.037.044-.062v-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m556.64 898.31-.6-.348a.075.075 0 0 1-.031-.025.082.082 0 0 1-.013-.037v.121c0 .013.005.026.013.036a.056.056 0 0 0 .031.023l.6.351v-.121z"
            fill="#636363"
        />
        <path
            d="M557.5 897.9a.07.07 0 0 1-.043.061l-.6.347a.226.226 0 0 1-.208 0v.122a.237.237 0 0 0 .208 0l.6-.352a.065.065 0 0 0 .043-.058v-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m554.58 898.34-.6-.349c-.031-.019-.045-.039-.045-.062v.119a.06.06 0 0 0 .013.037c.008.011.019.02.032.024l.6.351v-.12z"
            fill="#636363"
        />
        <path
            d="M555.43 897.92a.08.08 0 0 1-.043.061l-.6.349a.24.24 0 0 1-.21 0v.12c.032.017.068.025.104.025s.071-.008.103-.025l.6-.351a.062.062 0 0 0 .029-.024.064.064 0 0 0 .014-.035l.003-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m555.63 898.94-.606-.349a.072.072 0 0 1-.03-.025.07.07 0 0 1-.011-.037v.121a.07.07 0 0 0 .011.037c.008.011.018.02.03.025l.606.349v-.121z"
            fill="#636363"
        />
        <path
            d="M556.48 898.54a.073.073 0 0 1-.015.035.062.062 0 0 1-.029.024l-.6.349a.23.23 0 0 1-.207 0v.121a.233.233 0 0 0 .207 0l.6-.349a.062.062 0 0 0 .029-.024.069.069 0 0 0 .013-.036l.002-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m550.42 897.12-2.715-1.567c-.012-.006-.022-.014-.029-.025s-.012-.023-.013-.036v.122c0 .021.015.04.042.06l2.715 1.567v-.121zM551.46 897.74l-.6-.347a.082.082 0 0 1-.032-.026.09.09 0 0 1-.013-.039v.123c.002.014.007.027.015.038s.019.019.031.024l.6.348-.001-.121z"
            fill="#636363"
        />
        <path
            d="M552.31 897.33a.077.077 0 0 1-.015.036.067.067 0 0 1-.03.025l-.6.348a.229.229 0 0 1-.21 0v.121a.235.235 0 0 0 .21 0l.6-.348a.07.07 0 0 0 .044-.059l.001-.123z"
            fill="#3D3D3D"
        />
        <path
            d="m552.51 898.35-.6-.351a.083.083 0 0 1-.029-.024.093.093 0 0 1-.013-.035v.118c.002.013.008.025.016.036s.018.02.03.025l.6.35-.004-.119z"
            fill="#636363"
        />
        <path
            d="M553.36 897.94c0 .02-.013.04-.045.059l-.6.349a.224.224 0 0 1-.209 0v.12a.222.222 0 0 0 .104.025.226.226 0 0 0 .105-.025l.6-.35a.064.064 0 0 0 .031-.023.076.076 0 0 0 .014-.036v-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m553.56 898.96-.6-.353a.062.062 0 0 1-.03-.023.069.069 0 0 1-.013-.037v.122a.066.066 0 0 0 .013.036.057.057 0 0 0 .03.023l.6.351v-.119z"
            fill="#636363"
        />
        <path
            d="M554.42 898.55a.065.065 0 0 1-.012.036.063.063 0 0 1-.031.022l-.6.351a.247.247 0 0 1-.208 0v.119a.225.225 0 0 0 .208 0l.6-.351a.062.062 0 0 0 .042-.057l.001-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m554.62 899.56-.605-.35a.07.07 0 0 1-.03-.024.074.074 0 0 1-.012-.036v.12a.071.071 0 0 0 .043.061l.6.348.004-.119z"
            fill="#636363"
        />
        <path
            d="M555.47 899.16a.082.082 0 0 1-.041.063l-.6.347a.223.223 0 0 1-.208 0v.119c.032.018.068.027.105.027s.073-.009.105-.027l.6-.346c.027-.019.043-.037.043-.062l-.004-.121z"
            fill="#3D3D3D"
        />
        <path
            d="m558.7 898.26-.6-.35a.064.064 0 0 1-.031-.023.066.066 0 0 1-.013-.036v.119c0 .014.005.027.013.038a.06.06 0 0 0 .031.026l.6.346v-.12z"
            fill="#636363"
        />
        <path
            d="M559.55 897.85c-.001.013-.005.026-.013.037s-.019.019-.031.024l-.6.348a.219.219 0 0 1-.207 0v.12a.223.223 0 0 0 .208 0l.6-.346a.07.07 0 0 0 .031-.025.07.07 0 0 0 .011-.038l.001-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m557.7 898.92-.6-.347a.083.083 0 0 1-.03-.026.081.081 0 0 1-.012-.038v.123a.057.057 0 0 0 .013.034c.007.01.017.018.029.022l.6.352v-.12z"
            fill="#636363"
        />
        <path
            d="M558.55 898.5c-.002.013-.006.026-.014.037s-.018.019-.03.025l-.6.347a.223.223 0 0 1-.209 0v.12a.226.226 0 0 0 .105.025.222.222 0 0 0 .104-.025l.6-.352a.063.063 0 0 0 .043-.056l.001-.121z"
            fill="#3D3D3D"
        />
        <path
            d="m556.69 899.55-.6-.349c-.012-.005-.023-.013-.031-.023s-.013-.023-.015-.035v.117c0 .024.017.042.044.061l.606.349-.004-.12z"
            fill="#636363"
        />
        <path
            d="M557.54 899.15a.073.073 0 0 1-.043.058l-.6.349a.216.216 0 0 1-.209 0v.12a.223.223 0 0 0 .209 0l.6-.349c.029-.019.043-.038.043-.06v-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m555.67 900.17-.606-.348a.08.08 0 0 1-.042-.063v.12a.08.08 0 0 0 .042.063l.6.349.006-.121z"
            fill="#636363"
        />
        <path
            d="M556.53 899.77a.093.093 0 0 1-.014.036.078.078 0 0 1-.03.024l-.6.348a.223.223 0 0 1-.208 0v.121a.247.247 0 0 0 .209 0l.6-.349a.068.068 0 0 0 .029-.024.07.07 0 0 0 .011-.037l.003-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m547.34 896.52-.6-.352a.083.083 0 0 1-.029-.024.078.078 0 0 1-.013-.036v.119a.075.075 0 0 0 .013.036.062.062 0 0 0 .029.024l.6.351v-.118z"
            fill="#636363"
        />
        <path
            d="M548.2 896.1a.078.078 0 0 1-.013.036.083.083 0 0 1-.029.024l-.6.35a.255.255 0 0 1-.21 0v.117a.224.224 0 0 0 .21 0l.6-.35c.03-.017.042-.035.043-.056l-.001-.121z"
            fill="#3D3D3D"
        />
        <path
            d="m548.35 897.1-.609-.346a.096.096 0 0 1-.027-.026.077.077 0 0 1-.012-.035v.119a.081.081 0 0 0 .039.063l.609.346v-.121z"
            fill="#636363"
        />
        <path
            d="M549.2 896.69a.073.073 0 0 1-.043.061l-.6.346a.217.217 0 0 1-.207 0v.121a.23.23 0 0 0 .207 0l.6-.349a.073.073 0 0 0 .029-.026.07.07 0 0 0 .014-.036v-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m549.41 897.7-.605-.349a.07.07 0 0 1-.029-.025.076.076 0 0 1-.014-.036v.119a.072.072 0 0 0 .013.037.07.07 0 0 0 .03.023l.605.351v-.12z"
            fill="#636363"
        />
        <path
            d="M550.26 897.3a.076.076 0 0 1-.014.036.07.07 0 0 1-.029.025l-.6.349c-.032.017-.067.025-.103.025s-.072-.008-.104-.025v.12a.237.237 0 0 0 .207 0l.6-.351a.07.07 0 0 0 .043-.06v-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m554.68 900.75-4.823-2.785c-.031-.019-.046-.039-.046-.061v.119c.001.014.006.026.014.037s.018.02.031.025l4.824 2.786v-.121zM559.76 898.87l-.608-.35a.072.072 0 0 1-.028-.024.072.072 0 0 1-.013-.036v.12a.082.082 0 0 0 .015.036c.007.01.018.018.029.024l.606.35-.001-.12z"
            fill="#636363"
        />
        <path
            d="M560.61 898.46a.07.07 0 0 1-.014.036.068.068 0 0 1-.029.024l-.6.35a.237.237 0 0 1-.207 0v.12a.238.238 0 0 0 .209 0l.6-.35a.07.07 0 0 0 .028-.023.06.06 0 0 0 .012-.036l.001-.121z"
            fill="#3D3D3D"
        />
        <path
            d="m560.81 899.48-.6-.348a.083.083 0 0 1-.03-.026.092.092 0 0 1-.014-.037v.122a.066.066 0 0 0 .013.036.062.062 0 0 0 .031.022l.6.351v-.12z"
            fill="#636363"
        />
        <path
            d="M561.66 899.07a.088.088 0 0 1-.014.036.076.076 0 0 1-.029.025l-.6.348a.229.229 0 0 1-.209 0v.12a.219.219 0 0 0 .21 0l.6-.351a.06.06 0 0 0 .028-.022.069.069 0 0 0 .014-.034v-.122z"
            fill="#3D3D3D"
        />
        <path
            d="m562.92 900.7-1.659-.959a.073.073 0 0 1-.031-.024.068.068 0 0 1-.012-.037v.12c0 .014.005.026.013.037a.056.056 0 0 0 .031.023l1.66.96-.002-.12z"
            fill="#636363"
        />
        <path
            d="M563.77 900.28a.098.098 0 0 1-.014.037.083.083 0 0 1-.03.026l-.6.347a.224.224 0 0 1-.209 0v.12a.234.234 0 0 0 .209 0l.6-.349c.012-.005.022-.014.03-.025s.013-.024.014-.037v-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m558.75 899.53-.6-.348c-.029-.02-.045-.038-.045-.062v.12a.098.098 0 0 0 .014.037.093.093 0 0 0 .029.027l.6.346.002-.12z"
            fill="#636363"
        />
        <path
            d="M559.6 899.12a.072.072 0 0 1-.013.037.064.064 0 0 1-.03.024l-.6.349a.23.23 0 0 1-.106.025.229.229 0 0 1-.105-.025v.12a.223.223 0 0 0 .209 0l.6-.346a.067.067 0 0 0 .03-.025.064.064 0 0 0 .012-.038l.003-.121z"
            fill="#3D3D3D"
        />
        <path
            d="m559.81 900.14-.607-.348a.073.073 0 0 1-.029-.026.073.073 0 0 1-.015-.035v.118a.08.08 0 0 0 .014.038c.007.011.018.02.03.027l.6.348.007-.122z"
            fill="#636363"
        />
        <path
            d="M560.66 899.73c0 .021-.015.04-.045.058l-.6.348a.227.227 0 0 1-.209 0v.122c.033.017.069.025.106.025s.074-.008.107-.025l.6-.348c.029-.019.045-.039.045-.06l-.004-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m560.86 900.74-.6-.349a.065.065 0 0 1-.031-.023.069.069 0 0 1-.013-.037v.119a.072.072 0 0 0 .044.063l.6.349v-.122z"
            fill="#636363"
        />
        <path
            d="M561.72 900.34a.069.069 0 0 1-.013.036.076.076 0 0 1-.03.023l-.6.349a.222.222 0 0 1-.104.025.226.226 0 0 1-.105-.025v.122a.233.233 0 0 0 .207 0l.6-.349a.062.062 0 0 0 .029-.024.064.064 0 0 0 .014-.035l.002-.122z"
            fill="#3D3D3D"
        />
        <path
            d="m561.92 901.36-.6-.348a.072.072 0 0 1-.031-.026.073.073 0 0 1-.014-.038v.121a.078.078 0 0 0 .041.061l.6.348.004-.118z"
            fill="#636363"
        />
        <path
            d="M562.77 900.95c0 .022-.016.043-.046.062l-.6.348a.24.24 0 0 1-.211 0v.118a.23.23 0 0 0 .106.025.229.229 0 0 0 .105-.025l.6-.348c.03-.019.044-.037.044-.061l.002-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m557.74 900.16-.606-.349a.064.064 0 0 1-.03-.024.077.077 0 0 1-.015-.036v.119a.078.078 0 0 0 .043.063l.608.349v-.122z"
            fill="#636363"
        />
        <path
            d="M558.6 899.75c-.001.013-.006.025-.013.036s-.017.019-.029.024l-.6.349a.219.219 0 0 1-.207 0v.122a.233.233 0 0 0 .207 0l.6-.347a.072.072 0 0 0 .03-.025.088.088 0 0 0 .014-.036l-.002-.123z"
            fill="#3D3D3D"
        />
        <path
            d="m558.8 900.77-.6-.351a.07.07 0 0 1-.045-.06v.121c0 .022.014.042.045.061l.6.349v-.12z"
            fill="#636363"
        />
        <path
            d="M559.65 900.36a.063.063 0 0 1-.012.037.06.06 0 0 1-.03.022l-.6.351a.223.223 0 0 1-.208 0v.12c.032.017.068.025.104.025s.072-.008.104-.025l.6-.349a.07.07 0 0 0 .043-.061l-.001-.12z"
            fill="#3D3D3D"
        />
        <path
            d="m560.9 901.99-1.658-.959a.073.073 0 0 1-.045-.061v.123a.083.083 0 0 0 .014.035c.008.01.018.018.03.023l1.659.959v-.12z"
            fill="#636363"
        />
        <path
            d="M561.76 901.58c-.001.012-.006.024-.013.034s-.017.018-.029.024l-.6.35a.233.233 0 0 1-.208 0v.12a.223.223 0 0 0 .208 0l.6-.348c.012-.006.023-.015.03-.026s.012-.023.012-.036v-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m556.73 900.78-.606-.347a.079.079 0 0 1-.029-.025.083.083 0 0 1-.013-.036v.121a.075.075 0 0 0 .013.035.09.09 0 0 0 .029.026l.606.349v-.123z"
            fill="#636363"
        />
        <path
            d="M557.58 900.38a.08.08 0 0 1-.014.036.08.08 0 0 1-.029.023l-.6.347a.223.223 0 0 1-.212 0v.123a.24.24 0 0 0 .211 0l.6-.349a.062.062 0 0 0 .029-.024.07.07 0 0 0 .014-.037l.001-.119z"
            fill="#3D3D3D"
        />
        <path
            d="m557.78 901.39-.6-.352a.067.067 0 0 1-.045-.058v.12c0 .023.014.043.045.06l.6.349v-.119z"
            fill="#636363"
        />
        <path
            d="M558.64 900.98a.066.066 0 0 1-.041.059l-.6.351a.224.224 0 0 1-.21 0v.119c.032.019.068.028.105.028s.073-.009.105-.028l.6-.347c.027-.019.041-.038.041-.058v-.124z"
            fill="#3D3D3D"
        />
        <path
            d="m559.89 902.61-1.658-.959a.061.061 0 0 1-.03-.023.066.066 0 0 1-.013-.036v.119a.068.068 0 0 0 .043.06l1.658.958v-.119z"
            fill="#636363"
        />
        <path
            d="M560.75 902.2a.088.088 0 0 1-.014.036.09.09 0 0 1-.029.026l-.6.344a.223.223 0 0 1-.208 0v.119a.212.212 0 0 0 .208 0l.6-.348a.08.08 0 0 0 .029-.023.078.078 0 0 0 .013-.036l.001-.118z"
            fill="#3D3D3D"
        />
        <path
            d="m555.74 901.36-.6-.347c-.031-.02-.045-.04-.045-.063v.119c0 .013.005.026.013.037.008.01.019.018.032.021l.6.353v-.12z"
            fill="#636363"
        />
        <path
            d="M556.58 900.95a.077.077 0 0 1-.04.061l-.6.347a.223.223 0 0 1-.209 0v.12a.224.224 0 0 0 .209 0l.6-.353a.063.063 0 0 0 .031-.022.064.064 0 0 0 .011-.036l-.002-.117z"
            fill="#3D3D3D"
        />
        <path
            d="m556.79 901.97-.6-.349a.082.082 0 0 1-.032-.026.08.08 0 0 1-.014-.038v.121a.065.065 0 0 0 .014.037.07.07 0 0 0 .032.024l.6.348v-.117z"
            fill="#636363"
        />
        <path
            d="M557.64 901.56a.075.075 0 0 1-.042.06l-.6.351a.256.256 0 0 1-.105.024.257.257 0 0 1-.106-.024v.117a.23.23 0 0 0 .211 0l.6-.348a.064.064 0 0 0 .03-.024.067.067 0 0 0 .014-.035l-.002-.121z"
            fill="#3D3D3D"
        />
        <path
            d="M557.59 901.5c.058.034.058.087 0 .121l-.6.351a.24.24 0 0 1-.211 0l-.6-.349c-.057-.036-.057-.089 0-.123l.6-.351a.25.25 0 0 1 .208 0l.603.351z"
            fill="#4A4A4A"
        />
        <path
            d="m558.9 903.19-1.661-.959a.07.07 0 0 1-.028-.023.07.07 0 0 1-.015-.034v.12a.083.083 0 0 0 .014.035c.008.01.018.019.029.024l1.661.959v-.122z"
            fill="#636363"
        />
        <path
            d="M559.75 902.78c0 .025-.015.042-.043.061l-.6.348a.229.229 0 0 1-.21 0v.122a.212.212 0 0 0 .208 0l.6-.351c.028-.02.043-.037.043-.058l.002-.122zM551.28 896.72a.078.078 0 0 1-.013.037.073.073 0 0 1-.031.024l-.6.351c-.033.016-.069.023-.105.023s-.071-.007-.104-.023v.117a.223.223 0 0 0 .209 0l.6-.346a.07.07 0 0 0 .03-.024.08.08 0 0 0 .012-.037l.002-.122z"
            fill="#3D3D3D"
        />
        <path
            d="m564 901.65.011.264-.6.385-.013-.265.602-.384zM564.9 901.08l.016.268-.6.383-.011-.265.595-.386z"
            fill="#393939"
        />
        <path
            d="m564.86 901.32-.546.346-.009-.2.545-.348.01.202zM563.96 901.88l-.55.352-.011-.2.553-.353.008.201z"
            fill="#000"
        />
        <path
            d="M544.67 895.87s3.009-.676 3.569-.773a7.44 7.44 0 0 1 3.156.773l1.276 1.178s.168.265-.289.365-1.145-.724-1.145-.724l-1.338-.385s-.862-.03-.893.384c-.024.315.719.479 1.04.533.219.037.706.184.791.408a.37.37 0 0 1-.167.484 5.386 5.386 0 0 1-1.207-.146c-.819-.146-1.432-.177-1.9-.267a1.869 1.869 0 0 1-1.036-.6l-1.5.385-.357-1.615z"
            fill="#FFE1CC"
        />
        <path
            d="M533.96 890.46s-2.7-.225-2.829 3.182a25.918 25.918 0 0 0 2.313 5.75 3.41 3.41 0 0 0 3.536 1.366c1.87-.286 8.969-2.458 8.969-2.458s.351-.385-.067-1.574a1.635 1.635 0 0 0-.8-1l-7.746.8-3.376-6.066z"
            fill="#3D5A72"
        />
        <path
            d="m537.1 897.1 1.46-.829 1.124.652-1.423.829-1.161-.652z"
            fill="#995710"
        />
        <path
            d="m540.79 881.24 2.815.609-1.872 7.218c-.495 2.078-1.435 2.24-2.072 2.135a7.738 7.738 0 0 1-3.321-1.792c-1.284-1.1-.82-3.547-.795-3.748l.4-4.969 4.845.547z"
            fill="#FFE1CC"
        />
        <path
            d="m534.48 890.67 1.177-4.345 3.634 1.207-.877 4.245c-.059.61 1.774 6.1 1.6 7.994l-6.805-2.9c.069-.813 1.271-6.201 1.271-6.201z"
            fill="#FFE1CC"
        />
        <path
            d="M543.13 880.76c1.442 1.15 1.141 2.444-.1 3.184a4.212 4.212 0 0 0-1.408 2.145l-.231.751c-.037.285-.483.633-.615.188-.15-.5.246-.788.082-1.058s-.73-.456-1.548 1.018l-.5 1.162a2.002 2.002 0 0 1-2.692.867 3.475 3.475 0 0 1-1.134-.831 17.38 17.38 0 0 1-1.177-3.142c-.658-3.709 1.621-7.9 6.891-5.771a9.05 9.05 0 0 1 2.432 1.487z"
            fill="#633A11"
        />
        <path
            d="M540.89 885.15a1.077 1.077 0 0 0-.9.678 1.242 1.242 0 0 0 0 1.031c.104.197.267.356.465.455 0 0 .144-1.169.185-1.384.068-.264.151-.525.25-.78z"
            fill="#EFCFBD"
        />
        <path
            d="M541.2 884.93s.343.027.038.485a2.482 2.482 0 0 0-.448 1.023c-.042.252-.08 1.019-.08 1.019s-.254.283-.4-.205a3.068 3.068 0 0 1 0-1.2c.031-.215.532-1.281.89-1.122z"
            fill="#FFE8D9"
        />
        <path
            d="M540.65 895.18c.741.921.972 1.886.694 4.86l-.754 11.4a4.203 4.203 0 0 1-2.458 3.616 6.818 6.818 0 0 1-4.916.291c-.742-.328-4.13-2.657-4.03-3.745l1.385-15.281c.606-5.156 3.649-5.971 3.649-5.971l3.426 1.563 3.004 3.267z"
            fill="#4D6B89"
        />
        <path
            d="M535 889.4c-.488-.164-.619-.089-.745.206a5.758 5.758 0 0 1-.265.589c-.115.231-.008.259-.008.259a17.017 17.017 0 0 1 4.172 2.354c1.237 1.021 1.328 1.116 1.328 1.116l-.214-1.042c-.157-.885-1.081-1.831-2.507-2.624A14.989 14.989 0 0 0 535 889.4z"
            fill="#E4EFF4"
        />
        <path
            d="M552.6 902.74a18.125 18.125 0 0 1 3.327 0c.914.192 3.615 1.253 3.615 1.253s.77.287.337.772c-.339.276-.693.534-1.06.771-.242.191-.964.239-2.412-.048a5.27 5.27 0 0 0-1.975-.047 4.809 4.809 0 0 1-1.879-.289l.047-2.412z"
            fill="#FFE1CC"
        />
        <path
            d="M553.65 903.97a3.563 3.563 0 0 1-.446 1.7s-5.765.552-6.543.606a4.19 4.19 0 0 1-2.626-.6c-1.82-.914-5.483-4.9-5.483-4.9s-2.666-2.572-1.537-4.839c.833-1.67 3.022-1.441 4.033-.159.944 1.2 3.085 4.079 4.3 5.517a2.292 2.292 0 0 0 1.816.822l5.336.149a.878.878 0 0 1 .89.32c.213.428.303.907.26 1.384z"
            fill="#688CAA"
        />
        <path d="M555.37 870.76v.85l-8.7 5.059v-.853l8.7-5.056z" fill="#CFCFCF" />
        <path
            d="M546.67 875.82v.853l-17.026-9.834v-.849l17.026 9.83z"
            fill="#9D9D9D"
        />
        <path
            d="m555.37 870.76-8.7 5.056-17.029-9.83 8.7-5.058 17.029 9.832z"
            fill="#E2E2E2"
        />
        <path
            d="m538.89 858.27-.007 6.582-2.192 1.271v-6.579l2.199-1.274z"
            fill="#3581D9"
        />
        <path
            d="M536.7 859.55v6.579l-2.208-1.271v-6.582l2.208 1.274z"
            fill="#4895EF"
        />
        <path
            d="m538.89 858.27-2.2 1.273-2.208-1.273 2.194-1.278 2.214 1.278z"
            fill="#4CC9F0"
        />
        <path
            d="M542.37 854.71v12.248l-2.2 1.274v-12.247l2.2-1.275z"
            fill="#8CC149"
        />
        <path
            d="M540.18 855.99v12.247l-2.206-1.274v-12.248l2.206 1.275z"
            fill="#AAD86F"
        />
        <path
            d="m542.37 854.71-2.2 1.275-2.207-1.275 2.194-1.271 2.213 1.271z"
            fill="#C7F08F"
        />
        <path
            d="M545.93 859.47v9.563l-2.2 1.273v-9.562l2.2-1.274z"
            fill="#65149A"
        />
        <path
            d="M543.74 860.74v9.562l-2.208-1.273v-9.563l2.208 1.274z"
            fill="#7209B7"
        />
        <path
            d="m545.94 859.47-2.2 1.274-2.208-1.274 2.194-1.277 2.214 1.277z"
            fill="#9133D0"
        />
        <path
            d="M549.99 853.21v18.139l-2.193 1.272v-18.136l2.193-1.275z"
            fill="#D3176D"
        />
        <path
            d="M547.8 854.48v18.135l-2.21-1.272v-18.138l2.21 1.275z"
            fill="#F72585"
        />
        <path
            d="m549.99 853.21-2.194 1.275-2.209-1.275 2.2-1.274 2.203 1.274z"
            fill="#F856A0"
        />
        <path
            d="m576.02 900.63 6.814-3.944a.362.362 0 0 0-.154.338c.009.219.083.43.211.608a1.066 1.066 0 0 0 .312.301l-6.813 3.945a.984.984 0 0 1-.311-.302 1.102 1.102 0 0 1-.214-.607.373.373 0 0 1 .155-.339z"
            fill="#C6C6C6"
        />
        <path
            d="m576.78 900.89 6.813-3.945v-.1l-6.812 3.945-.001.1z"
            fill="#878787"
        />
        <path
            d="M582.77 896.57a.436.436 0 0 1 .439.042l.392.228-6.813 3.945-.39-.228a.441.441 0 0 0-.441-.042l6.813-3.945zM584.94 906.81l6.814-3.943-8.559-4.939-6.813 3.945 8.558 4.937z"
            fill="#F2F2F2"
        />
        <path
            d="m584.94 906.92 6.814-3.946v-.106l-6.814 3.943v.109z"
            fill="#878787"
        />
        <path
            d="M576.4 900.56c-.344-.2-.624-.037-.624.355a1.365 1.365 0 0 0 .616 1.066l8.557 4.942v-.11l-8.557-4.937a1.157 1.157 0 0 1-.525-.909c0-.333.24-.466.53-.3l.392.227v-.1l-.389-.234z"
            fill="#BCBCBC"
        />
        <path
            d="M578.66 902.15c-.078.046-.042.14.081.212a.428.428 0 0 0 .367.049l2.167-1.253 1.557-.895c.077-.047.04-.143-.086-.215a.439.439 0 0 0-.361-.047l-1.557.9-2.168 1.249zM582.64 904.31c-.1.057-.083.164.037.234a.457.457 0 0 0 .408.027l2.774-1.6 1.995-1.15c.1-.057.081-.165-.044-.233a.453.453 0 0 0-.4-.027l-1.995 1.149-2.775 1.6zM581.52 903.74c-.079.044-.038.141.083.211a.428.428 0 0 0 .364.048l2.127-1.228 1.527-.882c.074-.044.039-.137-.085-.209a.439.439 0 0 0-.36-.048l-1.528.881-2.128 1.227zM580.53 903.12c-.112.064-.1.174.026.242a.472.472 0 0 0 .42.02l3.022-1.745 2.171-1.255c.1-.061.093-.17-.03-.244a.476.476 0 0 0-.418-.015l-2.172 1.254-3.019 1.743zM579.6 902.61c-.1.057-.08.164.042.236a.456.456 0 0 0 .4.024l2.776-1.6 1.994-1.154c.1-.057.078-.163-.043-.235a.473.473 0 0 0-.4-.025l-1.995 1.152-2.774 1.602zM577.86 901.65c-.11.066-.1.173.023.248a.482.482 0 0 0 .423.012l3.02-1.742 2.171-1.254c.107-.064.1-.174-.028-.244a.452.452 0 0 0-.417-.015l-2.172 1.25-3.02 1.745z"
            fill="#838383"
        />
        <path
            d="M590.04 902.3a.537.537 0 0 1-.005 1.017 1.965 1.965 0 0 1-1.761 0 .54.54 0 0 1 .008-1.019 1.946 1.946 0 0 1 1.758.002zm-.068.98a.497.497 0 0 0 .339-.47.497.497 0 0 0-.334-.475 1.8 1.8 0 0 0-1.634 0 .497.497 0 0 0-.249.761c.06.085.145.15.243.184a1.789 1.789 0 0 0 1.635 0z"
            fill="#B84F4F"
        />
        <path
            d="m589.04 902.85.061.039.275-.163-.061-.037-.275.161zM588.54 902.4l.063.032a1.32 1.32 0 0 1 .467-.116v-.05a1.352 1.352 0 0 0-.53.134zM588.46 902.46a.507.507 0 0 0-.224.284h.087a.467.467 0 0 1 .2-.246l-.063-.038zM589.26 903.3v.048c.185-.007.367-.054.533-.138l-.063-.035a1.17 1.17 0 0 1-.47.125zM588.22 902.81a.321.321 0 0 0 .029.139l.081-.012a.33.33 0 0 1-.024-.127h-.086zM589.19 902.27v.05c.076.002.151.009.225.022l.018-.047a1.787 1.787 0 0 0-.243-.025zM590 902.68a.335.335 0 0 1 .028.128h.085a.397.397 0 0 0-.029-.139l-.084.011zM588.62 903.1l.062.039.352-.209-.06-.031-.354.201z"
            fill="#B84F4F"
        />
        <path
            d="m590.03 902.57-1.307.759-.442-.257 1.308-.757.441.255zm-1.307.688 1.183-.688-.317-.182-1.186.684.32.186z"
            fill="#B84F4F"
        />
        <path
            d="m589.38 902.65.06.033.255-.145-.061-.034-.254.146zM590 902.89a.438.438 0 0 1-.19.245l.061.038a.486.486 0 0 0 .216-.283H590zM588.92 903.28l-.023.051c.081.014.163.021.245.02v-.045a1.526 1.526 0 0 1-.222-.026z"
            fill="#B84F4F"
        />
        <path
            d="M603 932.9a1.765 1.765 0 0 1-1.124.686c-.5.105-2.128.306-2.128.306-.81.1-1.792.358-1.946 1.152a2.633 2.633 0 0 0-.026.532c.1.444.532.619 1.061.807.58.202 1.172.366 1.773.489.79.171 1.604.188 2.4.051.448-.08.9-.136 1.353-.168.431 0 .359.313.408.717l1.37.355a2.093 2.093 0 0 0 2.237-1.368l-.369-3.01L603 932.9z"
            fill="#545454"
        />
        <path
            d="M603.88 936.69c-.836.136-1.684.169-2.527.1a15.557 15.557 0 0 1-2.685-.721c-.465-.166-.862-.453-.9-.717-.01.087-.01.173 0 .259.1.446.535.623 1.062.809a13.13 13.13 0 0 0 1.774.491c.791.17 1.608.186 2.406.048l1.145-.162c.254-.037.506.03.51.074-.001-.017-.106-.249-.785-.181zM606.07 937.3l-1.355-.354c.015.132.046.447.06.577l1.372.358a2.096 2.096 0 0 0 2.236-1.371l-.076-.575a2.087 2.087 0 0 1-2.237 1.365z"
            fill="#383736"
        />
        <path
            d="M605.9 929.9a1.01 1.01 0 0 1-.879.864c-.479.04-1.164.062-1.164.062-.812-.154-1.831-.139-2.018.467-.044.117-.069.24-.074.365.043.447-.115.074.5.618.593.451 1.22.855 1.876 1.208a3.02 3.02 0 0 0 1.653.409c.311-.061.629-.084.946-.068.4.048.3.558.3.957l1.243.512a1.962 1.962 0 0 0 2.253-1.066v-3.193L605.9 929.9z"
            fill="#545454"
        />
        <path
            d="M606.29 933.71a7.282 7.282 0 0 1-1.8-.356 9.621 9.621 0 0 1-2.149-1.133 1.16 1.16 0 0 1-.552-.769 2.464 2.464 0 0 0-.029.257c-.028.407.33.628.621.834a7.97 7.97 0 0 0 1.75.995 3.946 3.946 0 0 0 1.554.3l.918.044c.163.005.391.1.391.147-.007-.026-.061-.305-.704-.319zM608.27 934.95l-1.233-.51c0 .132-.01.269-.01.4l1.243.516a1.965 1.965 0 0 0 2.253-1.071v-.4a1.965 1.965 0 0 1-.935.937 1.965 1.965 0 0 1-1.318.128z"
            fill="#383736"
        />
        <path
            d="M610.07 913.44c-.027.555-.799.886-1.299.859-.176-.008-.335 1.028-.612 1.4a.463.463 0 0 1-.596.154.472.472 0 0 1-.167-.147c.166-.671.37-1.332.613-1.978.4-1.275.926-1.3 1.431-1.271s.654.43.63.983z"
            fill="#FFE8D9"
        />
        <path
            d="M609.98 912.31c.568 0 1.671-1.082 1.671-1.082s.025-.14.065-.388c.232-1.384 1.28-6.115 1.338-7.86a62.777 62.777 0 0 0-.7-6.992s-.341-4.29-3.247-4.169c-1.756.073-.842 2.591-.86 4.13-.014 1.208.607 7.352.607 7.352l-.388 7.548s.402 1.451 1.514 1.461z"
            fill="#38556D"
        />
        <path
            d="m610.75 912.55-1.458-.091-.638 1.7-.013.285.113 2.272a1.132 1.132 0 0 0 1.129 1.165c.757.048.082.006.082.006 1.039.064 1.187-1.054 1.187-1.054l.414-2.9c.047-.623-.148-1.345-.816-1.383z"
            fill="#FFE8D9"
        />
        <path
            d="M608.17 912.5c-.006.256.553.758 1.3.836.477.074.964.047 1.43-.082.45-.152.7-.327.737-.644 0 0 .148-1.172.175-1.541.022-.239-.1-.241-.1-.241-.009.088-.03.175-.061.258-.148.248-.567.575-1.52.599-1.5.036-1.671-.849-1.671-.849-.217 0-.291.093-.282.345l-.008 1.319z"
            fill="#E4EFF4"
        />
        <path
            d="M611.19 912.58s.683-3.2-3.279-3.2c-3.136 0-3.136 3.331-3.136 3.331l1.583 19.184h3.92l.912-19.315z"
            fill="#E8C5AC"
        />
        <path
            d="m603.41 882.58-2.692.33 1.126 6.926c.285 1.988 1.153 2.223 1.76 2.178a7.216 7.216 0 0 0 3.263-1.39c1.3-.916 1.078-3.253 1.076-3.444l.054-4.691-4.587.091z"
            fill="#FFE1CC"
        />
        <path
            d="m608.5 891.97-.727-4.173-3.507.815.452 4.054c0 .576-2.192 5.562-2.192 7.353l6.629-2.129c0-.764-.655-5.92-.655-5.92z"
            fill="#FFE1CC"
        />
        <path
            d="M603.75 907.54v1.835c.043 1.231.152 2.458.324 3.676l6.274.237c.787-.155 1.088-1.235 1.088-2.32v-3.428h-7.686z"
            fill="#14546D"
        />
        <path
            d="M611.19 912.58a2.733 2.733 0 0 0-3.024-2.224h-1.089a3.109 3.109 0 0 0-3.011 2.7l1.647 18.76 4.2.079 1.277-19.315z"
            fill="#FFE1CC"
        />
        <path
            d="M601.26 881.92c-1.449.953-1.28 2.2-.181 2.995.591.575.988 1.32 1.135 2.132l.152.726c.01.267.4.633.56.228.182-.452-.163-.76.014-1s.726-.362 1.36 1.089l.367 1.134c.092.229.229.437.402.613a1.866 1.866 0 0 0 2.045.428c.42-.147.807-.378 1.135-.679a16.396 16.396 0 0 0 1.376-2.841c.938-3.419-.833-7.549-5.959-6.005a8.576 8.576 0 0 0-2.406 1.18z"
            fill="#633A11"
        />
        <path
            d="m604.1 910.99.169 21.933a5.93 5.93 0 0 0 3.809 1.33c1.333 0 2.634-.859 2.665-1.23l.793-22.417-7.436.384z"
            fill="#282827"
        />
        <path
            d="m602.3 913.23.387 19.443c-.01-.009-.045.477-.249.589s-.194.522-.091.8a4.289 4.289 0 0 0 4.084 2.244c.815-.039 1.775-.351 1.814-.7l1.334-22.359-7.279-.017z"
            fill="#383736"
        />
        <path
            d="M602.34 895.66c-.775.8-1.077 1.686-1.077 4.5l.269 12.8a1.8 1.8 0 0 0 .855 1.888c.212.126.448.206.692.237a7.83 7.83 0 0 0 4.038-.006c.727-.241 4.535-2 4.535-3.023l.031-14.444c-.118-4.885-2.9-5.914-2.9-5.914l-3.344 1.17-3.099 2.792z"
            fill="#4D6B89"
        />
        <path
            d="M608.13 890.73c.471-.113.59-.032.681.256.055.196.121.388.2.576.089.226-.018.241-.018.241a16.055 16.055 0 0 0-4.112 1.846c-1.247.849-1.345.93-1.345.93l.293-.956a4.28 4.28 0 0 1 2.577-2.243c.56-.253 1.136-.47 1.724-.65z"
            fill="#E4EFF4"
        />
        <path
            d="m590.33 903.52.393-1.691-.191-.415-2.407-.8-2.706.016s-.551 0-.551.4c0 .215.518.252 1.653.215.536-.015.351.353.351.353a3.516 3.516 0 0 0 0 1.956c.1.191.262.341.46.425a.927.927 0 0 0 .625.039c.054-.02.052-.213.052-.213 1.119.316 2.18.471 2.321-.285z"
            fill="#FFE8D9"
        />
        <path
            d="M602.98 886.23a1.013 1.013 0 0 1 .783.716 1.18 1.18 0 0 1-.081.967 1.03 1.03 0 0 1-.479.386s-.034-1.11-.051-1.313a7.308 7.308 0 0 0-.172-.756z"
            fill="#EFCFBD"
        />
        <path
            d="M602.71 886.01s-.327 0-.077.453c.186.303.298.645.328 1 .018.236-.014.961-.014.961s.213.284.399-.159c.107-.363.141-.743.101-1.119-.011-.215-.388-1.255-.737-1.136z"
            fill="#FFE8D9"
        />
        <path
            d="M589.33 902.69c-.045.56.049 1.121.272 1.635 0 0 5.354 1.014 6.08 1.132a3.929 3.929 0 0 0 2.51-.334c1.787-.7 5.565-4.112 5.565-4.112s2.723-2.177 1.861-4.4a2.25 2.25 0 0 0-3.766-.5c-.988 1.037-3.243 3.552-4.51 4.8a2.148 2.148 0 0 1-1.774.61l-5.011-.327a.848.848 0 0 0-.866.23 2.45 2.45 0 0 0-.361 1.266z"
            fill="#688CAA"
        />
        <path
            d="M598.62 894.61a.077.077 0 0 0 .042-.064v-1.642a.069.069 0 0 1-.012.039.072.072 0 0 1-.03.027v1.64z"
            fill="#49240B"
        />
        <path
            d="M590.51 888.7v1.623l7.76 4.482v-1.621l-7.76-4.484z"
            fill="#271306"
        />
        <path
            d="m590.51 888.68 7.738 4.5.362-.211c.061-.034.061-.09 0-.121l-7.523-4.377a.254.254 0 0 0-.216 0l-.361.209z"
            fill="#271306"
        />
        <path
            d="m584.54 893.63 7.371 4.282a.36.36 0 0 0 .185.045.382.382 0 0 0 .184-.045v.354a.418.418 0 0 1-.368 0l-7.37-4.284a.144.144 0 0 1-.054-.044.128.128 0 0 1-.024-.063v-.35c.002.022.011.044.024.062s.031.033.052.043z"
            fill="#532C12"
        />
        <path
            d="M584.54 893.41a.107.107 0 0 0-.055.041c-.014.019-.021.042-.021.065s.007.046.021.065a.113.113 0 0 0 .055.041l7.371 4.282a.394.394 0 0 0 .369 0l5.971-3.447-7.738-4.5-5.973 3.453z"
            fill="#451E03"
        />
        <path
            d="M592.13 896.58v1.235l5.922-3.464v-1.234l-5.922 3.463z"
            fill="#B1B2B4"
        />
        <path
            d="M584.86 892.51v1.107l7.263 4.2v-1.235l-7.263-4.072z"
            fill="#C6C7C9"
        />
        <path
            d="m592.19 896.52 5.692-3.354-5.858-3.348-5.861 3.362 6.027 3.34z"
            fill="#7B7C7D"
        />
        <path
            d="M598.25 893.63c0-.01-.003-.02-.008-.028a.045.045 0 0 0-.021-.02.057.057 0 0 0-.056.001l-5.886 3.4v-.353l6.337-3.662v1.64l-6.336 3.656v-.358l5.922-3.421a.088.088 0 0 0 .037-.032.087.087 0 0 0 .012-.047l-.001-.776z"
            fill="#391F0C"
        />
        <path
            d="m584.54 892.34 7.371 4.283a.417.417 0 0 0 .369 0v.352a.407.407 0 0 1-.366.002l-7.37-4.284c-.05-.03-.078-.065-.078-.1v-.354a.136.136 0 0 0 .074.101z"
            fill="#532C12"
        />
        <path
            d="M584.54 892.13a.106.106 0 0 0-.055.04.113.113 0 0 0 .055.172l7.373 4.283a.427.427 0 0 0 .366 0l5.974-3.447-7.738-4.5-5.975 3.452z"
            fill="#5C3114"
        />
        <path
            d="m593.83 896.36-.557.344 1.068.613-.2-.449.616.079-.927-.587z"
            fill="#FC6363"
        />
        <path
            d="m594.14 896.87.616.079v.086l-.578-.074-.038-.091zM594.34 897.32v.086l-1.068-.613v-.086l1.068.613z"
            fill="#E53535"
        />
        <path
            d="m481.06 882.81-1.367-.792.386-.221 1.366.793-.385.22z"
            fill="#606060"
        />
        <path
            d="m480.15 882.9-1.365-.793a.91.91 0 0 0 .913-.087l1.367.792a.91.91 0 0 1-.915.088zM479.76 883.57l-1.364-.795a1.275 1.275 0 0 1-.536-1.172l1.366.793a1.287 1.287 0 0 0 .534 1.174z"
            fill="#606060"
        />
        <path d="m479.22 882.39-1.365-.793v-.9l1.366.793-.001.9z" fill="#606060" />
        <path
            d="m479.22 881.49-1.366-.793.55-.317 1.366.793-.55.317z"
            fill="#2B2B2B"
        />
        <path
            d="M479.77 881.17v.9c0 .817.58 1.144 1.288.736l.385-.22v.633l-.385.214c-1.009.585-1.838.118-1.839-1.044v-.9l.551-.319z"
            fill="#272727"
        />
        <path
            d="M481.95 881.57a.235.235 0 0 0-.1.215v1.556l1.98-1.15v-1.558a.222.222 0 0 1 .021-.119.222.222 0 0 1 .079-.093l-1.98 1.149z"
            fill="#818182"
        />
        <path
            d="M482.37 867.51a2.634 2.634 0 0 1 1.219 2.482l-.252 1.077c-.124.522-.185 4.085-.187 4.693l-.017 5.624c0 .421-.3.59-.662.378l-.287-.165c-.184-.1-.332-.022-.332.19v1.556l-6.4-3.694a.327.327 0 0 1-.162-.281v-1.369a.713.713 0 0 0-.329-.571l-.285-.164a1.466 1.466 0 0 1-.661-1.142l.016-5.627c0-.608-.058-4.243-.177-4.9l-.245-1.365c-.183-1.013.416-1.537 1.231-1.068l7.53 4.346z"
            fill="#ADADAD"
        />
        <path
            d="m484.35 866.35-7.531-4.346a.888.888 0 0 0-.894-.09l-1.979 1.151a.89.89 0 0 1 .9.089l7.529 4.348a2.634 2.634 0 0 1 1.219 2.482l-.252 1.077c-.124.522-.185 4.085-.187 4.693l-.017 5.624a.458.458 0 0 1-.191.423l1.98-1.149a.46.46 0 0 0 .194-.424l.014-5.628c0-.6.065-4.169.187-4.69l.251-1.075a2.644 2.644 0 0 0-1.223-2.485z"
            fill="#969696"
        />
        <path
            d="m533.89 918.78-1.365-.793.385-.218 1.364.793-.384.218z"
            fill="#606060"
        />
        <path
            d="m532.98 918.86-1.363-.795a.893.893 0 0 0 .912-.088l1.366.793a.91.91 0 0 1-.915.09zM532.59 919.54l-1.365-.801a1.272 1.272 0 0 1-.535-1.172l1.366.791a1.293 1.293 0 0 0 .534 1.178v.004z"
            fill="#606060"
        />
        <path d="m532.05 918.36-1.365-.79v-.906l1.365.795v.901z" fill="#606060" />
        <path
            d="m532.05 917.46-1.365-.795.549-.315 1.365.792-.549.318z"
            fill="#2B2B2B"
        />
        <path
            d="M532.6 917.14v.906c0 .81.58 1.14 1.289.731l.383-.217v.632l-.386.217c-1.007.582-1.833.114-1.837-1.05v-.9l.551-.319z"
            fill="#272727"
        />
        <path
            d="M534.78 917.54a.227.227 0 0 0-.1.212l-.006 1.558 1.981-1.152v-1.557a.237.237 0 0 1 .023-.12.243.243 0 0 1 .077-.094l-1.975 1.153z"
            fill="#818182"
        />
        <path
            d="M535.2 903.47a2.643 2.643 0 0 1 1.218 2.483l-.251 1.077c-.122.516-.188 4.084-.188 4.69l-.018 5.625c0 .42-.3.587-.664.378l-.284-.166c-.183-.107-.331-.02-.331.19l-.006 1.558-6.4-3.7a.334.334 0 0 1-.161-.28v-1.374a.711.711 0 0 0-.332-.568l-.283-.164a1.466 1.466 0 0 1-.661-1.143l.015-5.625c0-.607-.056-4.243-.173-4.905l-.247-1.361c-.182-1.013.415-1.539 1.23-1.071l7.536 4.356z"
            fill="#ADADAD"
        />
        <path
            d="m537.18 902.32-7.531-4.347a.86.86 0 0 0-.891-.084l-1.982 1.146a.897.897 0 0 1 .895.087l7.531 4.351a2.643 2.643 0 0 1 1.218 2.483l-.251 1.077c-.122.516-.188 4.084-.188 4.69l-.018 5.625a.464.464 0 0 1-.19.424l1.978-1.149a.463.463 0 0 0 .192-.425l.019-5.626c0-.6.061-4.172.186-4.689l.254-1.077a2.634 2.634 0 0 0-1.222-2.486z"
            fill="#969696"
        />
        <path
            d="M498.36 915.42a1.954 1.954 0 0 0-.886 1.533c0 .565.4.793.892.507a1.948 1.948 0 0 0 .887-1.531c-.002-.566-.402-.794-.893-.509zm0 1.639c-.295.169-.537.033-.539-.3a1.182 1.182 0 0 1 .537-.929c.295-.173.537-.035.538.309a1.183 1.183 0 0 1-.532.92h-.004z"
            fill="#3B3B3B"
        />
        <path
            d="M498.36 915.83c.295-.173.537-.035.538.309a1.166 1.166 0 0 1-.536.925c-.295.169-.537.033-.539-.3a1.19 1.19 0 0 1 .537-.934z"
            fill="#747474"
        />
        <path
            d="M498.25 914.93a.638.638 0 0 0-.633.061 1.941 1.941 0 0 0-.883 1.535.614.614 0 0 0 .257.569l.739.432a.631.631 0 0 1-.259-.572 1.965 1.965 0 0 1 .886-1.533.63.63 0 0 1 .634-.062l-.741-.43z"
            fill="#4C4C4C"
        />
        <path
            d="M511.32 907.94a1.957 1.957 0 0 0-.886 1.532c0 .564.4.792.892.507a1.95 1.95 0 0 0 .885-1.532c0-.565-.402-.79-.891-.507zm0 1.637c-.294.169-.534.033-.534-.3a1.171 1.171 0 0 1 .532-.93c.3-.167.538-.035.539.307a1.17 1.17 0 0 1-.535.923h-.002z"
            fill="#3B3B3B"
        />
        <path
            d="M511.32 908.34c.3-.167.538-.035.539.307a1.183 1.183 0 0 1-.537.928c-.294.169-.534.033-.534-.3a1.168 1.168 0 0 1 .532-.935z"
            fill="#747474"
        />
        <path
            d="M511.22 907.45a.623.623 0 0 0-.632.064 1.938 1.938 0 0 0-.885 1.532.624.624 0 0 0 .258.569l.739.431a.626.626 0 0 1-.259-.571 1.956 1.956 0 0 1 .886-1.532.63.63 0 0 1 .629-.062l-.736-.431z"
            fill="#4C4C4C"
        />
        <path
            d="M510.77 915.24a.633.633 0 0 0-.634-.062c-.063.036-.12.072-.185.1-.086.054-.171.1-.259.152s-.195.115-.3.173a.613.613 0 0 1 .632.062c.108.064.206.142.294.232l-.294.172a1.199 1.199 0 0 1 .535.926.385.385 0 0 1-.159.346l.5-.29c.007.049.01.098.011.147a.619.619 0 0 1-.259.57l.742-.431a.616.616 0 0 0 .259-.567 1.952 1.952 0 0 0-.883-1.53z"
            fill="#3B3B3B"
        />
        <path
            d="m509.65 916.04.741-.429a.363.363 0 0 0-.157.343 1.186 1.186 0 0 0 .534.928l-.739.428a1.174 1.174 0 0 1-.533-.925.365.365 0 0 1 .03-.193.367.367 0 0 1 .124-.152z"
            fill="#4C4C4C"
        />
        <path
            d="M510.03 915.67c-.489-.285-.889-.055-.889.507a1.936 1.936 0 0 0 .884 1.534c.491.284.89.056.89-.508a1.95 1.95 0 0 0-.885-1.533zm0 1.637a1.165 1.165 0 0 1-.533-.925c0-.34.24-.48.536-.308a1.193 1.193 0 0 1 .535.926c-.005.342-.247.478-.541.307h.003z"
            fill="#4C4C4C"
        />
        <path
            d="M510.03 916.07c-.3-.172-.536-.032-.536.308a1.164 1.164 0 0 0 .533.925c.294.171.536.035.538-.307a1.186 1.186 0 0 0-.535-.926z"
            fill="#7B7B7B"
        />
        <path
            d="M497.81 907.76a.634.634 0 0 0-.633-.064c-.064.036-.124.074-.187.109-.083.051-.174.1-.259.152l-.294.169a.638.638 0 0 1 .63.063c.11.064.21.143.3.234l-.3.171a1.193 1.193 0 0 1 .536.925.378.378 0 0 1-.158.345l.5-.286c.005.049.009.098.01.147a.615.615 0 0 1-.258.568l.741-.432a.624.624 0 0 0 .258-.568 1.965 1.965 0 0 0-.886-1.533z"
            fill="#3B3B3B"
        />
        <path
            d="M497.06 908.18c-.492-.283-.888-.057-.889.508.016.307.105.607.259.873.153.267.368.494.626.662.491.283.89.055.891-.507a1.955 1.955 0 0 0-.887-1.536zm0 1.64a1.192 1.192 0 0 1-.532-.928c0-.341.239-.476.536-.307a1.183 1.183 0 0 1 .536.925c-.01.34-.247.482-.544.31h.004z"
            fill="#4C4C4C"
        />
        <path
            d="M497.06 908.59c-.3-.169-.536-.034-.536.307a1.19 1.19 0 0 0 .532.928c.3.172.538.03.54-.31a1.183 1.183 0 0 0-.536-.925z"
            fill="#7B7B7B"
        />
        <path
            d="m511.31 906.73-6.079 3.531v1.173l6.076-3.53a.444.444 0 0 0 .255-.361v-1.172a.441.441 0 0 1-.252.359z"
            fill="#303030"
        />
        <path
            d="M496.61 906.73a.442.442 0 0 1-.26-.363v1.173a.44.44 0 0 0 .261.364l6.117 3.53v-1.171l-6.118-3.533z"
            fill="#3E3E3E"
        />
        <path
            d="M511.3 906.01a1.373 1.373 0 0 0-1.248 0l-6.078 3.532v.246l6.521-3.789a.381.381 0 0 1 .357 0 .114.114 0 0 1 .052.04.112.112 0 0 1 0 .127.114.114 0 0 1-.052.04l-6.519 3.792.889.266 6.079-3.531a.383.383 0 0 0-.001-.723z"
            fill="#414141"
        />
        <path
            d="M497.06 906a.39.39 0 0 1 .36 0l6.563 3.789v-.246l-6.118-3.534a1.38 1.38 0 0 0-1.248 0 .376.376 0 0 0-.187.139.377.377 0 0 0 0 .444.383.383 0 0 0 .187.14l6.117 3.533.894-.268-6.565-3.792c-.101-.056-.101-.148-.003-.205z"
            fill="#494949"
        />
        <path
            d="M510.86 906c.022.008.04.022.053.04a.112.112 0 0 1 0 .127.112.112 0 0 1-.053.04l-6.519 3.792 6.563 3.788c.1.057.1.15 0 .2a.365.365 0 0 1-.355 0l-6.567-3.787-6.517 3.787a.376.376 0 0 1-.361 0c-.1-.055-.1-.146 0-.2l6.522-3.788-6.565-3.792c-.1-.058-.1-.15 0-.207a.392.392 0 0 1 .36 0l6.563 3.789 6.521-3.789a.381.381 0 0 1 .355 0z"
            fill="#303030"
        />
        <path
            d="M511.35 914.52a1.365 1.365 0 0 1-1.248 0l-6.119-3.53v1.173l6.118 3.533a1.37 1.37 0 0 0 1.248 0 .45.45 0 0 0 .257-.361v-1.174a.425.425 0 0 1-.256.359z"
            fill="#3E3E3E"
        />
        <path
            d="m511.35 913.8-6.12-3.534-.889-.266 6.563 3.788c.1.057.1.15 0 .2a.365.365 0 0 1-.355 0l-6.567-3.787v.785l6.119 3.53a1.356 1.356 0 0 0 1.248 0 .38.38 0 0 0 .001-.716zM503.98 910.21l-6.517 3.787a.376.376 0 0 1-.361 0c-.1-.055-.1-.146 0-.2l6.522-3.788-.894.268-6.075 3.532a.386.386 0 0 0-.258.36.383.383 0 0 0 .258.361 1.376 1.376 0 0 0 1.251 0l6.075-3.53-.001-.79z"
            fill="#4C4C4C"
        />
        <path
            d="M497.91 914.52a1.369 1.369 0 0 1-1.251 0 .44.44 0 0 1-.259-.364v1.173a.455.455 0 0 0 .08.219.455.455 0 0 0 .18.148 1.368 1.368 0 0 0 1.247 0l6.078-3.532v-1.173l-6.075 3.529zM505.08 907.11a.546.546 0 0 0-.312-.444 1.693 1.693 0 0 0-1.553-.015.552.552 0 0 0-.332.452l-.008 3.064a.501.501 0 0 0 .01.066.385.385 0 0 0 .008.049c.008.026.02.05.034.073.009.014.014.031.024.047a.485.485 0 0 0 .065.071c.01.014.021.028.033.04.043.037.089.07.137.1a1.72 1.72 0 0 0 1.552.014.85.85 0 0 0 .145-.1c.013-.012.02-.023.032-.036a.62.62 0 0 0 .071-.074.223.223 0 0 0 .024-.049.352.352 0 0 0 .035-.07.125.125 0 0 0 .012-.054.496.496 0 0 0 .013-.067v-.005c.002-.921.005-2.146.01-3.062z"
            fill="#303030"
        />
        <path
            d="M504.38 904.39a.888.888 0 0 0-.79-.01.284.284 0 0 0-.169.231l-.005 2.291c0 .011.002.021.005.031a.15.15 0 0 0 0 .03l.019.034.005.016.037.042.019.022c.022.02.045.037.07.052a.87.87 0 0 0 .788.007.361.361 0 0 0 .091-.069l.035-.037a.08.08 0 0 0 .011-.027.12.12 0 0 0 .021-.034l.005-.028v-2.322a.272.272 0 0 0-.142-.229z"
            fill="#969696"
        />
        <path
            d="m496.67 899.42 7.159-4.121a.685.685 0 0 1 .682-.071l8.064 4.65a.671.671 0 0 0-.681.068l-7.158 4.121a2.094 2.094 0 0 0-.955 1.653.668.668 0 0 0 .279.613c-1.989-1.155-6.075-3.49-8.065-4.647a.673.673 0 0 1-.279-.615 2.105 2.105 0 0 1 .954-1.651z"
            fill="silver"
        />
        <path
            d="M504.73 904.06a2.085 2.085 0 0 0-.955 1.653c0 .608.43.85.959.549l7.159-4.125a2.103 2.103 0 0 0 .957-1.652c0-.609-.432-.854-.962-.546l-7.158 4.121z"
            fill="#ADADAD"
        />
        <path
            d="m500.66 902.85-1.361-.793.385-.219 1.366.793-.39.219zM499.75 902.94l-1.365-.794a.884.884 0 0 0 .467.082.884.884 0 0 0 .444-.169l1.365.792a.903.903 0 0 1-.911.089zM499.36 903.61l-1.365-.792a1.282 1.282 0 0 1-.534-1.173l1.364.789a1.279 1.279 0 0 0 .535 1.176z"
            fill="#606060"
        />
        <path d="m498.82 902.43-1.364-.79v-.9l1.364.793v.897z" fill="#606060" />
        <path
            d="m498.82 901.53-1.364-.793.549-.319 1.364.8-.549.312z"
            fill="#2B2B2B"
        />
        <path
            d="M499.36 901.22v.9c0 .811.581 1.142 1.289.731l.386-.217v.632l-.387.218c-1.008.582-1.834.115-1.838-1.05l-.005-.9.555-.314z"
            fill="#272727"
        />
        <path
            d="M501.55 901.61a.225.225 0 0 0-.1.21v1.558l1.981-1.148v-1.558a.236.236 0 0 1 .1-.213l-1.981 1.151z"
            fill="#818182"
        />
        <path
            d="M501.96 887.55a2.646 2.646 0 0 1 1.222 2.484l-.255 1.076c-.12.519-.186 4.085-.187 4.69l-.016 5.627c0 .418-.3.589-.664.377l-.286-.165c-.182-.1-.332-.021-.332.187v1.558l-6.4-3.693a.32.32 0 0 1-.163-.28l.006-1.368a.738.738 0 0 0-.33-.574l-.287-.165a1.46 1.46 0 0 1-.658-1.141l.013-5.627c0-.608-.055-4.242-.176-4.9l-.245-1.363c-.183-1.016.418-1.54 1.231-1.071l7.527 4.348z"
            fill="#ADADAD"
        />
        <path
            d="m503.94 886.4-7.53-4.347a.877.877 0 0 0-.9-.089l-1.975 1.15a.885.885 0 0 1 .894.088l7.529 4.348a2.64 2.64 0 0 1 1.222 2.484l-.255 1.076c-.12.519-.186 4.085-.187 4.69l-.016 5.627a.454.454 0 0 1-.192.423l1.981-1.152a.461.461 0 0 0 .19-.424l.018-5.624c0-.606.062-4.172.187-4.691l.253-1.077a2.625 2.625 0 0 0-1.219-2.482z"
            fill="#969696"
        />
        <path
            d="m448.9 820.24.014 5.131-4.465 2.578-.015-5.131 2-1.151.476-.275 1.99-1.152z"
            fill="#F72585"
        />
        <path
            d="m443.13 821.92 3.775-2.178.006 1.643-.476.275v-1.114l-3.3 1.906-.005-.532z"
            fill="#496876"
        />
        <path
            d="M443.13 821.66v1.161l-1.011.584v-1.158l.247-.144.475-.273.289-.17z"
            fill="#496876"
        />
        <path
            d="M442.36 822.11v-.972l.474-.272v.971l-.474.273zM437.85 826.62l-.006-1.645 4.271-2.465v.529l-3.795 2.192v1.115l-.47.274z"
            fill="#496876"
        />
        <path
            d="m440.32 825.19.015 5.13-2 1.154-.463.267-2 1.155-.016-5.129 2-1.153.476-.272 1.988-1.152zM444.88 814.55l.017 5.129-2.059 1.188-.474.272-1.933 1.116-.013-5.128 1.881-1.087.462-.267 2.119-1.223z"
            fill="#331083"
        />
        <path
            d="m438.57 816.59 4.188-2.417v1.6l-.462.267v-1.062l-3.723 2.151-.003-.539zM438.56 816.27v1.161l-1.01.582v-1.16l.272-.156.462-.267.276-.16z"
            fill="#496876"
        />
        <path
            d="M437.83 816.7v-.7l.46-.267v.7l-.46.267zM434.2 825.84v1.759l-4.475 2.583v1.115l-.461.267v-1.647l4.474-2.58v-1.23l.462-.267z"
            fill="#496876"
        />
        <path
            d="m431.74 830.15.014 5.131-4.456 2.577-.017-5.131 2-1.154.461-.267 1.998-1.156z"
            fill="#331083"
        />
        <path
            d="M433.72 820.99v-1.594l3.845-2.222v.532l-3.384 1.954v1.06l-.461.27z"
            fill="#496876"
        />
        <path
            d="m436.18 819.57.015 5.127-1.991 1.15-.463.268-2.012 1.162-.014-5.129 2-1.155.463-.269 2.002-1.154z"
            fill="#F72585"
        />
        <path
            d="m440.28 809.45.014 5.128-2 1.157-.46.267-2 1.155-.015-5.128 4.461-2.579z"
            fill="#331083"
        />
        <path
            d="m628.23 415.6-3.521-2.046 12.241-21.3 3.521 2.046-12.241 21.3zM636.71 392.17l-3.521-2.046 13.633-12.139 3.521 2.046-13.633 12.139z"
            fill="#9CB5CC"
        />
        <path
            d="m611.3 417.54-3.521-2.046 16.937-1.94 3.521 2.046-16.937 1.94z"
            fill="#9CB5CC"
        />
        <path
            d="m588.1 457.7-3.521-2.046 23.2-40.166 3.521 2.046-23.2 40.166z"
            fill="#9CB5CC"
        />
        <path
            d="m636.71 392.17 13.633-12.139-3.568 17.8-3.768-2.129-13.895 24.177-16.953 1.949-21.533 37.31-2.52-1.436 23.2-40.166 16.937-1.94 12.241-21.3-3.774-2.126z"
            fill="#F8F9FC"
        />
        <path
            d="m602 406.69-.009 3.054-1.165.677.009-3.055 1.165-.676z"
            fill="#F72585"
        />
        <path
            d="m600.83 407.36-.009 3.055-2.631 1.529.009-3.055 2.631-1.529z"
            fill="#C38E0F"
        />
        <path
            d="m602 406.69-1.165.677-2.63 1.529-1.173.681-10.686-6.17 4.968-2.887L602 406.69z"
            fill="#F856A0"
        />
        <path
            d="m598.2 408.89-.009 3.055-1.173.681.009-3.055 1.173-.681z"
            fill="#F72585"
        />
        <path
            d="m597.03 409.58-.009 3.055-10.686-6.17.009-3.055 10.686 6.17z"
            fill="#D3176D"
        />
        <path
            d="m601.01 410.51-.009 3.055-2.809-1.622.009-3.055 2.809 1.622z"
            fill="#013046"
        />
        <path
            d="m603.64 408.99-.008 3.054a9.59 9.59 0 0 0-2.632 1.528l.008-3.055a9.624 9.624 0 0 1 2.632-1.526v-.001z"
            fill="#024462"
        />
        <path
            d="M603.64 408.99a9.639 9.639 0 0 0-2.632 1.526l-2.81-1.622 2.631-1.528 2.811 1.624z"
            fill="#024462"
        />
        <path
            d="m617.28 413.9-.008 3.054a3.939 3.939 0 0 0-2.309-3.216 9.574 9.574 0 0 0-2.736-1.026l-.089-.019-.068-.014c-.3-.062-.617-.115-.938-.155l-.05-.007a13.535 13.535 0 0 0-.838-.077 11.591 11.591 0 0 0-6.286 1.284 4.172 4.172 0 0 0-2.26 2.759 2.616 2.616 0 0 0-.039.451l.008-3.055c.001-.151.014-.301.039-.449a4.18 4.18 0 0 1 2.26-2.759 11.588 11.588 0 0 1 6.288-1.285l.237.017c.2.015.4.036.6.06l.05.007c.321.041.634.093.938.155l.068.015.089.018a9.644 9.644 0 0 1 2.736 1.026 3.942 3.942 0 0 1 2.309 3.217l-.001-.001zM619.74 413.91l-.008 3.055a3.592 3.592 0 0 1-.051.585l.008-3.055c.034-.193.051-.389.051-.585z"
            fill="#BE8A0E"
        />
        <path
            d="m617.28 413.9-.008 3.054a2.73 2.73 0 0 1-.04.451 4.19 4.19 0 0 1-2.257 2.757 10.841 10.841 0 0 1-4.7 1.282c-.527.031-1.056.031-1.583 0a10.845 10.845 0 0 1-4.732-1.3 3.939 3.939 0 0 1-2.305-3.213l.008-3.055a3.941 3.941 0 0 0 2.305 3.213 10.857 10.857 0 0 0 4.734 1.3c.527.03 1.055.03 1.582 0a10.843 10.843 0 0 0 4.7-1.284 4.175 4.175 0 0 0 2.257-2.757c.026-.149.04-.299.04-.449l-.001.001z"
            fill="#40A19E"
        />
        <path
            d="m617.28 413.9-.008 3.054a2.73 2.73 0 0 1-.04.451 4.19 4.19 0 0 1-2.257 2.757 10.841 10.841 0 0 1-4.7 1.282c-.527.031-1.056.031-1.583 0a10.845 10.845 0 0 1-4.732-1.3 3.939 3.939 0 0 1-2.305-3.213l.008-3.055a3.941 3.941 0 0 0 2.305 3.213 10.857 10.857 0 0 0 4.734 1.3c.527.03 1.055.03 1.582 0a10.843 10.843 0 0 0 4.7-1.284 4.175 4.175 0 0 0 2.257-2.757c.026-.149.04-.299.04-.449l-.001.001z"
            fill="#40A19E"
        />
        <path
            d="m617.28 413.9-.008 3.054a2.73 2.73 0 0 1-.04.451 4.19 4.19 0 0 1-2.257 2.757 10.841 10.841 0 0 1-4.7 1.282c-.527.031-1.056.031-1.583 0a10.845 10.845 0 0 1-4.732-1.3 3.939 3.939 0 0 1-2.305-3.213l.008-3.055a3.941 3.941 0 0 0 2.305 3.213 10.857 10.857 0 0 0 4.734 1.3c.527.03 1.055.03 1.582 0a10.843 10.843 0 0 0 4.7-1.284 4.175 4.175 0 0 0 2.257-2.757c.026-.149.04-.299.04-.449l-.001.001z"
            fill="#40A19E"
        />
        <path
            d="M619.69 414.49c-.561 3.264-5.588 5.64-11.217 5.309a14.263 14.263 0 0 1-6.212-1.708c-2.115-1.221-3.3-2.961-2.983-4.811a4.735 4.735 0 0 1 1.736-2.763 9.69 9.69 0 0 1 2.632-1.526 16.203 16.203 0 0 1 6.842-1.016c2.178.089 4.307.674 6.223 1.711 2.113 1.218 3.298 2.955 2.979 4.804zm-9.4 3.9a10.826 10.826 0 0 0 4.7-1.284 4.156 4.156 0 0 0 2.257-2.757c.245-1.411-.658-2.736-2.269-3.666a9.694 9.694 0 0 0-2.736-1.026l-.089-.018-.068-.015a12.653 12.653 0 0 0-.938-.155l-.05-.007c-.2-.024-.4-.044-.6-.06l-.237-.017a11.608 11.608 0 0 0-6.288 1.285 4.196 4.196 0 0 0-2.26 2.759c-.244 1.408.657 2.734 2.266 3.662a10.83 10.83 0 0 0 4.734 1.3c.527.031 1.056.031 1.582 0l-.004-.001z"
            fill="#F856A0"
        />
        <path
            d="M614.98 410.68c1.611.93 2.515 2.255 2.269 3.666a4.19 4.19 0 0 1-2.257 2.757 10.847 10.847 0 0 1-4.7 1.284c-.527.03-1.056.03-1.582 0a10.85 10.85 0 0 1-4.734-1.3c-1.609-.929-2.51-2.254-2.266-3.662a4.178 4.178 0 0 1 2.26-2.759 11.586 11.586 0 0 1 6.288-1.285l.237.017c.2.015.4.036.6.06l.05.007c.321.041.634.093.938.155l.068.015.089.018c.96.201 1.883.548 2.74 1.027z"
            fill="#4CC9F0"
        />
        <path
            d="m619.69 414.49-.008 3.055c-.561 3.264-5.588 5.64-11.218 5.308a14.28 14.28 0 0 1-6.212-1.706c-1.889-1.091-3.037-2.6-3.033-4.227l.008-3.055c0 1.63 1.144 3.136 3.034 4.226a14.255 14.255 0 0 0 6.212 1.708c5.629.331 10.656-2.045 11.217-5.309z"
            fill="#F72585"
        />
        <path
            d="m651.69 453.85-10.564-6.139-.111-39.294 10.564 6.139.111 39.294z"
            fill="#D3176D"
        />
        <path
            d="m651.57 414.56-10.564-6.139 11.388-6.575 10.564 6.139-11.388 6.575z"
            fill="#F856A0"
        />
        <path
            d="m662.96 407.98.111 39.295-11.388 6.575-.111-39.295 11.388-6.575z"
            fill="#F72585"
        />
        <path
            d="m637.23 462.19-10.564-6.139-.068-23.982 10.564 6.139.068 23.982z"
            fill="#65149A"
        />
        <path
            d="m637.17 438.21-10.564-6.139 11.388-6.575 10.564 6.139-11.388 6.575z"
            fill="#9133D0"
        />
        <path
            d="m648.55 431.64.068 23.982-11.388 6.575-.068-23.982 11.388-6.575z"
            fill="#7217B7"
        />
        <path
            d="m622.78 470.54-10.564-6.139-.086-30.378 10.564 6.139.086 30.378z"
            fill="#8CC149"
        />
        <path
            d="m622.7 440.16-10.564-6.139 11.4-6.58 10.557 6.139-11.393 6.58z"
            fill="#C7F08F"
        />
        <path
            d="m634.1 433.58.086 30.378-11.4 6.58-.086-30.378 11.4-6.58z"
            fill="#AAD86F"
        />
        <path
            d="m608.34 478.71-10.563-6.14-.048-16.751 10.564 6.139.047 16.752z"
            fill="#3581D9"
        />
        <path
            d="m608.29 461.95-10.564-6.139 11.388-6.575 10.56 6.144-11.384 6.57z"
            fill="#4CC9F0"
        />
        <path
            d="m619.68 455.38.048 16.752-11.388 6.575-.048-16.752 11.388-6.575z"
            fill="#4895EF"
        />
        <path
            d="M511.76 509.81v-31.153l26.878 15.408v31.153L511.76 509.81z"
            fill="#DEDDE2"
        />
        <path
            d="M565.52 509.81v-31.153l-26.878 15.408v31.153l26.878-15.408z"
            fill="#ADABB9"
        />
        <path
            d="m538.64 463.25-26.878 15.407 26.878 15.408 26.877-15.408-26.877-15.407z"
            fill="#E3DAD7"
        />
        <path
            d="M511.76 478.77v-31.153l26.878 15.408v31.145l-26.878-15.4z"
            fill="#DEDDE2"
        />
        <path
            d="M565.52 478.77v-31.153l-26.878 15.408v31.145l26.878-15.4z"
            fill="#ADABB9"
        />
        <path
            d="m538.64 432.2-26.878 15.408 26.878 15.408 26.877-15.408L538.64 432.2z"
            fill="#D7D6DD"
        />
        <path
            d="M549.58 469.65v-5.372l6.533-3.772v5.372l5.151-2.974v6.434l-5.151 2.974v5.422l-6.533 3.771v-5.422l-5.151 2.974v-6.43l5.151-2.977zM528.16 469.65v-5.372l-6.533-3.772v5.372l-5.151-2.974v6.434l5.151 2.974v5.422l6.533 3.771v-5.422l5.151 2.974v-6.43l-5.151-2.977z"
            fill="#4361EE"
        />
        <path
            d="m534.79 492.42-19.236-10.947.008 25.45 19.228 10.942V492.42z"
            fill="#ADABB9"
        />
        <path
            d="m516.43 506.44 18.354 10.44v-24.467l-18.361-10.445.007 24.472z"
            fill="#FAF8F8"
        />
        <path
            d="m542.7 492.42 19.236-10.947-.008 25.45-19.228 10.942V492.42z"
            fill="#888595"
        />
        <path
            d="m561.06 506.44-18.354 10.44v-24.467l18.361-10.445-.007 24.472z"
            fill="#E9E5F2"
        />
        <path
            d="m538.64 432.2-26.878 15.408 26.878 15.408 26.877-15.408L538.64 432.2zm-20.991 15.408 20.991-12.034 20.991 12.034-20.991 12.033-20.991-12.033z"
            fill="#F4EFED"
        />
        <path
            d="M478.76 536.46v-23.18l20 11.465v23.18l-20-11.465z"
            fill="#DEDDE2"
        />
        <path
            d="M518.76 536.46v-23.18l-20 11.465v23.18l20-11.465z"
            fill="#ADABB9"
        />
        <path
            d="m498.76 501.81-20 11.466 20 11.464 20-11.464-20-11.466z"
            fill="#E3DAD7"
        />
        <path
            d="M478.76 513.35v-23.18l20 11.465v23.18l-20-11.465z"
            fill="#DEDDE2"
        />
        <path
            d="M518.76 513.35v-23.18l-20 11.465v23.18l20-11.465z"
            fill="#ADABB9"
        />
        <path
            d="m498.76 478.71-20 11.465 20 11.465 20-11.465-20-11.465z"
            fill="#D7D6DD"
        />
        <path
            d="M506.9 506.58v-4l4.861-2.806v4l3.832-2.213v4.786l-3.832 2.214v4.034L506.9 515.4v-4.033l-3.833 2.213v-4.784l3.833-2.216zM490.97 506.58v-4l-4.861-2.806v4l-3.832-2.213v4.786l3.832 2.214v4.034l4.861 2.805v-4.033l3.833 2.213v-4.784l-3.833-2.216z"
            fill="#4361EE"
        />
        <path
            d="m495.89 523.52-14.313-8.146.006 18.937 14.307 8.142V523.52z"
            fill="#ADABB9"
        />
        <path
            d="m482.24 533.95 13.657 7.769v-18.206l-13.662-7.771.005 18.208z"
            fill="#FAF8F8"
        />
        <path
            d="m501.78 523.52 14.313-8.146-.006 18.937-14.307 8.142V523.52z"
            fill="#888595"
        />
        <path
            d="m515.44 533.95-13.657 7.769v-18.206l13.662-7.771-.005 18.208z"
            fill="#E9E5F2"
        />
        <path
            d="m498.76 478.71-20 11.465 20 11.465 20-11.465-20-11.465zm-15.619 11.465 15.619-8.954 15.619 8.954-15.619 8.954-15.619-8.954z"
            fill="#F4EFED"
        />
        <path
            d="m678.22 410.22-.008 2.784-1.53-2.7.008-2.785 1.53 2.701z"
            fill="#1B2127"
        />
        <path d="m681.35 408.4-3.128 1.825-1.529-2.7 4.657.875z" fill="#35404D" />
        <path
            d="m681.36 408.4 7.92 4.574-3.139 1.823-7.92-4.572 3.139-1.825z"
            fill="#FBAB20"
        />
        <path
            d="m686.14 414.8-.008 2.785-7.92-4.574.008-2.781 7.92 4.57z"
            fill="#8D5700"
        />
        <path
            d="m690.02 412.9-4 2.323.124-.426 3.139-1.823.737-.074z"
            fill="#35404D"
        />
        <path
            d="m700.51 423.59-.009 2.79-14.488-8.37.008-2.784 14.489 8.364z"
            fill="#B73D34"
        />
        <path
            d="m686.02 415.22 4-2.323 14.489 8.366-4 2.322-14.489-8.365z"
            fill="#EB5A49"
        />
        <path
            d="m705.53 421.86-4 2.323-.831.483-.084.048a1.042 1.042 0 0 1-.944 0l-.884-.51-4.278-2.47-.473-.273-.059-.037a2.29 2.29 0 0 0-.918-.211 2.314 2.314 0 0 1-.817-.159.334.334 0 0 1-.112-.096.342.342 0 0 1-.058-.136c-.09-.507 1.279-.575 2.179-.286.368.125.724.285 1.061.478l.219.126 4.278 2.47.327.19.362-.211 4-2.322 1.032.593z"
            fill="#35404D"
        />
        <path
            d="m700.71 424.67-.084.048a.74.74 0 0 1-.208.08c-.026.006-.052.007-.077.011-.052.01-.105.016-.159.018h-.094a.886.886 0 0 1-.235-.042.756.756 0 0 1-.171-.066l-.884-.51-4.278-2.47-.473-.273-.059-.037a.932.932 0 0 0-.135-.065l-.029-.007a2.009 2.009 0 0 0-.324-.086l-.085-.012a4.92 4.92 0 0 0-.345-.041l-.344-.036c-.024 0-.047-.005-.07-.009a1.464 1.464 0 0 1-.402-.113.318.318 0 0 1-.17-.232.368.368 0 0 1 0-.047l-.009 2.785a.336.336 0 0 0 .063.182c.03.04.068.073.112.096a.603.603 0 0 0 .081.039l.032.007c.094.032.19.055.288.068l.076.008c.108.014.222.025.34.036s.238.025.355.043l.069.009c.113.02.223.049.33.088.057.019.112.043.164.071l.059.038.471.272 4.279 2.471.883.51a.704.704 0 0 0 .1.045.415.415 0 0 0 .077.02.886.886 0 0 0 .328.042.84.84 0 0 0 .158-.018.71.71 0 0 0 .287-.09l.082-.049.831-.483.008-2.784-.838.483z"
            fill="#1C2128"
        />
        <path
            d="m707.54 423.02-.008 2.784-.43.249.009-2.784.429-.249zM703.98 425.09l-.008 2.784-.429.25.008-2.785.429-.249z"
            fill="#731F00"
        />
        <path
            d="m703.55 425.34-.008 2.785-2.007-1.159.008-2.784 2.007 1.158z"
            fill="#B73D34"
        />
        <path
            d="m705.54 421.86 2.007 1.159-.429.249-3.138 1.824-.43.249-2.007-1.158 3.997-2.323z"
            fill="#EB5A49"
        />
        <path
            d="m707.93 423.74-.008 2.785-3.139 1.823.008-2.784 3.139-1.824z"
            fill="#1E242B"
        />
        <path
            d="m704.79 425.56-.008 2.784-.813-.47.008-2.784.813.47z"
            fill="#1D232A"
        />
        <path
            d="m707.93 423.74-3.135 1.824-.813-.47 3.138-1.824.81.47z"
            fill="#35404D"
        />
        <path d="m718.22 380.48-9.926 5.769-9.99-5.769h19.916z" fill="#D7E7F7" />
        <path
            d="m722.5 385.5-30.735 17.861-3.363-1.938 30.734-17.86 3.364 1.937zM728.93 389.21l-30.734 17.861-3.367-1.944 30.734-17.86 3.367 1.943z"
            fill="#F8F9FC"
        />
        <path
            d="m728.93 389.21-17.092 9.925-3.367-1.944 17.092-9.919 3.367 1.938zM735.2 392.83l-30.734 17.861-3.36-1.941 30.735-17.861 3.359 1.941zM733.12 402.13l-21.669 12.593-3.367-1.943 21.666-12.594 3.37 1.944z"
            fill="#35404D"
        />
        <path
            d="m718.22 380.48-9.927 5.768-9.991-5.768-25.943 15.078 44.555 25.723 35.87-20.847-34.564-19.954zm-29.818 20.943 30.735-17.861 3.365 1.942-30.736 17.861-3.364-1.942zm6.423 3.708 30.734-17.86 3.367 1.943-30.733 17.862-3.368-1.945zm6.275 3.624 30.737-17.862 3.364 1.942-30.736 17.861-3.365-1.941zm10.345 5.971-3.367-1.943 21.666-12.592 3.368 1.945-21.667 12.59z"
            fill="#F8F9FC"
        />
        <path
            d="m716.92 421.28-44.554-25.724v1.371l44.554 25.724 35.87-20.845v-1.372l-35.87 20.846z"
            fill="#D7E7F7"
        />
        <path
            d="M696 401.42c.126.07.24.16.338.267.05.056.093.12.128.188a.634.634 0 0 1 .068.385.979.979 0 0 1-.529.664 2.17 2.17 0 0 1-.468.2l-.1.027a3.08 3.08 0 0 1-1.622-.046 2.114 2.114 0 0 1-.516-.245 1.273 1.273 0 0 1-.238-.207c-.412-.461-.173-1.02.516-1.325a2.783 2.783 0 0 1 .598-.172 2.854 2.854 0 0 1 1.825.264z"
            fill="#FFBF00"
        />
        <path
            d="M701.5 401.42c.01.137.059.268.143.378l-5.107.463a.633.633 0 0 0-.068-.385l5.032-.456z"
            fill="#02567D"
        />
        <path
            d="M704.64 400.63c.129.072.244.164.343.273.458.523.1 1.165-.8 1.428a3.084 3.084 0 0 1-1.556.035 2.227 2.227 0 0 1-.585-.227 1.327 1.327 0 0 1-.399-.346.711.711 0 0 1-.143-.378c-.023-.4.345-.79 1-.983a3.049 3.049 0 0 1 1.467-.047c.236.046.463.129.673.245z"
            fill="#E54332"
        />
        <path
            d="m701.86 388.92.192.37-4.027.709a.631.631 0 0 0-.071-.395l3.906-.684z"
            fill="#02567D"
        />
        <path
            d="M697.49 389.16c.128.071.243.164.342.273a.905.905 0 0 1 .122.176c.065.12.09.259.071.395-.053.355-.409.687-1 .861a3.255 3.255 0 0 1-.336.075 3.16 3.16 0 0 1-.666.034 2.597 2.597 0 0 1-1.127-.306 1.354 1.354 0 0 1-.34-.271c-.465-.528-.108-1.169.794-1.433a2.91 2.91 0 0 1 2.14.196z"
            fill="#E54332"
        />
        <path
            d="m696.68 390.94.567 2.1a3.046 3.046 0 0 0-.661.051l-.572-2.112c.222.011.446-.002.666-.039z"
            fill="#02567D"
        />
        <path
            d="M698.46 393.34c.128.071.243.163.34.272a.674.674 0 0 1 .06.9c-.1.133-.227.244-.372.326a2.123 2.123 0 0 1-.482.2 3 3 0 0 1-1.95-.1 1.507 1.507 0 0 1-.533-.369c-.458-.524-.1-1.165.807-1.433a3.056 3.056 0 0 1 .925-.113c.422.008.835.116 1.205.317zM705.66 395.91c.096.052.182.12.255.2.342.386.072.866-.6 1.059-.16.047-.325.075-.492.084a2.318 2.318 0 0 1-.664-.061 1.678 1.678 0 0 1-.426-.167 1.054 1.054 0 0 1-.255-.2.512.512 0 0 1-.112-.532.763.763 0 0 1 .3-.345c.127-.081.264-.142.408-.181a2.135 2.135 0 0 1 1.586.143z"
            fill="#FFBF00"
        />
        <path
            d="m698.86 394.52 4.811 1.424a.758.758 0 0 0-.3.345l-4.88-1.444c.144-.083.269-.193.369-.325zM703.97 400.39a3.042 3.042 0 0 0-.66-.067l.846-3.13c.218.053.441.073.664.061l-.85 3.136z"
            fill="#02567D"
        />
        <path
            d="M692.78 396.59c.074.043.144.089.21.136.115.082.221.176.315.281.659.743.233 1.643-.934 2.09-.093.036-.19.069-.291.1s-.2.056-.308.078c-1 .223-2.047.09-2.96-.376a2.095 2.095 0 0 1-.521-.415 1.16 1.16 0 0 1-.3-.63.964.964 0 0 1 .033-.385 2.05 2.05 0 0 1 1.5-1.182 4.572 4.572 0 0 1 3 .167c.082.043.171.088.256.136z"
            fill="#134663"
        />
        <path
            d="M695.6 394.66a1.483 1.483 0 0 0 .451.285l-3.062 1.776a2.799 2.799 0 0 0-.478-.272l3.089-1.789zM693.86 401.22a2.33 2.33 0 0 0-.284.1l-.854-.968-.956-1.084c.1-.023.207-.048.308-.078s.2-.062.291-.1l1.808 2.053a2.75 2.75 0 0 0-.313.077z"
            fill="#02567D"
        />
        <path
            d="M702.49 388.69a.847.847 0 0 1 .227.181c.307.342.072.764-.525.937a1.887 1.887 0 0 1-1.393-.126.924.924 0 0 1-.227-.181c-.307-.342-.072-.764.525-.937a1.886 1.886 0 0 1 1.393.126z"
            fill="#E54332"
        />
        <path
            d="m732.4 363.59 42.8 24.875a7.903 7.903 0 0 0 7.146 0l32.217-18.6a2.53 2.53 0 0 0 1.485-2.084l.007 2.9a2.52 2.52 0 0 1-1.485 2.084l-32.215 18.6a7.912 7.912 0 0 1-7.147 0l-42.8-24.875a2.49 2.49 0 0 1-1.461-2.055l-.008-2.9a2.49 2.49 0 0 0 1.461 2.055z"
            fill="#134663"
        />
        <path
            d="M732.43 359.45c-1.97 1.138-1.982 3-.024 4.14l42.8 24.875a7.91 7.91 0 0 0 7.147 0l32.216-18.6c1.97-1.137 1.981-3 .023-4.139l-42.8-24.875a7.892 7.892 0 0 0-7.146 0L732.43 359.45z"
            fill="#02567D"
        />
        <path
            d="m756.67 347.29.008 2.816 1.132.658-.008-2.817-1.132-.657z"
            fill="#919191"
        />
        <path
            d="m757.8 347.95.008 2.816a.526.526 0 0 1 .305.43l-.007-2.816a.532.532 0 0 0-.306-.43z"
            fill="#BFBFBF"
        />
        <path
            d="m746.96 348.65.007 2.816a.657.657 0 0 1 .383-.534 2.022 2.022 0 0 1 1.825 0 .654.654 0 0 1 .377.529l-.008-2.817a.644.644 0 0 0-.377-.528 2.023 2.023 0 0 0-1.825 0 .644.644 0 0 0-.382.534zM757.8 348.81l.007 2.816a.525.525 0 0 0 .31-.436l-.007-2.816a.525.525 0 0 1-.31.436z"
            fill="#BC8430"
        />
        <path
            d="M744.64 352.78a.8.8 0 0 1-.1-.36l-.007-2.817a1.028 1.028 0 0 0 .593.854l1.162.675.007 2.816-.431-.251.007 2.645-1.1-.641a.54.54 0 0 1-.311-.435l-.008-2.817a.469.469 0 0 0 .188.331z"
            fill="#8E6424"
        />
        <path
            d="m745.87 353.52.008 2.816 1.132.658-.008-2.816-1.132-.658z"
            fill="#8E6424"
        />
        <path
            d="m748.49 354.18.008 2.816 9.3-5.37-.008-2.817-9.3 5.371z"
            fill="#8F6424"
        />
        <path
            d="m747 354.18.007 2.816a1.655 1.655 0 0 0 1.5 0l-.007-2.816a1.655 1.655 0 0 1-1.5 0z"
            fill="#BC8430"
        />
        <path
            d="m746.29 351.13-1.162-.675c-.84-.488-.784-1.325.142-1.859l2.9-1.672a3.548 3.548 0 0 1 3.2-.072l1.161.674 1.529-.883a1.654 1.654 0 0 1 1.5 0l1.1.641 1.132.658a.458.458 0 0 1 0 .866l-9.3 5.37a1.648 1.648 0 0 1-1.5 0l-1.132-.658-1.1-.641a.453.453 0 0 1-.311-.435.46.46 0 0 1 .311-.435l1.53-.879zm2.876-1.949a.554.554 0 0 0 .376-.528.565.565 0 0 0-.103-.325.566.566 0 0 0-.273-.204 2.026 2.026 0 0 0-1.825 0 .568.568 0 0 0-.382.529.552.552 0 0 0 .103.326.55.55 0 0 0 .273.206 2.008 2.008 0 0 0 1.832 0l-.001-.004z"
            fill="#FFBF00"
        />
        <path
            d="M776.95 347.08c-1.662 3.743-5.252 6.683-8.793 8.593a37.297 37.297 0 0 1-16.29 4.167c-3.077.052-6.158-.324-9.225-.534a19.347 19.347 0 0 1-4.363-.98l-3.6 1.651v1.325l34.91 20.374 9.5 5.264.043-.026v-38.631l-2.182-1.203z"
            fill="#D9D9D9"
        />
        <path
            d="m812.22 366.51-33.082-18.224v38.631l33.082-19.234v-1.173z"
            fill="#E5E5E5"
        />
        <path
            d="m767.93 340.79-11.258 6.5 1.132.658a.46.46 0 0 1 .222.698.469.469 0 0 1-.222.168l-9.3 5.37a1.661 1.661 0 0 1-1.5 0l-1.132-.658-11.184 6.457 44.407 25.638 33.126-19.111-44.291-25.72z"
            fill="#FDFDFD"
        />
        <path
            d="m779.32 349.26 23.522 13.58a2.991 2.991 0 0 1-1.363 2.223.946.946 0 0 1-.948.081l-22.002-12.793a.94.94 0 0 0 .484.086.941.941 0 0 0 .463-.167c.01-.006.019-.018.029-.024l-1.373-.8a2.998 2.998 0 0 1 1.188-2.186z"
            fill="#E54332"
        />
        <path
            d="m778.52 352.36 22 12.789a.964.964 0 0 1-.4-.9l-22-12.792a.964.964 0 0 0 .4.903zM779.5 349.11a.955.955 0 0 1 .948-.081l22.007 12.79a.958.958 0 0 1 .4.9c0 .038-.016.08-.02.119l-23.522-13.58c.063-.045.121-.11.187-.148z"
            fill="#A11E1A"
        />
        <path
            d="M800.87 365.22a1.146 1.146 0 0 1-.176-.647 2.996 2.996 0 0 1 1.384-2.342c.182-.106.39-.16.6-.155a.7.7 0 0 0-.222-.255l.565.328.829.482.574.334.421.244-.1-.055.157.092.08.045-.138-.082.275.16a.488.488 0 0 1 .065.043l-.076-.045.012.006.022.013.044.026a.75.75 0 0 1 .223.291c0 .006.008.008.011.014.062.148.096.306.1.466v.089a2.305 2.305 0 0 1-.113.663c-.023.075-.065.145-.095.22a3.18 3.18 0 0 1-.195.434c-.047.082-.11.151-.165.228a2.892 2.892 0 0 1-.259.344 2.641 2.641 0 0 1-.213.181c-.082.08-.17.155-.263.224a.916.916 0 0 1-.08.046c-.16.095-.339.153-.525.171a.875.875 0 0 1-.142-.03.727.727 0 0 1-.279-.059l-.7-.405-.574-.334a.723.723 0 0 0 .003 0l-.828-.48-.565-.329a.73.73 0 0 0 .343.074z"
            fill="#E54332"
        />
        <path
            d="M800.69 364.57v-.005l3.493 2.017-.05.029c-.16.095-.339.153-.525.171a.875.875 0 0 1-.142-.03.727.727 0 0 1-.279-.059l-.7-.405-.574-.334a.723.723 0 0 0 .003 0l-.828-.48-.565-.329a.716.716 0 0 0 .343.072 1.146 1.146 0 0 1-.176-.647z"
            fill="#A11E1A"
        />
        <path
            d="m803.22 366.64 1.073.623a.931.931 0 0 1-.384-.871l-1.072-.623a.929.929 0 0 0 .383.871z"
            fill="#BF8F00"
        />
        <path
            d="m806.16 364.05-1.073-.624a.91.91 0 0 0-.914.079 2.885 2.885 0 0 0-1.335 2.26l1.073.623a2.887 2.887 0 0 1 1.335-2.26.921.921 0 0 1 .914-.078z"
            fill="#FFBF00"
        />
        <path
            d="M804.3 367.26a1.857 1.857 0 0 0 2.716-1.073 1.845 1.845 0 0 0-.016-1.103 1.874 1.874 0 0 0-.838-1.034.916.916 0 0 0-.914.078 2.931 2.931 0 0 0-1.305 1.938 3.824 3.824 0 0 0-.012.586.816.816 0 0 0 .369.608z"
            fill="#FAC93A"
        />
        <path
            d="m776.36 348.88.985 1.674a.647.647 0 0 1-.076-.337l-.909-1.337z"
            fill="#A11E1A"
        />
        <path
            d="m778.3 348.9-1.942-.027.908 1.336a1.565 1.565 0 0 1 .721-1.22.63.63 0 0 1 .313-.089z"
            fill="#E54332"
        />
        <path
            d="m777.34 350.55.924 1.551a1.24 1.24 0 0 1-.148-.651l-.853-1.239a.655.655 0 0 0 .077.339z"
            fill="#BF8F00"
        />
        <path
            d="m780.11 348.94-1.805-.034a.632.632 0 0 0-.314.09 1.56 1.56 0 0 0-.721 1.22l.853 1.239a2.994 2.994 0 0 1 1.383-2.342c.182-.109.391-.169.604-.173z"
            fill="#FFBF00"
        />
        <path
            d="m800.52 365.14.565.329a.976.976 0 0 1-.4-.9l-.565-.328a.969.969 0 0 0 .4.899z"
            fill="#BF8F00"
        />
        <path
            d="m803.02 362.15-.565-.328a.95.95 0 0 0-.947.081 3.007 3.007 0 0 0-1.384 2.342l.565.328a3.008 3.008 0 0 1 1.384-2.342.951.951 0 0 1 .947-.081zM804.43 362.96l-.573-.334a.95.95 0 0 0-.948.081 2.995 2.995 0 0 0-1.384 2.342l.574.334a2.996 2.996 0 0 1 1.384-2.342.946.946 0 0 1 .947-.081z"
            fill="#FFBF00"
        />
        <path
            d="m801.92 365.95.574.334a.975.975 0 0 1-.4-.9l-.574-.334a.968.968 0 0 0 .4.9z"
            fill="#BF8F00"
        />
        <path d="M802.1 365.34v.046l.067.038.01-.033-.077-.051z" fill="#E54332" />
        <path
            d="M801.52 365.05a.967.967 0 0 0 .4.9l-.828-.48a.967.967 0 0 1-.4-.9l.828.48zM804.18 363.5c-.028.015-.053.045-.08.063l-.738-.426c.043-.029.079-.073.123-.1a.946.946 0 0 1 .947-.081l.421.244-.1-.055.157.092.08.045-.138-.082.275.16a.488.488 0 0 1 .065.043l-.076-.045.012.006.022.013.044.026a.662.662 0 0 1 .1.13l-.2-.115a.908.908 0 0 0-.914.082zM802.9 362.71c-.043.025-.08.069-.124.1l-.831-.479c.044-.029.082-.074.127-.1a1.28 1.28 0 0 1 .412-.135 1.08 1.08 0 0 1 .188-.019.712.712 0 0 1 .346.072l.829.482a.955.955 0 0 0-.947.079z"
            fill="#A11E1A"
        />
        <path
            d="M804.18 363.5a.913.913 0 0 1 .914-.079l.2.115.875.508a.826.826 0 0 0-.67 0 1.15 1.15 0 0 0-.243.079c-.028.015-.051.044-.077.061l-1.076-.621c.025-.018.05-.047.077-.063zM801.51 361.9a.952.952 0 0 1 .947-.081l.565.328a.728.728 0 0 0-.346-.072.916.916 0 0 0-.188.019 1.169 1.169 0 0 0-.412.135c-.044.026-.082.071-.127.1l-.566-.327c.041-.031.081-.077.127-.102z"
            fill="#BF8F00"
        />
        <path
            d="M802.08 362.23zM804.43 362.96l-.574-.334.574.334z"
            fill="#FFBF00"
        />
        <path
            d="M803.48 363.04c-.043.024-.079.068-.123.1l-.575-.333c.043-.029.08-.073.124-.1a.946.946 0 0 1 .948-.081l.573.334a.95.95 0 0 0-.947.08z"
            fill="#BF8F00"
        />
        <path
            d="M770.74 359.44a.655.655 0 0 0 .131.347l-4.683.424a.591.591 0 0 0-.062-.353l4.614-.418zM768.32 353.11l4.017 1.189a.921.921 0 0 0-.278.317l-4.08-1.207c.133-.075.249-.177.341-.299zM770.99 348c.017.127.07.246.152.344l-3.587.632a.585.585 0 0 0-.065-.362l3.5-.614z"
            fill="#02567D"
        />
        <path
            d="M767.06 348.2c.118.067.224.151.314.251.044.05.081.104.111.163.06.111.083.238.065.362-.047.326-.374.63-.917.79a2.688 2.688 0 0 1-.919.1 2.354 2.354 0 0 1-1.033-.281 1.189 1.189 0 0 1-.311-.249c-.427-.484-.1-1.072.728-1.314a2.67 2.67 0 0 1 1.962.178z"
            fill="#E54332"
        />
        <path
            d="m766.33 349.83.52 1.921a2.8 2.8 0 0 0-.606.046l-.525-1.936c.204.011.409.001.611-.031z"
            fill="#02567D"
        />
        <path
            d="M767.95 352.04c.116.066.221.15.311.25a.624.624 0 0 1 .055.828 1.127 1.127 0 0 1-.341.3 1.927 1.927 0 0 1-.441.188c-.59.17-1.22.138-1.789-.092a1.748 1.748 0 0 1-.173-.087 1.316 1.316 0 0 1-.314-.25c-.421-.481-.094-1.069.74-1.315a2.795 2.795 0 0 1 .847-.103c.385.004.764.101 1.105.281z"
            fill="#FFBF00"
        />
        <path
            d="M765.33 353.25c.073.067.154.125.239.174.056.032.114.061.173.087l-3.444 2a1.284 1.284 0 0 0-.183-.125 1.765 1.765 0 0 0-.26-.123l3.475-2.013z"
            fill="#02567D"
        />
        <path
            d="M773.62 358.72c.118.066.224.151.314.251.42.48.093 1.068-.734 1.311a2.676 2.676 0 0 1-1.96-.177 1.24 1.24 0 0 1-.366-.317.655.655 0 0 1-.131-.347c-.021-.367.317-.724.92-.9a2.862 2.862 0 0 1 1.345-.039c.214.041.421.114.612.218z"
            fill="#E54332"
        />
        <path
            d="M773.01 358.5a2.865 2.865 0 0 0-.606-.061l.707-2.615c.2.04.404.059.608.056l-.709 2.62zM747.56 359.19a.632.632 0 0 0-.111.347l-3.277-.237a.602.602 0 0 0 .077-.352l3.311.242z"
            fill="#02567D"
        />
        <path
            d="M753.91 362.91c.116.066.221.149.311.248a.837.837 0 0 1 .136.211.59.59 0 0 1 .038.359 1.168 1.168 0 0 1-.9.744 2.668 2.668 0 0 1-1.963-.179 1.227 1.227 0 0 1-.313-.251c-.373-.426-.158-.936.476-1.218a2.143 2.143 0 0 1 .549-.165 2.62 2.62 0 0 1 1.666.251z"
            fill="#FFBF00"
        />
        <path
            d="M758.47 363.5a.578.578 0 0 0 .052.357l-4.132-.129a.59.59 0 0 0-.038-.359l4.118.131z"
            fill="#02567D"
        />
        <path
            d="M761.33 362.92a1.374 1.374 0 0 1 .314.25c.427.476.094 1.068-.734 1.311a2.714 2.714 0 0 1-1.143.085 2.254 2.254 0 0 1-.807-.259 1.214 1.214 0 0 1-.314-.252.783.783 0 0 1-.131-.193.58.58 0 0 1-.052-.357c.058-.316.383-.609.91-.764a2.786 2.786 0 0 1 1.6.026c.124.039.243.09.357.153z"
            fill="#E54332"
        />
        <path
            d="m760.39 364.58.445 1.641a2.876 2.876 0 0 0-.607.043l-.461-1.7c.207.028.416.033.623.016zM763.7 360.98l-2.25 2.008a1.937 1.937 0 0 0-.469-.23l2.245-2a1.8 1.8 0 0 0 .474.222z"
            fill="#02567D"
        />
        <path
            d="M762.12 355.38a1.275 1.275 0 0 1 .31.245c.377.429.164.94-.47 1.222a1.993 1.993 0 0 1-.264.1c-.093.028-.189.05-.286.066a2.618 2.618 0 0 1-1.67-.249 1.236 1.236 0 0 1-.316-.251.732.732 0 0 1-.167-.31.595.595 0 0 1 .028-.354 1.284 1.284 0 0 1 .873-.647 2.774 2.774 0 0 1 1.7.059c.091.032.179.072.262.119z"
            fill="#E54332"
        />
        <path
            d="M765.7 359.44c.116.064.22.147.309.244.047.052.087.11.119.172a.584.584 0 0 1 .062.353c-.046.327-.375.631-.915.793a2.796 2.796 0 0 1-1.578-.019 1.947 1.947 0 0 1-.378-.164l-.1-.06a1.169 1.169 0 0 1-.219-.191c-.378-.423-.159-.935.472-1.216a2.28 2.28 0 0 1 .55-.161 2.614 2.614 0 0 1 1.678.249z"
            fill="#FFBF00"
        />
        <path
            d="M763.74 359.26a2.079 2.079 0 0 0-.26.095l-.784-.889-1.287-1.458a2.272 2.272 0 0 0 .55-.166l2.068 2.348a2.354 2.354 0 0 0-.287.07z"
            fill="#02567D"
        />
        <path
            d="M750.32 358.85c.118.067.224.151.314.251.372.426.157.937-.474 1.216a1.97 1.97 0 0 1-.26.095c-.095.028-.191.05-.289.067a2.62 2.62 0 0 1-1.671-.244 1.244 1.244 0 0 1-.311-.249.68.68 0 0 1-.187-.45.643.643 0 0 1 .111-.347 1.44 1.44 0 0 1 .809-.521c.463-.13.95-.139 1.417-.027.181.043.354.11.516.2l.025.009z"
            fill="#FFBF00"
        />
        <path
            d="M749.9 360.41c.089-.026.176-.058.26-.095l2.069 2.348a2.104 2.104 0 0 0-.549.165l-2.069-2.347c.098-.018.194-.042.289-.071zM752.01 356.65c.172.08.352.138.538.173l-2.255 2.016a2.023 2.023 0 0 0-.516-.2l2.233-1.989z"
            fill="#02567D"
        />
        <path
            d="M754.28 355.2c.117.066.222.15.311.249.067.074.119.16.153.253a.575.575 0 0 1 .012.353 1.196 1.196 0 0 1-.893.709c-.424.12-.871.139-1.305.056a2.268 2.268 0 0 1-.658-.235 1.267 1.267 0 0 1-.314-.251c-.42-.479-.093-1.068.741-1.314a2.667 2.667 0 0 1 1.953.18z"
            fill="#E54332"
        />
        <path
            d="M754.75 356.06a.576.576 0 0 0-.012-.353l4.544.141a.595.595 0 0 0-.028.354l-4.504-.142z"
            fill="#02567D"
        />
        <path
            d="M743.75 358.31c.118.066.224.151.314.251a.698.698 0 0 1 .18.388.602.602 0 0 1-.077.352 1.372 1.372 0 0 1-.843.574 2.652 2.652 0 0 1-1.953-.179 1.3 1.3 0 0 1-.312-.25c-.42-.48-.093-1.069.735-1.311a2.64 2.64 0 0 1 1.956.175zM773.86 347.24c.118.066.224.151.315.251.421.48.094 1.068-.734 1.311a2.668 2.668 0 0 1-1.959-.177 1.267 1.267 0 0 1-.311-.249c-.011-.013-.023-.026-.032-.039a.676.676 0 0 1-.152-.344c-.043-.378.3-.752.918-.934a2.663 2.663 0 0 1 1.955.181z"
            fill="#E54332"
        />
        <path
            d="M761.94 366.5c.115.065.22.147.31.244.427.485.1 1.072-.734 1.318a2.66 2.66 0 0 1-1.956-.182 1.183 1.183 0 0 1-.316-.251c-.42-.479-.093-1.068.734-1.311a2.725 2.725 0 0 1 .863-.104c.384.006.76.105 1.099.286zM774.86 354.2c.117.065.222.149.311.248.421.481.094 1.068-.734 1.311a2.668 2.668 0 0 1-.721.109 2.822 2.822 0 0 1-.608-.057 2.104 2.104 0 0 1-.628-.228 1.262 1.262 0 0 1-.313-.251.614.614 0 0 1-.113-.721.934.934 0 0 1 .282-.311 1.76 1.76 0 0 1 .569-.273 2.657 2.657 0 0 1 1.955.173zM783.79 369.4c.144.081.275.185.386.308a.768.768 0 0 1 .046 1.037 1.46 1.46 0 0 1-.442.37c-.162.09-.333.161-.511.211a3.265 3.265 0 0 1-2.417-.217 1.533 1.533 0 0 1-.389-.309.765.765 0 0 1-.115-.934c.095-.155.222-.287.374-.387.116-.08.24-.147.371-.2a3.053 3.053 0 0 1 .785-.2 3.204 3.204 0 0 1 1.912.321z"
            fill="#FFBF00"
        />
        <path
            d="m784.22 370.74 5.265 1.287a.835.835 0 0 0-.183.429l-5.525-1.346a1.45 1.45 0 0 0 .443-.37z"
            fill="#02567D"
        />
        <path
            d="M788.83 376.73c.114.064.217.147.305.244.419.464.1 1.034-.709 1.271a2.593 2.593 0 0 1-1.9-.176 1.214 1.214 0 0 1-.305-.243c-.4-.464-.1-1.035.709-1.271.28-.08.57-.114.861-.1.247.009.491.054.725.134.109.037.214.084.314.141z"
            fill="#FFBF00"
        />
        <path
            d="m790.79 373.69-2.267 2.9a2.524 2.524 0 0 0-.725-.134l2.316-2.965c.216.094.443.161.676.199z"
            fill="#02567D"
        />
        <path
            d="M792.85 371.67c.144.081.275.185.386.308.527.6.123 1.324-.9 1.623a3.476 3.476 0 0 1-1.551.08 2.796 2.796 0 0 1-.676-.2 1.867 1.867 0 0 1-.194-.1 1.502 1.502 0 0 1-.385-.307.806.806 0 0 1-.227-.624.825.825 0 0 1 .183-.429c.251-.284.583-.485.952-.575a3.462 3.462 0 0 1 1.995.037c.145.049.284.112.417.187z"
            fill="#E54332"
        />
        <path
            d="m795.49 369.44-3.052 2.051a3.227 3.227 0 0 0-.771-.155l3.272-2.2c.067.047.137.092.21.136.11.063.224.119.341.168zM795.74 366.68c-.209.067-.41.155-.6.264l-2.376-2.271a2.858 2.858 0 0 0 .668-.2l2.308 2.207z"
            fill="#02567D"
        />
        <path
            d="M793.61 362.67c.144.08.274.184.385.308.472.523.207 1.154-.564 1.5-.109.049-.221.09-.335.123a3.21 3.21 0 0 1-.333.077 3.246 3.246 0 0 1-2.084-.3 1.559 1.559 0 0 1-.389-.31c-.527-.589-.123-1.316.907-1.619a3.3 3.3 0 0 1 2.413.221z"
            fill="#134663"
        />
        <path
            d="M799.14 366.95c.198.111.376.253.528.422.713.8.164 1.793-1.235 2.2a4.65 4.65 0 0 1-2.943-.136 2.709 2.709 0 0 1-.551-.304 1.907 1.907 0 0 1-.313-.283c-.581-.65-.332-1.416.517-1.9.191-.109.392-.197.6-.264.037-.012.075-.025.114-.036a4.458 4.458 0 0 1 3.283.301z"
            fill="#E54332"
        />
        <path
            d="M769.87 375.48c.107.061.204.137.288.228.043.049.08.103.11.161a.549.549 0 0 1 .058.328.837.837 0 0 1-.452.566c-.126.072-.26.13-.4.171l-.085.023a2.618 2.618 0 0 1-1.383-.04 1.77 1.77 0 0 1-.442-.209 1.122 1.122 0 0 1-.2-.177c-.352-.393-.147-.87.439-1.13a2.076 2.076 0 0 1 .51-.151 2.446 2.446 0 0 1 1.557.23z"
            fill="#FFBF00"
        />
        <path
            d="M774.56 375.48a.615.615 0 0 0 .123.323l-4.355.395a.54.54 0 0 0-.058-.328l4.29-.39z"
            fill="#02567D"
        />
        <path
            d="M777.24 374.81c.11.061.209.14.293.233.391.446.087.993-.684 1.219a2.628 2.628 0 0 1-1.324.028 1.948 1.948 0 0 1-.5-.193 1.18 1.18 0 0 1-.341-.296.615.615 0 0 1-.123-.323c-.019-.341.295-.673.856-.838a2.593 2.593 0 0 1 1.252-.043c.201.04.393.112.571.213z"
            fill="#E54332"
        />
        <path
            d="m774.86 364.82.164.316-3.434.605a.548.548 0 0 0-.061-.337l3.331-.584z"
            fill="#02567D"
        />
        <path
            d="M771.14 365.02c.109.062.208.14.292.233a.841.841 0 0 1 .1.151.548.548 0 0 1 .061.337c-.044.3-.35.586-.853.734a2.572 2.572 0 0 1-.856.093 2.185 2.185 0 0 1-.961-.261 1.099 1.099 0 0 1-.29-.231c-.4-.451-.093-1 .677-1.223a2.488 2.488 0 0 1 1.83.167z"
            fill="#E54332"
        />
        <path
            d="m770.45 366.54.485 1.786a2.734 2.734 0 0 0-.564.043l-.489-1.799c.19.01.38 0 .568-.03z"
            fill="#02567D"
        />
        <path
            d="M771.96 368.59c.109.061.207.14.29.232a.579.579 0 0 1 .052.77 1.044 1.044 0 0 1-.318.277 1.726 1.726 0 0 1-.41.174 2.548 2.548 0 0 1-1.664-.086 1.53 1.53 0 0 1-.162-.081 1.244 1.244 0 0 1-.292-.232c-.391-.446-.087-.994.689-1.223a2.734 2.734 0 0 1 .789-.096c.359.006.71.097 1.026.265zM778.11 370.78a.863.863 0 0 1 .218.172c.292.329.062.738-.511.9a1.913 1.913 0 0 1-.985.018 1.48 1.48 0 0 1-.364-.142.91.91 0 0 1-.218-.172.427.427 0 0 1-.095-.454.644.644 0 0 1 .258-.295c.108-.069.226-.121.349-.155a1.824 1.824 0 0 1 1.348.128z"
            fill="#FFBF00"
        />
        <path
            d="m772.3 369.6 4.1 1.214a.65.65 0 0 0-.258.295l-4.163-1.231c.125-.07.234-.165.321-.278zM776.67 374.6a2.593 2.593 0 0 0-.563-.057l.722-2.671c.185.045.376.063.566.053l-.725 2.675z"
            fill="#02567D"
        />
        <path
            d="M767.12 371.36c.061.035.121.074.178.117.098.069.188.149.268.239.563.635.2 1.4-.8 1.784-.079.03-.161.058-.247.082s-.174.048-.263.067a3.761 3.761 0 0 1-2.525-.321 1.813 1.813 0 0 1-.444-.354.99.99 0 0 1-.259-.537.824.824 0 0 1 .028-.328 1.752 1.752 0 0 1 1.275-1.008 3.895 3.895 0 0 1 2.556.143c.08.034.157.073.233.116z"
            fill="#134663"
        />
        <path
            d="M769.53 369.72c.068.062.143.116.222.161.053.03.107.057.162.081l-2.612 1.515a1.95 1.95 0 0 0-.407-.232l2.635-1.525zM768.05 375.31a1.882 1.882 0 0 0-.241.089l-.729-.826-.816-.926a4.215 4.215 0 0 0 .511-.148l1.542 1.75c-.09.015-.179.036-.267.061z"
            fill="#02567D"
        />
        <path
            d="M775.4 364.62c.073.04.138.093.193.155.263.292.062.652-.448.8-.395.118-.82.079-1.188-.107a.802.802 0 0 1-.193-.155c-.262-.292-.062-.651.448-.8.396-.118.821-.08 1.188.107zM776.93 361.43a.74.74 0 0 1 .191.152.455.455 0 0 1 .1.181.375.375 0 0 1-.072.324.911.911 0 0 1-.483.3 1.614 1.614 0 0 1-1.189-.109.744.744 0 0 1-.191-.153c-.26-.295-.056-.653.447-.8.398-.12.826-.083 1.197.105zM786.61 365.44c.108.06.205.137.287.228a.724.724 0 0 1 .125.194.52.52 0 0 1 .034.33 1.07 1.07 0 0 1-.828.683 2.45 2.45 0 0 1-1.8-.164 1.19 1.19 0 0 1-.289-.23c-.342-.391-.144-.86.437-1.118a1.953 1.953 0 0 1 .503-.149 2.406 2.406 0 0 1 1.531.226z"
            fill="#E54332"
        />
        <path
            d="M782.94 363.15c.081-.024.16-.053.238-.087l1.9 2.155a2.297 2.297 0 0 0-.261.06 1.841 1.841 0 0 0-.242.089l-1.9-2.156a2.21 2.21 0 0 0 .265-.061z"
            fill="#02567D"
        />
        <path
            d="M783.33 361.71c.107.061.205.139.289.23.342.392.144.861-.435 1.117a2.07 2.07 0 0 1-.503.148 2.402 2.402 0 0 1-1.534-.224 1.093 1.093 0 0 1-.286-.228.616.616 0 0 1-.172-.412.582.582 0 0 1 .1-.32c.185-.24.447-.408.743-.477a2.58 2.58 0 0 1 1.3-.025c.164.038.323.099.472.179l.026.012z"
            fill="#FFBF00"
        />
        <path
            d="M780.79 362.02a.598.598 0 0 0-.1.32l-3.537-.256a.37.37 0 0 0 .072-.324l3.565.26zM784.88 359.69c.157.073.323.127.494.159l-2.07 1.85a1.898 1.898 0 0 0-.472-.179l2.048-1.83z"
            fill="#02567D"
        />
        <path
            d="M786.96 358.36c.107.06.204.137.287.229a.719.719 0 0 1 .14.231.535.535 0 0 1 .011.324 1.11 1.11 0 0 1-.82.652c-.391.11-.802.128-1.2.052a2.08 2.08 0 0 1-.494-.159 1.601 1.601 0 0 1-.109-.058 1.11 1.11 0 0 1-.289-.23c-.386-.44-.086-.981.679-1.206a2.451 2.451 0 0 1 1.795.165z"
            fill="#E54332"
        />
        <defs>
            <radialGradient
                id="a"
                cx={0}
                cy={0}
                r={1}
                gradientTransform="rotate(60 -84.753 802.824) scale(169.5 656.03)"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#212739" offset={0} />
                <stop stopColor="#191822" offset={1} />
            </radialGradient>
        </defs>
    </svg>
)

export default SvgComponent
